const bookies =  [
      {
        "kind": "books#volume",
        "id": "r2yCRUxo0EYC",
        "etag": "1YEEXLpcQ6Y",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/r2yCRUxo0EYC",
        "volumeInfo": {
          "title": "Start With Why",
          "subtitle": "How Great Leaders Inspire Everyone To Take Action",
          "authors": [
            "Simon Sinek"
          ],
          "publisher": "Penguin UK",
          "publishedDate": "2011-10-06",
          "description": "Simon Sinek's recent video on 'The Millennial Question' went viral with over 150 million views. Start with Why is a global bestseller and the TED Talk based on it is the third most watched of all time. Why are some people and organisations more inventive, pioneering and successful than others? And why are they able to repeat their success again and again? In business, it doesn't matter what you do, it matters WHY you do it. Start with Why analyses leaders like Martin Luther King Jr and Steve Jobs and discovers that they all think in the same way - they all started with why. Simon Sinek explains the framework needed for businesses to move past knowing what they do to how they do it, and then to ask the more important question-WHY? Why do we do what we do? Why do we exist? Learning to ask these questions can unlock the secret to inspirational business. Sinek explains what it truly takes to lead and inspire and how anyone can learn how to do it.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780241958230"
            },
            {
              "type": "ISBN_10",
              "identifier": "0241958237"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 256,
          "printType": "BOOK",
          "categories": [
            "Business & Economics"
          ],
          "averageRating": 3.5,
          "ratingsCount": 28,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.15.16.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=r2yCRUxo0EYC&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=r2yCRUxo0EYC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=r2yCRUxo0EYC&printsec=frontcover&dq=Action&hl=&cd=1&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=r2yCRUxo0EYC&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=r2yCRUxo0EYC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 530.11,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 247.66,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=r2yCRUxo0EYC&rdid=book-r2yCRUxo0EYC&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 530110000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 247660000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Start_With_Why-sample-epub.acsm?id=r2yCRUxo0EYC&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=r2yCRUxo0EYC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "WHAT READERS ARE SAYING ABOUT START WITH WHY: &#39;It&#39;s amazing how a book can change the course of your life, and this book did that&#39; Reader Review &#39;Imagine the Ted Talk expanded to 2 hours long, with more depth, intrigue and examples&#39; Reader ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "XTozEAAAQBAJ",
        "etag": "A8gNALCIa9A",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/XTozEAAAQBAJ",
        "volumeInfo": {
          "title": "Machine Learning in Action",
          "authors": [
            "Peter Harrington"
          ],
          "publisher": "Simon and Schuster",
          "publishedDate": "2012-04-03",
          "description": "Summary Machine Learning in Action is unique book that blends the foundational theories of machine learning with the practical realities of building tools for everyday data analysis. You'll use the flexible Python programming language to build programs that implement algorithms for data classification, forecasting, recommendations, and higher-level features like summarization and simplification. About the Book A machine is said to learn when its performance improves with experience. Learning requires algorithms and programs that capture data and ferret out the interestingor useful patterns. Once the specialized domain of analysts and mathematicians, machine learning is becoming a skill needed by many. Machine Learning in Action is a clearly written tutorial for developers. It avoids academic language and takes you straight to the techniques you'll use in your day-to-day work. Many (Python) examples present the core algorithms of statistical data processing, data analysis, and data visualization in code you can reuse. You'll understand the concepts and how they fit in with tactical tasks like classification, forecasting, recommendations, and higher-level features like summarization and simplification. Readers need no prior experience with machine learning or statistical processing. Familiarity with Python is helpful. Purchase of the print book comes with an offer of a free PDF, ePub, and Kindle eBook from Manning. Also available is all code from the book. What's Inside A no-nonsense introduction Examples showing common ML tasks Everyday data analysis Implementing classic algorithms like Apriori and Adaboos Table of Contents PART 1 CLASSIFICATION Machine learning basics Classifying with k-Nearest Neighbors Splitting datasets one feature at a time: decision trees Classifying with probability theory: naïve Bayes Logistic regression Support vector machines Improving classification with the AdaBoost meta algorithm PART 2 FORECASTING NUMERIC VALUES WITH REGRESSION Predicting numeric values: regression Tree-based regression PART 3 UNSUPERVISED LEARNING Grouping unlabeled items using k-means clustering Association analysis with the Apriori algorithm Efficiently finding frequent itemsets with FP-growth PART 4 ADDITIONAL TOOLS Using principal component analysis to simplify data Simplifying data with the singular value decomposition Big data and MapReduce",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781638352457"
            },
            {
              "type": "ISBN_10",
              "identifier": "1638352453"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 384,
          "printType": "BOOK",
          "categories": [
            "Computers"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.2.2.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=XTozEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=XTozEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=XTozEAAAQBAJ&printsec=frontcover&dq=Action&hl=&cd=2&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=XTozEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=XTozEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 2355.28,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 2355.28,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=XTozEAAAQBAJ&rdid=book-XTozEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 2355280000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 2355280000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED_FOR_ACCESSIBILITY",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Machine_Learning_in_Action-sample-epub.acsm?id=XTozEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=XTozEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Familiarity with Python is helpful. Purchase of the print book comes with an offer of a free PDF, ePub, and Kindle eBook from Manning. Also available is all code from the book."
        }
      },
      {
        "kind": "books#volume",
        "id": "AfQ1EAAAQBAJ",
        "etag": "XpE5Ue//6IY",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/AfQ1EAAAQBAJ",
        "volumeInfo": {
          "title": "Rust in Action",
          "authors": [
            "Tim McNamara"
          ],
          "publisher": "Simon and Schuster",
          "publishedDate": "2021-09-07",
          "description": "Rust in Action is a hands-on guide to systems programming with Rust. Written for inquisitive programmers, it presents real-world use cases that go far beyond syntax and structure. Summary Rust in Action introduces the Rust programming language by exploring numerous systems programming concepts and techniques. You'll be learning Rust by delving into how computers work under the hood. You'll find yourself playing with persistent storage, memory, networking and even tinkering with CPU instructions. The book takes you through using Rust to extend other applications and teaches you tricks to write blindingly fast code. You'll also discover parallel and concurrent programming. Filled to the brim with real-life use cases and scenarios, you'll go beyond the Rust syntax and see what Rust has to offer in real-world use cases. Purchase of the print book includes a free eBook in PDF, Kindle, and ePub formats from Manning Publications. About the technology Rust is the perfect language for systems programming. It delivers the low-level power of C along with rock-solid safety features that let you code fearlessly. Ideal for applications requiring concurrency, Rust programs are compact, readable, and blazingly fast. Best of all, Rust’s famously smart compiler helps you avoid even subtle coding errors. About the book Rust in Action is a hands-on guide to systems programming with Rust. Written for inquisitive programmers, it presents real-world use cases that go far beyond syntax and structure. You’ll explore Rust implementations for file manipulation, networking, and kernel-level programming and discover awesome techniques for parallelism and concurrency. Along the way, you’ll master Rust’s unique borrow checker model for memory management without a garbage collector. What's inside Elementary to advanced Rust programming Practical examples from systems programming Command-line, graphical and networked applications About the reader For intermediate programmers. No previous experience with Rust required. About the author Tim McNamara uses Rust to build data processing pipelines and generative art. He is an expert in natural language processing and data engineering. Table of Contents 1 Introducing Rust PART 1 RUST LANGUAGE DISTINCTIVES 2 Language foundations 3 Compound data types 4 Lifetimes, ownership, and borrowing PART 2 DEMYSTIFYING SYSTEMS PROGRAMMING 5 Data in depth 6 Memory 7 Files and storage 8 Networking 9 Time and timekeeping 10 Processes, threads, and containers 11 Kernel 12 Signals, interrupts, and exceptions",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781638356226"
            },
            {
              "type": "ISBN_10",
              "identifier": "163835622X"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 456,
          "printType": "BOOK",
          "categories": [
            "Computers"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.4.4.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=AfQ1EAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=AfQ1EAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=AfQ1EAAAQBAJ&printsec=frontcover&dq=Action&hl=&cd=3&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=AfQ1EAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=AfQ1EAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 2960.62,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 2960.62,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=AfQ1EAAAQBAJ&rdid=book-AfQ1EAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 2960620000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 2960620000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED_FOR_ACCESSIBILITY",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Rust_in_Action-sample-epub.acsm?id=AfQ1EAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=AfQ1EAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "&quot;This well-written book will help you make the most of what Rust has to offer.&quot; - Ramnivas Laddad, author of AspectJ in Action Rust in Action is a hands-on guide to systems programming with Rust."
        }
      },
      {
        "kind": "books#volume",
        "id": "6TozEAAAQBAJ",
        "etag": "EB3L2njDSb0",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/6TozEAAAQBAJ",
        "volumeInfo": {
          "title": "Gradle in Action",
          "authors": [
            "Benjamin Muschko"
          ],
          "publisher": "Simon and Schuster",
          "publishedDate": "2014-02-19",
          "description": "Summary Gradle in Action is a comprehensive guide to end-to-end project automation with Gradle. Starting with the basics, this practical, easy-to-read book discusses how to build a full-fledged, real-world project. Along the way, it touches on advanced topics like testing, continuous integration, and monitoring code quality. You'll also explore tasks like setting up your target environment and deploying your software. About the Technology Gradle is a general-purpose build automation tool. It extends the usage patterns established by its forerunners, Ant and Maven, and allows builds that are expressive, maintainable, and easy to understand. Using a flexible Groovy-based DSL, Gradle provides declarative and extendable language elements that let you model your project's needs the way you want. About the Book Gradle in Action is a comprehensive guide to end-to-end project automation with Gradle. Starting with the basics, this practical, easy-to-read book discusses how to establish an effective build process for a full-fledged, real-world project. Along the way, it covers advanced topics like testing, continuous integration, and monitoring code quality. You'll also explore tasks like setting up your target environment and deploying your software. The book assumes a basic background in Java, but no knowledge of Groovy. Purchase of the print book includes a free eBook in PDF, Kindle, and ePub formats from Manning Publications. Whats Inside A comprehensive guide to Gradle Practical, real-world examples Transitioning from Ant and Maven In-depth plugin development Continuous delivery with Gradle About the Author Benjamin Muschko is a member of the Gradleware engineering team and the author of several popular Gradle plugins. Table of Contents PART 1 INTRODUCING GRADLE Introduction to project automation Next-generation builds with Gradle Building a Gradle project by example PART 2 MASTERING THE FUNDAMENTALS Build script essentials Dependency management Multiproject builds Testing with Gradle Extending Gradle Integration and migration PART 3 FROM BUILD TO DEPLOYMENT IDE support and tooling Building polyglot projects Code quality management and monitoring Continuous integration Artifact assembly and publishing Infrastructure provisioning and deployment",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781638351726"
            },
            {
              "type": "ISBN_10",
              "identifier": "1638351724"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 480,
          "printType": "BOOK",
          "categories": [
            "Computers"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.5.6.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=6TozEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=6TozEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=6TozEAAAQBAJ&printsec=frontcover&dq=Action&hl=&cd=4&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=6TozEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=6TozEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 2355.28,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 2355.28,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=6TozEAAAQBAJ&rdid=book-6TozEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 2355280000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 2355280000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED_FOR_ACCESSIBILITY",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Gradle_in_Action-sample-epub.acsm?id=6TozEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=6TozEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The book assumes a basic background in Java, but no knowledge of Groovy. Purchase of the print book includes a free eBook in PDF, Kindle, and ePub formats from Manning Publications."
        }
      },
      {
        "kind": "books#volume",
        "id": "tx9pYZkwxugC",
        "etag": "FAOOdUe6A8A",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/tx9pYZkwxugC",
        "volumeInfo": {
          "title": "Systemic Action Research",
          "subtitle": "A Strategy for Whole System Change",
          "authors": [
            "Danny Burns"
          ],
          "publisher": "Policy Press",
          "publishedDate": "2007-10-24",
          "description": "\"Systemic Action Research works with live social and organisational issues to uncover their complex dynamics, reveal opportunities for effective interventions, and generate action to support whole system change.\" \"Filled with illustrative stories and pictures which bring the concepts to life, this book shows how to design and facilitate systematic action research programmes, extending the possibilities of action research beyond the 'individual' and the 'group' to whole organisations, multi agency governance arenas, and networks.\" \"It will be of interest to experienced action researchers, social researchers, international development organisations, community development practitioners, change management facilitators and policy makers.\"--BOOK JACKET.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1861347375"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781861347374"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 194,
          "printType": "BOOK",
          "categories": [
            "Political Science"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.4.2.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=tx9pYZkwxugC&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=tx9pYZkwxugC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=tx9pYZkwxugC&printsec=frontcover&dq=Action&hl=&cd=5&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=tx9pYZkwxugC&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Systemic_Action_Research.html?hl=&id=tx9pYZkwxugC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=tx9pYZkwxugC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "&quot; &quot;Filled with illustrative stories and pictures which bring the concepts to life, this book shows how to design and facilitate systematic action research programmes, extending the possibilities of action research beyond the &#39;individual&#39; ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "lqphQgAACAAJ",
        "etag": "K/CtwGSWoOE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/lqphQgAACAAJ",
        "volumeInfo": {
          "title": "Text in Action",
          "authors": [
            "Cicely Berry"
          ],
          "publisher": "Virgin Pub",
          "publishedDate": "2001",
          "description": "Following on from the widely acclaimed The Actor and the Text - which was addressed directly to the actor - Text in Action is drawn from Cicely's group work experiences, encompassing the viewpoint of the director as well. To begin with, the author explores language from a cultural and personal perspective. In these days of management jargon and internet technology are we losing touch with the ability to communicate fully?' Is the deeper imaginative world being left unexpressed? The main body of the book contains detailed, practical exercises for actors and directors during the rehearsal process. All exercises will be tied to specific scenes, leading to a fuller exploration of the rext. Text In Action analyses the imagery of plays, speech structures, the physicality of language and emphasises the importance of finding a collective voice. Cicely's guidance on the matter of voice will help actors find relationships and situations through the text in a unique way, in order to make it more dynamic and creative.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "075350541X"
            },
            {
              "type": "ISBN_13",
              "identifier": "9780753505410"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 278,
          "printType": "BOOK",
          "categories": [
            "Performing Arts"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=lqphQgAACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=lqphQgAACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=lqphQgAACAAJ&dq=Action&hl=&cd=6&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=lqphQgAACAAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Text_in_Action.html?hl=&id=lqphQgAACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=lqphQgAACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book is essential for all actors and directors, covers both classical and modern writing. It includes pratical exercises to maximise understanding and communication of text."
        }
      },
      {
        "kind": "books#volume",
        "id": "OzkzEAAAQBAJ",
        "etag": "2KAHQ3jpzeM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/OzkzEAAAQBAJ",
        "volumeInfo": {
          "title": "Kotlin in Action",
          "authors": [
            "Dmitry Jemerov",
            "Svetlana Isakova"
          ],
          "publisher": "Simon and Schuster",
          "publishedDate": "2017-02-03",
          "description": "Summary Kotlin in Action guides experienced Java developers from the language basics of Kotlin all the way through building applications to run on the JVM and Android devices. Foreword by Andrey Breslav, Lead Designer of Kotlin. Purchase of the print book includes a free eBook in PDF, Kindle, and ePub formats from Manning Publications. About the Technology Developers want to get work done - and the less hassle, the better. Coding with Kotlin means less hassle. The Kotlin programming language offers an expressive syntax, a strong intuitive type system, and great tooling support along with seamless interoperability with existing Java code, libraries, and frameworks. Kotlin can be compiled to Java bytecode, so you can use it everywhere Java is used, including Android. And with an effi cient compiler and a small standard library, Kotlin imposes virtually no runtime overhead. About the Book Kotlin in Action teaches you to use the Kotlin language for production-quality applications. Written for experienced Java developers, this example-rich book goes further than most language books, covering interesting topics like building DSLs with natural language syntax. The authors are core Kotlin developers, so you can trust that even the gnarly details are dead accurate. What's Inside Functional programming on the JVM Writing clean and idiomatic code Combining Kotlin and Java Domain-specific languages About the Reader This book is for experienced Java developers. About the Author Dmitry Jemerov and Svetlana Isakova are core Kotlin developers at JetBrains. Table of Contents PART 1 - INTRODUCING KOTLIN Kotlin: what and why Kotlin basics Defining and calling functions Classes, objects, and interfaces Programming with lambdas The Kotlin type system PART 2 - EMBRACING KOTLIN Operator overloading and other conventions Higher-order functions: lambdas as parameters and return values Generics Annotations and reflection DSL construction",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781638353690"
            },
            {
              "type": "ISBN_10",
              "identifier": "1638353697"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 360,
          "printType": "BOOK",
          "categories": [
            "Computers"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=OzkzEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=OzkzEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=OzkzEAAAQBAJ&pg=PP1&dq=Action&hl=&cd=7&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=OzkzEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=OzkzEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 2355.28,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 2355.28,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=OzkzEAAAQBAJ&rdid=book-OzkzEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 2355280000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 2355280000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED_FOR_ACCESSIBILITY",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Kotlin_in_Action-sample-epub.acsm?id=OzkzEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=OzkzEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "And with an effi cient compiler and a small standard library, Kotlin imposes virtually no runtime overhead. About the Book Kotlin in Action teaches you to use the Kotlin language for production-quality applications."
        }
      },
      {
        "kind": "books#volume",
        "id": "nDszEAAAQBAJ",
        "etag": "JNwub4Z881k",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/nDszEAAAQBAJ",
        "volumeInfo": {
          "title": "Go in Action",
          "authors": [
            "Erik St. Martin",
            "William Kennedy",
            "Brian Ketelsen"
          ],
          "publisher": "Simon and Schuster",
          "publishedDate": "2015-11-04",
          "description": "Summary Go in Action introduces the Go language, guiding you from inquisitive developer to Go guru. The book begins by introducing the unique features and concepts of Go. Then, you'll get hands-on experience writing real-world applications including websites and network servers, as well as techniques to manipulate and convert data at speeds that will make your friends jealous. Purchase of the print book includes a free eBook in PDF, Kindle, and ePub formats from Manning Publications. About the Technology Application development can be tricky enough even when you aren't dealing with complex systems programming problems like web-scale concurrency and real-time performance. While it's possible to solve these common issues with additional tools and frameworks, Go handles them right out of the box, making for a more natural and productive coding experience. Developed at Google, Go powers nimble startups as well as big enterprises—companies that rely on high-performing services in their infrastructure. About the Book Go in Action is for any intermediate-level developer who has experience with other programming languages and wants a jump-start in learning Go or a more thorough understanding of the language and its internals. This book provides an intensive, comprehensive, and idiomatic view of Go. It focuses on the specification and implementation of the language, including topics like language syntax, Go's type system, concurrency, channels, and testing. What's Inside Language specification and implementation Go's type system Internals of Go's data structures Testing and benchmarking About the Reader This book assumes you're a working developer proficient with another language like Java, Ruby, Python, C#, or C++. About the Authors William Kennedy is a seasoned software developer and author of the blog GoingGo.Net. Brian Ketelsen and Erik St. Martin are the organizers of GopherCon and coauthors of the Go-based Skynet framework. Table of Contents Introducing Go Go quick-start Packaging and tooling Arrays, slices, and maps Go's type system Concurrency Concurrency patterns Standard library Testing and benchmarking",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781638352020"
            },
            {
              "type": "ISBN_10",
              "identifier": "163835202X"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 264,
          "printType": "BOOK",
          "categories": [
            "Computers"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=nDszEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=nDszEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=nDszEAAAQBAJ&pg=PP1&dq=Action&hl=&cd=8&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=nDszEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=nDszEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 2355.28,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 2355.28,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=nDszEAAAQBAJ&rdid=book-nDszEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 2355280000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 2355280000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED_FOR_ACCESSIBILITY",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Go_in_Action-sample-epub.acsm?id=nDszEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=nDszEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "About the Book Go in Action is for any intermediate-level developer who has experience with other programming languages and wants a jump-start in learning Go or a more thorough understanding of the language and its internals."
        }
      },
      {
        "kind": "books#volume",
        "id": "WxBIEAAAQBAJ",
        "etag": "lDARRQ5Ud4A",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/WxBIEAAAQBAJ",
        "volumeInfo": {
          "title": "Mentor In Action",
          "authors": [
            "Simran Chhabra"
          ],
          "publisher": "Notion Press",
          "publishedDate": "2021-10-14",
          "description": "Born into a Punjabi middle-class household in the late nineties, Simran Chhabra’s world was the south east side of Panchkula, where her parents raised her to be fearless as they shared a small nook in her paternal grandmothers’ brown-brick bungalow. But life soon took her further afield from the crowded classrooms of Sacred Heart Senior Secondary School, Chandigarh, where she learned about detractors, and the vast lecture halls of Panjab University, Chandigarh where she pursued her bachelors to the hallowed halls of Harvard University, Cambridge, where she learned what it felt to be the only South Asian Hindu Punjabi woman. More recently she served as an advocacy intern for Consul General, Mia Yen at the Canadian High Commission in Chandigarh. Mentor in Action takes us through Chandigarh living rooms and high-profile diplomatic boardrooms, through moments of heart-wrenching grief and profound resilience, taking us deep into the soul of an ordinary mentee from Chandigarh and her extraordinary mentor from Canada. In narrating her story with grace, good humor and rare candor, Simran moots a question to the rest of us: Who are we in action?",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781639976034"
            },
            {
              "type": "ISBN_10",
              "identifier": "1639976035"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 88,
          "printType": "BOOK",
          "categories": [
            "Education"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.1.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=WxBIEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=WxBIEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=WxBIEAAAQBAJ&pg=PP1&dq=Action&hl=&cd=9&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=WxBIEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=WxBIEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 199,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 139.3,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=WxBIEAAAQBAJ&rdid=book-WxBIEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 199000000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 139300000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=WxBIEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Mentor in Action takes us through Chandigarh living rooms and high-profile diplomatic boardrooms, through moments of heart-wrenching grief and profound resilience, taking us deep into the soul of an ordinary mentee from Chandigarh and her ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "WBDuwwEACAAJ",
        "etag": "0sE6F20Xzpg",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/WBDuwwEACAAJ",
        "volumeInfo": {
          "title": "The Magic of Action: The Self-improvement Book to Act, Achieve, and Live Better",
          "authors": [
            "Julien Castel"
          ],
          "publishedDate": "2019-03-29",
          "description": "TheMagic of Action is a personal development book to act, achieve and livebetter. Whydo some people succeed and thrive better than others? These are people who actand fulfill their aspirations. \"Wehave two lives, and the second begins when we realize we only have one.\" Theproblem is that we encounter obstacles that prevent us from acting. Thispersonal development book is made for you if you wish to: Overcome fear Overcome doubts Overcome boredom Develop self-esteem Stop procrastinating Take control of your life Takeaction and let the magic happen. Indeed, actions are magical because theybuild self-esteem and bring opportunities and positive things into our lives.They will free you from your troubles and frustrations. Itis true that it is not always easy to jump bravely and take action. The purposeof this book is to help people accomplish their projects and grow. We shouldall get involved in our projects. This is good for our well-being andpersonal development. Thebenefits of action Action is life-saving and attractsopportunities to you. Action builds self-confidence andbrings happiness, unlike boredom, which is a fertile ground for doubt andmisery. Action allows you to better manage yourtime. Action allows you to better manage youremotions. Action reinforces your feeling of controlover your life. Itis for these reasons in particular that I advocate action. Becomean actor in your life and fulfill your aspirations with The Magic of Action. Therecan't be results without actions. The life we have is the result of our pastactions. It is never too late to take control and act for yourself.It concerns all aspects of our lives, such as health, relationships,professional success... Thereare some things we cannot act on. There are those on which we can act.Ultimately, we must distinguish between the two. Inthis personal development book you will find: Chapters with theoretical explanationsto understand the principles of personal development Summaries of each chapter Practical exercises to follow Advice and recommendations to be applied A BONUS Thispersonal development book is a manual for anyone who wants to takecontrol of their own lives and act on their own destiny. At the endof this book, you will have a destination, a goal. You will have clearobjectives and a vision that will guide you towards them. You will also bemotivated and take action, and your horizons will be broadened. Readersof The Magic of Action are interested in their: Personal success Well-being Self-esteem Emotion management Enriching experiences Personal development Freedom Self-knowledge Spirituality Life is hanging by a thread, grab it!",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1091577897"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781091577893"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 290,
          "printType": "BOOK",
          "categories": [
            "Self-Help"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=WBDuwwEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=WBDuwwEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=WBDuwwEACAAJ&dq=Action&hl=&cd=10&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=WBDuwwEACAAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_Magic_of_Action_The_Self_improvement.html?hl=&id=WBDuwwEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=WBDuwwEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The purposeof this book is to help people accomplish their projects and grow. We shouldall get involved in our projects. This is good for our well-being andpersonal development."
        }
      },
      {
        "kind": "books#volume",
        "id": "tXeoMBiOeI8C",
        "etag": "4qdzikAnDSE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/tXeoMBiOeI8C",
        "volumeInfo": {
          "title": "The Creativity of Action",
          "authors": [
            "Hans Joas"
          ],
          "publisher": "University of Chicago Press",
          "publishedDate": "1996",
          "description": "Hans Joas is one of the foremost social theorists in Germany today. Based on Joas’s celebrated study of George Herbert Mead, this work reevaluates the contribution of American pragmatism and European philosophical anthropology to theories of action in the social sciences. Joas also establishes direct ties between Mead’s work and approaches drawn from German traditions of philosophical anthropology. Joas argues for adding a third model of action to the two predominant models of rational and normative action—one that emphasizes the creative character of human action. This model encompasses the other two, allowing for a more comprehensive theory of action. Joas elaborates some implications of his model for theories of social movements and social change and for the status of action theory in sociology in the face of competition from theories advanced by Luhmann and Habermas. The problem of action is of crucial importance in both sociology and philosophy, and this book—already widely debated in Germany—will add fresh impetus to the lively discussions current in the English-speaking world.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "0226400441"
            },
            {
              "type": "ISBN_13",
              "identifier": "9780226400440"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 336,
          "printType": "BOOK",
          "categories": [
            "Philosophy"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.2.11.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=tXeoMBiOeI8C&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=tXeoMBiOeI8C&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=tXeoMBiOeI8C&dq=Action&hl=&cd=11&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=tXeoMBiOeI8C&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_Creativity_of_Action.html?hl=&id=tXeoMBiOeI8C"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=tXeoMBiOeI8C&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Based on Joas’s celebrated study of George Herbert Mead, this work reevaluates the contribution of American pragmatism and European philosophical anthropology to theories of action in the social sciences."
        }
      },
      {
        "kind": "books#volume",
        "id": "ws7tDwAAQBAJ",
        "etag": "HHTJgn9g8ZM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/ws7tDwAAQBAJ",
        "volumeInfo": {
          "title": "Data Action",
          "subtitle": "Using Data for Public Good",
          "authors": [
            "Sarah Williams"
          ],
          "publisher": "MIT Press",
          "publishedDate": "2020-12-08",
          "description": "How to use data as a tool for empowerment rather than oppression. Big data can be used for good, from tracking disease to exposing human rights violations, and for bad, implementing surveillance and control. Data inevitably represents the ideologies of those who control its use; data analytics and algorithms too often exclude women, the poor, and ethnic groups. In Data Action, Sarah Williams provides a guide for working with data in more ethical and responsible ways. Too often data has been used--and manipulated--to make policy decisions without much stakeholder input. Williams outlines a method that emphasizes collaboration among data scientists, policy experts, data designers, and the public. This approach creates trust and co-ownership in the data by opening the process to those who know the issues best.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780262359153"
            },
            {
              "type": "ISBN_10",
              "identifier": "0262359154"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 312,
          "printType": "BOOK",
          "categories": [
            "Computers"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=ws7tDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=ws7tDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=ws7tDwAAQBAJ&pg=PP1&dq=Action&hl=&cd=12&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=ws7tDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=ws7tDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 3613.69,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 3613.69,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=ws7tDwAAQBAJ&rdid=book-ws7tDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 3613690000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 3613690000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Data_Action-sample-epub.acsm?id=ws7tDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Data_Action-sample-pdf.acsm?id=ws7tDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=ws7tDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "In Data Action, Sarah Williams provides a guide for working with data in more ethical and responsible ways. Too often data has been used--and manipulated--to make policy decisions without much stakeholder input."
        }
      },
      {
        "kind": "books#volume",
        "id": "DejsAAAAQBAJ",
        "etag": "7ZmG9dtvsFc",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/DejsAAAAQBAJ",
        "volumeInfo": {
          "title": "Supervision In Action: A Relational Approach To Coaching And Consulting Supervision",
          "subtitle": "A relational approach to coaching and consulting supervision",
          "authors": [
            "de Haan, Erik"
          ],
          "publisher": "McGraw-Hill Education (UK)",
          "publishedDate": "2012-02-01",
          "description": "This book will help you open a conversation in English and keep the conversation going. It provides a huge number of phrases to use with people you know and people you don’tBusiness Spotlight, September 2012",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780335245772"
            },
            {
              "type": "ISBN_10",
              "identifier": "0335245773"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 154,
          "printType": "BOOK",
          "categories": [
            "Psychology"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=DejsAAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=DejsAAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=DejsAAAAQBAJ&printsec=frontcover&dq=Action&hl=&cd=13&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=DejsAAAAQBAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Supervision_In_Action_A_Relational_Appro.html?hl=&id=DejsAAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=DejsAAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book will help you open a conversation in English and keep the conversation going. It provides a huge number of phrases to use with people you know and people you don’tBusiness Spotlight, September 2012"
        }
      },
      {
        "kind": "books#volume",
        "id": "qLozrgEACAAJ",
        "etag": "OUpDKdJgHXI",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/qLozrgEACAAJ",
        "volumeInfo": {
          "title": "Apache Cordova in Action",
          "authors": [
            "Raymond Camden"
          ],
          "publisher": "Manning Publications",
          "publishedDate": "2015-11-09",
          "description": "Summary Apache Cordova in Action teaches you to create and launch hybrid mobile apps using Cordova or Phonegap. By following carefully selected examples, step-by-step tutorials, and crystal-clear explanations, you'll learn to build apps from the Cordova CLI, how to make use of device features like the camera and accelerometer, how to submit your apps to Google Play and the Apple App Store, and more. Purchase of the print book includes a free eBook in PDF, Kindle, and ePub formats from Manning Publications. About the Book Developing a mobile app requires extensive knowledge of native programming techniques for multiple platforms. Apache Cordova lets you use your existing skills in web development (HTML, CSS, and JavaScript) to build powerful mobile apps. Your apps also get the power of integration with native device features like the camera and file system. Apache Cordova in Action teaches you how to design, create, and launch hybrid mobile apps people will want to use. With the help of straightforward, real-world examples, you'll learn to build apps from the Cordova CLI and to make use of native device features like the camera and accelerometer. You'll learn testing techniques and discover the PhoneGap Build service and how to submit your apps to Google Play and the Apple App Store. Along the way, this helpful guide discusses mobile app design and shows you how to create effective, professional-quality UI and UX. What's Inside Build mobile apps UI, UX, and testing techniques Deploy to Google Play and the Apple App Store Employ libraries like Bootstrap, jQuery Mobile, and Ionic About the Reader Readers should be familiar with HTML, CSS, and JavaScript. No experience with mobile app development needed. About the Author Raymond Camden is a developer advocate for IBM. He is passionate about mobile development and has spoken at conferences worldwide. The Table of Contents PART 1 GETTING STARTED WITH APACHE CORDOVA What is Cordova? Installing Cordova and the Android SDK PART 2 CORE CONCEPTS Creating Cordova projects Using plugins to access device features Mobile design and user experience Considerations when building mobile apps Tools for debugging Cordova and other hybrid apps Creating custom plugins Packing options for Cordova projects Using PhoneGap tools PART 3 APPLICATION RELEASE Submitting your app Building an RSS reader app with Ionic",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1633430065"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781633430068"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 248,
          "printType": "BOOK",
          "categories": [
            "Computers"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=qLozrgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=qLozrgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=qLozrgEACAAJ&dq=Action&hl=&cd=14&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=qLozrgEACAAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Apache_Cordova_in_Action.html?hl=&id=qLozrgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=qLozrgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Purchase of the print book includes a free eBook in PDF, Kindle, and ePub formats from Manning Publications. About the Book Developing a mobile app requires extensive knowledge of native programming techniques for multiple platforms."
        }
      },
      {
        "kind": "books#volume",
        "id": "cfhADwAAQBAJ",
        "etag": "aKvkbJbWBqg",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/cfhADwAAQBAJ",
        "volumeInfo": {
          "title": "Action Learning",
          "subtitle": "Praxiology",
          "authors": [
            "Wojciech W. Gasparski"
          ],
          "publisher": "Routledge",
          "publishedDate": "2017-11-30",
          "description": "Praxiology is the study of working and doing from the point of view of effectiveness. It has three components: analysis of concepts involving purposive actions; critique of modes of action from the viewpoint of efficiency; and normative advisory aspects in recommen-dations for increasing human efficacy. This sixth volume of the Praxiology series fo-cuses on action learning. Learning from distinguishable action is surprisingly different than learning from a sub-ject expert in human or book form. For those who have worked with and in action learn-ing, the latest form is always distinguishably different from a former experience. Action learning programs are not, in general, intended to tackle puzzles, namely, questions to which an answer may be said to exist even if that answer is difficult to find; action learn-ing is intended to help to develop the ability to tackle problems or opportunities, of which different persons, all experienced, intelligent, and motivated, might well advocate differ-ent courses of action, all reasonable. The essentials of action learning, according to this volume, are: there can be no learning unless the participant receives feedback about his/her performance; partici-pants learn only of their own volition and never at the will of others; the volition to learn is most readily engendered by the lure of success or by the fear of calamity. Building upon these essentials, the authors view action learning as a process of inquiry begin-ning with the experience of not knowing what to do next, and finding that an answer is not available from current expertise. All chapters in this volume are sound contributions to the continuing debate on the processes of learning from distinguishable action. Action Learning is intriguing reading for sociologists, philosophers, managers, and research-ers of all disciplines.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781351290388"
            },
            {
              "type": "ISBN_10",
              "identifier": "135129038X"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 221,
          "printType": "BOOK",
          "categories": [
            "Philosophy"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=cfhADwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=cfhADwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=cfhADwAAQBAJ&pg=PT109&dq=Action&hl=&cd=15&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=cfhADwAAQBAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Action_Learning.html?hl=&id=cfhADwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Action_Learning-sample-epub.acsm?id=cfhADwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Action_Learning-sample-pdf.acsm?id=cfhADwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=cfhADwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Introduction Praxiology, \u003cb\u003eaction\u003c/b\u003e research, and critical systems heuristics share a basic concern in the problem of rational \u003cb\u003eaction\u003c/b\u003e: How can we identify, discuss, and justify rational \u003cb\u003eaction\u003c/b\u003e rationally? Dealing “rationally” with the&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "HFgeAQAAMAAJ",
        "etag": "AHL6dh7lTZg",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/HFgeAQAAMAAJ",
        "volumeInfo": {
          "title": "Do Children Form Associations Between Actions and Object Features?",
          "authors": [
            "Cynthia L. Wallace"
          ],
          "publishedDate": "2007",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "IND:30000095225482"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 80,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.5.4.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=HFgeAQAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=HFgeAQAAMAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=HFgeAQAAMAAJ&q=Action&dq=Action&hl=&cd=16&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=HFgeAQAAMAAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Do_Children_Form_Associations_Between_Ac.html?hl=&id=HFgeAQAAMAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=HFgeAQAAMAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "However, these interactions are subsumed by a three-way interaction indicating that infants displayed different behaviors (generalized \u003cb\u003eactions\u003c/b\u003e vs. contacts) with different test objects (target vs. distractor) in the different modeled&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "4BrICQAAQBAJ",
        "etag": "iOgpISPD28g",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/4BrICQAAQBAJ",
        "volumeInfo": {
          "title": "Essays on Freedom of Action (Routledge Revivals)",
          "authors": [
            "Ted Honderich"
          ],
          "publisher": "Routledge",
          "publishedDate": "2015-06-03",
          "description": "Essays on Freedom of Action, first published in 1973, brings together original papers by contemporary British and American philosophers on questions which have long concerned philosophers and others: the question of whether persons are wholly a part of the natural world and their actions the necessary effects of causal processes, and the question of whether our actions are free, and such that we can be held responsible for them, even if they are the necessary effects of casual processes. This volume will be of interest not only to those who are primarily concerned with philosophy but also to students in those many other disciplines in which freedom and determinism arise as problems.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781317516132"
            },
            {
              "type": "ISBN_10",
              "identifier": "1317516133"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 216,
          "printType": "BOOK",
          "categories": [
            "Philosophy"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.0.1.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=4BrICQAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=4BrICQAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=4BrICQAAQBAJ&pg=PT216&dq=Action&hl=&cd=17&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=4BrICQAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=4BrICQAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 3922.32,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 3922.32,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=4BrICQAAQBAJ&rdid=book-4BrICQAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 3922320000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 3922320000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Essays_on_Freedom_of_Action_Routledge_Re-sample-pdf.acsm?id=4BrICQAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=4BrICQAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "(a) For the most part, statutes require for conviction that it be established that a man intended to perform a prohibited \u003cb\u003eaction\u003c/b\u003e or at least was negligent about avoiding it. Other statutes, notably those which are interpreted as&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "oDqDAgAAQBAJ",
        "etag": "mtBP8hiJwe0",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/oDqDAgAAQBAJ",
        "volumeInfo": {
          "title": "Action Research",
          "subtitle": "Principles and Practice",
          "authors": [
            "Jean McNiff"
          ],
          "publisher": "Routledge",
          "publishedDate": "2002-01-22",
          "description": "Since the first edition of this established text was published in 1988, action research has gained ground as a popular method amongst educational researchers, and in particular for practising teachers doing higher-level courses. In this new edition Jean McNiff provides updates on methodological discussions and includes new sections of case study material and information on supporting action research. The book raises issues about how action research is theorised, whether it is seen as a spectator discipline or as a real life practice, and how practitioners position themselves within the debate. It discusses the importance for educators of understanding their own work and showing how their educative influence can lead to the development of good orders in formal and informal learning settings and in the wider community. This second edition comes at a time when, after years of debate over what counts as action research, it is now considered an acceptable and useful part of mainstream research practice.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781134600847"
            },
            {
              "type": "ISBN_10",
              "identifier": "1134600844"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 176,
          "printType": "BOOK",
          "categories": [
            "Education"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=oDqDAgAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=oDqDAgAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=oDqDAgAAQBAJ&pg=PT74&dq=Action&hl=&cd=18&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=oDqDAgAAQBAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Action_Research.html?hl=&id=oDqDAgAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Action_Research-sample-epub.acsm?id=oDqDAgAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Action_Research-sample-pdf.acsm?id=oDqDAgAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=oDqDAgAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "category, \u003cb\u003eaction\u003c/b\u003e research is a methodologythatis developed fromwithin practice, a processof trying to understand howvaluesmay be lived in practice.There isalso debate between the different members of thebroadaction research family about&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "MJveDwAAQBAJ",
        "etag": "BTu1JUk9mqI",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/MJveDwAAQBAJ",
        "volumeInfo": {
          "title": "SDG13 - Climate Action",
          "subtitle": "Combatting Climate Change and its Impacts",
          "authors": [
            "Federica Doni",
            "Andrea Gasperini",
            "João Torres Soares"
          ],
          "publisher": "Emerald Group Publishing",
          "publishedDate": "2020-04-28",
          "description": "SDG13 - Climate Action: Combatting Climate Change and its Impacts will consider empirical and science-based analysis to explore a wide range of practical implementation tools and mechanisms, enabling conditions, and monitoring and reporting tools, to demonstrate the potential innovation in implementing SDG13.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781787569171"
            },
            {
              "type": "ISBN_10",
              "identifier": "1787569179"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 112,
          "printType": "BOOK",
          "categories": [
            "Science"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=MJveDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=MJveDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=MJveDwAAQBAJ&pg=PT29&dq=Action&hl=&cd=19&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=MJveDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=MJveDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 3179.44,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 3179.44,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=MJveDwAAQBAJ&rdid=book-MJveDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 3179440000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 3179440000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/SDG13_Climate_Action-sample-epub.acsm?id=MJveDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/SDG13_Climate_Action-sample-pdf.acsm?id=MJveDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=MJveDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "To ensure major implementation of goal 13 by governments in different countries, it is important to implement climate \u003cb\u003eactions\u003c/b\u003e through other goals by sustainable development approaches. To support countries in reaching the SDG 13 targets&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "LSzDDwAAQBAJ",
        "etag": "LLfcCNqfB5A",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/LSzDDwAAQBAJ",
        "volumeInfo": {
          "title": "Quick Action",
          "authors": [
            "Robert W. Chambers"
          ],
          "publisher": "Good Press",
          "publishedDate": "2021-04-25",
          "description": "\"Quick Action\" by Robert W. Chambers. Published by Good Press. Good Press publishes a wide range of titles that encompasses every genre. From well-known classics & literary fiction and non-fiction to forgotten−or yet undiscovered gems−of world literature, we issue the books that need to be read. Each Good Press edition has been meticulously edited and formatted to boost readability for all e-readers and devices. Our goal is to produce eBooks that are user-friendly and accessible to everyone in a high-quality digital format.",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "EAN:4064066236960"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 821,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.4.5.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=LSzDDwAAQBAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=LSzDDwAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=LSzDDwAAQBAJ&dq=Action&hl=&cd=20&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=LSzDDwAAQBAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Quick_Action.html?hl=&id=LSzDDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true
          },
          "pdf": {
            "isAvailable": true
          },
          "webReaderLink": "http://play.google.com/books/reader?id=LSzDDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "&quot;Quick Action&quot; by Robert W. Chambers."
        }
      },
      {
        "kind": "books#volume",
        "id": "oHSyDwAAQBAJ",
        "etag": "xhsCmI0O5PU",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/oHSyDwAAQBAJ",
        "volumeInfo": {
          "title": "Western Pacific Regional Framework for Action on Health and Environment on a Changing Planet",
          "authors": [
            "Who Regional Office for the Western Paci"
          ],
          "publisher": "World Health Organization",
          "publishedDate": "2018-06",
          "description": "Environmental determinants of health are responsible for more than a quarter of the burden of disease in the Western Pacific Region. Communicable and noncommunicable disease, disability and death result from a lack of safe water and sanitation, indoor and outdoor air pollution, hazardous chemicals, occupational hazards and climate-related disasters. The Western Pacific Regional Framework for Action on Health and Environment on a Changing Planetintends to relaunch the World Health Organization (WHO)'s Health and the Environment program and fulfill its mandate in the area of environmental health. It proposes to leverage the health sector focus on the Sustainable Development Goals (SDGs) process, providing guidance for prioritizing the work of WHO in support of Member States improving health outcomes through action on environmental determinants. It articulates entry points for health and environment priority actions in WHO country cooperation strategies, the United Nations Framework Convention on Climate Change and other mechanisms for international collaboration, and notably with the United Nations Environment Program and ministries of environment. The framework also sets a course for the health sector to advocate adaptive measures, policies and action to protect health and well-being as a co-benefit of interventions in energy, agriculture, transport, housing and other spheres.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789290618164"
            },
            {
              "type": "ISBN_10",
              "identifier": "9290618167"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 41,
          "printType": "BOOK",
          "categories": [
            "Business & Economics"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=oHSyDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=oHSyDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=oHSyDwAAQBAJ&pg=PA14&dq=Action&hl=&cd=21&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=oHSyDwAAQBAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Western_Pacific_Regional_Framework_for_A.html?hl=&id=oHSyDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "ALL_PAGES",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=oHSyDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Western Pacific Regional Gramework for \u003cb\u003eAction\u003c/b\u003e on Health and Environment on a Changing Planet VISION Healthier people and healthier environments on a changing planet. OBJECTIVE Development Goals STRATEGIC \u003cb\u003eACTION\u003c/b\u003e 1 Governance and&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "xsvsngEACAAJ",
        "etag": "Q/A4fhsXRQM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/xsvsngEACAAJ",
        "volumeInfo": {
          "title": "Mongodb in Action",
          "authors": [
            "Kyle Banker",
            "Peter Bakkum",
            "Tim Hawkins",
            "Shaun Verch",
            "Doug Garrett"
          ],
          "publisher": "Manning Publications",
          "publishedDate": "2015-01-15",
          "description": "Application developers love MongoDB, a document-oriented NoSQL database, for its speed, flexibility, scalability, and ease of use. MongoDB is well-suited as a back-end for modern web applications. Its schema-free design encourages rapid application development, and built-in replication and auto-sharding architecture allow for massive parallel distribution. Production deployments at SourceForge, Foursquare, and Shutterfly demonstrate daily that MongoDB is up to real-world challenges. MongoDB in Action, Second Edition is a comprehensive guide to MongoDB version 2.6. It begins with a general overview of current database systems, explaining what makes MongoDB unique and describing its ideal use cases. Then, a series of tutorials lead into detailed examples for leveraging MongoDB in e-commerce, social networking, and other common applications. A reference section on schema design patterns helps ease the transition from the relational data model of SQL to MongoDB's document-based data model. Purchase of the print book comes with an offer of a free PDF, ePub, and Kindle eBook from Manning. Also available is all code from the book.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1617291609"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781617291609"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 375,
          "printType": "BOOK",
          "categories": [
            "Computers"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=xsvsngEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=xsvsngEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=xsvsngEACAAJ&dq=Action&hl=&cd=22&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=xsvsngEACAAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Mongodb_in_Action.html?hl=&id=xsvsngEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=xsvsngEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "MongoDB 3.0 is flexible, scalable, and very fast, even with big data loads. About the Book MongoDB in Action, Second Edition is a completely revised and updated version. It introduces MongoDB 3.0 and the document-oriented database model."
        }
      },
      {
        "kind": "books#volume",
        "id": "wQ7iCwAAQBAJ",
        "etag": "/7SHP1rL5pg",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/wQ7iCwAAQBAJ",
        "volumeInfo": {
          "title": "The Taking Action Guide to Building Coherence in Schools, Districts, and Systems",
          "authors": [
            "Michael Fullan"
          ],
          "publisher": "Corwin Press",
          "publishedDate": "2016-04-28",
          "description": "Get there faster: Your road map to smart, sustainable change! Taking Action is a hands-on guide to the groundbreaking book, Coherence: The Right Drivers in Action for Schools, Districts and Systems, providing step-by-step protocols to help foster deep coherence for maximum student learning—all within a reasonably short time frame. You’ll develop: Deeper understanding of The Coherence Framework A 100-Day Coherence Plan Leadership, capacity, and coalition-building skills Systems and tools to assess your organization Includes video links, print resources, case studies, and diagnostic and planning tools. Fostering greater coherence is at your fingertips with this instant action guide!",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781506350363"
            },
            {
              "type": "ISBN_10",
              "identifier": "1506350364"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 96,
          "printType": "BOOK",
          "categories": [
            "Education"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.4.4.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=wQ7iCwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=wQ7iCwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=wQ7iCwAAQBAJ&pg=PT91&dq=Action&hl=&cd=23&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=wQ7iCwAAQBAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_Taking_Action_Guide_to_Building_Cohe.html?hl=&id=wQ7iCwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/The_Taking_Action_Guide_to_Building_Cohe-sample-epub.acsm?id=wQ7iCwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/The_Taking_Action_Guide_to_Building_Cohe-sample-pdf.acsm?id=wQ7iCwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=wQ7iCwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Taking \u003cb\u003eAction\u003c/b\u003e Protocol 61 32. Coherence Progression Protocol 63 33. Coherence Planning Protocol 73 Synthesizing \u003cb\u003eActions\u003c/b\u003e for Each Chapter 31. Taking \u003cb\u003eAction\u003c/b\u003e Protocol Purpose Identify key \u003cb\u003eactions\u003c/b\u003e for the school or district for each&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "mrbODQAAQBAJ",
        "etag": "TDVQO7CfCCk",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/mrbODQAAQBAJ",
        "volumeInfo": {
          "title": "Metrics That Matter for Population Health Action",
          "subtitle": "Workshop Summary",
          "authors": [
            "National Academies of Sciences, Engineering, and Medicine",
            "Institute of Medicine",
            "Board on Population Health and Public Health Practice",
            "Roundtable on Population Health Improvement"
          ],
          "publisher": "National Academies Press",
          "publishedDate": "2017-01-28",
          "description": "In times of rapid change and constrained resources, measures that are important, focused, and reliable are vital. However there is an overabundance of measures available for evaluating various aspects of population health and previous efforts to simplify existing sets to meet the needs of all decision makers have been unsuccessful. The National Academies of Sciences, Engineering, and Medicine convened a workshop to explore the status and uses of measures and measurement in the work of improving population health. Participants explored existing and emerging population health metric sets and characteristics of metrics necessary for stakeholder action across multiple sectors. This report summarizes the presentations and discussions from the workshop.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780309391535"
            },
            {
              "type": "ISBN_10",
              "identifier": "0309391539"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 140,
          "printType": "BOOK",
          "categories": [
            "Medical"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.132.1.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=mrbODQAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=mrbODQAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=mrbODQAAQBAJ&pg=PA31&dq=Action&hl=&cd=24&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=mrbODQAAQBAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Metrics_That_Matter_for_Population_Healt.html?hl=&id=mrbODQAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=mrbODQAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "THE METRICS LANDSCAPE 31 income—that it believes will address some of the issues around income inequality and that may help understand \u003cb\u003eactions\u003c/b\u003e that can improve life conditions in a community without gentrification."
        }
      },
      {
        "kind": "books#volume",
        "id": "EuM2DwAAQBAJ",
        "etag": "HBwovGf22Sw",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/EuM2DwAAQBAJ",
        "volumeInfo": {
          "title": "Action Learning in Health, Social and Community Care",
          "subtitle": "Principles, Practices and Resources",
          "authors": [
            "John Edmonstone"
          ],
          "publisher": "CRC Press",
          "publishedDate": "2017-09-22",
          "description": "This comprehensive guide covers all aspects of action learning, one of the most widely used development methods in health, social and community care. The book addresses the theory and practice of action learning in these fields, and considers action learning as an adult educational ethos as well as a helpful tool. Based upon emerging experience, it identifies good practice in action learning and offers a wide range of resources to enable individuals and organisations extract maximum benefit from this approach. Offering practical tips grounded in sound educational principles, this book is invaluable reading for all senior managers and professionals considering using action learning for leadership, management and organisation development purposes, including organisation development practitioners and action learning facilitators, and for medical and healthcare educators and their counterparts in social and community care looking for a general introduction to this growing field.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781351970891"
            },
            {
              "type": "ISBN_10",
              "identifier": "1351970895"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 197,
          "printType": "BOOK",
          "categories": [
            "Medical"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.2.4.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=EuM2DwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=EuM2DwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=EuM2DwAAQBAJ&pg=PT247&dq=Action&hl=&cd=25&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=EuM2DwAAQBAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Action_Learning_in_Health_Social_and_Com.html?hl=&id=EuM2DwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Action_Learning_in_Health_Social_and_Com-sample-epub.acsm?id=EuM2DwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Action_Learning_in_Health_Social_and_Com-sample-pdf.acsm?id=EuM2DwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=EuM2DwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "\u003cb\u003eAction\u003c/b\u003e planning What is it? A list of the major and minor activities which have to be carried out in order to achieve an intended goal. Why would I use it? Unless the \u003cb\u003eactions\u003c/b\u003e which need to be taken are &#39;tied down&#39;, then there is a&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "DygoAQAAMAAJ",
        "etag": "54dFUGWLhRE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/DygoAQAAMAAJ",
        "volumeInfo": {
          "title": "The European Union Mine Actions in ...",
          "publishedDate": "2001",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "IND:30000092610066"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "categories": [
            "Explosive ordnance disposal"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.2.1.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=DygoAQAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=DygoAQAAMAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=DygoAQAAMAAJ&q=Action&dq=Action&hl=&cd=26&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=DygoAQAAMAAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_European_Union_Mine_Actions_in.html?hl=&id=DygoAQAAMAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=DygoAQAAMAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This effort is coordinated with the European Committee for Standardisation (CEN) and the Geneva International Centre for Humanitarian Demining, the custodian of the International Mine \u003cb\u003eAction\u003c/b\u003e Standards."
        }
      },
      {
        "kind": "books#volume",
        "id": "UTgzEAAAQBAJ",
        "etag": "Ah8Xbyq+VUE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/UTgzEAAAQBAJ",
        "volumeInfo": {
          "title": "Microservices in Action",
          "authors": [
            "Morgan Bruce",
            "Paulo A Pereira"
          ],
          "publisher": "Simon and Schuster",
          "publishedDate": "2018-10-03",
          "description": "Summary Microservices in Action is a practical book about building and deploying microservice-based applications. Written for developers and architects with a solid grasp of service-oriented development, it tackles the challenge of putting microservices into production. Purchase of the print book includes a free eBook in PDF, Kindle, and ePub formats from Manning Publications. About the Technology Invest your time in designing great applications, improving infrastructure, and making the most out of your dev teams. Microservices are easier to write, scale, and maintain than traditional enterprise applications because they're built as a system of independent components. Master a few important new patterns and processes, and you'll be ready to develop, deploy, and run production-quality microservices. About the Book Microservices in Action teaches you how to write and maintain microservice-based applications. Created with day-to-day development in mind, this informative guide immerses you in real-world use cases from design to deployment. You'll discover how microservices enable an efficient continuous delivery pipeline, and explore examples using Kubernetes, Docker, and Google Container Engine. What's inside An overview of microservice architecture Building a delivery pipeline Best practices for designing multi-service transactions and queries Deploying with containers Monitoring your microservices About the Reader Written for intermediate developers familiar with enterprise architecture and cloud platforms like AWS and GCP. About the Author Morgan Bruce and Paulo A. Pereira are experienced engineering leaders. They work daily with microservices in a production environment, using the techniques detailed in this book. Table of Contents PART 1 - The lay of the land Designing and running microservices Microservices at SimpleBank PART 2 - Design Architecture of a microservice application Designing new features Transactions and queries in microservices Designing reliable services Building a reusable microservice framework PART 3 - Deployment Deploying microservices Deployment with containers and schedulers Building a delivery pipeline for microservices PART 4 - Observability and ownership Building a monitoring system Using logs and traces to understand behavior Building microservice teams",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781638356066"
            },
            {
              "type": "ISBN_10",
              "identifier": "1638356068"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 392,
          "printType": "BOOK",
          "categories": [
            "Computers"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.2.2.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=UTgzEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=UTgzEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=UTgzEAAAQBAJ&pg=PP1&dq=Action&hl=&cd=27&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=UTgzEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=UTgzEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 2624.32,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 2624.32,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=UTgzEAAAQBAJ&rdid=book-UTgzEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 2624320000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 2624320000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED_FOR_ACCESSIBILITY",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Microservices_in_Action-sample-epub.acsm?id=UTgzEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=UTgzEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "About the Book Microservices in Action teaches you how to write and maintain microservice-based applications."
        }
      },
      {
        "kind": "books#volume",
        "id": "RNZCQAAACAAJ",
        "etag": "+stFLKuIW0E",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/RNZCQAAACAAJ",
        "volumeInfo": {
          "title": "I Am Jackie Chan",
          "subtitle": "My Life in Action",
          "authors": [
            "Long Cheng",
            "Jeff Yang"
          ],
          "publishedDate": "1998",
          "description": "The action-movie superstar known for his death-defying martial arts stunts, as well as his slapstick comedy, charts his rise from Hong Kong, where he was trained in Chinese opera, to Hollywood, where he has broken every bone in his body. Tour.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "0345415035"
            },
            {
              "type": "ISBN_13",
              "identifier": "9780345415035"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 356,
          "printType": "BOOK",
          "categories": [
            "Biography & Autobiography"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=RNZCQAAACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=RNZCQAAACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=RNZCQAAACAAJ&dq=Action&hl=&cd=28&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=RNZCQAAACAAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/I_Am_Jackie_Chan.html?hl=&id=RNZCQAAACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=RNZCQAAACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Tour. In I AM JACKIE CHAN, Chan tells the fascinating, harrowing, ultimately triumphant story of his life: How the rebellious son of refugees in tumultuous 1950s Hong Kong became the disciplined disciple of a Chinese opera master."
        }
      },
      {
        "kind": "books#volume",
        "id": "qJgMBwAAQBAJ",
        "etag": "mP+3ENAgWCo",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/qJgMBwAAQBAJ",
        "volumeInfo": {
          "title": "From Science to Action? 100 Years Later - Alcohol Policies Revisited",
          "authors": [
            "Richard Müller",
            "Harald Klingemann"
          ],
          "publisher": "Springer Science & Business Media",
          "publishedDate": "2007-05-08",
          "description": "Alcohol has been central to social, religious and personal use throughout the history. Alcohol drinking goes back almost as far as the human race does. A hundred years, therefore, may be seen as only a flash. The past century, however, has witnessed a fundamental change in dealing with alcohol problems. Hence, to give an overview of a hundred years of alcohol polices is a rather ambitious task and the contributions to this book shed only some light on the way in which alcohol policy issues have changed in this period. This authoritative volume is relevant to both scientists and policy makers providing a state of the art in alcohol policy from different perspectives, covering both science/research/treatment and prevention practice and linking these areas.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781402026058"
            },
            {
              "type": "ISBN_10",
              "identifier": "1402026056"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 192,
          "printType": "BOOK",
          "categories": [
            "Psychology"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.3.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=qJgMBwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=qJgMBwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=qJgMBwAAQBAJ&pg=PA9&dq=Action&hl=&cd=29&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=qJgMBwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=qJgMBwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 7563.8,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 7563.8,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=qJgMBwAAQBAJ&rdid=book-qJgMBwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 7563800000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 7563800000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/From_Science_to_Action_100_Years_Later_A-sample-epub.acsm?id=qJgMBwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/From_Science_to_Action_100_Years_Later_A-sample-pdf.acsm?id=qJgMBwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=qJgMBwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The resolution and call for \u003cb\u003eaction\u003c/b\u003e sought a common BAC limit, and a Commission proposal for a Council directive was presented in 1988, but it was stalemated in the Council (Sutton &amp; Nylander, 1999, 79). Alcohol-related problems were&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "erhC5I4pD3cC",
        "etag": "GWDgu+eW5BA",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/erhC5I4pD3cC",
        "volumeInfo": {
          "title": "A Bias for Action",
          "subtitle": "How Effective Managers Harness Their Willpower, Achieve Results, and Stop Wasting Time",
          "authors": [
            "Heike Bruch",
            "Sumantra Ghoshal"
          ],
          "publisher": "Harvard Business Press",
          "publishedDate": "2004",
          "description": "Annotation.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1591394082"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781591394082"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 212,
          "printType": "BOOK",
          "categories": [
            "Business & Economics"
          ],
          "averageRating": 4.5,
          "ratingsCount": 2,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.0.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=erhC5I4pD3cC&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=erhC5I4pD3cC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=erhC5I4pD3cC&printsec=frontcover&dq=Action&hl=&cd=30&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=erhC5I4pD3cC&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/A_Bias_for_Action.html?hl=&id=erhC5I4pD3cC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/A_Bias_for_Action-sample-pdf.acsm?id=erhC5I4pD3cC&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=erhC5I4pD3cC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Annotation."
        }
      },
      {
        "kind": "books#volume",
        "id": "tLDJR2bNOQwC",
        "etag": "uDK/7QUJ0Cw",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/tLDJR2bNOQwC",
        "volumeInfo": {
          "title": "Cost of Implementing Protective Action Guides for Food",
          "authors": [
            "Byron Bunger"
          ],
          "publishedDate": "1990",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "UCR:31210012658967"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 53,
          "printType": "BOOK",
          "categories": [
            "Food contamination"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.2.3.0.full.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=tLDJR2bNOQwC&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=tLDJR2bNOQwC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=tLDJR2bNOQwC&pg=PA1&dq=Action&hl=&cd=31&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=tLDJR2bNOQwC&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=tLDJR2bNOQwC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FREE",
          "isEbook": true,
          "buyLink": "https://play.google.com/store/books/details?id=tLDJR2bNOQwC&rdid=book-tLDJR2bNOQwC&rdot=1&source=gbs_api"
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "ALL_PAGES",
          "embeddable": true,
          "publicDomain": true,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false,
            "downloadLink": "http://books.google.co.in/books/download/Cost_of_Implementing_Protective_Action_G.epub?id=tLDJR2bNOQwC&hl=&output=epub&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=tLDJR2bNOQwC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "FULL_PUBLIC_DOMAIN",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "INTRODUCTION Protective \u003cb\u003eAction\u003c/b\u003e Guides ( PAGS ) provide direction to public and private sector officials to aid them in making decisions to protect the public in case of accidents that release radiation or radioactive materials to the&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "4TmvDwAAQBAJ",
        "etag": "12UtEIO+bSA",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/4TmvDwAAQBAJ",
        "volumeInfo": {
          "title": "Self-Action Leadership (Volume I)",
          "subtitle": "A Theoretical Framework for Existential Growth",
          "authors": [
            "Jordan R. Jensen"
          ],
          "publisher": "Cambridge Scholars Publishing",
          "publishedDate": "2019-08-30",
          "description": "Self-Action Leadership (Volumes 1 and 2) provides the first, and only, books of their kind in the academic world today. This two volume set single-handedly carves out a new and unique scholarly niche by providing the first comprehensive and secular manual to holistically address society’s universal need for personal leadership and character education. Its single-minded aim is the global promotion and proliferation of leadership, character, and life skills education in nations, communities, organizations, schools, homes, and individual lives everywhere. The concept of Self-Action Leadership (SAL) is rooted in 30 years of extensive research spanning the fields of self-leadership, leadership, action research, character education, and autoethnography. In addition to drawing on the scholarship of these extant fields, SAL simultaneously builds upon them by introducing an original theory and model that executives, administrators, scholars, teachers, and practitioners alike can universally utilize to their own advantages and to the benefit of their colleagues, subordinates, and students. Volume I—The Self-Action Leadership Theory—contains prefacing material for the combined texts. It also includes the first four book sections of the two volume set.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781527539235"
            },
            {
              "type": "ISBN_10",
              "identifier": "1527539237"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 536,
          "printType": "BOOK",
          "categories": [
            "Business & Economics"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.2.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=4TmvDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=4TmvDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=4TmvDwAAQBAJ&pg=PA326&dq=Action&hl=&cd=32&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=4TmvDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=4TmvDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 10727.13,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 10727.13,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=4TmvDwAAQBAJ&rdid=book-4TmvDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 10727130000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 10727130000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Self_Action_Leadership_Volume_I-sample-pdf.acsm?id=4TmvDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=4TmvDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Thus, by expanding our formula slightly, we can determine (as long as we Nnow what the variables are) with a high degree of accuracy2how a personГs future \u003cb\u003eactions\u003c/b\u003e are liNely to unfold. PAST EXPERIENCES PRESENT BELIEFS FUTURE \u003cb\u003eACTIONS\u003c/b\u003e PE&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "5ULNBQAAQBAJ",
        "etag": "UxCW8xQl8L0",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/5ULNBQAAQBAJ",
        "volumeInfo": {
          "title": "Software and Systems Architecture in Action",
          "authors": [
            "Raghvinder S. Sangwan"
          ],
          "publisher": "CRC Press",
          "publishedDate": "2014-10-27",
          "description": "Modern-day projects require software and systems engineers to work together in realizing architectures of large and complex software-intensive systems. To date, the two have used their own tools and methods to deal with similar issues when it comes to the requirements, design, testing, maintenance, and evolution of these architectures. Software and Systems Architecture in Action explores practices that can be helpful in the development of architectures of large-scale systems in which software is a major component. Examining the synergies that exist between the disciplines of software and systems engineering, it presents concepts, techniques, and methods for creating and documenting architectures. The book describes an approach to architecture design that is driven from systemic quality attributes determined from both the business and technical goals of the system, rather than just its functional requirements. This architecture-centric design approach utilizes analytically derived patterns and tactics for quality attributes that inform the architect’s design choices and help shape the architecture of a given system. The book includes coverage of techniques used to assess the impact of architecture-centric design on the structural complexity of a system. After reading the book, you will understand how to create architectures of systems and assess their ability to meet the business goals of your organization. Ideal for anyone involved with large and complex software-intensive systems, the book details powerful methods for engaging the software and systems engineers on your team. The book is also suitable for use in undergraduate and graduate-level courses on software and systems architecture as it exposes students to the concepts and techniques used to create and manage architectures of software-intensive systems.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781439849170"
            },
            {
              "type": "ISBN_10",
              "identifier": "143984917X"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 232,
          "printType": "BOOK",
          "categories": [
            "Business & Economics"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=5ULNBQAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=5ULNBQAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=5ULNBQAAQBAJ&pg=PA167&dq=Action&hl=&cd=33&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=5ULNBQAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=5ULNBQAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 6164.32,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 6164.32,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=5ULNBQAAQBAJ&rdid=book-5ULNBQAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 6164320000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 6164320000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Software_and_Systems_Architecture_in_Act-sample-pdf.acsm?id=5ULNBQAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=5ULNBQAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This conceptual sequence of \u003cb\u003eactions\u003c/b\u003e can serve as a good backdrop to our understanding, and we may be tempted to start putting together our blueprint for implementing the rule manager. There are, however, a few other considerations that&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "O2ozBgAAQBAJ",
        "etag": "9bIBE9yP3SU",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/O2ozBgAAQBAJ",
        "volumeInfo": {
          "title": "All Positive Action Starts with Criticism",
          "subtitle": "Hans Freudenthal and the Didactics of Mathematics",
          "authors": [
            "Sacha la Bastide-van Gemert"
          ],
          "publisher": "Springer",
          "publishedDate": "2015-01-16",
          "description": "This study provides a historical analysis of Freudenthal’s didactic ideas and his didactic career. It is partly biographical, but also contributes to the historiography of mathematics education and addresses closely related questions such as: what is mathematics and where does it start? Which role does mathematics play in society and what influence does it have on the prevailing views concerning its accompanying didactics?. Hans Freudenthal (1905–1990), professor in mathematics, scientist, literator, but above all mathematics-educator, was inextricably linked to the changes which took place in mathematics education and didactics during the second half of the last century. His diversity as a scientist and his inexhaustible efforts to establish the didactics of mathematics as a seriously pursued science, made Freudenthal's influence in this area considerable. He foresaw an essential, practical role for mathematics in everyone’s life, encouraging students to discover and create mathematics themselves, instead of imposing a ready-made mathematical system. The theory of mathematics education thus developed in the Netherlands would gain world fame in the following decades. Today, in the light of the discussions about mathematics education, in which the call for `genuine’ mathematics instead of the so-called 'kindergarten'-mathematics can be heard, Freudenthal's approach seems to be passé. However, the outcome of this study (which is mainly based on documents from Freudenthal’s vast personal archive) shows a more refined picture. The direct identification of 'kindergarten'-mathematics with Freudenthal’s view on mathematics education is not justified. 'Realistic mathematics' as advocated by Freudenthal includes more than just a practical introductory and should, among other things, always aim at teaching 'genuine' mathematics in the end.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789401793346"
            },
            {
              "type": "ISBN_10",
              "identifier": "9401793344"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 386,
          "printType": "BOOK",
          "categories": [
            "Education"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.0.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=O2ozBgAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=O2ozBgAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=O2ozBgAAQBAJ&pg=PA138&dq=Action&hl=&cd=34&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=O2ozBgAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=O2ozBgAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 10926.8,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 10926.8,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=O2ozBgAAQBAJ&rdid=book-O2ozBgAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 10926800000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 10926800000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/All_Positive_Action_Starts_with_Criticis-sample-pdf.acsm?id=O2ozBgAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=O2ozBgAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Balancing contradictions, the pros and cons of certain \u003cb\u003eactions\u003c/b\u003e was not practiced in mathematics and thus Freudenthal stressed unnecessarily: Ik ben nog een keer zo uitvoerig op principiële kwesties 138 6 From Critical Outsider to True&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "w-VgCwAAQBAJ",
        "etag": "ko03CzvkbrE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/w-VgCwAAQBAJ",
        "volumeInfo": {
          "title": "TRUTH IN ACTION",
          "authors": [
            "Mark Westbrook"
          ],
          "publisher": "Lulu.com",
          "publishedDate": "2013",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781291581164"
            },
            {
              "type": "ISBN_10",
              "identifier": "1291581162"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 201,
          "printType": "BOOK",
          "categories": [
            "Acting"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=w-VgCwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=w-VgCwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=w-VgCwAAQBAJ&printsec=frontcover&dq=Action&hl=&cd=35&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=w-VgCwAAQBAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/TRUTH_IN_ACTION.html?hl=&id=w-VgCwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=w-VgCwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "A manual of common sense for actors and those that want to be.&quot;Thank you so much Mark for this fabulous book, I feel elated again and have ditched all the other stuff."
        }
      },
      {
        "kind": "books#volume",
        "id": "Id5GAQAAIAAJ",
        "etag": "PhttXxnhIgg",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/Id5GAQAAIAAJ",
        "volumeInfo": {
          "title": "Real Property Law, Real Property Actions and Proceedings Law, and Related Miscellaneous Statutes, as Amended",
          "authors": [
            "New York (State)."
          ],
          "publishedDate": "1982",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "STANFORD:36105061525742"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "categories": [
            "Real property"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.4.3.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=Id5GAQAAIAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=Id5GAQAAIAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=Id5GAQAAIAAJ&q=Action&dq=Action&hl=&cd=36&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=Id5GAQAAIAAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Real_Property_Law_Real_Property_Actions.html?hl=&id=Id5GAQAAIAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=Id5GAQAAIAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "In an \u003cb\u003eaction\u003c/b\u003e to recover real property or the possession thereof, the person who establishes a legal title to the premises is presumed to have been possessed thereof within the time required by law; and the occupation of the premises by&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "wbMTAAAAQBAJ",
        "etag": "i+Mi/JjGFpk",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/wbMTAAAAQBAJ",
        "volumeInfo": {
          "title": "True Story",
          "subtitle": "How to Combine Story and Action to Transform Your Business",
          "authors": [
            "Ty Montague"
          ],
          "publisher": "Harvard Business Press",
          "publishedDate": "2013",
          "description": "The co-founder of a brand studio describes how businesses can change their marketing strategies to describe and promote their brand's story in an effort to appeal to modern consumers who have become increasingly interested in what a business embodies and represents. 20,000 first printing.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781422170687"
            },
            {
              "type": "ISBN_10",
              "identifier": "1422170683"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 224,
          "printType": "BOOK",
          "categories": [
            "Business & Economics"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.0.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=wbMTAAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=wbMTAAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=wbMTAAAAQBAJ&printsec=frontcover&dq=Action&hl=&cd=37&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=wbMTAAAAQBAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/True_Story.html?hl=&id=wbMTAAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=wbMTAAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The co-founder of a brand studio describes how businesses can change their marketing strategies to describe and promote their brand&#39;s story in an effort to appeal to modern consumers who have become increasingly interested in what a ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "UBWoCgAAQBAJ",
        "etag": "oERcDCFDsZM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/UBWoCgAAQBAJ",
        "volumeInfo": {
          "title": "Excellence Now: Action",
          "authors": [
            "Tom Peters"
          ],
          "publisher": "New Word City",
          "publishedDate": "2015-10-05",
          "description": "In 1982, Tom Peters and Bob Waterman put \"A Bias for Action\" at the top of their list of eight traits of successful companies in their groundbreaking book In Search of Excellence. Given the subsequent acceleration of change, \"A Bias for Action\" would doubtless top a similar list in 2012. Here's Peters' excellent (and beautifully designed) take for today.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781612301952"
            },
            {
              "type": "ISBN_10",
              "identifier": "1612301959"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 207,
          "printType": "BOOK",
          "categories": [
            "Business & Economics"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=UBWoCgAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=UBWoCgAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=UBWoCgAAQBAJ&printsec=frontcover&dq=Action&hl=&cd=38&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=UBWoCgAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=UBWoCgAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 893.55,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 893.55,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=UBWoCgAAQBAJ&rdid=book-UBWoCgAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 893550000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 893550000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true
          },
          "pdf": {
            "isAvailable": true
          },
          "webReaderLink": "http://play.google.com/books/reader?id=UBWoCgAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "In 1982, Tom Peters and Bob Waterman put &quot;A Bias for Action&quot; at the top of their list of eight traits of successful companies in their groundbreaking book In Search of Excellence."
        }
      },
      {
        "kind": "books#volume",
        "id": "qZBEEAAAQBAJ",
        "etag": "eT5qS53pepM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/qZBEEAAAQBAJ",
        "volumeInfo": {
          "title": "The Cambridge Handbook of Class Actions",
          "subtitle": "An International Survey",
          "authors": [
            "Brian T. Fitzpatrick",
            "Randall S. Thomas"
          ],
          "publisher": "Cambridge Law Handbooks",
          "publishedDate": "2021-02-18",
          "description": "International authors describe class action procedure in this concise, comparative, and empirical perspective on aggregate litigation.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781108488587"
            },
            {
              "type": "ISBN_10",
              "identifier": "1108488587"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 450,
          "printType": "BOOK",
          "categories": [
            "Law"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=qZBEEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=qZBEEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=qZBEEAAAQBAJ&pg=PA351&dq=Action&hl=&cd=39&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=qZBEEAAAQBAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_Cambridge_Handbook_of_Class_Actions.html?hl=&id=qZBEEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=qZBEEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The Civil Procedural Law in China devotes two provisions to how joint \u003cb\u003eactions\u003c/b\u003e operate in China. According to §52, if one or both parties to an individual \u003cb\u003eaction\u003c/b\u003e consist of two or more persons and the object of \u003cb\u003eaction\u003c/b\u003e is the same or in&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "DAy1swEACAAJ",
        "etag": "612+uESOEt4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/DAy1swEACAAJ",
        "volumeInfo": {
          "title": "Action Book",
          "authors": [
            "Brian Proctor"
          ],
          "publisher": "Createspace Independent Publishing Platform",
          "publishedDate": "2017-07-31",
          "description": "This book is a pose reference drawing book, showing the anatomy in various action poses. designed for the comic book artist, or anyone wishing to better their skills in anatomy drawing.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1973795515"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781973795513"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 50,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=DAy1swEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=DAy1swEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=DAy1swEACAAJ&dq=Action&hl=&cd=40&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=DAy1swEACAAJ&dq=Action&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Action_Book.html?hl=&id=DAy1swEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=DAy1swEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book is a pose reference drawing book, showing the anatomy in various action poses. designed for the comic book artist, or anyone wishing to better their skills in anatomy drawing."
        }
      },
  {
        "kind": "books#volume",
        "id": "qbSrDwAAQBAJ",
        "etag": "nUBP0FjivwU",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/qbSrDwAAQBAJ",
        "volumeInfo": {
          "title": "A Grammar of Darma",
          "authors": [
            "Christina Willis Oko"
          ],
          "publisher": "BRILL",
          "publishedDate": "2019-08-26",
          "description": "A Grammar of Darma provides a comprehensive description of this threatened Tibeto-Burman language spoken in India’s Himalayan region. The description is based on a corpus that includes natural discourse and elicited data. The analysis is informed by a functional-typological framework.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789004409491"
            },
            {
              "type": "ISBN_10",
              "identifier": "9004409491"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 592,
          "printType": "BOOK",
          "categories": [
            "Language Arts & Disciplines"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=qbSrDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=qbSrDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=qbSrDwAAQBAJ&printsec=frontcover&dq=Darma&hl=&cd=1&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=qbSrDwAAQBAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/A_Grammar_of_Darma.html?hl=&id=qbSrDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=qbSrDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "A Grammar of Darma provides a comprehensive description of this threatened Tibeto-Burman language spoken in India’s Himalayan region."
        }
      },
      {
        "kind": "books#volume",
        "id": "b8_tCAAAQBAJ",
        "etag": "OLBXO6DeEmg",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/b8_tCAAAQBAJ",
        "volumeInfo": {
          "title": "The Romance of King Aṅliṅ Darma in Javanese Literature",
          "authors": [
            "Gerardus Willebrordus Joannes Drewes"
          ],
          "publisher": "Springer",
          "publishedDate": "2013-12-14",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789401768221"
            },
            {
              "type": "ISBN_10",
              "identifier": "9401768226"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 375,
          "printType": "BOOK",
          "categories": [
            "Foreign Language Study"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=b8_tCAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=b8_tCAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=b8_tCAAAQBAJ&pg=PA21&dq=Darma&hl=&cd=2&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=b8_tCAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=b8_tCAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 6726,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 6726,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=b8_tCAAAQBAJ&rdid=book-b8_tCAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 6726000000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 6726000000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/The_Romance_of_King_A%E1%B9%85li%E1%B9%85_Darma_in_J-sample-pdf.acsm?id=b8_tCAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=b8_tCAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The name of the father of Añlin \u003cb\u003eDarma\u003c/b\u003e in the socalled “major Sérat Kanda” (Jav. MS. Bat. Gen. No. 7), for instance, is Pañcadriya, whilst in that same text Anlin \u003cb\u003eDarma&#39;s\u003c/b\u003e name as a boy is Añlin Driya. In the tale itself Añlin Driya is&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "nU5cAQAACAAJ",
        "etag": "1kiiR0LSGwM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/nU5cAQAACAAJ",
        "volumeInfo": {
          "title": "A Descriptive Grammar of Darma",
          "subtitle": "An Endangered Tibeto-Burman Language",
          "authors": [
            "Christina Marie Willis"
          ],
          "publishedDate": "2007",
          "description": "This dissertation is a description of Darma, an under-documented Tibeto-Burman language spoken in the eastern corner of the state of Uttarakhand, India. With fewer than 2,600 speakers and no writing system, Darma is considered endangered. This is the most comprehensive description of Darma to date. Like the other Himalayan languages, the genetic classification of Darma has not been definitively determined. It is widely described as a western Himalayish language that is closely related to Byansi, Chaudangsi and Rangkas (the latter being extinct). The data presented in this dissertation were obtained through three methodologies: direct elicitation, participant observation, and the discourse-centered approach to data collection advocated by University of Texas linguistic anthropologist Joel Sherzer. The discourse-centered methodology relies on naturally occurring speech, including conversation, stories, songs and public dialogues. The resulting data are contextualized in a cultural framework, which is useful to linguists and anthropologists alike; and the majority of examples presented come from these texts. The dissertation is presented in five sections with a total of nineteen chapters and a glossary. The first section provides background information on the Darma people, the language, and how this project came about. The second section describes the sound system of Darma, including its typologically unusual class of oral stops. The third section introduces the words that comprise a noun phrase including nouns, personal pronouns, and pronominal demonstrative forms, which are marked on a spatial axis (e.g. proximate, neutral, distal, and non-visible). The fourth section examines the affixes that combine with verb stems to form clauses and sentences. This includes a discussion of the basic SV/AOV constituent order, and the ergative/absolutive alignment system. Here nominalization/relativization, a common feature of Tibeto-Burman languages, is also presented along with the clause chaining strategy commonly found in narrative discourse. The analysis for this dissertation is informed by a functional-typological perspective, and an effort has been made to capture general patterns found in the grammar. The goals are to provide a description of the grammar of Darma in a format that is accessible to many, and to avoid relying on any overly specific theoretical framework that may become obsolete.",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OCLC:263979550"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 1194,
          "printType": "BOOK",
          "categories": [
            "Darma language"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=nU5cAQAACAAJ&dq=Darma&hl=&cd=3&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=nU5cAQAACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/A_Descriptive_Grammar_of_Darma.html?hl=&id=nU5cAQAACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=nU5cAQAACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "With fewer than 2,600 speakers and no writing system, Darma is considered endangered. This is the most comprehensive description of Darma to date."
        }
      },
      {
        "kind": "books#volume",
        "id": "N7ZxMwEACAAJ",
        "etag": "lXgWcCY4qSA",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/N7ZxMwEACAAJ",
        "volumeInfo": {
          "title": "The Elements of Darma",
          "authors": [
            "J. L. Styan"
          ],
          "publishedDate": "1967",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OCLC:796889330"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 306,
          "printType": "BOOK",
          "categories": [
            "Darma"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=N7ZxMwEACAAJ&dq=Darma&hl=&cd=4&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=N7ZxMwEACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_Elements_of_Darma.html?hl=&id=N7ZxMwEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=N7ZxMwEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "q1yHDwAAQBAJ",
        "etag": "HD4zMrkcwgo",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/q1yHDwAAQBAJ",
        "volumeInfo": {
          "title": "Learning from the Best",
          "subtitle": "Best Practices from Professor Sri Darma",
          "authors": [
            "I.B. Arya Lawa Manuaba, S.Pd., M.Pd."
          ],
          "publisher": "Nilacakra",
          "publishedDate": "2019-02-18",
          "description": "Apabila kamu ingin sungguh-sungguh belajar, maka kamu memerlukan contoh yang terbaik. Kisah hidup, perjuangan, kerja keras, dilema dan keputusan besar yang diambil oleh orang-orang hebat ini telah menginspirasi dan menggerakkan banyak orang. Figur-figur yang mencapai impiannya dengan penuh perjuangan adalah aset karakter bagi generasi kini dan yang akan datang. Salah satu aset karakter itu kini ada juga di Bali. Di tengah gejolak zaman yang makin garang, di mana anak-anak muda kehilangan karakter, kamu masih bisa belajar dari tokoh-tokoh hebat yang telah berproses lebih dulu. Anak-anak muda kini memerlukan mentor yang tepat dan tempat yang tepat untuk belajar dan mengambil teladan. Orang-orang hebat itu bisa jadi salah satu panutanmu. Buku kecil ini mencatat best practices, kesan-kesan pengalaman alur kehidupan Prof. Gede Sri Darma, rektor dan profesor termuda yang pernah dimiliki Bali dan Indonesia. Kamu yang mulai putus asa, kehilangan harapan dan patah semangat bisa membaca kisah hidupnya yang penuh intrik dan suka-duka. Dari sana, kamu bisa sadar bahwa selalu ada harapan di balik setiap peristiwa kelam dalam hidupmu. Jadi, bangkitlah lagi dan belajarlah!",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9786025375828"
            },
            {
              "type": "ISBN_10",
              "identifier": "6025375828"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 164,
          "printType": "BOOK",
          "categories": [
            "Biography & Autobiography"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=q1yHDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=q1yHDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "id",
          "previewLink": "http://books.google.co.in/books?id=q1yHDwAAQBAJ&printsec=frontcover&dq=Darma&hl=&cd=5&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=q1yHDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=q1yHDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 403.66,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 282.56,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=q1yHDwAAQBAJ&rdid=book-q1yHDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 403660000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 282560000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Learning_from_the_Best-sample-pdf.acsm?id=q1yHDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=q1yHDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Apabila kamu ingin sungguh-sungguh belajar, maka kamu memerlukan contoh yang terbaik."
        }
      },
      {
        "kind": "books#volume",
        "id": "5HTTuQEACAAJ",
        "etag": "ig20uDrr5vo",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/5HTTuQEACAAJ",
        "volumeInfo": {
          "title": "Darma Sembada",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OCLC:1042029522"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=5HTTuQEACAAJ&dq=Darma&hl=&cd=6&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=5HTTuQEACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Darma_Sembada.html?hl=&id=5HTTuQEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=5HTTuQEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "qVKMAAAAQBAJ",
        "etag": "Ijf6c9jZiB0",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/qVKMAAAAQBAJ",
        "volumeInfo": {
          "title": "Code 3",
          "subtitle": "The Rise & Fall of a Private Ambulance Empire",
          "authors": [
            "Sean C. Cusack"
          ],
          "publisher": "Xlibris Corporation",
          "publishedDate": "2008-05-31",
          "description": "The year was 1995 and three very successful private ambulance companies joined forces in a mammoth merger to thwart the impending threat of FMR (Frequent Medical Response), the U.S.A.s largest nationally based private ambulance company. Power Ambulance from Chicago, Reagan-Stiller Ambulance from Greater Chicagoland, and Baileys Ambulance from southern Illinois and Indiana combined forces to become Tri*Medic Transport Incorporated. Code 3: The Rise & Fall of a Private Ambulance Empire proves that people from all walks of life are attracted to the strange realm that is Emergency Medical Services (E.M.S.). But like average employees, many of them come and go. Like druggies, they get their quick fix and then they leave. E.M.S. sees them come and go like the motions of the ocean. But what they leave behind are their unforgettable stories. Code 3: The Rise & Fall of a Private Ambulance Empire is not your typical novel about the heroisms of what takes place in the back of an ambulance, rather, Code 3 takes you on a fast-paced lights and sirens ride through the delightful disgraces that are hidden well from the public eye. The tribulations of the mighty E.M.S. Tri*Medic are well chronicled in this in-depth partisan culture of the unique private ambulance company world. Code 3: The Rise & Fall of a Private Ambulance Empire is a dauntless expos of Nazi Germany and the Titanic Disaster, uniquely intertwined in the unforgiving E.M.S. field of battle. Code 3 is set inside a huge garage on the north side of Chicago that is a branch of the massive private ambulance company merger. It was inside this garage that most of the mayhem took place, making for an unforgettable reading experience. Like the stories and characters involved in the inception of this novel, you will never forget it.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781469100715"
            },
            {
              "type": "ISBN_10",
              "identifier": "1469100711"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 448,
          "printType": "BOOK",
          "categories": [
            "Biography & Autobiography"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "2.6.6.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=qVKMAAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=qVKMAAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=qVKMAAAAQBAJ&pg=PA185&dq=Darma&hl=&cd=7&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=qVKMAAAAQBAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Code_3.html?hl=&id=qVKMAAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Code_3-sample-epub.acsm?id=qVKMAAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Code_3-sample-pdf.acsm?id=qVKMAAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=qVKMAAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Watching \u003cb\u003eDarma\u003c/b\u003e clean and prepare her MAST room was a sight to be seen. She was laughing and smoking, ordering us around, and blasting her radio whenever the corniest songs came on. I felt like taking that small grungy radio and bashing&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "9FVwAAAAMAAJ",
        "etag": "FnSwST55HoQ",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/9FVwAAAAMAAJ",
        "volumeInfo": {
          "title": "Dwitunggal pendiri Darma Ayu Nagari",
          "subtitle": "Aria Wiralodra (Aria Indrawijaya) & Nyi Endang Darma (Ratu Gandasari)",
          "authors": [
            "H. R. Sutadji K. S."
          ],
          "publishedDate": "2003",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "UOM:39015061604784"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 118,
          "printType": "BOOK",
          "categories": [
            "Indramayu (Indonesia : Kabupaten)"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.2.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=9FVwAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=9FVwAAAAMAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "id",
          "previewLink": "http://books.google.co.in/books?id=9FVwAAAAMAAJ&q=Darma&dq=Darma&hl=&cd=8&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=9FVwAAAAMAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Dwitunggal_pendiri_Darma_Ayu_Nagari.html?hl=&id=9FVwAAAAMAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=9FVwAAAAMAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Aria Wiralodra (Aria Indrawijaya) &amp; Nyi Endang \u003cb\u003eDarma\u003c/b\u003e (Ratu Gandasari) H. R. Sutadji K. S.. i « - i i □ Prakata Bila membaca buku ini, akan anda jumpai beberapa kejadian."
        }
      },
      {
        "kind": "books#volume",
        "id": "SfE3EAAAQBAJ",
        "etag": "FsrWXwquY30",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/SfE3EAAAQBAJ",
        "volumeInfo": {
          "title": "People from Bloomington",
          "authors": [
            "Budi Darma"
          ],
          "publisher": "Penguin",
          "publishedDate": "2022-04-12",
          "description": "An eerie, alienating, yet comic and profoundly sympathetic short story collection about Americans in America by one of Indonesia’s most prominent writers, now in an English translation for its fortieth anniversary, with a foreword by Intan Paramaditha A Penguin Classic In these seven stories of The People from Bloomington, our peculiar narrators find themselves in the most peculiar of circumstances and encounter the most peculiar of people. Set in Bloomington, Indiana, where the author lived as a graduate student in the 1970s, this is far from the idyllic portrait of small-town America. Rather, sectioned into apartment units and rented rooms, and gridded by long empty streets and distances traversable only by car, it’s a place where the solitary can all too easily remain solitary; where people can at once be obsessively curious about others, yet fail to form genuine connections with anyone. The characters feel their loneliness acutely and yet deliberately estrange others. Budi Darma paints a realist world portrayed through an absurdist frame, morbid and funny at the same time. For decades, Budi Darma has influenced and inspired many writers, artists, filmmakers, and readers in Indonesia, yet his stories transcend time and place. With The People from Bloomington, Budi Darma draws us to a universality recognized by readers around the world—the cruelty of life and the difficulties that people face in relating to one another while negotiating their own identities. The stories are not about “strangeness” in the sense of culture, race, and nationality. Instead, they are a statement about how everyone, regardless of nationality or race, is strange, and subject to the same tortures, suspicions, yearnings, and peculiarities of the mind.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780525508106"
            },
            {
              "type": "ISBN_10",
              "identifier": "0525508104"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 208,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=SfE3EAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=SfE3EAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=SfE3EAAAQBAJ&printsec=frontcover&dq=Darma&hl=&cd=9&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=SfE3EAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=SfE3EAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 632.04,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 316.02,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=SfE3EAAAQBAJ&rdid=book-SfE3EAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 632040000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 316020000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/People_from_Bloomington-sample-epub.acsm?id=SfE3EAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=SfE3EAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "An eerie, alienating, yet comic and profoundly sympathetic short story collection about Americans in America by one of Indonesia’s most prominent writers, now in an English translation for its fortieth anniversary, with a foreword by ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "As_4aQjGaUEC",
        "etag": "MH7CNvJlIE8",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/As_4aQjGaUEC",
        "volumeInfo": {
          "title": "The Story of Tibet",
          "subtitle": "Conversations with the Dalai Lama",
          "authors": [
            "Thomas Laird"
          ],
          "publisher": "Open Road + Grove/Atlantic",
          "publishedDate": "2007-12-01",
          "description": "“A memorable and vivid history lesson about a remote mysterious place that, in terms of its sheer survival, has implications for our own lives.” —The Times-Picayune Over the course of three years, journalist Thomas Laird spent more than sixty hours with His Holiness the Dalai Lama in candid, one-on-one interviews that ranged widely, covering not only the history of Tibet but science, reincarnation, and Buddhism. Laird brings these meetings to life in this vibrant, monumental work that outlines the essence of thousands of years of civilization, myth, and spirituality. Tibet’s story is rich with tradition and filled with promise. It begins with the Bodhisattva Chenrizi (“The Holy One”) whose spirit many Tibetans believe resides within the Dalai Lama. We learn the origins of Buddhism, and about the era of Great Tibetan Emperors, whose reign stretched from southwestern China to Northern India. His Holiness introduces us to Tibet’s greatest yogis and meditation masters, and explains how the institution of the Dalai Lama was founded. Laird explores, with His Holiness, Tibet’s relations with the Mongols, the Golden Age under the Great Fifth Dalai Lama, Tibet’s years under Manchu overlords, modern independence in the early twentieth century, and the Dalai Lama’s personal meetings with Mao just before His Holiness fled into exile in 1959. The Story of Tibet is “a tenderly crafted study that is equal parts love letter, traditional history and oral history” (Publishers Weekly). “Captivating reading.” —Tricycle",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781555846725"
            },
            {
              "type": "ISBN_10",
              "identifier": "1555846726"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 496,
          "printType": "BOOK",
          "categories": [
            "Religion"
          ],
          "averageRating": 4.5,
          "ratingsCount": 8,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "2.11.4.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=As_4aQjGaUEC&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=As_4aQjGaUEC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=As_4aQjGaUEC&pg=PA65&dq=Darma&hl=&cd=10&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=As_4aQjGaUEC&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=As_4aQjGaUEC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 503.86,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 251.93,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=As_4aQjGaUEC&rdid=book-As_4aQjGaUEC&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 503860000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 251930000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/The_Story_of_Tibet-sample-epub.acsm?id=As_4aQjGaUEC&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/The_Story_of_Tibet-sample-pdf.acsm?id=As_4aQjGaUEC&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=As_4aQjGaUEC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "In Tibet, the decline into chaos began with Lang \u003cb\u003eDarma&#39;s\u003c/b\u003e bitterness at losing his throne, which was inflamed by an anti-Buddhist sentiment spreading throughout Tibet and China. The two factors doomed both imperial Tibet and \u003cb\u003eDarma&#39;s\u003c/b\u003e&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "jyawCQAAQBAJ",
        "etag": "0HpeQY4smac",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/jyawCQAAQBAJ",
        "volumeInfo": {
          "title": "The Sun Rises",
          "subtitle": "A Shaman’s Chant, Ritual Exchange and Fertility in the Apatani Valley",
          "authors": [
            "Stuart Blackburn"
          ],
          "publisher": "BRILL",
          "publishedDate": "2010-03-02",
          "description": "A shaman chants to make the sun rise in the Apatani valley, high in the eastern Himalayas. A comparative analysis of this oral text, its ritual context and performer reveal the core ideas of local society, including fertility and cohesion.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789047429227"
            },
            {
              "type": "ISBN_10",
              "identifier": "9047429222"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 448,
          "printType": "BOOK",
          "categories": [
            "Social Science"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=jyawCQAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=jyawCQAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=jyawCQAAQBAJ&pg=PA351&dq=Darma&hl=&cd=11&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=jyawCQAAQBAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_Sun_Rises.html?hl=&id=jyawCQAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=jyawCQAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "lolyang ka nanii pa, ngo niikun jaka loder mi, sukun loder mi, dardun ka neku do, arii huron ja, no siitii huron do, amyo hiire si, no siimyo hiire do, niikun \u003cb\u003edarma\u003c/b\u003e do, sukun \u003cb\u003edarma\u003c/b\u003e do, arii soyi si, no dimbo soyi do, amyo sokiir si,&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "-Ij5MQAACAAJ",
        "etag": "00R3lbL/Wfc",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/-Ij5MQAACAAJ",
        "volumeInfo": {
          "title": "Aji Darma",
          "subtitle": "Or. 11.249",
          "authors": [
            "I Ketut Rumiasta (typist.)"
          ],
          "publishedDate": "1939",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OCLC:150317377"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 30,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=-Ij5MQAACAAJ&dq=Darma&hl=&cd=12&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=-Ij5MQAACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Aji_Darma.html?hl=&id=-Ij5MQAACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=-Ij5MQAACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "bY3tuQEACAAJ",
        "etag": "Idrfh8zc7H4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/bY3tuQEACAAJ",
        "volumeInfo": {
          "title": "Darma Kaya Gaguritan",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OCLC:1042036995"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=bY3tuQEACAAJ&dq=Darma&hl=&cd=13&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=bY3tuQEACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Darma_Kaya_Gaguritan.html?hl=&id=bY3tuQEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=bY3tuQEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "u_3KtgAACAAJ",
        "etag": "MhHr4E0Oj2g",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/u_3KtgAACAAJ",
        "volumeInfo": {
          "title": "Kiduṅ Aji Darma",
          "authors": [
            "Kiduṅ Aji Darma"
          ],
          "publishedDate": "1975",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OCLC:251426783"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=u_3KtgAACAAJ&dq=Darma&hl=&cd=14&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=u_3KtgAACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Kidu%E1%B9%85_Aji_Darma.html?hl=&id=u_3KtgAACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=u_3KtgAACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "9z89NQEACAAJ",
        "etag": "voKQ/CW/5ZE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/9z89NQEACAAJ",
        "volumeInfo": {
          "title": "Gaguritan Darma Suniata",
          "subtitle": "Or. 26.451",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OCLC:150327635"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 60,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=9z89NQEACAAJ&dq=Darma&hl=&cd=15&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=9z89NQEACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Gaguritan_Darma_Suniata.html?hl=&id=9z89NQEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=9z89NQEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "iDwCEAAAQBAJ",
        "etag": "xSsmmYfa84I",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/iDwCEAAAQBAJ",
        "volumeInfo": {
          "title": "Darma Wasana",
          "authors": [
            "O S Tjokroaminoto"
          ],
          "publisher": "NV Setija Oesaha, Soerabaia",
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 29,
          "printType": "BOOK",
          "categories": [
            "Social Science"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=iDwCEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=iDwCEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "jw",
          "previewLink": "http://books.google.co.in/books?id=iDwCEAAAQBAJ&printsec=frontcover&dq=Darma&hl=&cd=16&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=iDwCEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=iDwCEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 8.44,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 8.44,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=iDwCEAAAQBAJ&rdid=book-iDwCEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 8440000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 8440000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Darma_Wasana-sample-pdf.acsm?id=iDwCEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=iDwCEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "SNRijwEACAAJ",
        "etag": "UqV37e6iWSE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/SNRijwEACAAJ",
        "volumeInfo": {
          "title": "Darma Da Floresta",
          "publishedDate": "2014",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1784320293"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781784320294"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=SNRijwEACAAJ&dq=Darma&hl=&cd=17&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=SNRijwEACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Darma_Da_Floresta.html?hl=&id=SNRijwEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=SNRijwEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "0nHVCgAAQBAJ",
        "etag": "fduMdYF73Wo",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/0nHVCgAAQBAJ",
        "volumeInfo": {
          "title": "A Fragile Nation",
          "subtitle": "The Indonesian Crisis",
          "authors": [
            "Khoon Choy Lee"
          ],
          "publisher": "World Scientific",
          "publishedDate": "1999-06-02",
          "description": "In May 1998, President Suharto stepped down as President of Indonesia. With his fall, the third largest country in Asia has plunged into anarchy and political, economic and social strife. Racial and religious clashes, culminating in riots, burning and chaos, have become the order of the day. Fissures in the social fabric are widening and there is a real danger that this multi-racial, multi-religious and multi-cultural country may disintegrate, just like Yugoslavia and the Soviet Union. Indonesia today is a fragile nation, a country in crisis. It is breaking apart because just as Sukarno had failed in his interplay of strength between Communism and the armed forces, Suharto failed to keep the balance of power between the armed forces and Islam. Moreover, the Indonesian people, by and large, have lost the spirit of tolerance, symbolised in the Indonesian state crest, Bhinneka Tunggal Ika (Unity in Diversity). Without this spirit, so vital to a multi-religious and plural society, Indonesia is becoming economically ravaged, spiritually plundered, politically distraught, and socially incoherent. The author served as Singapore's Ambassador to Indonesia from 1970 to 1974. His interest in Indonesia began many years ago from 1955, when he had gone to Bandung to cover the Afro-Asian conference as a journalist. As Ambassador, he had the opportunity to travel widely across the country and observe the Indonesians at close quarters. Today, his friends range from President Suharto, Indonesia's military leaders, governors, mayors, to ordinary citizens, journalists, musicians and artists. In this book, he portrays the Indonesian people, their history and their cultural traditions. He provides insightful analyses and perspectives of the political collapse of Suharto and describes the danger facing the country. Describing the diversity in the history, traditions, customs and cultures of the various ethnic groups, he understands Indonesia like no other. Bringing the outsider's clarity of perception and the journalist-diplomat's experience of tradition and history, Lee Khoon Choy speaks with authority and credibility, passion and sensitivity about the challenges facing a vast, heterogeneous country that comprises 336 ethnic groups speaking 250 dialects. Contents:Why Suharto FellThe JavaneseThe SundaneseThe BaduisThe TenggereseThe MadureseThe BalineseThe TimoreseThe ChineseThe MinangkabauThe BataksThe AcehneseThe Orang MelayuThe Bugis and MakassareseThe TorajansThe AmboneseThe BandaneseThe IrianeseThe Dayaks Readership: General. Keywords:",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789814494526"
            },
            {
              "type": "ISBN_10",
              "identifier": "9814494526"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 492,
          "printType": "BOOK",
          "categories": [
            "Business & Economics"
          ],
          "averageRating": 3,
          "ratingsCount": 1,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=0nHVCgAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=0nHVCgAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=0nHVCgAAQBAJ&pg=PA116&dq=Darma&hl=&cd=18&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=0nHVCgAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=0nHVCgAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 1967.47,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 1967.47,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=0nHVCgAAQBAJ&rdid=book-0nHVCgAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 1967470000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 1967470000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/A_Fragile_Nation-sample-pdf.acsm?id=0nHVCgAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=0nHVCgAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "There are other major kebatinan schools such as the Sapta \u003cb\u003eDarma\u003c/b\u003e, Pangestu, Subud and Majapahit Pancasila. Sapta \u003cb\u003eDarma\u003c/b\u003e was founded by Harjosapura, a barber from a village called Para in East Java. Believers of Sapta \u003cb\u003eDarma\u003c/b\u003e say that the&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "w4xD4GOKj7QC",
        "etag": "re6/MZk3toM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/w4xD4GOKj7QC",
        "volumeInfo": {
          "title": "Modeling of Monthly Intermittent Streamflow Processes",
          "authors": [
            "DIANE Publishing Company"
          ],
          "publisher": "DIANE Publishing",
          "publishedDate": "1993-06",
          "description": "Discusses the analysis of water availability in the form of streamflow, which is extremely important for planning and management of water resources, especially in arid and semiarid areas of the world. Graphs and tables.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1568064705"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781568064703"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 153,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.2.3.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=w4xD4GOKj7QC&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=w4xD4GOKj7QC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=w4xD4GOKj7QC&pg=PA4&dq=Darma&hl=&cd=19&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=w4xD4GOKj7QC&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Modeling_of_Monthly_Intermittent_Streamf.html?hl=&id=w4xD4GOKj7QC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "ALL_PAGES",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true
          },
          "webReaderLink": "http://play.google.com/books/reader?id=w4xD4GOKj7QC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "It is noted that the NDARMA has an explicit autoregression autoregression as in the usual ARMA model while the autoregression in the \u003cb\u003eDARMA\u003c/b\u003e process is defined via an autoregressive tail given by Eq . Eq . ( 1.1b ) ."
        }
      },
      {
        "kind": "books#volume",
        "id": "e-lYDnO2MXwC",
        "etag": "ALq4rqzKReA",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/e-lYDnO2MXwC",
        "volumeInfo": {
          "title": "Tibet & Nepal",
          "authors": [
            "Arnold Henry Savage Landor"
          ],
          "publishedDate": "1905",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "HARVARD:32044022644355"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 233,
          "printType": "BOOK",
          "categories": [
            "Nepal"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.5.6.0.full.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=e-lYDnO2MXwC&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=e-lYDnO2MXwC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=e-lYDnO2MXwC&pg=PA197&dq=Darma&hl=&cd=20&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=e-lYDnO2MXwC&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=e-lYDnO2MXwC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FREE",
          "isEbook": true,
          "buyLink": "https://play.google.com/store/books/details?id=e-lYDnO2MXwC&rdid=book-e-lYDnO2MXwC&rdot=1&source=gbs_api"
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "ALL_PAGES",
          "embeddable": true,
          "publicDomain": true,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false,
            "downloadLink": "http://books.google.co.in/books/download/Tibet_Nepal.epub?id=e-lYDnO2MXwC&hl=&output=epub&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "downloadLink": "http://books.google.co.in/books/download/Tibet_Nepal.pdf?id=e-lYDnO2MXwC&hl=&output=pdf&sig=ACfU3U3QqAlKduSot9M-maqUaJT2rNUyqA&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=e-lYDnO2MXwC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "FULL_PUBLIC_DOMAIN",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "THE \u003cb\u003eDARMA\u003c/b\u003e DISTRICT 197 upper ” and ice and mud . To the south - east could be seen one of the high snowy peaks towering over the Rama Glacier to the south of the Lebung . The \u003cb\u003eDarma\u003c/b\u003e Valley , in which we now found ourselves , takes its&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "vNPQDAEACAAJ",
        "etag": "Ze/dZce1Um4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/vNPQDAEACAAJ",
        "volumeInfo": {
          "title": "Yeomans, Darma",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OCLC:733130133"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=vNPQDAEACAAJ&dq=Darma&hl=&cd=21&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=vNPQDAEACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Yeomans_Darma.html?hl=&id=vNPQDAEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=vNPQDAEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "ok9bHAAACAAJ",
        "etag": "847dWna57Yo",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/ok9bHAAACAAJ",
        "volumeInfo": {
          "title": "Darma wasita",
          "authors": [
            "Karel Fredrik Winter"
          ],
          "publishedDate": "1943",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "LCCN:93949813"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 56,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=ok9bHAAACAAJ&dq=Darma&hl=&cd=22&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=ok9bHAAACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Darma_wasita.html?hl=&id=ok9bHAAACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=ok9bHAAACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "5oCsAQAACAAJ",
        "etag": "+rUNEm7Ex4Y",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/5oCsAQAACAAJ",
        "volumeInfo": {
          "title": "Company Profiles: PT Darma Henwa Tbk",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OCLC:958754960"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=5oCsAQAACAAJ&dq=Darma&hl=&cd=23&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=5oCsAQAACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Company_Profiles_PT_Darma_Henwa_Tbk.html?hl=&id=5oCsAQAACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=5oCsAQAACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "3mynQAAACAAJ",
        "etag": "ICsiW1NmxyI",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/3mynQAAACAAJ",
        "volumeInfo": {
          "title": "Angling Darma",
          "subtitle": "",
          "publishedDate": "1853*",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OCLC:57648331"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 8,
          "printType": "BOOK",
          "categories": [
            "Folk literature"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=3mynQAAACAAJ&dq=Darma&hl=&cd=24&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=3mynQAAACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Angling_Darma.html?hl=&id=3mynQAAACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=3mynQAAACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "furluQEACAAJ",
        "etag": "ieqMF6hSYn4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/furluQEACAAJ",
        "volumeInfo": {
          "title": "Aji Darma, didactic and moralistic poem",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OCLC:1041984923"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "language": "jw",
          "previewLink": "http://books.google.co.in/books?id=furluQEACAAJ&dq=Darma&hl=&cd=25&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=furluQEACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Aji_Darma_didactic_and_moralistic_poem.html?hl=&id=furluQEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=furluQEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "8l7buQEACAAJ",
        "etag": "4BsB6Im1vT8",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/8l7buQEACAAJ",
        "volumeInfo": {
          "title": "Darma Putus,Old Javanese didactic religious poem in Indian metres",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OCLC:1041987522"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "language": "jw",
          "previewLink": "http://books.google.co.in/books?id=8l7buQEACAAJ&dq=Darma&hl=&cd=26&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=8l7buQEACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Darma_Putus_Old_Javanese_didactic_religi.html?hl=&id=8l7buQEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=8l7buQEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "oGeanQEACAAJ",
        "etag": "8qGNgzsWMOE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/oGeanQEACAAJ",
        "volumeInfo": {
          "title": "Iphigenie Auf Tauris",
          "subtitle": "A Darma",
          "authors": [
            "Goethe Johann Wolfgang Von 1749-1832",
            "HardPress"
          ],
          "publisher": "Hardpress Publishing",
          "publishedDate": "2013-01",
          "description": "Unlike some other reproductions of classic texts (1) We have not used OCR(Optical Character Recognition), as this leads to bad quality books with introduced typos. (2) In books where there are images such as portraits, maps, sketches etc We have endeavoured to keep the quality of these images, so they represent accurately the original artefact. Although occasionally there may be certain imperfections with these old texts, we feel they deserve to be made available for future generations to enjoy.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1313665894"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781313665896"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 218,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=oGeanQEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=oGeanQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=oGeanQEACAAJ&dq=Darma&hl=&cd=27&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=oGeanQEACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Iphigenie_Auf_Tauris.html?hl=&id=oGeanQEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=oGeanQEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Although occasionally there may be certain imperfections with these old texts, we feel they deserve to be made available for future generations to enjoy."
        }
      },
      {
        "kind": "books#volume",
        "id": "ohQIv7-gdHYC",
        "etag": "U4aJCjwzsJA",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/ohQIv7-gdHYC",
        "volumeInfo": {
          "title": "Darma, das Kaninchen das fliegen konnte",
          "publisher": "AOP-Creatives",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789491619014"
            },
            {
              "type": "ISBN_10",
              "identifier": "9491619012"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.3",
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=ohQIv7-gdHYC&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=ohQIv7-gdHYC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "de",
          "previewLink": "http://books.google.co.in/books?id=ohQIv7-gdHYC&pg=PA14&dq=Darma&hl=&cd=28&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=ohQIv7-gdHYC&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Darma_das_Kaninchen_das_fliegen_konnte.html?hl=&id=ohQIv7-gdHYC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Darma_das_Kaninchen_das_fliegen_konnte-sample-epub.acsm?id=ohQIv7-gdHYC&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=ohQIv7-gdHYC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Bei vieren klappt das auch, aber \u003cb\u003eDarma\u003c/b\u003e schläft und schläft. Sie will einfach nicht wach werden. &quot;Liebling, komm, Du musst zur Schule&quot;, flüstert Mama Mare, während sie \u003cb\u003eDarma\u003c/b\u003e leicht schüttelt. \u003cb\u003eDarma\u003c/b\u003e brummt etwas vor sich hin und dreht&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "6rxw9tAo_qMC",
        "etag": "GLXsCWMhHcE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/6rxw9tAo_qMC",
        "volumeInfo": {
          "title": "Darma, het konijntje dat kon vliegen",
          "publisher": "AOP-Creatives",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789491619007"
            },
            {
              "type": "ISBN_10",
              "identifier": "9491619004"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.2.2.0.preview.3",
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=6rxw9tAo_qMC&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=6rxw9tAo_qMC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "nl",
          "previewLink": "http://books.google.co.in/books?id=6rxw9tAo_qMC&pg=PT43&dq=Darma&hl=&cd=29&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=6rxw9tAo_qMC&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Darma_het_konijntje_dat_kon_vliegen.html?hl=&id=6rxw9tAo_qMC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Darma_het_konijntje_dat_kon_vliegen-sample-epub.acsm?id=6rxw9tAo_qMC&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=6rxw9tAo_qMC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Hij kijkt op Bart neeren krast: &quot;En wat heb jijmet \u003cb\u003eDarma\u003c/b\u003e dat jij tegen mijdurft in te gaan?&quot; Bart kijktnaar \u003cb\u003eDarma\u003c/b\u003e en stilletjes lijkt hij te vragen of hij het mag zeggen. Darmabegrijpt hem enknikt. &quot;\u003cb\u003eDarma\u003c/b\u003e iseenheel speciaal konijn."
        }
      },
      {
        "kind": "books#volume",
        "id": "fIptEAAAQBAJ",
        "etag": "jE3WmaovU0k",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/fIptEAAAQBAJ",
        "volumeInfo": {
          "title": "Sewaka Darma",
          "subtitle": "Peti Tiga Ciburuy Garut",
          "authors": [
            "Undang A. Darsa"
          ],
          "publisher": "Kiblat Buku Utama",
          "description": "Inti dari prinsip-prinsip ajaran Séwaka Darma ialah mengenai kaleupasan sesuai dengan tuntunan dan petunjuk darma, yang ditulis dalam bentuk kawih panyaraman (kawih nasihat) pada tahun 1405 Saka (1484 Masehi). Naskah Séwaka Darma dari Kabuyutan Ciburuy ini berisi pengajaran keagamaan tempat Sang Séwaka Darma sering muncul sebagai murid yang diberi tuntunan mengenai segala sesuatu yang berkaitan dengan kehidupan dan kematian, mengenai nilai-nilai moral dan etika, dan berbagai hal yang terdapat di dunia dan di alam kesorgaan, serta kosmologi. Pendek kata, isinya sarat dengan ajaran mistis religio-filosofis yang merupakan koalisi antara konsep tradisi lokal dan konsep-konsep Hindu-Budha. Yayasan Pusat Studi Sunda menganggap penting untuk membukakan isi naskah-naskah Sunda Kuna supaya dapat diketahui isinya oleh orang-orang Sunda yang menjadi ahli waris penulis naskah-naskah tersebut. AJIP ROSIDI",
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 132,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=fIptEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=fIptEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "id",
          "previewLink": "http://books.google.co.in/books?id=fIptEAAAQBAJ&pg=PA8&dq=Darma&hl=&cd=30&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=fIptEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=fIptEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 334.57,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 234.2,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=fIptEAAAQBAJ&rdid=book-fIptEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 334570000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 234200000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Sewaka_Darma-sample-pdf.acsm?id=fIptEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=fIptEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Baru dua judul dari koléksi Ciburuy yang sudah digarap , yaitu Séwaka \u003cb\u003eDarma\u003c/b\u003e dan Ramayana . Yayasan Pusat Studi Sunda yang menganggap penting untuk membukakan isi naskah - naskah Sunda Kuna supaya dapat diketahui isinya oléh orang&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "DlC7KvwH0OQC",
        "etag": "SvXkpsddEF0",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/DlC7KvwH0OQC",
        "volumeInfo": {
          "title": "The Taming of the Demons",
          "subtitle": "Violence and Liberation in Tibetan Buddhism",
          "authors": [
            "Jacob P. Dalton"
          ],
          "publisher": "Yale University Press",
          "publishedDate": "2011-06-28",
          "description": "The Taming of the Demons examines mythic and ritual themes of violence, demon taming, and blood sacrifice in Tibetan Buddhism. Taking as its starting point Tibet's so-called age of fragmentation (842 to 986 C.E.), the book draws on previously unstudied manuscripts discovered in the \"library cave\" near Dunhuang, on the old Silk Road. These ancient documents, it argues, demonstrate how this purportedly inactive period in Tibetan history was in fact crucial to the Tibetan assimilation of Buddhism, and particularly to the spread of violent themes from tantric Buddhism into Tibet at the local and the popular levels. Having shed light on this \"dark age\" of Tibetan history, the second half of the book turns to how, from the late tenth century onward, the period came to play a vital symbolic role in Tibet, as a violent historical \"other\" against which the Tibetan Buddhist tradition defined itself. -- Georges Dreyfus",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780300153927"
            },
            {
              "type": "ISBN_10",
              "identifier": "0300153929"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 311,
          "printType": "BOOK",
          "categories": [
            "Religion"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.4.5.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=DlC7KvwH0OQC&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=DlC7KvwH0OQC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=DlC7KvwH0OQC&pg=PA47&dq=Darma&hl=&cd=31&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=DlC7KvwH0OQC&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_Taming_of_the_Demons.html?hl=&id=DlC7KvwH0OQC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/The_Taming_of_the_Demons-sample-epub.acsm?id=DlC7KvwH0OQC&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=DlC7KvwH0OQC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "There is some disagreement between Chinese and Tibetan sources on when exactly Lang \u003cb\u003eDarma\u003c/b\u003e took the throne; the Chinese say 838, while the Tibetans say 841. Relpachen apparently suffered from a serious illness during the last three years&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "HP8MEAAAQBAJ",
        "etag": "s7BWSjB9rRE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/HP8MEAAAQBAJ",
        "volumeInfo": {
          "title": "Therapeutic Stories for Foster, Adoptive and Kinship Families",
          "subtitle": "Addressing the Domino Effect of Issues Facing 10–14-Year-Olds",
          "authors": [
            "Joan E. Moore"
          ],
          "publisher": "Routledge",
          "publishedDate": "2021-01-29",
          "description": "This accessible resource contains therapeutic stories and guidance for adults who are supporting young people aged 10–14 in foster, adoptive or kinship families. With a solution-focused approach, the stories are designed to address a range of social and emotional problems, covering topics such as bullying, eating disorders, trauma, parents’ health, homophobia and racism. Each story is accompanied by relevant context and theory, discussion points and creative activities that will stimulate the young person’s problem-solving skills and imagination, empowering them to explore solutions to situations in their own lives. Key features include: 35 therapeutic stories created to help young people make sense of their experiences, illustrating empathetic responses and solutions to social and emotional difficulties. Discussion points and related activities based on the author’s extensive practical experience and knowledge. Practice guidelines and case studies to illustrate how the story-making approach can be used by therapists, adoptive parents, social workers and teachers. Photocopiable and downloadable resources. This book will enable foster, adoptive and kinship parents, social workers, therapists, teachers and other professionals to support the young people with whom they are working to resolve their dilemmas and enhance their self-esteem.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781000300178"
            },
            {
              "type": "ISBN_10",
              "identifier": "100030017X"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 226,
          "printType": "BOOK",
          "categories": [
            "Education"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=HP8MEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=HP8MEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=HP8MEAAAQBAJ&pg=PT49&dq=Darma&hl=&cd=32&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=HP8MEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=HP8MEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 3249.72,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 3249.72,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=HP8MEAAAQBAJ&rdid=book-HP8MEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 3249720000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 3249720000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Therapeutic_Stories_for_Foster_Adoptive-sample-epub.acsm?id=HP8MEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Therapeutic_Stories_for_Foster_Adoptive-sample-pdf.acsm?id=HP8MEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=HP8MEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Encourage the children to express their wishes and dreams Story 3: \u003cb\u003eDarma&#39;s\u003c/b\u003e despair \u003cb\u003eDarma\u003c/b\u003e, 14, had been at Ma Dominos since she was 4 years old, when she arrived bent and battered. Memories of her Mum getting horribly damaged by men&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "sCdtDwAAQBAJ",
        "etag": "innrv0zbDSI",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/sCdtDwAAQBAJ",
        "volumeInfo": {
          "title": "Judah’S Justice",
          "authors": [
            "Robin Winters"
          ],
          "publisher": "AuthorHouse",
          "publishedDate": "2018-08-20",
          "description": "Islamic terrorists loyal to Hezbollah have plotted to detonate a thermonuclear IED (improvised explosive device) in New York City. With Gods grace, the CIA acted as liaison with SOCOM (Special Operations Command) in a highly classified, Super Secret, clandestine operation, code-named Wrath of God. The land of milk and honey is under siege by genocidal Islamic combatants. The threat to humanity must be terminated under the most supreme lawthe divine decree of Gods law. Judahs Justice sheds a very bright light upon a very dark path that our courageous counterterrorism operatives must tread. Youll be deeply shaken, inspired, and motivated to respect and honor the sacred men and women of the CIA Directorate of Operations, Clandestine Service. Without their sacrifices in the face of existing dangers, America would be under martial law; our civil liberties and freedoms lost. Life in America would be anarchy. The true colors of our star-spangled banner would no longer shine. Judahs Justice is the stage for the NWOD (New World Order Decree) endorsed by the United Nations Security Council.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781546254744"
            },
            {
              "type": "ISBN_10",
              "identifier": "1546254749"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 362,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=sCdtDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=sCdtDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=sCdtDwAAQBAJ&pg=PT105&dq=Darma&hl=&cd=33&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=sCdtDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=sCdtDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 323.32,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 226.32,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=sCdtDwAAQBAJ&rdid=book-sCdtDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 323320000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 226320000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Judah_S_Justice-sample-epub.acsm?id=sCdtDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=sCdtDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "En route Elsa had a conversation with a young deck hand by the name of \u003cb\u003eDarma\u003c/b\u003e, a student at Yogyakarta State University. Elsa offered \u003cb\u003eDarma\u003c/b\u003e a cup of our relished Kopi luwak coffee, suddenly we both noticed \u003cb\u003eDarma\u003c/b\u003e grimace, it appeared he&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "q0kEJVPxvJIC",
        "etag": "WcPfo+0ToK4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/q0kEJVPxvJIC",
        "volumeInfo": {
          "title": "Signs of the Wali",
          "subtitle": "Narratives at the Sacred Sites in Pamijahan, West Java",
          "authors": [
            "Tommy Christomy"
          ],
          "publisher": "ANU E Press",
          "publishedDate": "2008-04-01",
          "description": "\"This thesis is a study of traditional narratives which are recited and received both by villagers and pilgrims in regard to the local pilgrimage (ziarah) tradition in Pamijahan, particularly at Shaykh Abdul Muhyi's sacred site. The narratives will be examined as part of the popular beliefs of Priangan Timur or the eastern part of West Java. Locating them in the wider context of Sundanese oral and written traditions, my investigation will illuminate the nature and function of such traditions in the particular case of Pamijahan. The research will elucidate the role of the kuncen, the custodians of sacred sites, as guides and spiritual brokers who maintain the narratives. It will also be important to investigate the villagers' as well as visitors' view of the kuncen in regard to local pilgrimage. The study will also enhance comparative studies concerned with networks of holy men or saints (wali) on the island of Java (Pemberton 1994; Fox 1991: 20). I want to argue that people respond to, and participate in, saint veneration on pragmatic grounds. However, these grounds are subject to interpretation and contestation in time and space. In redefining their narratives, various individuals, such as custodians, Sufis, and even to some extent government functionaries, are considered to be authoritative persons by virtue of their capacity to conduct and manipulate narratives. As this argument develops, it will be important to understand the modes of signification in the village.\"--Provided by publisher.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781921313707"
            },
            {
              "type": "ISBN_10",
              "identifier": "1921313706"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 217,
          "printType": "BOOK",
          "categories": [
            "Social Science"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=q0kEJVPxvJIC&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=q0kEJVPxvJIC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=q0kEJVPxvJIC&pg=PA182&dq=Darma&hl=&cd=34&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=q0kEJVPxvJIC&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Signs_of_the_Wali.html?hl=&id=q0kEJVPxvJIC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "ALL_PAGES",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Signs_of_the_Wali-sample-epub.acsm?id=q0kEJVPxvJIC&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Signs_of_the_Wali-sample-pdf.acsm?id=q0kEJVPxvJIC&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=q0kEJVPxvJIC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "the countryside until he reached Kampung \u003cb\u003eDarma\u003c/b\u003e/Kadu Gede Lengkong in the district of Kuningan. He Stays in \u003cb\u003eDarma\u003c/b\u003e. In Kampung \u003cb\u003eDarma\u003c/b\u003e he rested and got to know the local people, who, it happened, were already Muslims."
        }
      },
      {
        "kind": "books#volume",
        "id": "ktRAAAAAYAAJ",
        "etag": "q5ncdVCeXLI",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/ktRAAAAAYAAJ",
        "volumeInfo": {
          "title": "Glimpses of the Eastern Archipelago",
          "subtitle": "Ethnographical, Geographical, Historical",
          "publishedDate": "1894",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "HARVARD:HNPEN9"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 137,
          "printType": "BOOK",
          "categories": [
            "Ethnology"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "2.2.4.0.full.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=ktRAAAAAYAAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=ktRAAAAAYAAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=ktRAAAAAYAAJ&pg=PA18&dq=Darma&hl=&cd=35&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=ktRAAAAAYAAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=ktRAAAAAYAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FREE",
          "isEbook": true,
          "buyLink": "https://play.google.com/store/books/details?id=ktRAAAAAYAAJ&rdid=book-ktRAAAAAYAAJ&rdot=1&source=gbs_api"
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "ALL_PAGES",
          "embeddable": true,
          "publicDomain": true,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false,
            "downloadLink": "http://books.google.co.in/books/download/Glimpses_of_the_Eastern_Archipelago.epub?id=ktRAAAAAYAAJ&hl=&output=epub&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "downloadLink": "http://books.google.co.in/books/download/Glimpses_of_the_Eastern_Archipelago.pdf?id=ktRAAAAAYAAJ&hl=&output=pdf&sig=ACfU3U38fyWVLknwVjYN08HpmGF7KPWOxg&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=ktRAAAAAYAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "FULL_PUBLIC_DOMAIN",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Once &amp; Tear the beginne ma ro Around the \u003cb\u003edarma\u003c/b\u003e a number of Codaeum sorts ( kadodoe ) are There is planted . On starting upon expeditions a piece of the bark is eaten , and and one ml at festivities they stick the leaves in their hair&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "xQMxDwAAQBAJ",
        "etag": "VhdCvQqJLv8",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/xQMxDwAAQBAJ",
        "volumeInfo": {
          "title": "Pursued by the Past",
          "subtitle": "A contemporary suspense novel",
          "authors": [
            "P.D. Workman"
          ],
          "publisher": "pd workman",
          "publishedDate": "2015-10-18",
          "description": "Vanna had a good life. She had her challenges—like her mother’s high expectations of her—but all in all, she had a job she enjoyed, a fun hobby and friends. She didn’t need any complications. But that all changed shortly after trying to break things off with Tino. The phone calls with no one on the other end. Anonymous gifts. Someone moving things around in her bedroom. A restraining order changed nothing. If anything, it caused things to escalate. If Vanna wants her life back, she will have to take things into her own hands.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781926500508"
            },
            {
              "type": "ISBN_10",
              "identifier": "1926500504"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 426,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=xQMxDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=xQMxDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=xQMxDwAAQBAJ&pg=PT20&dq=Darma&hl=&cd=36&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=xQMxDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=xQMxDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 446.4,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 312.48,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=xQMxDwAAQBAJ&rdid=book-xQMxDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 446400000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 312480000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true
          },
          "pdf": {
            "isAvailable": true
          },
          "webReaderLink": "http://play.google.com/books/reader?id=xQMxDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "“Probably nothing will happen,” \u003cb\u003eDarma\u003c/b\u003e assured her. “But Vanna&#39;s right. It would be a disaster to get locked out of all of your accounts.” “And that&#39;s not the most interesting thing that happened this week.” Vanna proceeded to tell them&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "Ja8EugEACAAJ",
        "etag": "2apn5RBU1aU",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/Ja8EugEACAAJ",
        "volumeInfo": {
          "title": "Parama Darma Waspada, on the aspects of Siwa etcetera",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OCLC:1041986638"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "language": "jw",
          "previewLink": "http://books.google.co.in/books?id=Ja8EugEACAAJ&dq=Darma&hl=&cd=37&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=Ja8EugEACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Parama_Darma_Waspada_on_the_aspects_of_S.html?hl=&id=Ja8EugEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=Ja8EugEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "fuQMAgAACAAJ",
        "etag": "5tIT2mTXCD4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/fuQMAgAACAAJ",
        "volumeInfo": {
          "title": "A Multivariable PI-controller for DARMA Processes",
          "authors": [
            "Juha T. Tanttu"
          ],
          "publishedDate": "1984",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "9517209169"
            },
            {
              "type": "ISBN_13",
              "identifier": "9789517209168"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 14,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=fuQMAgAACAAJ&dq=Darma&hl=&cd=38&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=fuQMAgAACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/A_Multivariable_PI_controller_for_DARMA.html?hl=&id=fuQMAgAACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=fuQMAgAACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "UEDhugEACAAJ",
        "etag": "vTBYB2JBeK4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/UEDhugEACAAJ",
        "volumeInfo": {
          "title": "No Darma Llama",
          "subtitle": "No Darma Cool Llama Cover and and Lined Pages, Extra Large (8. 5 X 11) Inches, 110 Pages, White Paper",
          "authors": [
            "C. cher"
          ],
          "publisher": "Createspace Independent Publishing Platform",
          "publishedDate": "2018-08-21",
          "description": "This notebook journal with 110 Lined pages (8.5 x 11) inches, awaits your writing pleasure. Use it for journaling, as a diary. The choice is all yours. Enjoy! Good choice for personal used and great gift for all.Get your journal today! pages Journal Book Journal Book For Kids notebook for kindergarten Journal Book For Women Journal Books Notebook Journal Boys Journal For Teens Journal For Writing Journal Lined Pages Journal Lined Paper Journal Men.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1725928051"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781725928053"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 110,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=UEDhugEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=UEDhugEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=UEDhugEACAAJ&dq=Darma&hl=&cd=39&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=UEDhugEACAAJ&dq=Darma&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/No_Darma_Llama.html?hl=&id=UEDhugEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=UEDhugEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This notebook journal with 110 Lined pages (8.5 x 11) inches, awaits your writing pleasure."
        }
      },
      {
        "kind": "books#volume",
        "id": "1qcsEAAAQBAJ",
        "etag": "pUFT+5868pw",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/1qcsEAAAQBAJ",
        "volumeInfo": {
          "title": "Darma Kadarman",
          "subtitle": "Rintisan, Pendidikan, Kaderisasi",
          "authors": [
            "St. Sularto, R. Royanto, Royani Lim"
          ],
          "publisher": "PT Kanisius",
          "description": "Hati dan jiwa Romo Kadarman sebagai pendidik, inspirator, perintis dan pengkader berbagai lembaga sosial kemasyaratan, tidak lepas dari kehidupan dan panggilan hidupnya sebagai seorang pastor Yesuit. Hati jiwanya adalah Indonesia, eksplisit tercermin dari testimoni, “Saya bangga boleh menjadi warga negara Indonesia yang berdiri sendiri dan bangga boleh menjadi warga negara Indonesia karena cinta akan bangsa kita ini.” Sesudah memperoleh KTP warga Indonesia, namanya berubah, lebih dikenal kemudian sebagai Romo Kadarman. Bangga dengan nama “Kadarman”, ia berkata, “Kadarman berarti man of quality, diawali dengan huruf Belanda K, tidak jelas-jelas nama Timur atau Barat.” Nama Romo Kadarman dikenang sebagai ahli manajemen dan peduli pada manusia dan kemanusiaan, pendidik yang tegas, penuh insitiatif yang serba menerobos, pedulian, pengkader kaum muda Indonesia. Seorang “pribadi yang memberikan teladan kepemimpinan transformatif, pemimpin-pemimpin yang mampu membuahkan pilihan-pilihan dan tindakan-tindakan kreatif yang mendorong terjadinya tranformasi sosial”, “yang berjiwa merdeka dan menjalankan kaderisasi yang diilhami tokoh rohani, Santo Ignatius Loyola”. Semua demi kemuliaan Allah yang Lebih besar (ad Maiorem Dei Gloriam), motto Serikat Yesus.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789792169607"
            },
            {
              "type": "ISBN_10",
              "identifier": "9792169601"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 160,
          "printType": "BOOK",
          "categories": [
            "History"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.2.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=1qcsEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=1qcsEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "id",
          "previewLink": "http://books.google.co.in/books?id=1qcsEAAAQBAJ&pg=PR1&dq=Darma&hl=&cd=40&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=1qcsEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=1qcsEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 506.95,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 253.48,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=1qcsEAAAQBAJ&rdid=book-1qcsEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 506950000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 253480000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Darma_Kadarman-sample-pdf.acsm?id=1qcsEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=1qcsEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "... Kaderisasi St. Sularto, R. Royanto, Royani Lim. \u003cb\u003eDarma\u003c/b\u003e Kadarman Rintisan, Pendidikan, Kaderisasi St. Sularto, R. Royanto, Royani Lim PENERBIT PT KANISIUS \u003cb\u003eDARMA\u003c/b\u003e KADARMAN Rintisan, Pendidikan, Kaderisasi Oleh: St. Sularto, R. Royanto,"
        }
      },
       {
        "kind": "books#volume",
        "id": "PRIxEAAAQBAJ",
        "etag": "DSKzPK4GWT4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/PRIxEAAAQBAJ",
        "volumeInfo": {
          "title": "To Sir, with Love",
          "authors": [
            "Lauren Layne"
          ],
          "publisher": "Simon and Schuster",
          "publishedDate": "2021-06-29",
          "description": "Love Is Blind meets You’ve Got Mail in this laugh-out-loud romantic comedy following two thirty-somethings who meet on a blind dating app—only to realize that their online chemistry is nothing compared to their offline rivalry. Perpetually cheerful and eager to please, Gracie Cooper strives to make the best out of every situation. So when her father dies just months after a lung cancer diagnosis, she sets aside her dreams of pursuing her passion for art to take over his Midtown Manhattan champagne shop. She soon finds out that the store’s profit margins are being squeezed perilously tight, and complicating matters further, a giant corporation headed by the impossibly handsome, but irritatingly arrogant Sebastian Andrews is proposing a buyout. But Gracie can’t bear the thought of throwing away her father’s dream like she did her own. Overwhelmed and not wanting to admit to her friends or family that she’s having second thoughts about the shop, Gracie seeks advice and solace from someone she’s never met—the faceless “Sir”, with whom she connected on a blind dating app where matches get to know each other through messages and common interests before exchanging real names or photos. But although Gracie finds herself slowly falling for Sir online, she has no idea she’s already met him in real life…and they can’t stand each other.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781982152819"
            },
            {
              "type": "ISBN_10",
              "identifier": "1982152818"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 288,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "averageRating": 4,
          "ratingsCount": 8,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=PRIxEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=PRIxEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=PRIxEAAAQBAJ&printsec=frontcover&dq=love&hl=&cd=1&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=PRIxEAAAQBAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/To_Sir_with_Love.html?hl=&id=PRIxEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED_FOR_ACCESSIBILITY",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=PRIxEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Love Is Blind meets You’ve Got Mail in this laugh-out-loud romantic comedy following two thirty-somethings who meet on a blind dating app—only to realize that their online chemistry is nothing compared to their offline rivalry."
        }
      },
      {
        "kind": "books#volume",
        "id": "83ZtDQAAQBAJ",
        "etag": "o/unBRO5B3I",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/83ZtDQAAQBAJ",
        "volumeInfo": {
          "title": "Love Is",
          "authors": [
            "Diane Adams"
          ],
          "publisher": "Chronicle Books",
          "publishedDate": "2017-01-24",
          "description": "Perfect for any fond gift or tender moment, this story of a girl and a duckling who share a touching year together will melt hearts old and young. In this tenderly funny book, girl and duckling grow in their understanding of what it is to care for each other, discovering that love is as much about letting go as it is about holding tight. Children and parents together will adore this fond exploration of growing up while learning about the joys of love offered and love returned.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781452143712"
            },
            {
              "type": "ISBN_10",
              "identifier": "1452143714"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 32,
          "printType": "BOOK",
          "categories": [
            "Juvenile Fiction"
          ],
          "averageRating": 5,
          "ratingsCount": 1,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.3.3.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=83ZtDQAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=83ZtDQAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=83ZtDQAAQBAJ&pg=PP1&dq=love&hl=&cd=2&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=83ZtDQAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=83ZtDQAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 784.7,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 392.35,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=83ZtDQAAQBAJ&rdid=book-83ZtDQAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 784700000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 392350000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Love_Is-sample-epub.acsm?id=83ZtDQAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Love_Is-sample-pdf.acsm?id=83ZtDQAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=83ZtDQAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Perfect for any fond gift or tender moment, this story of a girl and a duckling who share a touching year together will melt hearts old and young."
        }
      },
      {
        "kind": "books#volume",
        "id": "upFwTE9AK8wC",
        "etag": "IR2wvM7gJrY",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/upFwTE9AK8wC",
        "volumeInfo": {
          "title": "The Psychology of Romantic Love",
          "subtitle": "Romantic Love in an Anti-Romantic Age",
          "authors": [
            "Nathaniel Branden"
          ],
          "publisher": "Penguin",
          "publishedDate": "2008-01-31",
          "description": "What love is, why love is born, why it sometimes grows, and why it sometimes dies. Have you ever wondered how romantic love evolves? What the difference is between mature and immature love? What role sex plays in romantic love, and whether love necessarily implies sexual exclusivity? And, most important, how can we make love last? Originally published in 1980, this updated edition of The Psychology of Romantic Love explores the nature of romantic love on many levels-the philosophical, the historical, the sociological, and the physiological. Nathaniel Branden explains why so many people say that romantic love is just not possible in today's world and-drawing on his experience with thousands of couples-finds that such love is still a possibility for anyone who understands its essence and is willing to accept its challenges. Branden sees it as a pathway not only to extraordinary joy but also to profound self-discovery. His vision of love is thoroughly appropriate to our time and grounded in our humanness.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1585426253"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781585426256"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 240,
          "printType": "BOOK",
          "categories": [
            "Family & Relationships"
          ],
          "averageRating": 4,
          "ratingsCount": 2,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "2.1.3.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=upFwTE9AK8wC&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=upFwTE9AK8wC&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=upFwTE9AK8wC&dq=love&hl=&cd=3&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=upFwTE9AK8wC&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_Psychology_of_Romantic_Love.html?hl=&id=upFwTE9AK8wC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true
          },
          "webReaderLink": "http://play.google.com/books/reader?id=upFwTE9AK8wC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Originally published in 1980, this updated edition of The Psychology of Romantic Love explores the nature of romantic love on many levels-the philosophical, the historical, the sociological, and the physiological."
        }
      },
      {
        "kind": "books#volume",
        "id": "tvePDwAAQBAJ",
        "etag": "BCcQ7IEHMTE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/tvePDwAAQBAJ",
        "volumeInfo": {
          "title": "Love from A to Z",
          "authors": [
            "S. K. Ali"
          ],
          "publisher": "Simon & Schuster Books for Young Readers",
          "publishedDate": "2019-04-30",
          "description": "From William C. Morris Award Finalist S.K. Ali comes an unforgettable romance that is part The Sun Is Also a Star mixed with Anna and the French Kiss, following two Muslim teens who meet during a spring break trip. A marvel: something you find amazing. Even ordinary-amazing. Like potatoes—because they make French fries happen. Like the perfect fries Adam and his mom used to make together. An oddity: whatever gives you pause. Like the fact that there are hateful people in the world. Like Zayneb’s teacher, who won’t stop reminding the class how “bad” Muslims are. But Zayneb, the only Muslim in class, isn’t bad. She’s angry. When she gets suspended for confronting her teacher, and he begins investigating her activist friends, Zayneb heads to her aunt’s house in Doha, Qatar, for an early start to spring break. Fueled by the guilt of getting her friends in trouble, she resolves to try out a newer, “nicer” version of herself in a place where no one knows her. Then her path crosses with Adam’s. Since he got diagnosed with multiple sclerosis in November, Adam’s stopped going to classes, intent, instead, on perfecting the making of things. Intent on keeping the memory of his mom alive for his little sister. Adam’s also intent on keeping his diagnosis a secret from his grieving father. Alone, Adam and Zayneb are playing roles for others, keeping their real thoughts locked away in their journals. Until a marvel and an oddity occurs… Marvel: Adam and Zayneb meeting. Oddity: Adam and Zayneb meeting.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781534454132"
            },
            {
              "type": "ISBN_10",
              "identifier": "1534454136"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 352,
          "printType": "BOOK",
          "categories": [
            "Young Adult Fiction"
          ],
          "averageRating": 4.5,
          "ratingsCount": 4,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.0.1.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=tvePDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=tvePDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=tvePDwAAQBAJ&printsec=frontcover&dq=love&hl=&cd=4&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=tvePDwAAQBAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_from_A_to_Z.html?hl=&id=tvePDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED_FOR_ACCESSIBILITY",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=tvePDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "From William C. Morris Award Finalist S.K. Ali comes an unforgettable romance that is part The Sun Is Also a Star mixed with Anna and the French Kiss, following two Muslim teens who meet during a spring break trip."
        }
      },
      {
        "kind": "books#volume",
        "id": "A5ZDDwAAQBAJ",
        "etag": "AvZuI1nrQ78",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/A5ZDDwAAQBAJ",
        "volumeInfo": {
          "title": "All About Love",
          "subtitle": "New Visions",
          "authors": [
            "bell hooks"
          ],
          "publisher": "HarperCollins",
          "publishedDate": "2018-01-30",
          "description": "A New York Times bestseller and enduring classic, All About Love is the acclaimed first volume in feminist icon bell hooks' \"Love Song to the Nation\" trilogy. All About Love reveals what causes a polarized society, and how to heal the divisions that cause suffering. Here is the truth about love, and inspiration to help us instill caring, compassion, and strength in our homes, schools, and workplaces. “The word ‘love’ is most often defined as a noun, yet we would all love better if we used it as a verb,” writes bell hooks as she comes out fighting and on fire in All About Love. Here, at her most provocative and intensely personal, renowned scholar, cultural critic and feminist bell hooks offers a proactive new ethic for a society bereft with lovelessness--not the lack of romance, but the lack of care, compassion, and unity. People are divided, she declares, by society’s failure to provide a model for learning to love. As bell hooks uses her incisive mind to explore the question “What is love?” her answers strike at both the mind and heart. Razing the cultural paradigm that the ideal love is infused with sex and desire, she provides a new path to love that is sacred, redemptive, and healing for individuals and for a nation. The Utne Reader declared bell hooks one of the “100 Visionaries Who Can Change Your Life.” All About Love is a powerful, timely affirmation of just how profoundly her revelations can change hearts and minds for the better.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780062862174"
            },
            {
              "type": "ISBN_10",
              "identifier": "0062862170"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 272,
          "printType": "BOOK",
          "categories": [
            "Family & Relationships"
          ],
          "averageRating": 3,
          "ratingsCount": 12,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "2.4.4.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=A5ZDDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=A5ZDDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=A5ZDDwAAQBAJ&printsec=frontcover&dq=love&hl=&cd=5&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=A5ZDDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=A5ZDDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 523.2,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 327.01,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=A5ZDDwAAQBAJ&rdid=book-A5ZDDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 523200000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 327010000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/All_About_Love-sample-epub.acsm?id=A5ZDDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=A5ZDDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Here is the truth about love, and inspiration to help us instill caring, compassion, and strength in our homes, schools, and workplaces. “The word ‘love’ is most often defined as a noun, yet we would all love better if we used it as a ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "I37azQEACAAJ",
        "etag": "UmBXiStqmSE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/I37azQEACAAJ",
        "volumeInfo": {
          "title": "Out of Love",
          "authors": [
            "Jewel E. Ann"
          ],
          "publishedDate": "2020-09-27",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1734518286"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781734518283"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=I37azQEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=I37azQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=I37azQEACAAJ&dq=love&hl=&cd=6&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=I37azQEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Out_of_Love.html?hl=&id=I37azQEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=I37azQEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Conspiracies. Corruption."
        }
      },
      {
        "kind": "books#volume",
        "id": "OJUqDwAAQBAJ",
        "etag": "2wn8eBtrEas",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/OJUqDwAAQBAJ",
        "volumeInfo": {
          "title": "Let's Talk About Love",
          "authors": [
            "Claire Kann"
          ],
          "publisher": "Swoon Reads",
          "publishedDate": "2018-01-23",
          "description": "Striking a perfect balance between heartfelt emotions and spot-on humor, this debut features a pop-culture enthusiast protagonist with an unforgettable voice sure to resonate with readers. Alice had her whole summer planned. Nonstop all-you-can-eat buffets while marathoning her favorite TV shows (best friends totally included) with the smallest dash of adulting—working at the library to pay her share of the rent. The only thing missing from her perfect plan? Her girlfriend (who ended things when Alice confessed she's asexual). Alice is done with dating—no thank you, do not pass go, stick a fork in her, done. But then Alice meets Takumi and she can’t stop thinking about him or the rom com-grade romance feels she did not ask for (uncertainty, butterflies, and swoons, oh my!). When her blissful summer takes an unexpected turn and Takumi becomes her knight with a shiny library-employee badge (close enough), Alice has to decide if she’s willing to risk their friendship for a love that might not be reciprocated—or understood. Claire Kann’s debut novel Let’s Talk About Love, chosen by readers like you for Macmillan's young adult imprint Swoon Reads, gracefully explores the struggle with emerging adulthood and the complicated line between friendship and what it might mean to be something more. Praise for Let’s Talk About Love from the Swoon Reads community: “A sweet and beautiful journey about self-discovery and identity!” —Macy Filia, reader on SwoonReads.com “There aren't many novels that have asexual characters and it's something people need more of.” —Alice, reader on SwoonReads.com “I want this on my shelf where I can admire it every day.” —Kiara, reader on SwoonReads.com",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781250138828"
            },
            {
              "type": "ISBN_10",
              "identifier": "1250138825"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 304,
          "printType": "BOOK",
          "categories": [
            "Young Adult Fiction"
          ],
          "averageRating": 4,
          "ratingsCount": 4,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.3.3.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=OJUqDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=OJUqDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=OJUqDwAAQBAJ&pg=PP1&dq=love&hl=&cd=7&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=OJUqDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=OJUqDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 491.11,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 343.78,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=OJUqDwAAQBAJ&rdid=book-OJUqDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 491110000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 343780000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Let_s_Talk_About_Love-sample-epub.acsm?id=OJUqDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=OJUqDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Claire Kann’s debut novel Let’s Talk About Love, chosen by readers like you for Macmillan&#39;s young adult imprint Swoon Reads, gracefully explores the struggle with emerging adulthood and the complicated line between friendship and what ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "AxOvjwEACAAJ",
        "etag": "gWk8c/++jVw",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/AxOvjwEACAAJ",
        "volumeInfo": {
          "title": "What Love Is",
          "subtitle": "And What It Could Be",
          "authors": [
            "Carrie S. I. Jenkins"
          ],
          "publishedDate": "2017-01-24",
          "description": "What is love? Aside from being the title of many a popular love song, this is one of life s perennial questions. In \"What Love Is,\" philosopher Carrie Jenkins offers a bold new theory on the nature of romantic love that reconciles its humanistic and scientific components. Love can be a social construct (the idea of a perfect fairy tale romance) and a physical manifestation (those anxiety- inducing heart palpitations); we must recognize its complexities and decide for ourselves how to love. Motivated by her own polyamorous relationships, she examines the ways in which our parameters of love have recently changedto be more accepting of homosexual, interracial, and non-monogamous relationshipsand how they will continue to evolve in the future. Full of anecdotal, cultural, and scientific reflections on love, \"What Love Is\" is essential reading for anyone seeking to understand what it means to say I love you. Whether young or old, gay or straight, male or female, polyamorous or monogamous, this book will help each of us decide for ourselves how we choose to love. \"",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "0465098851"
            },
            {
              "type": "ISBN_13",
              "identifier": "9780465098859"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 224,
          "printType": "BOOK",
          "categories": [
            "Philosophy"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=AxOvjwEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=AxOvjwEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=AxOvjwEACAAJ&dq=love&hl=&cd=8&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=AxOvjwEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/What_Love_Is.html?hl=&id=AxOvjwEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=AxOvjwEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "&quot; Whether young or old, gay or straight, male or female, polyamorous or monogamous, this book will help each of us decide for ourselves how we choose to love."
        }
      },
      {
        "kind": "books#volume",
        "id": "IyKEDwAAQBAJ",
        "etag": "2fO+udBeXf4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/IyKEDwAAQBAJ",
        "volumeInfo": {
          "title": "Frankly in Love",
          "authors": [
            "David Yoon"
          ],
          "publisher": "Penguin UK",
          "publishedDate": "2019-09-12",
          "description": "Frank Li is a high school senior living in Southern California. Frank's parents emigrated from Korea, and have pretty much one big rule for Frank - he must only date Korean girls. But he's got strong feelings for a girl in his class, Brit - and she's not Korean. His friend Joy Song is in the same boat and knows her parents will never accept her Chinese American boyfriend, so they make a pact: they'll pretend to date each other in order to gain their freedom. Frank thinks fake-dating is the perfect plan, but it leaves him wondering if he ever really understood love - or himself - at all. David Yoon's debut novel is a quirky, authentic, heartbreaking romantic comedy and a refreshingly different take on race, immigrant communities, friendship and family.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780241373446"
            },
            {
              "type": "ISBN_10",
              "identifier": "0241373441"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 432,
          "printType": "BOOK",
          "categories": [
            "Juvenile Fiction"
          ],
          "averageRating": 4,
          "ratingsCount": 21,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.7.7.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=IyKEDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=IyKEDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=IyKEDwAAQBAJ&pg=PP1&dq=love&hl=&cd=9&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=IyKEDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=IyKEDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 398.25,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 278.78,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=IyKEDwAAQBAJ&rdid=book-IyKEDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 398250000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 278780000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Frankly_in_Love-sample-epub.acsm?id=IyKEDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=IyKEDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "David Yoon&#39;s debut novel is a quirky, authentic, heartbreaking romantic comedy and a refreshingly different take on race, immigrant communities, friendship and family."
        }
      },
      {
        "kind": "books#volume",
        "id": "J76NDwAAQBAJ",
        "etag": "Iu6/+bJyIIM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/J76NDwAAQBAJ",
        "volumeInfo": {
          "title": "The Love",
          "authors": [
            "Soborno Isaac Bari"
          ],
          "publisher": "AuthorHouse",
          "publishedDate": "2019-03-15",
          "description": "The Love is a book about Soborno Isaac Bari, a four-year-old Muslim child who launched a campaign to create a world without terrorism. The book is divided into two parts: (1) Soborno’s fight with Imams to change their perception on non-Muslims and (2) his fights with Muslim Americans to denounce terrorism and be patriotic. Millions of people joined his campaign across the world—especially people in Bangladesh where two young Muslim students, Sadiyan Lima (Dhaka University) and Marjia Farzana (Jahangirnagar University), led the movement on behalf of their respective universities. It inspired many people, including Zahid Hossain and Safir Biplob and his son, to stand against the terror of the Islamic State. Zahid published Soborno’s biography, while Safir and his son went to 64,000 villages in Bangladesh posting 64,000 posters. Meanwhile, Uday Bengali made a documentary, I Love Christmas, which created an anti-terrorism movement around Bangladesh that is based on the philosophy of Soborno.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781728301952"
            },
            {
              "type": "ISBN_10",
              "identifier": "1728301955"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 82,
          "printType": "BOOK",
          "categories": [
            "Philosophy"
          ],
          "averageRating": 2.5,
          "ratingsCount": 4,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.1.1.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=J76NDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=J76NDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=J76NDwAAQBAJ&printsec=frontcover&dq=love&hl=&cd=10&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=J76NDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=J76NDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 330.4,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 231.28,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=J76NDwAAQBAJ&rdid=book-J76NDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 330400000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 231280000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/The_Love-sample-epub.acsm?id=J76NDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=J76NDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The book is divided into two parts: (1) Soborno’s fight with Imams to change their perception on non-Muslims and (2) his fights with Muslim Americans to denounce terrorism and be patriotic."
        }
      },
      {
        "kind": "books#volume",
        "id": "Kok2mAEACAAJ",
        "etag": "SZ54xrWVFtM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/Kok2mAEACAAJ",
        "volumeInfo": {
          "title": "Love Vouchers",
          "authors": [
            "Summersdale"
          ],
          "publisher": "Summersdale",
          "publishedDate": "2014-01-06",
          "description": "Pamper someone you love with this sweet book of vouchers containing romantic gestures, from breakfast in bed to a dreamy weekend away - it's the gift that keeps on giving!",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1849534950"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781849534956"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 64,
          "printType": "BOOK",
          "categories": [
            "Humor"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=Kok2mAEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=Kok2mAEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=Kok2mAEACAAJ&dq=love&hl=&cd=11&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=Kok2mAEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_Vouchers.html?hl=&id=Kok2mAEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=Kok2mAEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Features vouchers containing romantic gestures, from breakfast in bed to a dreamy weekend away."
        }
      },
      {
        "kind": "books#volume",
        "id": "83b3DwAAQBAJ",
        "etag": "F7BgCw/mayA",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/83b3DwAAQBAJ",
        "volumeInfo": {
          "title": "Evelina The Omega",
          "authors": [
            "David Gomadza"
          ],
          "publisher": "David Gomadza",
          "description": "This is book 2 of the Evelina series. Things get even hot. Raised stakes and a matter of life or death. Mankind’s existence rest on the shoulders of one woman. The Omega. The first woman has become the last woman. The only true seal. What if it was all planned before this world was created? To save all humanity, mankind must find the only true key; the Omega. On the other hand, to restore the lost kingdom of darkness, the devil must find the most wanted catalyst; The Omega. When everyone’s fate is in your hands what are the risks to yourself? It is a dash against time as total obliteration of the losing team is imminent and inevitable. It is a story of courage, steadfast and honor in the face of death. When loyalty is tested to breaking points. When the person you are to protect is the same person you must kill to save humanity from extinction? Some choices are meant for gods as humans are too weak and unequipped to handle such traumatic experiences. One man’s quest to solve God’s Dilemma, but at what cost? One lady’s quest to clear her name and enjoy life like every woman out there, but with what is at stake will the evil regime turn a blind eye?And at what expense?On the edge of the seat from the word go. A MUST READ.",
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 428,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "0.4.4.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=83b3DwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=83b3DwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=83b3DwAAQBAJ&pg=PT675&dq=love&hl=&cd=12&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=83b3DwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=83b3DwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 233.54,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 163.48,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=83b3DwAAQBAJ&rdid=book-83b3DwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 233540000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 163480000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true
          },
          "pdf": {
            "isAvailable": true
          },
          "webReaderLink": "http://play.google.com/books/reader?id=83b3DwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "“This woman is the keeper of my \u003cb\u003elove\u003c/b\u003e and as such, I want to \u003cb\u003elove\u003c/b\u003e her forever for my \u003cb\u003elove\u003c/b\u003e is forever. I promise to \u003cb\u003elove\u003c/b\u003e her unconditionally and I pledge to \u003cb\u003elove\u003c/b\u003e no other than just her. I will never leave her for my \u003cb\u003elove\u003c/b\u003e for her will&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "w-rKDwAAQBAJ",
        "etag": "WWMHXi8jJu4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/w-rKDwAAQBAJ",
        "volumeInfo": {
          "title": "Being Love",
          "authors": [
            "Sister Shivani",
            "Suresh Oberoi"
          ],
          "publisher": "Manjul Publishing",
          "description": "We can each radiate unconditional love. We don’t even need to create it – we are love. But the flow of love is blocked in moments of hurt, blame, anger, criticism, competition or insecurity. These emotions have dominated our emotional space, and hardly enable us to feel our own love. So today, we rely on someone else to love us. This book teaches us to think right, enable self-love, feel it and extend it to other people. The central message here is that love is not ‘out there’, but within us. A spectrum of emotions like attachment, expectations, hurt, worry, stress, fear or anger, which we use in the pretext of love, are analysed. The conversations also explore the fact that the parent-child relationship is not challenging – It does not need to be. As you free yourself from judgments and expectations, as you start thinking right for people, and as you accept people for who they are, you become a Radiator of unconditional love. You are one decision away from vibrating at a frequency of love … by not needing love or giving love – but just by being love.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789389143874"
            },
            {
              "type": "ISBN_10",
              "identifier": "938914387X"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 394,
          "printType": "BOOK",
          "categories": [
            "Self-Help"
          ],
          "averageRating": 5,
          "ratingsCount": 1,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "0.0.1.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=w-rKDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=w-rKDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=w-rKDwAAQBAJ&pg=PR1&dq=love&hl=&cd=13&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=w-rKDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=w-rKDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 371.7,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 182,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=w-rKDwAAQBAJ&rdid=book-w-rKDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 371700000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 182000000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Being_Love-sample-pdf.acsm?id=w-rKDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=w-rKDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "So today, we rely on someone else to love us. This book teaches us to think right, enable self-love, feel it and extend it to other people. The central message here is that love is not ‘out there’, but within us."
        }
      },
      {
        "kind": "books#volume",
        "id": "PcAcAAAAMAAJ",
        "etag": "mLP1QkzQd0c",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/PcAcAAAAMAAJ",
        "volumeInfo": {
          "title": "Love and Violence",
          "authors": [
            "Bruno de Jésus-Marie (père, O.C.D.)"
          ],
          "publishedDate": "1954",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "UOM:39015011870063"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 260,
          "printType": "BOOK",
          "categories": [
            "Love"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.4.2.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=PcAcAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=PcAcAAAAMAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=PcAcAAAAMAAJ&q=love&dq=love&hl=&cd=14&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=PcAcAAAAMAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_and_Violence.html?hl=&id=PcAcAAAAMAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=PcAcAAAAMAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "For what the \u003cb\u003elove\u003c/b\u003e of God demands of him is the transmission of that \u003cb\u003elove\u003c/b\u003e to his fellow - men . God&#39;s \u003cb\u003elove\u003c/b\u003e , as he sees it , is something ever outflowing from its divine centre ; never that of the solus soli , the sterile , closed&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "R63SDwAAQBAJ",
        "etag": "8tybGRrNe/g",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/R63SDwAAQBAJ",
        "volumeInfo": {
          "title": "On Love",
          "subtitle": "A Novel",
          "authors": [
            "Alain de Botton"
          ],
          "publisher": "Grove/Atlantic, Inc.",
          "publishedDate": "2015-11-03",
          "description": "The New York Times-bestselling author’s modern classic that “takes a conventional love story and textures it with philosophical ruminations” (Kirkus Reviews). A man and a woman meet over casual conversation on a flight from Paris to London, and so begins a love story—from first kiss to first argument, elation to heartbreak, and everything in between. Each stage of the relationship is illuminated with starling clarity, as novelist and philosopher Alain de Botton explores young love and its emotions, often felt but rarely understood. With a brilliant new introduction by Sheila Heti, the New York Times-bestselling author of How Should a Person Be?, On Love is a contemporary classic from an author “who seems to have been born to write” (The Boston Globe). “Smart and ironic...The book’s success has much to do with its beautifully modeled sentences, its wry humor, and its unwavering deadpan respect for the reader's intelligence.” —Francine Prose, New Republic “Witty, funny, sophisticated...full of wise and illuminating insights.” —P.J. Kavanagh, Spectator",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780802189967"
            },
            {
              "type": "ISBN_10",
              "identifier": "0802189962"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 240,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=R63SDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=R63SDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=R63SDwAAQBAJ&pg=PP1&dq=love&hl=&cd=15&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=R63SDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=R63SDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 503.86,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 251.93,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=R63SDwAAQBAJ&rdid=book-R63SDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 503860000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 251930000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/On_Love-sample-epub.acsm?id=R63SDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/On_Love-sample-pdf.acsm?id=R63SDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=R63SDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Each stage of the relationship is illuminated with starling clarity, as novelist and philosopher Alain de Botton explores young love and its emotions, often felt but rarely understood."
        }
      },
      {
        "kind": "books#volume",
        "id": "i_MQmwEACAAJ",
        "etag": "zKtT7WWS4Zo",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/i_MQmwEACAAJ",
        "volumeInfo": {
          "title": "Money, a Love Story",
          "subtitle": "Untangle Your Financial Woes and Create the Life You Really Want",
          "authors": [
            "Kate Northrup"
          ],
          "publishedDate": "2013-09-10",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1781800685"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781781800683"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 272,
          "printType": "BOOK",
          "categories": [
            "Finance, Personal"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=i_MQmwEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=i_MQmwEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=i_MQmwEACAAJ&dq=love&hl=&cd=16&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=i_MQmwEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Money_a_Love_Story.html?hl=&id=i_MQmwEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=i_MQmwEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Using client stories and her own saga of moving from heavy debt to complete financial freedom by the age of 28, Kate Northrup acts as a guide in your quest for personal financial freedom through love."
        }
      },
      {
        "kind": "books#volume",
        "id": "4SN8vgAACAAJ",
        "etag": "+m8RJAW8FuM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/4SN8vgAACAAJ",
        "volumeInfo": {
          "title": "Love What Matters",
          "subtitle": "Real People. Real Stories. Real Heart.",
          "authors": [
            "LoveWhatMatters"
          ],
          "publisher": "Red Seat Ventures",
          "publishedDate": "2017-05-02",
          "description": "In the bestselling tradition of The Five People You Meet in Heaven and Humans of New York comes a collection of authentic, emotional, and inspiring stories about life’s most important moments, as curated by the editors at Love What Matters. “90% of the reads bring me to tears. I just can't believe the love this world truly has when all we see is hate. This is so uplifting.” —Shelsea Where do you go when you want to feel inspired? When you want to forget about the divisiveness and the anger? For over five million people, that place is Love What Matters, a digital platform dedicated to finding and sharing the daily moments of kindness, compassion, and love that so often go overlooked. This curated collection of powerful stories features first person accounts and photographs that perfectly capture each moment: A husband learning he’s about to be a dad. A new mom embracing her body. A cashier inadvertently teaching a young girl a lesson about patience. A bagel from a stranger that saved a homeless man’s life. From long overdue adoptions to military heroes returning home; from a fireman’s touching 9/11 tribute to what an old dinner plate found at a bake sale can teach us all about life—these are the moments that matter. They are genuine. Authentic. Raw. And they are perfect in their imperfection—just like all of us. You will no doubt experience goosebumps and tears, but this mosaic of life’s moments will leave you with something even more profound: a reminder that, in the end, love always wins. “This really is the best page on Facebook. It renews your love of humanity. There are still good people. We need more reports of acts of kindness.” —Johnny",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1501169130"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781501169137"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 272,
          "printType": "BOOK",
          "categories": [
            "Self-Help"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=4SN8vgAACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=4SN8vgAACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=4SN8vgAACAAJ&dq=love&hl=&cd=17&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=4SN8vgAACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_What_Matters.html?hl=&id=4SN8vgAACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=4SN8vgAACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "I just can&#39;t believe the love this world truly has when all we see is hate. This is so uplifting.” —Shelsea Where do you go when you want to feel inspired? When you want to forget about the divisiveness and the anger?"
        }
      },
      {
        "kind": "books#volume",
        "id": "tjVAAAAAIAAJ",
        "etag": "PPfepu8gl+E",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/tjVAAAAAIAAJ",
        "volumeInfo": {
          "title": "Best Philippine Love Stories",
          "authors": [
            "Tarrosa Subido"
          ],
          "publishedDate": "1957",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "UCAL:$B116529"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 297,
          "printType": "BOOK",
          "categories": [
            "Love stories, Philippine"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.4.4.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=tjVAAAAAIAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=tjVAAAAAIAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=tjVAAAAAIAAJ&q=love&dq=love&hl=&cd=18&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=tjVAAAAAIAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Best_Philippine_Love_Stories.html?hl=&id=tjVAAAAAIAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=tjVAAAAAIAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "BEST PHILIPPINE \u003cb\u003eLOVE\u003c/b\u003e STORIES is not just “ romantic boy - girl stuff &quot; , either . Intended for a heterogeneous fictionloving public , it has been compiled with variety as a decisive consideration . Thus , where two stories are of equal&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "lRkIT17ymDkC",
        "etag": "iEoNuL43gCw",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/lRkIT17ymDkC",
        "volumeInfo": {
          "title": "Love's Bright Torch",
          "authors": [
            "Dorothea J. Snow"
          ],
          "publisher": "Thomas Bouregy & Company",
          "publishedDate": "1984",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "0803484429"
            },
            {
              "type": "ISBN_13",
              "identifier": "9780803484429"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 180,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.3.3.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=lRkIT17ymDkC&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=lRkIT17ymDkC&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=lRkIT17ymDkC&q=love&dq=love&hl=&cd=19&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=lRkIT17ymDkC&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Bright_Torch.html?hl=&id=lRkIT17ymDkC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=lRkIT17ymDkC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "AVALUN RUMANUES Delightful romances for teenagers and adults OUR FOOLISH HEARTS , by Patricia Bird HAUNTING KISSES , by Juanita Tyree Osborne PERIL AT BLACKSTONE , by J . H . Rhodes \u003cb\u003eLOVE\u003c/b\u003e &#39; S BRIGHT TORCH , by Dorothea J . Snow THE&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "3Xfpxv0Th_kC",
        "etag": "KEy0Ia0wqeQ",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/3Xfpxv0Th_kC",
        "volumeInfo": {
          "title": "The History of Love",
          "authors": [
            "Nicole Krauss"
          ],
          "publisher": "Penguin UK",
          "publishedDate": "2012-06-28",
          "description": "Leo Gursky is a man who fell in love at the age of ten and has been in love ever since. These days he is just about surviving life in America, tapping his radiator each evening to let his upstairs neighbour know he's still alive, drawing attention to himself at the milk counter of Starbucks. But life wasn't always like this: sixty years ago in the Polish village where he was born Leo fell in love with a young girl called Alma and wrote a book in honour of his love. These days he assumes that the book, and his dreams, are irretrievably lost, until one day they return to him in the form of a brown envelope. Meanwhile, a young girl, hoping to find a cure for her mother's loneliness, stumbles across a book that changed her mother's life and she goes in search of the author. Soon these and other worlds collide in The History of Love, a captivating story of the power of love, of loneliness and of survival.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780241964200"
            },
            {
              "type": "ISBN_10",
              "identifier": "0241964202"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 272,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "averageRating": 4,
          "ratingsCount": 154,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "2.10.12.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=3Xfpxv0Th_kC&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=3Xfpxv0Th_kC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=3Xfpxv0Th_kC&pg=PP1&dq=love&hl=&cd=20&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=3Xfpxv0Th_kC&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=3Xfpxv0Th_kC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 353.11,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 353.11,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=3Xfpxv0Th_kC&rdid=book-3Xfpxv0Th_kC&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 353110000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 353110000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/The_History_of_Love-sample-epub.acsm?id=3Xfpxv0Th_kC&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=3Xfpxv0Th_kC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "It takes one&#39;s breath away&#39; Spectator Nicole Krauss is an American bestselling author who has received international critical acclaim for her first three novels: Great House (shortlisted for the Orange Prize for Fiction 2011), The History ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "o5lDEAAAQBAJ",
        "etag": "01Zc3YZUcrs",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/o5lDEAAAQBAJ",
        "volumeInfo": {
          "title": "The Love Hypothesis",
          "subtitle": "Tiktok made me buy it! The romcom of the year!",
          "authors": [
            "Ali Hazelwood"
          ],
          "publisher": "Hachette UK",
          "publishedDate": "2021-09-27",
          "description": "Based on the available information and the data hitherto collected, my hypothesis is that the further I stay away from love, the better off I will be. 'Contemporary romance's unicorn: the elusive marriage of deeply brainy and delightfully escapist.' Christina Lauren, New York Times bestselling author of The Unhoneymooners * When a fake relationship between scientists meets the irresistible force of attraction, it throws one woman's carefully calculated theories on love into chaos. As a third-year Ph.D. candidate, Olive Smith doesn't believe in lasting romantic relationships but her best friend does, and that's what got her into this situation. Convincing Anh that Olive on her way to a happily ever after was always going to be tough, scientists require proof. So, like any self-respecting woman, Olive panics and kisses the first man she sees. That man is none other than Adam Carlsen, a young hotshot professor and well-known ass. Which is why Olive is positively floored when he agrees to keep her charade a secret and be her fake boyfriend. But when a big science conference goes haywire and Adam surprises her again with his unyielding support (and his unyielding abs), their little experiment feels dangerously close to combustion. Olive soon discovers that the only thing more complicated than a hypothesis on love is putting her own heart under the microscope. What the five star reviews are saying about The Love Hypothesis: 'Did I read this in 24 hours? Yes.' 'Funny. Snarky. Intelligent. Real.' 'If you're even slightly thinking about getting this book to read, just go a head and do it' 'Adam is just *swoon*' 'Ali Hazelwood has made herself an auto-buy author' 'It was just... perfect.' 'A heroine you will instantly fall in love with'",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781408725757"
            },
            {
              "type": "ISBN_10",
              "identifier": "1408725754"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 384,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "averageRating": 4,
          "ratingsCount": 15,
          "maturityRating": "MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.4.4.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=o5lDEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=o5lDEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=o5lDEAAAQBAJ&pg=PP1&dq=love&hl=&cd=21&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=o5lDEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=o5lDEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 531,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 265.5,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=o5lDEAAAQBAJ&rdid=book-o5lDEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 531000000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 265500000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/The_Love_Hypothesis-sample-epub.acsm?id=o5lDEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=o5lDEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Yes.&#39; &#39;Funny. Snarky. Intelligent. Real.&#39; &#39;If you&#39;re even slightly thinking about getting this book to read, just go a head and do it&#39; &#39;Adam is just *swoon*&#39; &#39;Ali Hazelwood has made herself an auto-buy author&#39; &#39;It was just... perfect."
        }
      },
      {
        "kind": "books#volume",
        "id": "v_PBAQAACAAJ",
        "etag": "5BN/bpYgiQk",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/v_PBAQAACAAJ",
        "volumeInfo": {
          "title": "The New Faber Book of Love Poems",
          "authors": [
            "James Fenton"
          ],
          "publishedDate": "2008",
          "description": "James Fenton, a Whitbread-winning poet praised for his own love poetry, gathers together the best lyric poems originating in the English language. Ranging from the sixteenth century to the present day, The New Faber Book of Love Poems contains a fantastic mix of classics and popular favourites, as well as blues lyrics, American folk poetry, Elizabethan lyrics and Broadway songs. There are poems by men about women, women about men, men about men and women about women - in short, something for everyone, and a must-have for everyone's bookshelf.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "0571218156"
            },
            {
              "type": "ISBN_13",
              "identifier": "9780571218158"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 453,
          "printType": "BOOK",
          "categories": [
            "Love poetry, English"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=v_PBAQAACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=v_PBAQAACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=v_PBAQAACAAJ&dq=love&hl=&cd=22&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=v_PBAQAACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_New_Faber_Book_of_Love_Poems.html?hl=&id=v_PBAQAACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=v_PBAQAACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "&#39;The New Faber Book of Love Poems&#39; presents some of the most emotive and memorable lyric poems produced in the English language from the Renaissance to the present. _Filled with poems to treasure._, Daily MailCOPY The New Faber Book of Love ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "wuVqPwAACAAJ",
        "etag": "i1iF1zJiLtk",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/wuVqPwAACAAJ",
        "volumeInfo": {
          "title": "PS, I Love You",
          "authors": [
            "Cecelia Ahern"
          ],
          "publisher": "Hyperion",
          "publishedDate": "2005-11-29",
          "description": "A wonderfully warm and heartfelt debut from a stunning new talent. Everyone needs a guardian angel! Some people wait their whole lives to find their soul mates. But not Holly and Gerry. Childhood sweethearts, they could finish each other's sentences and even when they fought, they laughed. No one could imagine Holly and Gerry without each other. Until the unthinkable happens. Gerry's death devastates Holly. But as her 30th birthday looms, Gerry comes back to her. He's left her a bundle of notes, one for each of the months after his death, gently guiding Holly into her new life without him, each note signed 'PS, I Love You'. As the notes are gradually opened, and as the year unfolds, Holly is both cheered up and challenged. The man who knows her better than anyone sets out to teach her that life goes on. With some help from her friends, and her noisy and loving family, Holly finds herself laughing, crying, singing, dancing -- and being braver than ever before. Life is for living, she realises -- but it always helps if there's an angel watching over you.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "0786890932"
            },
            {
              "type": "ISBN_13",
              "identifier": "9780786890934"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 496,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "averageRating": 4,
          "ratingsCount": 105,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=wuVqPwAACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=wuVqPwAACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=wuVqPwAACAAJ&dq=love&hl=&cd=23&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=wuVqPwAACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/PS_I_Love_You.html?hl=&id=wuVqPwAACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=wuVqPwAACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "But as her 30th birthday looms, Gerry comes back to her. He&#39;s left her a bundle of notes, one for each of the months after his death, gently guiding Holly into her new life without him, each note signed &#39;PS, I Love You&#39;."
        }
      },
      {
        "kind": "books#volume",
        "id": "LPA9zgEACAAJ",
        "etag": "8lMbmXwzlKQ",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/LPA9zgEACAAJ",
        "volumeInfo": {
          "title": "Love Stories",
          "subtitle": "My First Love!",
          "authors": [
            "Destiny Media Llp"
          ],
          "publishedDate": "2021-02-14",
          "description": "♥ LOVE STORIES: MY FIRST LOVE seeks to recreate for the reader the excitement, the frustration, the pain, the agony, the anxiety, the rush of blood, the unsurpassable overwhelming emotion that floods out minds and bodies and leaves us completely helpless in front of the object of our desire. ♥ Love Stories My First Love is a collection of short romantic stories from India about various writers recreating their experience of falling in love for the very first time. ♥ Read and enjoy this Anthology with your loved one.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9798709299740"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 138,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=LPA9zgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=LPA9zgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=LPA9zgEACAAJ&dq=love&hl=&cd=24&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=LPA9zgEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_Stories.html?hl=&id=LPA9zgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=LPA9zgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The stories in this Anthology cover a whole gamut of emotions and attempt to decode what &#39;Love&#39;, especially falling in love for the first time can entail... ♥ Sonal Bakshi and Shireen Sethi write about epic romances that seem unbelievable ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "XGgYAQAAIAAJ",
        "etag": "WJlDzrytGzc",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/XGgYAQAAIAAJ",
        "volumeInfo": {
          "title": "The comedy of errors. Much ado about nothing. Love's labor's lost",
          "authors": [
            "William Shakespeare"
          ],
          "publishedDate": "1902",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "UCAL:B3042047"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.4.5.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=XGgYAQAAIAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=XGgYAQAAIAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=XGgYAQAAIAAJ&q=love&dq=love&hl=&cd=25&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=XGgYAQAAIAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_comedy_of_errors_Much_ado_about_noth.html?hl=&id=XGgYAQAAIAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=XGgYAQAAIAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "And, I pray thee now, tell me for which of my bad parts didst thou first fall in \u003cb\u003elove\u003c/b\u003e with me? 6I A&#39;eat. For them all together; which maintained so politic a state of evil that they will not admit any good part to intermingle with them."
        }
      },
      {
        "kind": "books#volume",
        "id": "AupOAQAAMAAJ",
        "etag": "JJ1zhzuWDi4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/AupOAQAAMAAJ",
        "volumeInfo": {
          "title": "Love's Denial",
          "subtitle": "Published Serially Under the Title The Shining Talent",
          "authors": [
            "Eleanor Early"
          ],
          "publishedDate": "1932",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OSU:32435007951700"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 310,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.2.2.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=AupOAQAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=AupOAQAAMAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=AupOAQAAMAAJ&q=love&dq=love&hl=&cd=26&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=AupOAQAAMAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Denial.html?hl=&id=AupOAQAAMAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=AupOAQAAMAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Published Serially Under the Title The Shining Talent Eleanor Early. The Ohio State Un iversity ||||||||||||| 3.2435.Qg795 1799 \u003cb\u003eLOVE&#39;S\u003c/b\u003e DENIAL - Isissilisi. 15 8 07 004 0."
        }
      },
      {
        "kind": "books#volume",
        "id": "KZf94iCfqX4C",
        "etag": "IS+96QrG/Fs",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/KZf94iCfqX4C",
        "volumeInfo": {
          "title": "Love's Advocate",
          "authors": [
            "Jean Kent"
          ],
          "publisher": "Harlequin Books",
          "publishedDate": "1985-04",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "0373092377"
            },
            {
              "type": "ISBN_13",
              "identifier": "9780373092376"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 252,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.1.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=KZf94iCfqX4C&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=KZf94iCfqX4C&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=KZf94iCfqX4C&q=love&dq=love&hl=&cd=27&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=KZf94iCfqX4C&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Advocate.html?hl=&id=KZf94iCfqX4C"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=KZf94iCfqX4C&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Jean Kent. - - - - - - - - - - - - - - - - - - - - - - - - - \u003cb\u003eLove\u003c/b\u003e &#39;"
        }
      },
      {
        "kind": "books#volume",
        "id": "g1UwAAAAIAAJ",
        "etag": "+sO7wtLa4mM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/g1UwAAAAIAAJ",
        "volumeInfo": {
          "title": "Love's Will",
          "subtitle": "(poems 1967)",
          "authors": [
            "Harvey Bialy"
          ],
          "publishedDate": "1968",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "UCAL:B3728098"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 16,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "3.3.2.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=g1UwAAAAIAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=g1UwAAAAIAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=g1UwAAAAIAAJ&q=love&dq=love&hl=&cd=28&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=g1UwAAAAIAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Will.html?hl=&id=g1UwAAAAIAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=g1UwAAAAIAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "... torture each other trying to find some exquisite pain will make us both scream this is the pleasure of the Glory, This is the body of the Celestial Magus, This horn of plenty opening between) a silver nail, fixes us. to \u003cb\u003eLove&#39;s\u003c/b\u003e will."
        }
      },
      {
        "kind": "books#volume",
        "id": "H8xrAAAAMAAJ",
        "etag": "kT9nHtpxngk",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/H8xrAAAAMAAJ",
        "volumeInfo": {
          "title": "Love's Labor",
          "subtitle": "Twenty-five Years of Experience in the Practice of Psychotherapy",
          "authors": [
            "Stanley E. Greben"
          ],
          "publisher": "Schocken",
          "publishedDate": "1984",
          "description": "Examines the effects of the psychotherapist's personality on the treatment of a patient and discusses the author's experiences as a psychotherapist",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "UOM:39015009567119"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 203,
          "printType": "BOOK",
          "categories": [
            "Psychology"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.1.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=H8xrAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=H8xrAAAAMAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=H8xrAAAAMAAJ&q=love&dq=love&hl=&cd=29&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=H8xrAAAAMAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Labor.html?hl=&id=H8xrAAAAMAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=H8xrAAAAMAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Twenty-five Years of Experience in the Practice of Psychotherapy Stanley E. Greben. பாக \u003cb\u003eLOVE\u003c/b\u003e &#39; S LABOR Twenty - five Years of Experience."
        }
      },
      {
        "kind": "books#volume",
        "id": "yjVCEAAAQBAJ",
        "etag": "uuyBsDYmc3s",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/yjVCEAAAQBAJ",
        "volumeInfo": {
          "title": "What Is Love?",
          "authors": [
            "Mac Barnett"
          ],
          "publisher": "Chronicle Books",
          "publishedDate": "2021-12-28",
          "description": "A beautiful fable about the nature of love, from beloved, award-winning picture book creators Mac Barnett and Carson Ellis. \"What is love?\" a young boy asks. \"I can't answer that,\" his grandmother says, and so the boy goes out into the world to find out. But while each person he meets—the fisherman, the actor, and others—has an answer to his question, not one seems quite right. Could love really be a fish, or applause, or the night? Or could it actually be something much closer to home? This tender, funny tale is an original take on the \"I love you\" story, a picture book treasure for all ages to read and cherish. A CLASSIC LOVE STORY: A wonderful narrative voice and spectacular pictures give this book the feel of a modern classic. Fans of The Runaway Bunny, Guess How Much I Love You, and Love You Forever will adore this book. A BOOK THAT KIDS AS WELL AS PARENTS WILL ENJOY: Many books about the love between parents and children are told from an adult's point of view. This book begins from the child's perspective, and it's funny and unexpected in ways that children can relate to, while being thoughtful in ways that adults will appreciate. Like all great children's books, this book can be understood on many levels. A BOOK ABOUT FINDING YOURSELF: The boy's journey takes him to many different people, whose descriptions of what love means to them is very much about how they see themselves and their lives. A GREAT READ-ALOUD: The engaging text is full of surprises and the distinctive voice of the narrator invites audiences to respond. STAR TALENT: Mac Barnett is a New York Times bestselling author and a beloved figure on the school speaking circuit. Carson Ellis is a Caldecott Honor–winner and illustrator of some of the most interesting and beautiful children's books published today. They're an incredible creative duo and long-time friends, working together for the first time on this book. Perfect for: • Mac Barnett fans • Carson Ellis Fans • Parents and grandparents • Educators • Librarians",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781452183633"
            },
            {
              "type": "ISBN_10",
              "identifier": "1452183635"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 44,
          "printType": "BOOK",
          "categories": [
            "Juvenile Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=yjVCEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=yjVCEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=yjVCEAAAQBAJ&printsec=frontcover&dq=love&hl=&cd=30&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=yjVCEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=yjVCEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 1056.1,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 528.05,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=yjVCEAAAQBAJ&rdid=book-yjVCEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 1056100000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 528050000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/What_Is_Love-sample-epub.acsm?id=yjVCEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/What_Is_Love-sample-pdf.acsm?id=yjVCEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=yjVCEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "A CLASSIC LOVE STORY: A wonderful narrative voice and spectacular pictures give this book the feel of a modern classic. Fans of The Runaway Bunny, Guess How Much I Love You, and Love You Forever will adore this book."
        }
      },
      {
        "kind": "books#volume",
        "id": "U4vlJxdjoroC",
        "etag": "eGK3WqfXBY4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/U4vlJxdjoroC",
        "volumeInfo": {
          "title": "Love's Majesty",
          "authors": [
            "Charles Beamer"
          ],
          "publishedDate": "1983-02",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "0890813256"
            },
            {
              "type": "ISBN_13",
              "identifier": "9780890813256"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 160,
          "printType": "BOOK",
          "categories": [
            "Christian fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.2.1.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=U4vlJxdjoroC&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=U4vlJxdjoroC&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=U4vlJxdjoroC&q=love&dq=love&hl=&cd=31&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=U4vlJxdjoroC&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Majesty.html?hl=&id=U4vlJxdjoroC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=U4vlJxdjoroC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "5fg5AhssBH8C",
        "etag": "Ac3fRqnlZKc",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/5fg5AhssBH8C",
        "volumeInfo": {
          "title": "Love's Ransom",
          "authors": [
            "Lisa Samson"
          ],
          "publisher": "Harvest House Pub",
          "publishedDate": "1997",
          "description": "This book is set in 1229 in England. The majority of this story unfolds in Marchemont Castle, the home of the Alexander de la Marche, Earl of Lambeth. This castle is situated on the Thames, on the ourskirts of London. It is also within a short distance of Westminster Abbey. This book touches on evil and the consquences of going against what God wants us to do.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1565075293"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781565075290"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 328,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.2.2.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=5fg5AhssBH8C&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=5fg5AhssBH8C&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=5fg5AhssBH8C&q=love&dq=love&hl=&cd=32&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=5fg5AhssBH8C&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Ransom.html?hl=&id=5fg5AhssBH8C"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=5fg5AhssBH8C&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "PbLYAAAAMAAJ",
        "etag": "a+ut6bjktHI",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/PbLYAAAAMAAJ",
        "volumeInfo": {
          "title": "Love's Enchantment; Story Poems and Ballads",
          "authors": [
            "Helen Josephine Ferris"
          ],
          "publisher": "Books for Libraries",
          "publishedDate": "1969",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "IND:30000121005106"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 120,
          "printType": "BOOK",
          "categories": [
            "Ballade"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.2.1.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=PbLYAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=PbLYAAAAMAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=PbLYAAAAMAAJ&pg=PP6&dq=love&hl=&cd=33&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=PbLYAAAAMAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Enchantment_Story_Poems_and_Balla.html?hl=&id=PbLYAAAAMAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=PbLYAAAAMAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "UBBOhHHcBDcC",
        "etag": "ZyQRn5e6jGo",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/UBBOhHHcBDcC",
        "volumeInfo": {
          "title": "Love's Promise",
          "authors": [
            "Adrienne Ellis Reeves"
          ],
          "publisher": "Pinnacle Books",
          "publishedDate": "1998",
          "description": "Partnered with gorgeous business man Cy Brewster for a community service event, Beth Jordan--who has difficulty with commitment--cannot deny the fierce passion that erupts between them and realizes that he is the one to quell her restless heart, until a dark secret from his past threatens to tear them apart. Original.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "0786005688"
            },
            {
              "type": "ISBN_13",
              "identifier": "9780786005680"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 283,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.2.1.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=UBBOhHHcBDcC&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=UBBOhHHcBDcC&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=UBBOhHHcBDcC&q=love&dq=love&hl=&cd=34&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=UBBOhHHcBDcC&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Promise.html?hl=&id=UBBOhHHcBDcC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=UBBOhHHcBDcC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "rawPAAAAYAAJ",
        "etag": "SL5Zj6i9iM4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/rawPAAAAYAAJ",
        "volumeInfo": {
          "title": "Love's Fire",
          "subtitle": "Re-creations of Rumi",
          "authors": [
            "Jalāl al-Dīn Rūmī (Maulana)",
            "Andrew Harvey"
          ],
          "publisher": "Jonathan Cape",
          "publishedDate": "1988",
          "description": "A collection of re-creations of poems taken from Rumi's Rubaiyat. Religious in inspiration, the poems are about love and its phases - longing, fulfilment, loss, mourning and final union. The author won the 1985 Christmas Humphreys Prize for his book A Journey in Ladakh.",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "UVA:X001602444"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 108,
          "printType": "BOOK",
          "categories": [
            "English poetry"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.1.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=rawPAAAAYAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=rawPAAAAYAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=rawPAAAAYAAJ&q=love&dq=love&hl=&cd=35&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=rawPAAAAYAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Fire.html?hl=&id=rawPAAAAYAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=rawPAAAAYAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "6ntBAQAAMAAJ",
        "etag": "YbmjsMbdcaI",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/6ntBAQAAMAAJ",
        "volumeInfo": {
          "title": "Love's Triumph",
          "subtitle": "An Opera in Three Acts",
          "authors": [
            "James Robinson Planché",
            "William Vincent Wallace"
          ],
          "publishedDate": "1862",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "UIUC:30112065883479"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 63,
          "printType": "BOOK",
          "categories": [
            "Operas"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.3.1.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=6ntBAQAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=6ntBAQAAMAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=6ntBAQAAMAAJ&q=love&dq=love&hl=&cd=36&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=6ntBAQAAMAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Triumph.html?hl=&id=6ntBAQAAMAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=6ntBAQAAMAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "WBA-Gy7qR6QC",
        "etag": "D/XH6LpZPLw",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/WBA-Gy7qR6QC",
        "volumeInfo": {
          "title": "Love's Dawning",
          "authors": [
            "Tate McKenna"
          ],
          "publishedDate": "1984",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "0440150205"
            },
            {
              "type": "ISBN_13",
              "identifier": "9780440150206"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 191,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.1.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=WBA-Gy7qR6QC&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=WBA-Gy7qR6QC&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=WBA-Gy7qR6QC&q=love&dq=love&hl=&cd=37&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=WBA-Gy7qR6QC&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Dawning.html?hl=&id=WBA-Gy7qR6QC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=WBA-Gy7qR6QC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "nT-MyalbhScC",
        "etag": "oRLdVmu2BQE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/nT-MyalbhScC",
        "volumeInfo": {
          "title": "Love's Body",
          "authors": [
            "Norman O. Brown"
          ],
          "publishedDate": "1968",
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.3.1.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=nT-MyalbhScC&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=nT-MyalbhScC&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=nT-MyalbhScC&q=love&dq=love&hl=&cd=38&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=nT-MyalbhScC&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Body.html?hl=&id=nT-MyalbhScC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=nT-MyalbhScC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "jtdmsnmFU6cC",
        "etag": "b4gxJC/FlQ4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/jtdmsnmFU6cC",
        "volumeInfo": {
          "title": "LOVE'S TEMPTATION",
          "authors": [
            "GLENNA FINLEY"
          ],
          "publishedDate": "1979",
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.1.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=jtdmsnmFU6cC&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=jtdmsnmFU6cC&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=jtdmsnmFU6cC&q=love&dq=love&hl=&cd=39&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=jtdmsnmFU6cC&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/LOVE_S_TEMPTATION.html?hl=&id=jtdmsnmFU6cC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=jtdmsnmFU6cC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "AW3QAAAAMAAJ",
        "etag": "mdUFXhYNXwI",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/AW3QAAAAMAAJ",
        "volumeInfo": {
          "title": "Love's Response",
          "subtitle": "A Story of Lutheran Deaconesses in America",
          "authors": [
            "Frederick Sheely Weiser"
          ],
          "publishedDate": "1962",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "WISC:89065278152"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 164,
          "printType": "BOOK",
          "categories": [
            "Deaconesses"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.2.2.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=AW3QAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=AW3QAAAAMAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=AW3QAAAAMAAJ&q=love&dq=love&hl=&cd=40&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=AW3QAAAAMAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Response.html?hl=&id=AW3QAAAAMAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=AW3QAAAAMAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      }, {
        "kind": "books#volume",
        "id": "AFlPEAAAQBAJ",
        "etag": "98Vqpsj1aSs",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/AFlPEAAAQBAJ",
        "volumeInfo": {
          "title": "Is This Love?",
          "authors": [
            "C. E. Riley"
          ],
          "publisher": "Serpent's Tail",
          "publishedDate": "2022-08-04",
          "description": "'This is a book about the untidy, complicated underbelly of love and love's end. Funny and true, wise and utterly authentic, you will recognise yourself over and over. I loved it.' Kit de Waal Did you mean to marry me? Did you understand the vows that we took? J's wife has left, and J is trying to understand why. How could someone you loved so much, who claimed to love you once, just walk away? How could they send divorce papers accusing you of terrible things, when all you've ever done is tried to make them happy? Narrated by J in the days, weeks and months after the marriage collapses, and interspersed with the departed wife's diary entries, Is This Love? is an addictive, deeply unsettling, and provocative novel of deception and betrayal, and passion turned to pain. As the story unfolds, and each character's version of events undermines the other, all our assumptions about victimhood, agency, love and control are challenged - for we never know J's gender. If we did, would it change our minds about who was telling the truth?",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781782839750"
            },
            {
              "type": "ISBN_10",
              "identifier": "1782839755"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=AFlPEAAAQBAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=AFlPEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=AFlPEAAAQBAJ&dq=love&hl=&cd=1&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=AFlPEAAAQBAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Is_This_Love.html?hl=&id=AFlPEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=AFlPEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "&#39;This is a book about the untidy, complicated underbelly of love and love&#39;s end."
        }
      },
      {
        "kind": "books#volume",
        "id": "VatQEAAAQBAJ",
        "etag": "oCYoBjrI1TM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/VatQEAAAQBAJ",
        "volumeInfo": {
          "title": "Miles Apart",
          "subtitle": "To Friendship, Love and All That!",
          "authors": [
            "Pratichi Sanaye"
          ],
          "publisher": "Notion Press",
          "publishedDate": "2021-11-09",
          "description": "Shruti, Simran, Ayush and Samar go through the ups and downs of friendship, love and togetherness. What started as a misunderstanding in college transforms into a full-blown conflict. Is it meaningless to apologise? Well, you will find out after you read the book! Miles Apart talks of the dichotomies that relationships bring. Loving someone is a special feeling indeed. However, love does have its share of crests and troughs. This book is all about the friendship they share and also about the misunderstandings that tend to creep into the picture out of nowhere. ‘Miles Apart’ has something for just about everybody. This book celebrates true love and friendship. All those who wish to revisit their days at college can pick this book right away and you won’t be able to get enough of it!",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781685388614"
            },
            {
              "type": "ISBN_10",
              "identifier": "1685388612"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 316,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "averageRating": 4.5,
          "ratingsCount": 2,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=VatQEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=VatQEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=VatQEAAAQBAJ&pg=PP1&dq=love&hl=&cd=2&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=VatQEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=VatQEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 149,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 149,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=VatQEAAAQBAJ&rdid=book-VatQEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 149000000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 149000000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=VatQEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book celebrates true love and friendship. All those who wish to revisit their days at college can pick this book right away and you won’t be able to get enough of it!"
        }
      },
      {
        "kind": "books#volume",
        "id": "6_uvzgEACAAJ",
        "etag": "OAM5v795f60",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/6_uvzgEACAAJ",
        "volumeInfo": {
          "title": "Self-Love: Falling In Love With Yourself",
          "authors": [
            "K. D. Jones"
          ],
          "publishedDate": "2021-11",
          "description": "Sequence your relationship with yourself. \"Self-Love - Falling in love with yourself\" guide will unfold the power of self-love and unravel the beneficial secret of loving oneself. These easy, practical methods achieve better self-esteem, more positive thinking, and a greater appreciation of yourself. This book includes: A path to self-love and its Principles―Acknowledging the power of self-love is the greatest decision to evolve. This is the key that helps in elaborating the relationship between self-compassion and self-love. Shedding light on the clue to dating yourself - From taking yourself on a \"date\" to celebrating life's small victories, establishing a self-love routine can be fun and easy to carry with this masterpiece. Unveiling the process of being a better version of yourself ―Avoids self-doubt, low self-esteem, and negative thought patterns with the highly effective activities in this book. Dating yourself is part of what you will benefit from ―Self-love enables you to see your true self and accept yourself wholeheartedly. Acceptance brings with it the freedom and confidence to live your life to the fullest. It's time to get rid of self-doubt and self-sabotage. It's time to start loving yourself!",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9798985064704"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 58,
          "printType": "BOOK",
          "categories": [
            "Self-Help"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=6_uvzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=6_uvzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=6_uvzgEACAAJ&dq=love&hl=&cd=3&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=6_uvzgEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Self_Love_Falling_In_Love_With_Yourself.html?hl=&id=6_uvzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=6_uvzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book includes: A path to self-love and its Principles―Acknowledging the power of self-love is the greatest decision to evolve. This is the key that helps in elaborating the relationship between self-compassion and self-love."
        }
      },
      {
        "kind": "books#volume",
        "id": "trQj0GrKuPoC",
        "etag": "AwtwOwnLeRU",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/trQj0GrKuPoC",
        "volumeInfo": {
          "title": "Love's Rite",
          "subtitle": "Same-Sex Marriages in Modern India",
          "authors": [
            "Ruth Vanita"
          ],
          "publisher": "Penguin Books India",
          "publishedDate": "2021-08",
          "description": "(This) Absorbing New Book Shows How Subtly And Imaginatively Indian Attitudes Toward Same-Sex Unions Have Evolved Over The Centuries&And Offers A Marvelously Global Perspective Characterized By Profound Historical Understanding, Impeccable Scholarship, And A Rare And Delightful Precision Of Feeling. - Terry Castle, Professor At Stanford University, Editor Of The Literature Of Lesbianism. Why Should The State S Refusal To Recognize A Union As Marriage Mean That The Union Is Not A Marriage? In Love S Rite Ruth Vanita Asks This Challenging Question In Order To Emphasize That Mutual Consent And Family And Community Recognition Validate A Marriage-And This Support Frequently Extends To Same-Sex Marriages As Well. When People Claim The Right To Marry, Their Sex Or Sexuality Is Not Intrinsic To That Right, Although Social Prejudice Makes It Appear So. Moreover, It Cannot Be Denied That A Multitude Of Events And Depictions In Vastly Different Cultures, Times And Places, All Point To The Possibility Of Same-Sex Love And Commitment Being Recognized And Accepted. Marriage Is A Universal Rite Of Passage That Can, In The Right Circumstances, Become The Perfect Ceremony Of Love S Rite . Vanita Examines The Twin Phenomena Of Same-Sex Weddings And Same-Sex Joint Suicides (Mostly Female) That Have Been Reported From Many Parts Of India. She Argues That These Couples, When They Choose To Marry Or Die Together, Invoke Long-Standing But Fluid Indian Legal, Religious, And Literary-Cinematic Traditions To Declare Their Love To The World. Using Her Intimate Knowledge Of Ancient Indian Textual History, The Author Demonstrates That Same-Sex Love And Relationships Are Deeply Rooted In Indian Culture- And Compares The Cultural And Legal Implications Of Same-Sex Marriage In India With Those In The West. The International Debate On Same-Sex Marriage Is Relevant To All Democratic Societies Today. Ruth Vanita Brings A Fresh Perspective To This Debate, Suggesting That Same-Sex Marriage Dwells At The Heart, Not On The Margins, Of Culture. An Effortless Combination Of Empathy, Moral Conviction And Deep Cultural Sensitivity -Ashis Nandy",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "0144000598"
            },
            {
              "type": "ISBN_13",
              "identifier": "9780144000593"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 280,
          "printType": "BOOK",
          "categories": [
            "History"
          ],
          "maturityRating": "MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.3.2.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=trQj0GrKuPoC&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=trQj0GrKuPoC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=trQj0GrKuPoC&printsec=frontcover&dq=love&hl=&cd=4&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=trQj0GrKuPoC&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Rite.html?hl=&id=trQj0GrKuPoC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=trQj0GrKuPoC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "In Love S Rite Ruth Vanita Asks This Challenging Question In Order To Emphasize That Mutual Consent And Family And Community Recognition Validate A Marriage-And This Support Frequently Extends To Same-Sex Marriages As Well."
        }
      },
      {
        "kind": "books#volume",
        "id": "TbFCEAAAQBAJ",
        "etag": "kBGWQbvkwbo",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/TbFCEAAAQBAJ",
        "volumeInfo": {
          "title": "Behind Love's Wall",
          "authors": [
            "Carrie Fancett Pagels"
          ],
          "publisher": "Barbour Publishing",
          "publishedDate": "2021-11-01",
          "description": "The Grand Hotel Slowly Reveals Her Secrets Walk through Doors to the Past via a new series of historical stories of romance and adventure. Two successful women, a hundred-and-twenty-years apart, build walls to protect their hearts. Modern-day Willa, a successful interior decorator, is chosen to go to Mackinac Island and consult for the Grand Hotel’s possible redesign. During work on a room, she discovers a journal detailing the struggles of a young woman, Lily—which reveals dark secrets. The renowned singer wasn’t who she pretended to be. As Willa reaches out to Lily’s descendant, a charismatic and prominent landscape artist, she lets down her guard. Should she share the journal with him—revealing hidden history—or once again erect a wall as she struggles to redesign both the Grand and her life? CARRIE FANCETT PAGELS, Ph.D., awarding-winning author of over twenty Christian fiction books, is a former psychologist of 25 years and enjoys spending her summers at the Straits of Mackinac, where this story is set.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781636090719"
            },
            {
              "type": "ISBN_10",
              "identifier": "1636090710"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 256,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "averageRating": 4,
          "ratingsCount": 13,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.2.2.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=TbFCEAAAQBAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=TbFCEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=TbFCEAAAQBAJ&pg=PP1&dq=love&hl=&cd=5&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=TbFCEAAAQBAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Behind_Love_s_Wall.html?hl=&id=TbFCEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true
          },
          "pdf": {
            "isAvailable": true
          },
          "webReaderLink": "http://play.google.com/books/reader?id=TbFCEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "4_YIEAAAQBAJ",
        "etag": "ccqqMFHdMgU",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/4_YIEAAAQBAJ",
        "volumeInfo": {
          "title": "Love's Dwelling",
          "authors": [
            "Kelly Irvin"
          ],
          "publisher": "Zondervan",
          "publishedDate": "2021-07-06",
          "description": "God always had a plan. But how could falling in love with an Englischer be God’s plan for one young Amish woman? Young Cassie Weaver only wants what is expected of an Amish woman: a good Amish husband and a large family. But she’s happy as Job and Dinah Keim’s housekeeper, helping Dinah, who is losing her sight due to diabetes. For two decades the Keims have prayed for the salvation of their two children who left the community in a cloud of shame and mystery. Mason knew there was more to his mother’s past than she let on, but nothing could have prepared him for learning about his Amish roots upon his mother’s sudden death. Even more surprising, his mother named her Amish parents, Job and Dinah, as guardians to her five children. Now Mason has to trust that this couple, and their pretty housekeeper, can take care of his younger siblings, even when all he wants is to take care of them himself. As the children adjust to this new lifestyle, Mason finds himself pulled back to the Keims’ home. Yes, he wants to see his siblings, but it’s the conversations with Cassie that keep him coming back for more. Is there more to this Amish faith and how does it play into his own past? Cassie guards against her growing feelings for Mason, because there can be no happy ending for a Plain girl in love with an Englisch man . . . right? Bestselling and award-winning Amish romance novelist Kelly Irvin is back with a heartwarming tale of the power of love to heal all wounds. The first in a new, sweet Amish romance series Full novel at 98,000 words Includes discussion questions for book clubs",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780310364498"
            },
            {
              "type": "ISBN_10",
              "identifier": "0310364493"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 368,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "averageRating": 4,
          "ratingsCount": 3,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.2.2.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=4_YIEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=4_YIEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=4_YIEAAAQBAJ&pg=PP1&dq=love&hl=&cd=6&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=4_YIEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=4_YIEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 754.3,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 377.15,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=4_YIEAAAQBAJ&rdid=book-4_YIEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 754300000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 377150000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Love_s_Dwelling-sample-epub.acsm?id=4_YIEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=4_YIEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Bestselling and award-winning Amish romance novelist Kelly Irvin is back with a heartwarming tale of the power of love to heal all wounds."
        }
      },
      {
        "kind": "books#volume",
        "id": "P2nprDLPRLwC",
        "etag": "sn2JC/UPUK8",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/P2nprDLPRLwC",
        "volumeInfo": {
          "title": "Same-Sex Love in India",
          "subtitle": "A Literary History",
          "authors": [
            "Ruth Vanita",
            "Saleem Kidwai"
          ],
          "publisher": "Penguin UK",
          "publishedDate": "2021-06-24",
          "description": "In 2009, the Delhi High Court's historic judgment overturning Section 377 as violative of the Indian Constitution referred to Same-Sex Love in India. So did the 2018 Supreme Court decision which upheld that judgment. All the petitions against this anti-sodomy law have cited this landmark book to prove that homosexuality is not a Western import. Same-Sex Love in India is the book that brought to light the long, incontestable history of same-sex love and desire in the Indian subcontinent. Covering over 2000 years, from the Mahabharata to the late twentieth century, the book contains excerpts from stories, poems, letters, biographies and histories in fifteen languages. The editors' introductions to each period and text trace the changing depictions of and debates around same-sex relations, illuminating their social, political and literary contexts. These essays have been called 'outstanding works of scholarship'. Including writings that range from romantic to analytical, playful to thoughtful, this classic work will help you see Indian culture and society with new eyes.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9788184759693"
            },
            {
              "type": "ISBN_10",
              "identifier": "818475969X"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 479,
          "printType": "BOOK",
          "categories": [
            "Social Science"
          ],
          "maturityRating": "MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.5.5.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=P2nprDLPRLwC&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=P2nprDLPRLwC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=P2nprDLPRLwC&printsec=frontcover&dq=love&hl=&cd=7&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=P2nprDLPRLwC&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=P2nprDLPRLwC"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 424,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 296.8,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=P2nprDLPRLwC&rdid=book-P2nprDLPRLwC&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 424000000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 296800000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Same_Sex_Love_in_India-sample-epub.acsm?id=P2nprDLPRLwC&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=P2nprDLPRLwC&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "These essays have been called &#39;outstanding works of scholarship&#39;. Including writings that range from romantic to analytical, playful to thoughtful, this classic work will help you see Indian culture and society with new eyes."
        }
      },
      {
        "kind": "books#volume",
        "id": "2uekzgEACAAJ",
        "etag": "VDfeR0ECwvY",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/2uekzgEACAAJ",
        "volumeInfo": {
          "title": "Waiting for Love's Return",
          "authors": [
            "Morris Fenris"
          ],
          "publisher": "Morris Fenris",
          "publishedDate": "2021-09-10",
          "description": "A man she couldn't forget ... a second chance to prove that love never fails. A clean wholesome romance that's touching and tender. Maddie Grantham and Jeff Young fell head over heels in love almost a year ago, but sudden deployment orders kept them from following a standard path down the aisle. They got married in front of a local judge just days before Jeff was flown away with his team. Maddie tried to keep a smile on her face but seeing the other military wives pitying her on a daily basis was wearing on her. When she had the chance to change her perspective, she jumped at it. She moved to Montana and continued her work as a pediatric nurse, working with cancer patients. That was nine months ago, and now her husband is back. They were married for less than a week before he left, and Maddie is having to come to terms with the fact that she's married to a virtual stranger. She loves him, or at least, she loves what she knew about him. Now she has to learn to love the man standing in front of her and not let her fear of the future keep her from living up to the kind of wife she promised Jeff she'd be. Jeff Young leads a team of Special Forces soldiers into some of the most horrific places on the earth. He's just returned after spending several months in captivity. He returned to base, hoping to see his wife waiting there for him, but instead he is summoned to the CO's office. His wife moved to Montana! Jeff is given the opportunity to go to her and decide if he wishes to remain in the military. To say his wife is surprised when he shows up is an understatement. She's thrilled to have him back with her, but also terrified that he will be called away again. Join Jeff and Maddie as they navigate the waters of their relationship and learn to love each other again. Love came in like a tidal wave the first time around. Hurried and without any of the normal wedding accouterments. No family. No parents. No wedding cake or reception. No wedding dress. When two of Jeff's new friends suggest changing that, he can't help but go along with it. His love for Maddie is larger than life. With the help of the townsfolk and his friends, he'll give Maddie what she's always longed for. A wedding that only Castle Peaks could pull off.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9798201618001"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 186,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=2uekzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=2uekzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=2uekzgEACAAJ&dq=love&hl=&cd=8&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=2uekzgEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Waiting_for_Love_s_Return.html?hl=&id=2uekzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=2uekzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "A man she couldn&#39;t forget ... a second chance to prove that love never fails."
        }
      },
      {
        "kind": "books#volume",
        "id": "1s2qzgEACAAJ",
        "etag": "8Fv2zuNEskc",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/1s2qzgEACAAJ",
        "volumeInfo": {
          "title": "A Healing Love",
          "authors": [
            "Jd Hudson"
          ],
          "publishedDate": "2021-09-03",
          "description": "There is an old saying that states that fate works in mysterious ways and has a way of working things out as they should be at the right time. He is a successful, good-looking, caring doctor. A good, loving man. Though sought after by women, he is a confirmed bachelor. He scoffs at his grandfather's vision about him meeting his wolf-mate but does as he is asked and keeps an open mind and heart. With the passing of her husband shortly after her mother's passing, she can finally see an end to the lifetime of mental, emotional, and physical abuse she has dealt with at their hands. Though she's a very beautiful, loving, caring, woman, the abuse left her feeling unworthy and undeserving of ever finding true love and happiness. Their lives were very intertwined without either being aware of the other. Until fate stepped in to bring them together. They knew there was something special about the other as soon as their eyes met. They knew it was more than just physical attraction at the first innocent touch. They were connected somehow. His medical knowledge can help her physically after a stalker leaves her body broken, but can his love heal the scars left from the abuse she has suffered?",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1636925227"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781636925226"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 268,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=1s2qzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=1s2qzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=1s2qzgEACAAJ&dq=love&hl=&cd=9&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=1s2qzgEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/A_Healing_Love.html?hl=&id=1s2qzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=1s2qzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "There is an old saying that states that fate works in mysterious ways and has a way of working things out as they should be at the right time."
        }
      },
      {
        "kind": "books#volume",
        "id": "YicvEAAAQBAJ",
        "etag": "7BmDdPjdI1M",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/YicvEAAAQBAJ",
        "volumeInfo": {
          "title": "LOVE'S ONLY DECEPTION",
          "subtitle": "Harlequin Comics",
          "authors": [
            "Atsuko Nakamura",
            "CAROLE MORTIMER"
          ],
          "publisher": "Harlequin / SB Creative",
          "publishedDate": "2021-06-17",
          "description": "A grieving young woman tempted by love… Callie lost both her mother and beloved stepfather, Jeff, in the span of six months. While still mourning her losses, a lawyer informs her that Jeff has left her a fortune and his family wants to meet her. Callie visits them but finds them cold and unwelcoming, and they plan to take her inheritance by orchestrating a marriage between her and their son! Meanwhile, she meets a gentleman named Logan and becomes attracted to him. But will there only be romantic tragedy in store for Callie?",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9784596035035"
            },
            {
              "type": "ISBN_10",
              "identifier": "4596035032"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.2.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "3d352d3a06fdc99f_A",
            "imageBubbleVersion": "3d352d3a06fdc99f_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=YicvEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=YicvEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=YicvEAAAQBAJ&printsec=frontcover&dq=love&hl=&cd=10&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=YicvEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=YicvEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 585.4,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 292.7,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=YicvEAAAQBAJ&rdid=book-YicvEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 585400000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 292700000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/LOVE_S_ONLY_DECEPTION-sample-epub.acsm?id=YicvEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/LOVE_S_ONLY_DECEPTION-sample-pdf.acsm?id=YicvEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=YicvEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "A grieving young woman tempted by love… Callie lost both her mother and beloved stepfather, Jeff, in the span of six months."
        }
      },
      {
        "kind": "books#volume",
        "id": "VUAzEAAAQBAJ",
        "etag": "pTfr97hLHUw",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/VUAzEAAAQBAJ",
        "volumeInfo": {
          "title": "Love After Love",
          "subtitle": "A Novel",
          "authors": [
            "Ingrid Persaud"
          ],
          "publisher": "One World",
          "publishedDate": "2021-07-13",
          "description": "“A stellar debut . . . about an unconventional family, fear, hatred, violence, chasing love, losing it and finding it again just when we need it most.”—The New York Times Book Review WINNER OF THE COSTA BOOK AWARD • “A wonder . . . [This book] teems with real, Trinidadian life.”—Claire Adam, award-winning author of Golden Child SEMI-FINALIST FOR THE OCM BOCAS PRIZE • One of the Best Books of the Summer: Time • The Guardian • Goop • Women’s Day • LitHub After Betty Ramdin’s husband dies, she invites a colleague, Mr. Chetan, to move in with her and her son, Solo. Over time, the three become a family, loving each other deeply and depending upon one another. Then, one fateful night, Solo overhears Betty confiding in Mr. Chetan and learns a secret that plunges him into torment. Solo flees Trinidad for New York to carve out a lonely existence as an undocumented immigrant, and Mr. Chetan remains the singular thread holding mother and son together. But soon, Mr. Chetan’s own burdensome secret is revealed, with heartbreaking consequences. Love After Love interrogates love and family in all its myriad meanings and forms, asking how we might exchange an illusory love for one that is truly fulfilling. In vibrant, addictive Trinidadian prose, Love After Love questions who and how we love, the obligations of family, and the consequences of choices made in desperation. Praise for Love After Love “Love After Love is gift after gift. An unforgettable symphony of love and loss, heartache and guilt, and the secrets and lies that pull us together, and tear us apart. Dazzlingly told in the most electrifying prose you will read all year.”—Marlon James, Booker Prize–winning author of Black Leopard, Red Wolf “This book teems with real, Trinidadian life: neighbors so nosy they know your business before it happens; descriptions of food that'll have you googling recipes; feting and liming and plenty of sex. There's darkness here, too—violence, loneliness, moments of despair—and how Ingrid Persaud weaves all these elements together in one book, with so much warmth and humor and love for her characters, is a wonder.”—Claire Adam, award-winning author of Golden Child",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780593157589"
            },
            {
              "type": "ISBN_10",
              "identifier": "0593157583"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 336,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "averageRating": 4,
          "ratingsCount": 2,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.0.0.preview.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=VUAzEAAAQBAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=VUAzEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=VUAzEAAAQBAJ&pg=PP1&dq=love&hl=&cd=11&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=VUAzEAAAQBAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_After_Love.html?hl=&id=VUAzEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=VUAzEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "LuAlEAAAQBAJ",
        "etag": "PETbCMraPYY",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/LuAlEAAAQBAJ",
        "volumeInfo": {
          "title": "Perfectly Imperfect Love",
          "authors": [
            "Sankalp Shrivastava"
          ],
          "publisher": "Blue Rose Publishers",
          "publishedDate": "2021-03-26",
          "description": "Love as confusing as it is, has a routine set of rules. You have a Boy & a Girl, both get-together and fall in love. But what happens when that love falls apart, what happens when even after loving the girl with all his heart the boy keeps hurting her in every moment. What happens when the girl gets her heartbroken & decides to walk away, leaving the boy question his own existence. What happens when another girl comes in & makes that boy dream again, only to become a part of that dream herself. What happens when unexpectedly the first girl comes back into his life, leaving the boy perplexed, whom to love whom to not? Perfectly Imperfect Love is the Story of Sanjay & Sonam who were deeply in love, but they eventually fell apart. It is also about Diya who somehow becomes a part of this Story that was always supposed to be about the other two. Will Sanjay give in to his infatuation for Diya? Will Sanjay & Sonam move on in life or their love will eventually bring them back together? What will happen when love is all they have & still no one knows will it ever be enough.",
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 334,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.0.1.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=LuAlEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=LuAlEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=LuAlEAAAQBAJ&pg=PP1&dq=love&hl=&cd=12&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=LuAlEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=LuAlEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 175,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 122.5,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=LuAlEAAAQBAJ&rdid=book-LuAlEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 175000000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 122500000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Perfectly_Imperfect_Love-sample-pdf.acsm?id=LuAlEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=LuAlEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Perfectly Imperfect Love is the Story of Sanjay &amp; Sonam who were deeply in love, but they eventually fell apart. It is also about Diya who somehow becomes a part of this Story that was always supposed to be about the other two."
        }
      },
      {
        "kind": "books#volume",
        "id": "p7YTEAAAQBAJ",
        "etag": "TGhxFbpsIXU",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/p7YTEAAAQBAJ",
        "volumeInfo": {
          "title": "Our Reckless Hope",
          "authors": [
            "Love Belvin"
          ],
          "publisher": "MKT Publishing, LLC",
          "publishedDate": "2021-01-13",
          "description": "“I believe it was the night before Thanksgiving of the year I’d fallen for a tomboy fighter from a trailer park in South Jersey. I was in your kitchen when you told me cheating is wrong, and will never be right. But the biggest conflict is when you fall in love with someone who isn’t yours. “You said people fall in and out of love every day, and that most of it is bullshit…being more about passion and temporary emotions. But when the person you’re cheating with is worth a commitment and sacrifice, and when you’re prepared in your heart and mind to walk through the fire of the mess, it might be something real after all. That was and still is KaToria McNabb.” Fate via her unconceivable success reconnected the unlikely pair. What has happened? Why didn’t he call? Why didn’t she reach out? Ashton and Tori unravel the paths their lives took after Blakewood State University. It’s been a painful twelve-year journey of losses, betrayal, miscommunications, and death. Even in between the devastation were new lives, burgeoning careers, and millions being earned by them both. Nonetheless, can the wins override the pain in between? Publisher’s Note: “Our Reckless Hope” is book THREE of a THREE-book series. This book contains angst, profanity, and sexually explicit content. If either of these elements is not what you prefer between the pages of a novel, this is not the venture for you.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781950014460"
            },
            {
              "type": "ISBN_10",
              "identifier": "1950014460"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=p7YTEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=p7YTEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=p7YTEAAAQBAJ&pg=PP1&dq=love&hl=&cd=13&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=p7YTEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=p7YTEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 801.57,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 400.78,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=p7YTEAAAQBAJ&rdid=book-p7YTEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 801570000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 400780000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Our_Reckless_Hope-sample-epub.acsm?id=p7YTEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Our_Reckless_Hope-sample-pdf.acsm?id=p7YTEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=p7YTEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book contains angst, profanity, and sexually explicit content. If either of these elements is not what you prefer between the pages of a novel, this is not the venture for you."
        }
      },
      {
        "kind": "books#volume",
        "id": "oEGLzgEACAAJ",
        "etag": "zAmMNMcRlzQ",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/oEGLzgEACAAJ",
        "volumeInfo": {
          "title": "Love, the Moon & the Stars Between",
          "authors": [
            "Hannah Comrie"
          ],
          "publishedDate": "2021-07-06",
          "description": "in these pages i present you my soul love & the moon written by Hannah Comrie explores the reality of love, friendship, self-discovery, and heartache. In a world shaped by escapism and expectations, this collection of poems depicts real life. The beauty in the pain of living. This book is split into 5 sections, chapters of the authors life so far; ...the self ...the broken ...the damaged ...the hopeful ...the mended The emotions of teenagers and young adults around the world, the reality of what it is like to be young and making mistakes, falling in love, and discovering what it is to be you.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9798525086586"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 140,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=oEGLzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=oEGLzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=oEGLzgEACAAJ&dq=love&hl=&cd=14&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=oEGLzgEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_the_Moon_the_Stars_Between.html?hl=&id=oEGLzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=oEGLzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book is split into 5 sections, chapters of the authors&#39; life so far; ...the self ...the broken ...the damaged ...the hopeful ...the mended The emotions of teenagers and young adults around the world, the reality of what it is like to ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "vWvJDwAAQBAJ",
        "etag": "F2ktUwkqK58",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/vWvJDwAAQBAJ",
        "volumeInfo": {
          "title": "Visible Means of Support",
          "authors": [
            "Helen Joyce Harris"
          ],
          "publisher": "Wheatmark, Inc.",
          "publishedDate": "2020-01-13",
          "description": "When an impetuous young man is imprisoned for conspiracy to deal cocaine, his mother's shame drives her to keep his whereabouts secret from her friends, colleagues, and most especially from her own distant, aristocratic mother. The cover story requires an elaborate -- sometimes almost absurd -- set of contortions. Set at the peak of the \"Just Say No\" era in the late 1980s, Visible Means of Support depicts a young felon's adjustment to life inside the federal correctional system, as well as his mother's struggle with self-blame and her efforts to reconcile herself to her son's plight. Will the trouble tear this small family apart? If the secret leaks, will the people around her delight in spreading this gossip? Will it seal off her chance of promotion at the high school where she teaches? How can either son or mother ever again earn respect? And is the grandmother better off not knowing? Visible Means of Support deals with universal issues not amenable to easy answers. Told from the points of view of the three main characters, this gripping, provocative, ultimately hopeful story explores the costs of locking away the truth, however unsavory, as well as the potential release to be found in setting it free.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781627876209"
            },
            {
              "type": "ISBN_10",
              "identifier": "1627876200"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 358,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=vWvJDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=vWvJDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=vWvJDwAAQBAJ&pg=PP1&dq=love&hl=&cd=15&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=vWvJDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=vWvJDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 893.55,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 446.78,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=vWvJDwAAQBAJ&rdid=book-vWvJDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 893550000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 446780000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Visible_Means_of_Support-sample-epub.acsm?id=vWvJDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Visible_Means_of_Support-sample-pdf.acsm?id=vWvJDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=vWvJDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The cover story requires an elaborate -- sometimes almost absurd -- set of contortions."
        }
      },
      {
        "kind": "books#volume",
        "id": "77nADwAAQBAJ",
        "etag": "zrbsNud9nhY",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/77nADwAAQBAJ",
        "volumeInfo": {
          "title": "A Forever Love",
          "subtitle": "Rocco & Bella’s Story",
          "authors": [
            "Marsha Robinson"
          ],
          "publisher": "AuthorHouse",
          "publishedDate": "2019-11-23",
          "description": "Rocco and Bella’s past relationships have left them drained and discouraged. Despite the disappointments of their past, they still have a strong desire for a ‘Forever Love’ with the right person. As they cry out to God, He supernaturally puts them in each others path. You will fall in love with Rocco and Bella, as well as, many other fun-loving characters, as they encourage one another in a romantic tale of love, life, and friendship! As iron sharpens iron, they minister to one another and their friends while gaining spiritual knowledge and wisdom for life. The Faith & Romance Series masterfully combines romantic love with walking in God’s divine providence. You will be inspired as you witness them bearing one another’s burdens and establishing a community of God’s love.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781728332253"
            },
            {
              "type": "ISBN_10",
              "identifier": "1728332257"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 350,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=77nADwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=77nADwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=77nADwAAQBAJ&pg=PP1&dq=love&hl=&cd=16&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=77nADwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=77nADwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 336.3,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 235.41,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=77nADwAAQBAJ&rdid=book-77nADwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 336300000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 235410000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/A_Forever_Love-sample-epub.acsm?id=77nADwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=77nADwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "As iron sharpens iron, they minister to one another and their friends while gaining spiritual knowledge and wisdom for life. The Faith &amp; Romance Series masterfully combines romantic love with walking in God’s divine providence."
        }
      },
      {
        "kind": "books#volume",
        "id": "fX2cDwAAQBAJ",
        "etag": "iGeSoz1iL+g",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/fX2cDwAAQBAJ",
        "volumeInfo": {
          "title": "Far From Love",
          "authors": [
            "Wasaka Bari"
          ],
          "publisher": "Lieper Publication",
          "publishedDate": "2019-06-09",
          "description": "Painful the moment for him and she being the knower Couldn't wipe his tears that was like a shower In a weepingly manner,he kissed her grave Was sorry for the pain that he gave",
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 35,
          "printType": "BOOK",
          "categories": [
            "Poetry"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=fX2cDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=fX2cDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=fX2cDwAAQBAJ&pg=PP1&dq=love&hl=&cd=17&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=fX2cDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=fX2cDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 116.82,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 116.82,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=fX2cDwAAQBAJ&rdid=book-fX2cDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 116820000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 116820000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Far_From_Love-sample-pdf.acsm?id=fX2cDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=fX2cDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Painful the moment for him and she being the knower Couldn&#39;t wipe his tears that was like a shower In a weepingly manner,he kissed her grave Was sorry for the pain that he gave"
        }
      },
      {
        "kind": "books#volume",
        "id": "MxiMDwAAQBAJ",
        "etag": "xszWvPgmWzM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/MxiMDwAAQBAJ",
        "volumeInfo": {
          "title": "Love",
          "subtitle": "A New Understanding of an Ancient Emotion",
          "authors": [
            "Simon May"
          ],
          "publisher": "Oxford University Press",
          "publishedDate": "2019-03-12",
          "description": "What is love's real aim? Why is it so ruthlessly selective in its choice of loved ones? Why do we love at all? In addressing these questions, Simon May develops a radically new understanding of love as the emotion we feel towards whomever or whatever we experience as grounding our life--as offering us a possibility of home in a world that we supremely value. He sees love as motivated by a promise of \"ontological rootedness,\" rather than, as two thousand years of tradition variously asserts, by beauty or goodness, by a search for wholeness, by virtue, by sexual or reproductive desire, by compassion or altruism or empathy, or, in one of today's dominant views, by no qualities at all of the loved one. After arguing that such founding Western myths as the Odyssey and Abraham's call by God to Canaan in the Bible powerfully exemplify his new conception of love, May goes on to re-examine the relation of love to beauty, sex, and goodness in the light of this conception, offering among other things a novel theory of beauty--and suggesting, against Plato, that we can love others for their ugliness (while also seeing them as beautiful). Finally, he proposes that, in the Western world, romantic love is gradually giving way to parental love as the most valued form of love: namely, the love without which one's life is not deemed complete or truly flourishing. May explains why childhood has become sacred and excellence in parenting a paramount ideal--as well as a litmus test of society's moral health. In doing so, he argues that the child is the first genuinely \"modern\" supreme object of love: the first to fully reflect what Nietzsche called \"the death of God.\"",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780190884840"
            },
            {
              "type": "ISBN_10",
              "identifier": "0190884843"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 256,
          "printType": "BOOK",
          "categories": [
            "Philosophy"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=MxiMDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=MxiMDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=MxiMDwAAQBAJ&printsec=frontcover&dq=love&hl=&cd=18&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=MxiMDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=MxiMDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 560.28,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 280.14,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=MxiMDwAAQBAJ&rdid=book-MxiMDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 560280000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 280140000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Love-sample-pdf.acsm?id=MxiMDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=MxiMDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "What is love&#39;s real aim? Why is it so ruthlessly selective in its choice of loved ones? Why do we love at all?"
        }
      },
      {
        "kind": "books#volume",
        "id": "SsYfEAAAQBAJ",
        "etag": "sbbCRo2J6S4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/SsYfEAAAQBAJ",
        "volumeInfo": {
          "title": "Love, in Theory",
          "authors": [
            "Elodie Cheesman"
          ],
          "publisher": "Macmillan Publishers Aus.",
          "publishedDate": "2021-05-25",
          "description": "'A stunning romantic comedy ... fun, warm and perceptive' Jessie Stephens Elodie Cheesman's joyous debut is a modern take on the age-old decision between following your head or your heart in the search for love. There's an algorithm for everything else, so why not love? When 24-year-old lawyer Romy learns that she is at her 'optimal stopping point' (the mathematically designated point at which one should select the next 'best person' who comes along in order to have the best chance at happily ever after), she knows it's time to get serious about her love life. Ruthlessly rational, with a belief in data over destiny, Romy knows that reliability and consistency are dependable options, while passion and lust are transitory and only bring pain and disillusionment. That's why sensible Hans the engineer is the right choice, as opposed to graphic designer James who exhibits the kind of behaviour that has got her into trouble before. Isn't he? LONGLISTED FOR THE AUSTRALIAN BOOK DESIGN AWARDS 2022 BEST DESIGNED COMMERCIAL FICTION COVER Praise for Love, in Theory 'Cheesman plays with love's biggest questions, like: Is finding a life partner chaos? Or could there be an underlying logic? A hopeful, feel-good read, Love, in Theory perfectly captures the beauty - and occasional horror - of dating in the modern age.' - Jessie Stephens, author of Heartsick",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781760986285"
            },
            {
              "type": "ISBN_10",
              "identifier": "1760986283"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 300,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "averageRating": 4,
          "ratingsCount": 1,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.9.9.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=SsYfEAAAQBAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=SsYfEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=SsYfEAAAQBAJ&dq=love&hl=&cd=19&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=SsYfEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=SsYfEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 1811.85,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 1811.85,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=SsYfEAAAQBAJ&rdid=book-SsYfEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 1811850000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 1811850000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true
          },
          "pdf": {
            "isAvailable": true
          },
          "webReaderLink": "http://play.google.com/books/reader?id=SsYfEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "When 24-year-old lawyer Romy learns that she is at her &#39;optimal stopping point&#39; (the mathematically designated point at which one should select the next &#39;best person&#39; who comes along in order to have the best chance at happily ever after), ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "vtOGDwAAQBAJ",
        "etag": "K9U62BLgUiE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/vtOGDwAAQBAJ",
        "volumeInfo": {
          "title": "Love's Broken Vow",
          "authors": [
            "Honey"
          ],
          "publisher": "Urban Renaissance",
          "publishedDate": "2019-02-26",
          "description": "Nicholas Gregory is everything any woman could ever wish for in a man. He’s towering in height, with a gorgeous chocolate complexion. Throw in the facts that he’s sexier than homemade sin and gainfully employed, and there’s no doubt he’s a certified keeper. So, why at age twenty-nine is he childless and a virgin? Stricken by a severe case of lust, Nicholas asks himself the same questions when he meets the irresistible Royce Phillips, a nurse turned health-and-fitness mogul. Her chance emergence into his world is more catastrophic than any natural disaster. For the first time in his life, Nicholas rethinks the decision he made as a little boy to become a Catholic priest. The raw essence of Royce causes him to long for romantic love and the intimate touch of a woman—both forbidden pleasures he’s vowed to never partake of. And Royce isn’t spiritually strong enough to lead him not into temptation. Now, fully indulged in the most sizzling secret affair of all time, Nicholas is living a double life. He’s a righteous man in the pulpit, preaching to his flock, but night after night, he’s anything but holy in Royce’s bed. The young priest is torn between his vow to God and his love for this woman who has grown tired of being his part-time lover. She wants more. She wants it all. So, Nicholas is forced to choose between the church and the love of his life. Heartbroken, Royce must learn to live without the man who made her feel born again, and a tiny, unexpected blessing gives her the inspiration to do just that. But while Royce embraces the next phase of her life, Nicholas realizes he can’t live without her. He takes a leap of faith, placing love before tradition. Happily together at last, tragedy tests the strength of their bond. Nicholas believes they’re being punished for the decision he made. He makes a new vow to God in exchange for a miracle, and this time, it’s a vow he plans to keep forever.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781601621207"
            },
            {
              "type": "ISBN_10",
              "identifier": "1601621205"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 288,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.3.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=vtOGDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=vtOGDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=vtOGDwAAQBAJ&printsec=frontcover&dq=love&hl=&cd=20&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=vtOGDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=vtOGDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 1212.62,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 606.31,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=vtOGDwAAQBAJ&rdid=book-vtOGDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 1212620000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 606310000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Love_s_Broken_Vow-sample-epub.acsm?id=vtOGDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Love_s_Broken_Vow-sample-pdf.acsm?id=vtOGDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=vtOGDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Nicholas Gregory is everything any woman could ever wish for in a man."
        }
      },
      {
        "kind": "books#volume",
        "id": "xtmGDwAAQBAJ",
        "etag": "I3xR1tJy/98",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/xtmGDwAAQBAJ",
        "volumeInfo": {
          "title": "Love’s Lobotomy",
          "authors": [
            "Swaizi Vaughan Ellis"
          ],
          "publisher": "AuthorHouse",
          "publishedDate": "2019-02-04",
          "description": "Have you ever heard of the comparison between insanity and love? They have very similar qualities at times. Swaizi Vaughan Ellis is a Texas born model and contemporary poet. She began writing songs at a very young age and as she began to understand herself more, within love and heartbreak, she evolved these journal entries into poems. “Love’s Lobotomy” is her debut as an author. Within this thought provoking collection of poems she expresses all the feelings she felt for men who she loved and experienced at one time or another. This book took Swaizi almost six years to complete. She reminisces her first love, describes polarizing infatuations, and also paints a vivid picture of her desperate need to fall out of love. Within her poems she often combines the senses and personifies the universe, this creates an unexpected image challenging average thought, for example giving color to emotions. Stylishly playing with the idea of being able to surgically rid herself of love this book can resonate with anyone who has experienced such a powerful sentiment.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781546259619"
            },
            {
              "type": "ISBN_10",
              "identifier": "1546259619"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 124,
          "printType": "BOOK",
          "categories": [
            "Poetry"
          ],
          "maturityRating": "MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=xtmGDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=xtmGDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=xtmGDwAAQBAJ&pg=PP1&dq=love&hl=&cd=21&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=xtmGDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=xtmGDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 330.4,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 231.28,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=xtmGDwAAQBAJ&rdid=book-xtmGDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 330400000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 231280000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Love_s_Lobotomy-sample-epub.acsm?id=xtmGDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=xtmGDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Within this thought provoking collection of poems she expresses all the feelings she felt for men who she loved and experienced at one time or another. This book took Swaizi almost six years to complete."
        }
      },
      {
        "kind": "books#volume",
        "id": "bodfzgEACAAJ",
        "etag": "wP1kTuTTfck",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/bodfzgEACAAJ",
        "volumeInfo": {
          "title": "Call Out",
          "subtitle": "Learn to Love Yourself and Find Love",
          "authors": [
            "Senada Cindy Nuredin"
          ],
          "publisher": "Richter Publishing LLC",
          "publishedDate": "2021-03-27",
          "description": "Life is hard, but love is harder. If you are still struggling with loving yourself or finding true love, then grab a bottle of wine, get this book and settle in for a wild ride that will change your life!",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1954094051"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781954094055"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 128,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=bodfzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=bodfzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=bodfzgEACAAJ&dq=love&hl=&cd=22&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=bodfzgEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Call_Out.html?hl=&id=bodfzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=bodfzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Life is hard, but love is harder. If you are still struggling with loving yourself or finding true love, then grab a bottle of wine, get this book and settle in for a wild ride that will change your life!"
        }
      },
      {
        "kind": "books#volume",
        "id": "LJB2DwAAQBAJ",
        "etag": "XKhdOrxRTnw",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/LJB2DwAAQBAJ",
        "volumeInfo": {
          "title": "The New Psychology of Love",
          "authors": [
            "Robert J. Sternberg",
            "Karin Sternberg"
          ],
          "publisher": "Cambridge University Press",
          "publishedDate": "2018-12-06",
          "description": "This is a much-needed update on the latest theory and research on love supplied by leading scientific experts. It is suitable for psychologists, neuroscientists, anthropologists, sociologists, and anyone with an interest in love and what has been learned from scientific studies of it.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781108475686"
            },
            {
              "type": "ISBN_10",
              "identifier": "110847568X"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 335,
          "printType": "BOOK",
          "categories": [
            "Family & Relationships"
          ],
          "maturityRating": "MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=LJB2DwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=LJB2DwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=LJB2DwAAQBAJ&pg=PP1&dq=love&hl=&cd=23&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=LJB2DwAAQBAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_New_Psychology_of_Love.html?hl=&id=LJB2DwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=LJB2DwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This is a much-needed update on the latest theory and research on love supplied by leading scientific experts."
        }
      },
      {
        "kind": "books#volume",
        "id": "7dBVzgEACAAJ",
        "etag": "6S09Z1t3SH0",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/7dBVzgEACAAJ",
        "volumeInfo": {
          "title": "Living Loved",
          "subtitle": "Unlock Oneness Love with God",
          "authors": [
            "Katharine Wang"
          ],
          "publishedDate": "2021-03-15",
          "description": "Learn how to live from oneness love--the most intimate, deeply satisfying bond you can experience with God. Online course available! In this book you can discover: The biblical paradigm for oneness love The original blueprint for our relationship with God The incredible love-based joy that can fill you every day How to expand your heart's capacity to experience God and enjoy his love in a greater way Common blocks to experiencing oneness love and how to overcome them Practical tools for awakening your oneness love with God",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9798702791203"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 262,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=7dBVzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=7dBVzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=7dBVzgEACAAJ&dq=love&hl=&cd=24&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=7dBVzgEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Living_Loved.html?hl=&id=7dBVzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=7dBVzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "In this book you can discover: The biblical paradigm for oneness love The original blueprint for our relationship with God The incredible love-based joy that can fill you every day How to expand your heart&#39;s capacity to experience God and ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "-c86zgEACAAJ",
        "etag": "8/4mxHXy+OA",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/-c86zgEACAAJ",
        "volumeInfo": {
          "title": "Love's Second Chance",
          "authors": [
            "Patty H Scott"
          ],
          "publishedDate": "2021-02-13",
          "description": "She swore off men, until she met him.Kat Bradshaw is a free-spirited photojournalist who has endured \"a series of unfortunate events\" (aka her love life). When she bumps into Jack, she wonders if he could be different than other men.Jack Anders is a buttoned-up young executive with a five-year plan and a dream he hasn't shared with anyone. When he coincidentally bumps into Kat, she opens possibilities Jack had only dared to imagine.A series of near misses threatens to keep Kat and Jack apart.What will it take for them to find their second chance at love?",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9798709093331"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 202,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=-c86zgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=-c86zgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=-c86zgEACAAJ&dq=love&hl=&cd=25&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=-c86zgEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Second_Chance.html?hl=&id=-c86zgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=-c86zgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "ALL PROCEEDS FROM THE SALE OF LOVE&#39;S SECOND CHANCE FROM JUNE 20th - JUNE 30th 2021 WILL GO TO ELIJAH RISING, A MINISTRY DEVOTED TO ENDING SEX TRAFFICKING THROUGH PRAYER, AWARENESS, INTERVENTION, AND RESTORATION."
        }
      },
      {
        "kind": "books#volume",
        "id": "_oArzgEACAAJ",
        "etag": "QvqNPH8oL4I",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/_oArzgEACAAJ",
        "volumeInfo": {
          "title": "Love's Labour's Lost Illustrated",
          "authors": [
            "William Shakespeare"
          ],
          "publishedDate": "2021-01-12",
          "description": "Love's Labour's Lost is one of William Shakespeare's early comedies, believed to have been written in the mid-1590s for a performance at the Inns of Court before Queen Elizabeth I. It follows the King of Navarre and his three companions as they attempt to swear off the company of women for three years in order to focus on study and fasting. Their subsequent infatuation with the Princess of France and her ladies makes them forsworn. In an untraditional ending for a comedy, the play closes with the death of the Princess's father, and all weddings are delayed for a year. The play draws on themes of masculine love and desire, reckoning and rationalisation, and reality versus fantasy.Though first published in quarto in 1598, the play's title page suggests a revision of an earlier version of the play. While there are no obvious sources for the play's plot, the four main characters are loosely based on historical figures. The use of apostrophes in the play's title varies in early editions, though it is most commonly given as Love's Labour's Lost.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9798593773319"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 220,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=_oArzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=_oArzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=_oArzgEACAAJ&dq=love&hl=&cd=26&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=_oArzgEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Labour_s_Lost_Illustrated.html?hl=&id=_oArzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=_oArzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Love&#39;s Labour&#39;s Lost is one of William Shakespeare&#39;s early comedies, believed to have been written in the mid-1590s for a performance at the Inns of Court before Queen Elizabeth I. It follows the King of Navarre and his three companions as ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "VYxwDwAAQBAJ",
        "etag": "EfM4a5dP4FQ",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/VYxwDwAAQBAJ",
        "volumeInfo": {
          "title": "DEAREST LOVE",
          "subtitle": "Harlequin Comics",
          "authors": [
            "Betty Neels",
            "Natsu Momose"
          ],
          "publisher": "Harlequin / SB Creative",
          "publishedDate": "2018-10-17",
          "description": "Arabella recently lost her parents in an accident. Now she lives in a London basement and works in a hospital as a custodian. At first her employer, Dr. Titus Tavener, ridicules her; however, as Arabella excels at her work and brightens up the hospital with her charm, Titus can’t help but look at her differently. Upon learning of her tragic past and former nobility, he decides to come to her aid by proposing to her.?But Arabella resists?she won’t have anything to do with his pity…or a loveless marriage!",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9784596285973"
            },
            {
              "type": "ISBN_10",
              "identifier": "4596285977"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 185,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "averageRating": 2,
          "ratingsCount": 1,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.2.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=VYxwDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=VYxwDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=VYxwDwAAQBAJ&pg=PP1&dq=love&hl=&cd=27&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=VYxwDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=VYxwDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 625.26,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 342.87,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=VYxwDwAAQBAJ&rdid=book-VYxwDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 625260000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 342870000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/DEAREST_LOVE-sample-epub.acsm?id=VYxwDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/DEAREST_LOVE-sample-pdf.acsm?id=VYxwDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=VYxwDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Arabella recently lost her parents in an accident."
        }
      },
      {
        "kind": "books#volume",
        "id": "p_kPEAAAQBAJ",
        "etag": "3dCAc1A8Qe4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/p_kPEAAAQBAJ",
        "volumeInfo": {
          "title": "Secrets On the Clock",
          "authors": [
            "Nicole Disney"
          ],
          "publisher": "Bold Strokes Books Inc",
          "publishedDate": "2018-10-16",
          "description": "Jenna Thompson is a recently promoted supervisor for Child Protective Services, but she's already having a hard time following the rules. She knows that if she dares act on her desire for her new trainee, she won’t keep her job long. Danielle Corey’s family disowned her when she came out at seventeen, so she’s passionate about helping children who have been neglected, abused, or abandoned by their families. Eager to prove herself as a new social worker, Danielle struggles with her unprofessional attraction for her new boss. As the case they’re working on becomes more volatile, their opinions start to clash even as coworkers become suspicious of their obvious connection. Tensions rise and, with their careers and hearts in the balance, Jenna and Danielle have to decide if they’re willing to risk everything they’ve worked for to take a chance at forever.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781635552935"
            },
            {
              "type": "ISBN_10",
              "identifier": "1635552931"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=p_kPEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=p_kPEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=p_kPEAAAQBAJ&pg=PP1&dq=love&hl=&cd=28&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=p_kPEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=p_kPEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 535.83,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 267.92,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=p_kPEAAAQBAJ&rdid=book-p_kPEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 535830000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 267920000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=p_kPEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Jenna Thompson is a recently promoted supervisor for Child Protective Services, but she&#39;s already having a hard time following the rules."
        }
      },
      {
        "kind": "books#volume",
        "id": "laYmzgEACAAJ",
        "etag": "RCgXdMmL+ng",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/laYmzgEACAAJ",
        "volumeInfo": {
          "title": "Doctor Love",
          "authors": [
            "Pankaj Gupta"
          ],
          "publishedDate": "2021-01-06",
          "description": "I wish there would be no problem in love. I wish there would be no broken hearts. I wish all the love stories would have happy ending. I wish no one would die or kill on the name of love. I wish there be a Doctor Love to help people if at all there are problems due to broken love affairs or sad end of love stories. This book is dedicated to all those who broke their hearts in love and looked for a shoulder to cry upon in any stage of life. It is also dedicated to those who offered their shoulder to support them. Aryan, running in his 25th years of life, an average looking middle class guy, claimed to fall in love with his office colleague and had broken up girl's heart due to his self-centered egoistic nature. Mayank is a bit handsome and rich guy in his 21st year of life, a final year college student. He had lost connection with his girlfriend when she had moved to another city. Then there is a girl, Guddi who happened to assist Doctor Love in his case studies. She is a beautiful girl of dominating nature, running in her 26th year, but still single. Doctor Love, a bit of handsome looking man in his early 40s who gained experiences in life but never got married which instigated him to conduct deep research on love and relationships. These two boys, Aryan and Mayank happened to visit Doctor Love's clinic and consult him to rebuild their love relationship. They had got their respective advice to handle and patch up their relationship. What happened when Doctor Love visited Guddi's hostel to help her and there he happened to meet the beautiful lady warden of the girl's hostel? What happened to Aryan? Was he able to patch-up? What happened to Mayank, did he get back his love? Well, let's peep into Doctor Love's clinic and discover further.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9798591205584"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 134,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=laYmzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=laYmzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=laYmzgEACAAJ&dq=love&hl=&cd=29&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=laYmzgEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Doctor_Love.html?hl=&id=laYmzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=laYmzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book is dedicated to all those who broke their hearts in love and looked for a shoulder to cry upon in any stage of life. It is also dedicated to those who offered their shoulder to support them."
        }
      },
      {
        "kind": "books#volume",
        "id": "0KE8zgEACAAJ",
        "etag": "pWDeHLIVV2s",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/0KE8zgEACAAJ",
        "volumeInfo": {
          "title": "Love and Other Crimes",
          "authors": [
            "Sara Paretsky"
          ],
          "publishedDate": "2021-10-07",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1529355079"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781529355079"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 288,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "averageRating": 4,
          "ratingsCount": 1,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=0KE8zgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=0KE8zgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=0KE8zgEACAAJ&dq=love&hl=&cd=30&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=0KE8zgEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_and_Other_Crimes.html?hl=&id=0KE8zgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=0KE8zgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "9KJdDwAAQBAJ",
        "etag": "MqjchF+THgo",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/9KJdDwAAQBAJ",
        "volumeInfo": {
          "title": "Love's Grip",
          "authors": [
            "Nika Michelle"
          ],
          "publisher": "Urban Books",
          "publishedDate": "2018-06-26",
          "description": "Two lonely hearts will find each other even in the darkest circumstances. . . . When Daisha’s boyfriend, Raekwan, takes his violent, jealous antics to the next level, a mysterious stranger intervenes, taking Daisha to his place to nurse her wounds. Even though she sneaks out the next morning. Daisha can’t stop thinking about him; but with her history of bad relationships with men and with her estranged mother, she knows that she should only be concerned with her own survival. In time, she will realize that he has a strong grip on her emotionally, and she has no control. Tyreek, AKA Pistol, witnesses Daisha’s assault and suddenly finds himself caring about a stranger. His life of crime has toughened him, but his thoughts are consumed with her safety. On the run from the feds, he knows that trust and loyalty are rarely given in the streets. After fleeing to Atlanta, he pulls off a murder that sets off a domino effect of events he never sees coming. There’s a street war brewing, but Pistol and Daisha are fighting a battle in their hearts. Despite all the drama and bloodshed surrounding them, they can’t seem to deny their true feelings. Will they make it out alive to pursue the prospect of a real hood love, or will it all be consumed by the fate of the streets?",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781945855160"
            },
            {
              "type": "ISBN_10",
              "identifier": "1945855169"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 288,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.4.4.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=9KJdDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=9KJdDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=9KJdDwAAQBAJ&printsec=frontcover&dq=love&hl=&cd=31&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=9KJdDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=9KJdDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 679.07,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 339.54,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=9KJdDwAAQBAJ&rdid=book-9KJdDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 679070000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 339540000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Love_s_Grip-sample-epub.acsm?id=9KJdDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Love_s_Grip-sample-pdf.acsm?id=9KJdDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=9KJdDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Two lonely hearts will find each other even in the darkest circumstances."
        }
      },
      {
        "kind": "books#volume",
        "id": "naVUDwAAQBAJ",
        "etag": "anbb0lLDjNk",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/naVUDwAAQBAJ",
        "volumeInfo": {
          "title": "Love A Little Stronger",
          "authors": [
            "Preeti Shenoy,"
          ],
          "publisher": "Sristhi Publishers & Distributors",
          "publishedDate": "2018-04-27",
          "description": "Life is a collection of moments, some memorable and some mundane. Often it is the tiniest things that bring the greatest joy, even though at that time, we have no idea that what we are witnessing may be magical, something that we will talk about and laugh over after many years. Packed with her hilarious narratives, poignant observations and a writing style loved by millions across the world, this book is certain to strike a chord with anybody who has children or who has been a child, themselves! For those who have read 34 Bubblegums and Candies, this is a new version, with many additional stories. For others, it is a heart-warming, hilarious, and inspiring collection of true anecdotes from the author’s life, telling us to Love A Little Stronger, no matter what happens.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789387022133"
            },
            {
              "type": "ISBN_10",
              "identifier": "9387022137"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 176,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.1.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=naVUDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=naVUDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=naVUDwAAQBAJ&pg=PP1&dq=love&hl=&cd=32&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=naVUDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=naVUDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 153.4,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 57.82,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=naVUDwAAQBAJ&rdid=book-naVUDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 153400000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 57820000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Love_A_Little_Stronger-sample-epub.acsm?id=naVUDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Love_A_Little_Stronger-sample-pdf.acsm?id=naVUDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=naVUDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Packed with her hilarious narratives, poignant observations and a writing style loved by millions across the world, this book is certain to strike a chord with anybody who has children or who has been a child, themselves!"
        }
      },
      {
        "kind": "books#volume",
        "id": "DDgPEAAAQBAJ",
        "etag": "6UtwZ0jAYTo",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/DDgPEAAAQBAJ",
        "volumeInfo": {
          "title": "Bailey & Love's Short Practice of Surgery, 27th Edition",
          "authors": [
            "Norman S. Williams",
            "P. Ronan O'Connell",
            "Andrew McCaskie"
          ],
          "publisher": "CRC Press",
          "publishedDate": "2018-04-27",
          "description": "Bailey & Love is the world famous textbook of surgery. Its comprehensive coverage includes the scientific basis of surgical practice, investigation, diagnosis, and pre-operative care. Trauma and Orthopaedics are included, as are the subspecialties of plastic and reconstructive, head and neck, cardiothoracic and vascular, abdominal and genitourinary surgery. The user-friendly format includes photographs, line diagrams, learning objectives, summary boxes, biographical footnotes, memorable anecdotes and full-colour page design. This book's reputation for unambiguous advice make it the first point of reference for student and practising surgeons worldwide.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781351617994"
            },
            {
              "type": "ISBN_10",
              "identifier": "1351617990"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 1612,
          "printType": "BOOK",
          "categories": [
            "Medical"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.1.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=DDgPEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=DDgPEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=DDgPEAAAQBAJ&pg=PP1&dq=love&hl=&cd=33&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=DDgPEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=DDgPEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 11770.5,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 11770.5,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=DDgPEAAAQBAJ&rdid=book-DDgPEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 11770500000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 11770500000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Bailey_Love_s_Short_Practice_of_Surgery-sample-pdf.acsm?id=DDgPEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=DDgPEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book&#39;s reputation for unambiguous advice make it the first point of reference for student and practising surgeons worldwide."
        }
      },
      {
        "kind": "books#volume",
        "id": "4JdYDwAAQBAJ",
        "etag": "NpA5qSlLtU4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/4JdYDwAAQBAJ",
        "volumeInfo": {
          "title": "Bailey & Love's Short Practice of Surgery, 27th Edition",
          "subtitle": "The Collector's edition",
          "authors": [
            "Norman Williams",
            "P Ronan O'Connell",
            "Andrew McCaskie"
          ],
          "publisher": "CRC Press",
          "publishedDate": "2018-04-27",
          "description": "Bailey & Love is the world famous textbook of surgery. Its comprehensive coverage includes the scientific basis of surgical practice, investigation, diagnosis, and pre-operative care. Trauma and Orthopaedics are included, as are the subspecialties of plastic and reconstructive, head and neck, cardiothoracic and vascular, abdominal and genitourinary surgery. The user-friendly format includes photographs, line diagrams, learning objectives, summary boxes, biographical footnotes, memorable anecdotes and full-colour page design. This book's reputation for unambiguous advice make it the first point of reference for student and practising surgeons worldwide.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781351617987"
            },
            {
              "type": "ISBN_10",
              "identifier": "1351617982"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 1612,
          "printType": "BOOK",
          "categories": [
            "Medical"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.8.6.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=4JdYDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=4JdYDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=4JdYDwAAQBAJ&pg=PP1&dq=love&hl=&cd=34&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=4JdYDwAAQBAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Bailey_Love_s_Short_Practice_of_Surgery.html?hl=&id=4JdYDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Bailey_Love_s_Short_Practice_of_Surgery-sample-epub.acsm?id=4JdYDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Bailey_Love_s_Short_Practice_of_Surgery-sample-pdf.acsm?id=4JdYDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=4JdYDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book&#39;s reputation for unambiguous advice make it the first point of reference for student and practising surgeons worldwide."
        }
      },
      {
        "kind": "books#volume",
        "id": "ZgYizgEACAAJ",
        "etag": "q9xSpICG1f4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/ZgYizgEACAAJ",
        "volumeInfo": {
          "title": "Love's Enemy",
          "subtitle": "Clear Print Edition",
          "authors": [
            "Betty McLain"
          ],
          "publishedDate": "2020-12-28",
          "description": "Returning from exile, Katie is looking to start a new life in her old hometown. Her family abandoned her once, allowing her grandfather's feud to rule their lives. Back then, it cost her a childhood friend. Now, it could cost even more. Carlos saw the reflection of his true love through the power of the famous magic mirror. Everything seemed okay - until she learned his name. Could his destined wife be the missing McCray daughter who left town all those years before? Their families' feud had already ended one ill-fated love affair in the past, resulting in the loss of two people and a broken heart. Could a love based on a reflection survive their grandfathers' wrath, and how was he supposed to concentrate on starting his new business with all these questions hanging over his head? Betty's note: each book in the Love's Magic series is a standalone romance novel, and can be enjoyed even if you haven't read other books in the series. This is the clear print edition of Love's Enemy, with a 14pt font size for easier reading.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9798586078544"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 176,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=ZgYizgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=ZgYizgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=ZgYizgEACAAJ&dq=love&hl=&cd=35&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=ZgYizgEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Love_s_Enemy.html?hl=&id=ZgYizgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=ZgYizgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This is the clear print edition of Love&#39;s Enemy, with a 14pt font size for easier reading."
        }
      },
      {
        "kind": "books#volume",
        "id": "yAkLzgEACAAJ",
        "etag": "JX6me9mTvqI",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/yAkLzgEACAAJ",
        "volumeInfo": {
          "title": "Amazing Love",
          "subtitle": "The Amazing Unrelenting Love of God",
          "authors": [
            "Jay Willhoite"
          ],
          "publishedDate": "2020-09-14",
          "description": "From the very beginning of time, God's purpose for man was to be His companion. Above all, it has always been God's plan to have a loving relationship with man. However, God would not compel man to love Him. God wanted man to love Him by his own choice, so God presented man with a choice. When man chose his own self-determination and own wisdom rather than accepting God benevolent love, God turned man away from the garden of Eden. Sin, suffering, and hardship became man's plight by his own choice. That would have been a sad outcome except in spite of man's self-serving selfish actions, God never stopped loving him. The Bible chronicles God's unrelenting actions to win man love. Only when we acknowledge God's relentless love by accepting the love relationship exemplified by Jesus will we experience the bond that God intended for us from the very beginning. When we accept God's love by following Jesus's example, our desire will be to meet God's expectations. Jesus taught us that this can be best accomplished by being obedient to his will and daily following the PASS Principle. The purpose of this book is to share the story of God's amazing love so that we can envision God's plan, past, present and future, through the prism of God's unrelenting love.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "109804813X"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781098048136"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 74,
          "printType": "BOOK",
          "categories": [
            "Religion"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=yAkLzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=yAkLzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=yAkLzgEACAAJ&dq=love&hl=&cd=36&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=yAkLzgEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Amazing_Love.html?hl=&id=yAkLzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=yAkLzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The purpose of this book is to share the story of God&#39;s amazing love so that we can envision God&#39;s plan, past, present and future, through the prism of God&#39;s unrelenting love."
        }
      },
      {
        "kind": "books#volume",
        "id": "VHSgzQEACAAJ",
        "etag": "lCiVsIcrL2A",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/VHSgzQEACAAJ",
        "volumeInfo": {
          "title": "The Four Fundamental Aspects of Love",
          "authors": [
            "Cheryl Jackson"
          ],
          "publishedDate": "2020-08",
          "description": "You Have Been Called and You Have Answered. Welcome. The Four Fundamental Aspects of Love is based on the teachings of Mary Magdalene, as received by Judy Satori. It is a journey of exploration to the place of inner earth called Amenti - a process of initiation to receive higher knowledge. There are seven gates to be passed through. At each one there is a challenge to demonstrate to the guardian of that gate your worthiness and readiness to receive this knowledge. With each successive passage you are blessed with higher energies in preparation for standing before the Seven Lords of Amenti. Hear from them what it means for you to have won the right to be and to become. After returning from Amenti, the four fundamental aspects of love - Loving Wisdom, Loving Kindness, Loving Strength and Loving Being-ness, and the symbol of four spirals are introduced. The most important thing about the four fundamental aspects of love is the connection with the truth of the soul through practicing Loving Wisdom. Loving Wisdom - tuning in and hearing the voice of the heart - is the wellspring of loving creation. All else follows. Enter this imaginative story to stand in the light of the truth that you are. Recognize the beautiful soul that you are and always have been. Reconnect with your authentic self and BE the love that you are. Practice how to be joyful from a place of peace. Gently guide your practice of Loving Wisdom using the seventy-eight angel-inspired compositions complete with \"I am\" statements. Cheryl Jackson has been a student of metaphysical concepts for over thirty years. Much of the basis of her knowledge came from a local angel and ascended master communicator. She added the teachings of Judy Satori in 2015 and continues to study Judy's teachings. Cheryl was granted permission by Judy and Spirit to continue these teachings of Mary Magdalene. The Four Fundamental Aspects of Love is her first book.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1945252871"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781945252877"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 140,
          "printType": "BOOK",
          "categories": [
            "Body, Mind & Spirit"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=VHSgzQEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=VHSgzQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=VHSgzQEACAAJ&dq=love&hl=&cd=37&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=VHSgzQEACAAJ&dq=love&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_Four_Fundamental_Aspects_of_Love.html?hl=&id=VHSgzQEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=VHSgzQEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Loving Wisdom - tuning in and hearing the voice of the heart - is the wellspring of loving creation. All else follows. Enter this imaginative story to stand in the light of the truth that you are."
        }
      },
      {
        "kind": "books#volume",
        "id": "fvtTDwAAQBAJ",
        "etag": "1JhgHuf1Y00",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/fvtTDwAAQBAJ",
        "volumeInfo": {
          "title": "Love on the Verge",
          "subtitle": "",
          "authors": [
            "Ankur Sharma"
          ],
          "publisher": "Diamond Pocket Books Pvt Ltd",
          "publishedDate": "2018-04-04",
          "description": "They never knew that their string of Emails and messages will obligate them to become a special part of each other's lives and in the way a part of their family too. They never expected that their relationship will flip soon from few kisses on the forehead to one night stay together in one blanket. They had a dream in their eyes for their relationship and career. Ansh moved to Spain to join his first ship for six months after completing his marine engineering; Shrutika got the admission in NIFT Delhi after nailing 15th rank in All India Ranking. But will they be able to turn up their foreseen future into a reality? Will they be able to keep those promises? Maybe YES or Maybe NO because whatever happens, happens for a reason. So let's see what their fate has written in the destiny of their relationship. This saga is an upshot of hiccups of Love, the hangover of Friendship and wheel of Fortune which will surely nudge you if you are in a relationship or looking to get into it...",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789352789665"
            },
            {
              "type": "ISBN_10",
              "identifier": "9352789660"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 176,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=fvtTDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=fvtTDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=fvtTDwAAQBAJ&pg=PP1&dq=love&hl=&cd=38&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=fvtTDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=fvtTDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 177,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 100.7,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=fvtTDwAAQBAJ&rdid=book-fvtTDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 177000000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 100700000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Love_on_the_Verge-sample-epub.acsm?id=fvtTDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Love_on_the_Verge-sample-pdf.acsm?id=fvtTDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=fvtTDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "They never knew that their string of Emails and messages will obligate them to become a special part of each other&#39;s lives and in the way a part of their family too."
        }
      },
      {
        "kind": "books#volume",
        "id": "UuZTDwAAQBAJ",
        "etag": "DlKE0JAtdUo",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/UuZTDwAAQBAJ",
        "volumeInfo": {
          "title": "A Reproposed Love Story",
          "subtitle": "Why Hate When You Can Still Love?",
          "authors": [
            "Shannmukh Pisipati"
          ],
          "publisher": "Notion Press",
          "publishedDate": "2018-04-03",
          "description": "Rahul’s heart gets crushed when he breaks up with Pooja. He stops loving people and hanging out with them. He cannot bear the utterance of the word love. Then, one day, out of the blue, his ex-girlfriend calls him. She wants him back and claims that she has realized that he’s innocent. Sometimes, all a broken heart craves is a “reproposal”. If your heart is broken, don’t sit in your room, locked up and crying all day. Breakup isn’t the end of everything. You still have a chance; it’s called “reproposal”.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781947283787"
            },
            {
              "type": "ISBN_10",
              "identifier": "1947283782"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 174,
          "printType": "BOOK",
          "categories": [
            "Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=UuZTDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=UuZTDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=UuZTDwAAQBAJ&pg=PP1&dq=love&hl=&cd=39&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=UuZTDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=UuZTDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 116.82,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 116.82,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=UuZTDwAAQBAJ&rdid=book-UuZTDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 116820000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 116820000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=UuZTDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Rahul’s heart gets crushed when he breaks up with Pooja."
        }
      },
      {
        "kind": "books#volume",
        "id": "HwtNDwAAQBAJ",
        "etag": "nw5cbUO5pco",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/HwtNDwAAQBAJ",
        "volumeInfo": {
          "title": "Love's Not Color Blind",
          "subtitle": "Race and Representation in Polyamorous and Other Alternative Communities",
          "authors": [
            "Kevin A. Patterson",
            "Ruby Bouie Johnson"
          ],
          "publisher": "Thorntree Press LLC",
          "publishedDate": "2018-03-30",
          "description": "The issues that make monogamous dating daunting for people of color—shaming and exclusion by white partners, being fetishized, having realities of everyday racism ignored—occur in polyamorous relationships too, and trying \"not to see race\" only makes it worse. To make polyamorous communities inclusive, we must all acknowledge our part in perpetuating racism and listen to people of color. Love's Not Color Blind puts forward the framework—through research, anecdotal testimony, and analogy—for understanding, identifying, and confronting racism within polyamorous communities.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781944934477"
            },
            {
              "type": "ISBN_10",
              "identifier": "1944934472"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 184,
          "printType": "BOOK",
          "categories": [
            "Family & Relationships"
          ],
          "averageRating": 4,
          "ratingsCount": 1,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.3.3.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=HwtNDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=HwtNDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=HwtNDwAAQBAJ&pg=PP1&dq=love&hl=&cd=40&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=HwtNDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=HwtNDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 1072.41,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 536.2,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=HwtNDwAAQBAJ&rdid=book-HwtNDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 1072410000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 536200000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Love_s_Not_Color_Blind-sample-epub.acsm?id=HwtNDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Love_s_Not_Color_Blind-sample-pdf.acsm?id=HwtNDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=HwtNDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Love&#39;s Not Color Blind puts forward the framework—through research, anecdotal testimony, and analogy—for understanding, identifying, and confronting racism within polyamorous communities."
        }
      },{
        "kind": "books#volume",
        "id": "--RwEAAAQBAJ",
        "etag": "9iKJTuEjaaQ",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/--RwEAAAQBAJ",
        "volumeInfo": {
          "title": "Leadership Insights for Wizards and Witches",
          "authors": [
            "Aditya Simha"
          ],
          "publisher": "Emerald Group Publishing",
          "publishedDate": "2022-05-30",
          "description": "Leadership Insights for Wizards and Witches outlines various leadership styles, theories, and concepts through the fictional lens of J.K. Rowling’s magical world – from ethical, servant, and authentic leadership, to power, influence, and persuasion.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781801175425"
            },
            {
              "type": "ISBN_10",
              "identifier": "180117542X"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 188,
          "printType": "BOOK",
          "categories": [
            "Business & Economics"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=--RwEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=--RwEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=--RwEAAAQBAJ&pg=PA3&dq=harrypotter&hl=&cd=1&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=--RwEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=--RwEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 1987.77,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 1987.77,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=--RwEAAAQBAJ&rdid=book---RwEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 1987770000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 1987770000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Leadership_Insights_for_Wizards_and_Witc-sample-pdf.acsm?id=--RwEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=--RwEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "HARRY. POTTER. CONTEXT. Prior to embarking on this journey, I must offer some detail as to why I chose to focus on the magical ... I first read \u003cb\u003eHarry Potter\u003c/b\u003e and the Philosopher&#39;s Stone when I was 16 years old, which was back in 1997."
        }
      },
      {
        "kind": "books#volume",
        "id": "87FYEAAAQBAJ",
        "etag": "o8ZhF2NIDZQ",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/87FYEAAAQBAJ",
        "volumeInfo": {
          "title": "Harry Potter: Magical Meditations",
          "subtitle": "64 Inspirational Cards Based on the Wizarding World (Harry Potter Inspiration, Gifts for Harry Potter Fans)",
          "authors": [
            "Jody Revenson"
          ],
          "publisher": "Simon and Schuster",
          "publishedDate": "2022-02-08",
          "description": "Let the wisdom of the Harry Potter films guide you with this card deck and book set featuring quotes, activities, and prompts to help you bring the magic of the Wizarding World to your daily life. This enchantingly designed inspirational card deck features 64 cards, each of which offers the reader a unique question, prompt, or invitation for self-reflection based on the major characters, moments, quotes, and themes of the Harry Potter films. It comes packaged in a decorative gift box with a book that delves deeper into the cinematic moments explored in the cards and the inspiration the filmmakers drew from while creating them. Harry Potter Guided Deck and Book Set is the perfect gift for fans looking to tap into the powerful messages of love, hope, and heroism in the Harry Potter films. INCLUDES 64 CARDS: Each card includes a question, prompt, inspirational quote, or suggestion to help guide your day FACT-FILLED BOOK: Included book delves deeper into the themes of love, hope, and heroism in the Harry Potter films PERFECT GIFT: Packaged in a beautiful gift box, Harry Potter Guided Deck and Book Set is an ideal gift for the Harry Potter fan OFFICIAL WIZARDING WORLD GIFT SET: Created in collaboration with Warner Bros. Entertainment Inc.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781647224639"
            },
            {
              "type": "ISBN_10",
              "identifier": "1647224632"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 112,
          "printType": "BOOK",
          "categories": [
            "Art"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=87FYEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=87FYEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=87FYEAAAQBAJ&pg=PP1&dq=harrypotter&hl=&cd=2&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=87FYEAAAQBAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_Magical_Meditations.html?hl=&id=87FYEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED_FOR_ACCESSIBILITY",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=87FYEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Let the wisdom of the Harry Potter films guide you with this card deck and book set featuring quotes, activities, and prompts to help you bring the magic of the Wizarding World to your daily life."
        }
      },
      {
        "kind": "books#volume",
        "id": "yWJaEAAAQBAJ",
        "etag": "xp+g4/epQgU",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/yWJaEAAAQBAJ",
        "volumeInfo": {
          "title": "The Politics of Fandom",
          "subtitle": "Conflicts That Divide Communities",
          "authors": [
            "Hannah Mueller"
          ],
          "publisher": "McFarland",
          "publishedDate": "2022-01-20",
          "description": "Fandom has been celebrated both as a harmonious, tolerant space and as apolitical and detached from reality. Yet fandom is neither harmonious nor apolitical. Throughout the past century, fandom has been shaped by recurring controversies and sparked by the emergence of new circles, platforms and discourses. Since the earliest days of science-fiction fandom, fans have conceived of their communities as quasi-political bodies, and of themselves as public actors in discursive spaces. They are concerned with the organizational structures, norms, and borders of fandom as well as their own position within it all. This latter concern has moved to the forefront as fan practices and platforms have been coopted by the entertainment industry and by political actors, forcing fans to situate their fannish and political identities in relation to both sprawling transmedia franchises and right-wing groups exploiting fannish formations for political ends. Through case studies of Glee and The Hunger Games fandoms as well as events such as Gamergate, RaceFail '09 and the Hugo Awards controversies, this book explores the complexities of political fandom.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781476643557"
            },
            {
              "type": "ISBN_10",
              "identifier": "1476643555"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 223,
          "printType": "BOOK",
          "categories": [
            "Social Science"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=yWJaEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=yWJaEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=yWJaEAAAQBAJ&pg=PA186&dq=harrypotter&hl=&cd=3&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=yWJaEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=yWJaEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 2503.3,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 2503.3,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=yWJaEAAAQBAJ&rdid=book-yWJaEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 2503300000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 2503300000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/The_Politics_of_Fandom-sample-epub.acsm?id=yWJaEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/The_Politics_of_Fandom-sample-pdf.acsm?id=yWJaEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=yWJaEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Melissa Anelli et al., The \u003cb\u003eHarry Potter\u003c/b\u003e Alliance, 2005. 6. See Ashley Hinck, “Theorizing a Public Engagement Keystone: Seeing Fandom&#39;s Integral Connection to Civic Engagement Through the Case of the \u003cb\u003eHarry Potter\u003c/b\u003e Alliance,”&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "2-LfzgEACAAJ",
        "etag": "k4I9zkZ8Hjg",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/2-LfzgEACAAJ",
        "volumeInfo": {
          "title": "Harry Potter and the Order of the Phoenix: The Illustrated Edition (Collector's Edition) (Harry Potter, Book 5) (Illustrated Edition)",
          "authors": [
            "J. K. Rowling"
          ],
          "publisher": "Scholastic Incorporated",
          "publishedDate": "2022-11",
          "description": "The fifth book in the beloved, bestselling Harry Potter series, now illustrated in brilliant full color in a deluxe, clothbound collector's edition. There is a door at the end of a silent corridor. And it's haunting Harry Potter's dreams. Why else would he be waking in the middle of the night, screaming in terror? It's not just the upcoming O.W.L. exams; a new teacher with a personality like poisoned honey; a venomous, disgruntled house-elf; or even the growing threat of He-Who-Must-Not-Be-Named. Now Harry Potter is faced with the unreliability of the very government of the magical world and the impotence of the authorities at Hogwarts. Despite this (or perhaps because of it), he finds depth and strength in his friends, beyond what even he knew; boundless loyalty; and unbearable sacrifice. This stunning illustrated edition brings together the talents of award-winning artists Jim Kay and Neil Packer in a visual feast, featuring iconic scenes and much loved characters -- Tonks, Luna Lovegood, and many more -- as the Order of the Phoenix keeps watch over Harry Potter's fifth year at Hogwarts. Special features of this deluxe collector's edition include a generously oversized clothbound book in a slipcase with intricate gold foil stamping; high quality paper with gilt edges; two ribbon bookmarks; a special art print; and a bespoke packing carton -- an impressive gift for Harry Potter fans and book lovers of all ages.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1338853791"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781338853797"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 576,
          "printType": "BOOK",
          "categories": [
            "Juvenile Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=2-LfzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=2-LfzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=2-LfzgEACAAJ&dq=harrypotter&hl=&cd=4&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=2-LfzgEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_and_the_Order_of_the_Phoeni.html?hl=&id=2-LfzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=2-LfzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This stunning illustrated edition brings together the talents of award-winning artists Jim Kay and Neil Packer in a visual feast, featuring iconic scenes and much loved characters -- Tonks, Luna Lovegood, and many more -- as the Order of ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "BwASEAAAQBAJ",
        "etag": "fNTg7EN4NJU",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/BwASEAAAQBAJ",
        "volumeInfo": {
          "title": "Making Numbers Count",
          "subtitle": "The art and science of communicating numbers",
          "authors": [
            "Chip Heath",
            "Karla Starr"
          ],
          "publisher": "Random House",
          "publishedDate": "2022-01-13",
          "description": "Making Numbers Count is a lively, practical, first-of-its-kind guide to turning cold, clinical data into a memorable story. __________ How many hours' worth of songs are on your Spotify Wrapped this year? How much is your commute time really worth? How do you work out how likely you are to get Covid based on the official statistics? How do your viewing hours track against the most popular shows on Netflix? Whether you're interested in global problems like climate change, and understanding that the Australian wildfires destroyed an area twice the size of Portugal, or just grasping how few people have washed their hands between visiting the bathroom and touching your hands, this book will help math-lovers and math-haters alike translate the numbers that animate our world. Until very recently, most languages had no words for numbers greater than five - anything from six to infinity was known as 'lots'. While the numbers in our world have become increasingly complex, our brains are stuck in the past. Yet the ability to communicate and understand numbers has never mattered more. How can we more effectively translate numbers and stats - so fundamental to the next big idea - to make data come to life? Drawing on years of research into making ideas stick, Chip Heath and Karla Starr outline six critical principles that will give anyone the tools to communicate numbers with more transparency and meaning. Using concepts such as simplicity, concreteness and familiarity, they reveal what's compelling about a number and show how to transform it into its most engaging form.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781473585324"
            },
            {
              "type": "ISBN_10",
              "identifier": "1473585325"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 192,
          "printType": "BOOK",
          "categories": [
            "Social Science"
          ],
          "averageRating": 4.5,
          "ratingsCount": 2,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.1.1.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=BwASEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=BwASEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=BwASEAAAQBAJ&pg=PT102&dq=harrypotter&hl=&cd=5&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=BwASEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=BwASEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 707.11,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 353.56,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=BwASEAAAQBAJ&rdid=book-BwASEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 707110000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 353560000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Making_Numbers_Count-sample-epub.acsm?id=BwASEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=BwASEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Ronald A. Howard (1989), “Microrisks for Medical Decision Analysis,” International Journal of Technology Assessment in Health Care, 5:3), pp. 357–70. (https://bit.ly/3tUMmRp) 62 Imagine the entire \u003cb\u003eHarry Potter\u003c/b\u003e series: \u003cb\u003eHarry Potter\u003c/b\u003e&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "s_VMEAAAQBAJ",
        "etag": "gYxLATSSWEE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/s_VMEAAAQBAJ",
        "volumeInfo": {
          "title": "Entertainment Weekly The Ultimate Guide to Harry Potter",
          "authors": [
            "Entertainment Weekly"
          ],
          "publisher": "Time Home Entertainment",
          "publishedDate": "2021-11-05",
          "description": "The world of Harry Potter had grown deeply meaningful for those who came of age using Hogwarts's four houses as shorthand for personality types and seeing the shadow of Voldemort in real-world acts of oppression. For them, Harry Potter is not just a series of books and movies and merchandise but a way of sortingright from wrong that they can remember and draw on for the rest of their lives. For countless readers, Platform 93/4 has served as a gateway into a world in which conflicts between good and evil unfold not in the distant past but the here and now. But it's also doubled as an invitation to explore a long tradition of fantasy literature, fable, folklore and myth, a tradition in which Harry and his friends are now ensconced. Like Oz and Narnia before it, it's a world destined not only to enchant one generation of readers but to be passed down from one to the next. There's magic in that that nothing can undo.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781547859702"
            },
            {
              "type": "ISBN_10",
              "identifier": "1547859709"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 96,
          "printType": "BOOK",
          "categories": [
            "Performing Arts"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=s_VMEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=s_VMEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=s_VMEAAAQBAJ&printsec=frontcover&dq=harrypotter&hl=&cd=6&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=s_VMEAAAQBAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Entertainment_Weekly_The_Ultimate_Guide.html?hl=&id=s_VMEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Entertainment_Weekly_The_Ultimate_Guide-sample-epub.acsm?id=s_VMEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=s_VMEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Like Oz and Narnia before it, it&#39;s a world destined not only to enchant one generation of readers but to be passed down from one to the next. There&#39;s magic in that that nothing can undo."
        }
      },
      {
        "kind": "books#volume",
        "id": "ouxKEAAAQBAJ",
        "etag": "qul24HxxwCA",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/ouxKEAAAQBAJ",
        "volumeInfo": {
          "title": "Smart Pop Explains Harry Potter Books and Movies",
          "authors": [
            "The Editors of Smart Pop"
          ],
          "publisher": "BenBella Books",
          "publishedDate": "2022-07-05",
          "description": "Who is Snape? What’s a horcrux? When did Sirius Black escape from Azkaban? Why was Hermione sorted into Gryffindor? It’s easy for new fans to get overwhelmed by the sprawling mythology and complexity of the Harry Potter movies and books. Unlike encyclopedias and guides that offer diehard fans trivia, details, and deep dives into every on-screen moment, this first-of-its-kind explainer is an easy, fun, and accessible introduction to the hundreds of characters, plots, and interconnected stories that make up one of the greatest pop culture franchises of all time. Maybe you’re a First Year and need an entry level class on the magical Hogwarts School of Witchcraft and Wizardry? Are you trying to figure out why Slytherins are so slippery? Trying to parcel out parceltongue? Having trouble sorting out when Dumbledore battled Grindelwald? Or maybe you’re a confident Ravenclaw who wants to understand why it’s leviOsa, not levioSA! If you’re a Muggle, witch, or wizard looking for an easy entry into what literally everyone is talking about then this is the book for you. As the perfect and unauthorized resource to keep on hand when watching something for the first—or tenth—time, Smart Pop ExplainsHarry Potter Movies and Books to you like no one could!",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781637740576"
            },
            {
              "type": "ISBN_10",
              "identifier": "1637740573"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 264,
          "printType": "BOOK",
          "categories": [
            "Performing Arts"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=ouxKEAAAQBAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=ouxKEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=ouxKEAAAQBAJ&dq=harrypotter&hl=&cd=7&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=ouxKEAAAQBAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Smart_Pop_Explains_Harry_Potter_Books_an.html?hl=&id=ouxKEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=ouxKEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Or maybe you’re a confident Ravenclaw who wants to understand why it’s leviOsa, not levioSA! If you’re a Muggle, witch, or wizard looking for an easy entry into what literally everyone is talking about then this is the book for you."
        }
      },
      {
        "kind": "books#volume",
        "id": "nYKYzgEACAAJ",
        "etag": "Tt9/0s6n4Lk",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/nYKYzgEACAAJ",
        "volumeInfo": {
          "title": "Harry Potter and the Philosopher's Stone - 25th Anniversary Edition",
          "authors": [
            "J. K. Rowling"
          ],
          "publisher": "Bloomsbury Children's Books",
          "publishedDate": "2022-06-09",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "152664665X"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781526646651"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 368,
          "printType": "BOOK",
          "averageRating": 1,
          "ratingsCount": 1,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=nYKYzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=nYKYzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=nYKYzgEACAAJ&dq=harrypotter&hl=&cd=8&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=nYKYzgEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_and_the_Philosopher_s_Stone.html?hl=&id=nYKYzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=nYKYzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "_F3HzgEACAAJ",
        "etag": "B6kPDHTMRq8",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/_F3HzgEACAAJ",
        "volumeInfo": {
          "title": "Harry Potter and the Transmedia Wizarding World",
          "subtitle": "The Franchise Post-Harry Potter",
          "authors": [
            "Cassie Brummitt"
          ],
          "publisher": "Bloomsbury Academic",
          "publishedDate": "2022-11-03",
          "description": "In 2011, the cinematic release of Harry Potter and the Deathly Hallows: Part 2 marked the end of the narrative journey of the orphan boy wizard Harry Potter. Since the end of the phenomenally successful books and films, however, the Harry Potter franchise has continued to expand, generating new texts such as the Fantastic Beasts film series and the stageplay sequel Harry Potter and the Cursed Child – alongside other opportunities to revisit the magical universe such as the 'Wizarding World of Harry Potter' theme parks and the Warner Bros. Studio Tour: The Making of Harry Potter in Watford, UK. This book traces the development of the Potter franchise in the crucial period following the books and films to explore how Harry Potter became the 'Wizarding World', a transmedia world-building phenomenon that expanded the franchise into new times, places and media while reinforcing the value of the Harry Potter texts at its core. Using five different case studies across five different media forms, this truly interdisciplinary study mingles textual analysis and empirical research to offer compelling insight into not only the business strategies of one of the world's best-loved and best-known franchises, but the wider contemporary media environment as well.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1501369067"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781501369063"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 192,
          "printType": "BOOK",
          "categories": [
            "Social Science"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=_F3HzgEACAAJ&dq=harrypotter&hl=&cd=9&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=_F3HzgEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_and_the_Transmedia_Wizardin.html?hl=&id=_F3HzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=_F3HzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Studio Tour: The Making of Harry Potter in Watford, UK. This book traces the development of the Potter franchise in the crucial period following the books and films to explore how Harry Potter became the &#39;Wizarding World&#39;, a transmedia ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "u4UxEAAAQBAJ",
        "etag": "Ej3h91yv8Lo",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/u4UxEAAAQBAJ",
        "volumeInfo": {
          "title": "The Official Harry Potter Baking Book",
          "subtitle": "40+ Recipes Inspired by the Films",
          "authors": [
            "Joanna Farrow"
          ],
          "publisher": "Scholastic Inc.",
          "publishedDate": "2021-07-20",
          "description": "#1 NEW YORK TIMES BESTSELLER! Bake your way through Hogwarts School of Witchcraft and Wizardry! Inspired by the films, this is the ONE and ONLY official Harry Potter cookbook! Packed with over 40 recipes and gorgeous, eye-catching photography, this baking cookbook is a must-have for every Harry Potter fan. Delight in 43 tasty recipes inspired by the Harry Potter films! From Pumpkin Patch Pies to Owl Muffins, Luna's Spectrespecs Cookies to Hogwarts Gingerbread, The Official Harry Potter Baking Cookbook is packed with mouthwatering recipes that will, dare we say, ... ensnare the senses. Host a Great Hall-inspired feast for your friends or delight in a portion for one. Includes recipes for all kinds of delicious baked goods, as well as nutritional and dietary information. This baking cookbook is great for everyone and includes gluten-free, vegetarian, and vegan recipes as well!",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781338756289"
            },
            {
              "type": "ISBN_10",
              "identifier": "1338756281"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 128,
          "printType": "BOOK",
          "categories": [
            "Juvenile Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.4.4.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=u4UxEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=u4UxEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=u4UxEAAAQBAJ&printsec=frontcover&dq=harrypotter&hl=&cd=10&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=u4UxEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=u4UxEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 1787.86,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 1787.86,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=u4UxEAAAQBAJ&rdid=book-u4UxEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 1787860000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 1787860000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/The_Official_Harry_Potter_Baking_Book-sample-epub.acsm?id=u4UxEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/The_Official_Harry_Potter_Baking_Book-sample-pdf.acsm?id=u4UxEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=u4UxEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "#1 NEW YORK TIMES BESTSELLER! Bake your way through Hogwarts School of Witchcraft and Wizardry! Inspired by the films, this is the ONE and ONLY official Harry Potter cookbook!"
        }
      },
      {
        "kind": "books#volume",
        "id": "QSZczgEACAAJ",
        "etag": "QEheCnEjkGo",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/QSZczgEACAAJ",
        "volumeInfo": {
          "title": "Harry Potter Gryffindor House Editions Hardback Box Set",
          "authors": [
            "J. K. Rowling"
          ],
          "publisher": "Bloomsbury Children's Books",
          "publishedDate": "2021-11-11",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1526624524"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781526624529"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 3888,
          "printType": "BOOK",
          "categories": [
            "Juvenile Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=QSZczgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=QSZczgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=QSZczgEACAAJ&dq=harrypotter&hl=&cd=11&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=QSZczgEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_Gryffindor_House_Editions_H.html?hl=&id=QSZczgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=QSZczgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "9MxqzgEACAAJ",
        "etag": "hZNo/cS2l5E",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/9MxqzgEACAAJ",
        "volumeInfo": {
          "title": "Harry Potter: a Magical Year",
          "authors": [
            "J. K. Rowling"
          ],
          "publishedDate": "2021-10-05",
          "description": "A unique and beautiful gift book celebrating the art of Jim Kay -- 366 magical moments from J.K Rowling's Harry Potter novels, evoked in spellbinding brushstrokes, characterful ink work, and illuminating pencil sketches. This irresistible gift book takes readers on an unforgettable journey through the seasons at Hogwarts. Jim Kay's captivating illustrations, paired with much-loved quotations from J.K. Rowling's Harry Potter novels -- one moment, anniversary, or memory for every day of the year -- bring to life all of the magic, beauty, and wonder of the wizarding world. Jim Kay has been enchanting readers since the publication of the Illustrated Edition of Harry Potter and the Sorcerer's Stone in 2015. Now, in Harry Potter: A Magical Year, a selection of Kay's most iconic illustrations are joined by previously unseen pencil sketches and preparatory pieces, offering unique and fascinating insight into the artist's sketchbook. From the snowy towers of Hogwarts, to the dancing eyes of Professor Albus Dumbledore, to the hustle and bustle of Diagon Alley, this visual feast is the perfect companion for readers of all ages, at any point on their Harry Potter journey, and a gift to cherish for years to come.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1338809970"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781338809978"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 240,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=9MxqzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=9MxqzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=9MxqzgEACAAJ&dq=harrypotter&hl=&cd=12&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=9MxqzgEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_a_Magical_Year.html?hl=&id=9MxqzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=9MxqzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This &quot;book takes readers on an unforgettable journey through the seasons at Hogwarts."
        }
      },
      {
        "kind": "books#volume",
        "id": "weIbEAAAQBAJ",
        "etag": "68AFM4KC//0",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/weIbEAAAQBAJ",
        "volumeInfo": {
          "title": "75 Books You Must Read Before You Die",
          "authors": [
            "Joe Rose"
          ],
          "publisher": "BookRix",
          "publishedDate": "2021-01-27",
          "description": "Stuck for something to read next? 75 Books You Must Read Before You Die might be able to help and includes reviews and thoughts on an eclectic range of suggested books to read by a diverse range of of authors. Everything from Alice's Adventures in Wonderland to Alan Moore's Watchmen (and so much more) awaits in 75 Books You Must Read Before You Die.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9783748773023"
            },
            {
              "type": "ISBN_10",
              "identifier": "3748773021"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 306,
          "printType": "BOOK",
          "categories": [
            "Literary Criticism"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=weIbEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=weIbEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=weIbEAAAQBAJ&pg=PT161&dq=harrypotter&hl=&cd=13&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=weIbEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=weIbEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 311,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 217.7,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=weIbEAAAQBAJ&rdid=book-weIbEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 311000000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 217700000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/75_Books_You_Must_Read_Before_You_Die-sample-epub.acsm?id=weIbEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/75_Books_You_Must_Read_Before_You_Die-sample-pdf.acsm?id=weIbEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=weIbEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This is a rather obvious inclusion as I suspect nearly everyone has read the \u003cb\u003eHarry Potter\u003c/b\u003e books by now. \u003cb\u003eHarry Potter\u003c/b\u003e is now a $25 billion franchise but it had surprisingly humble origins. JK Rowling received several rejections from&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "kUejzgEACAAJ",
        "etag": "DIroheUCblw",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/kUejzgEACAAJ",
        "volumeInfo": {
          "title": "Harry Potter Encyclopedia 340 Details That'll Totally Blow Your Mind",
          "authors": [
            "Jason Douglas"
          ],
          "publisher": "Independently Published",
          "publishedDate": "2021-09-03",
          "description": "Harry Potter Encyclopedia - 340 Details that'll Totally Blow Your Mind Hαrry Potter is the best-selling book series in history, with over 500 million copies sold worldwide. Bυt Hαrry Potter's wizαrding υniverse is mυch more thαn jυst novels, α film series, or α brαnd. Think yoυ know αll there is to know αboυt the Boy Who Lived? Think αgαin. Reαd on for whαt yoυ need to know αboυt the Hαrry Potter books αnd films. (Spoilers below!)",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9798470036384"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 62,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=kUejzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=kUejzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=kUejzgEACAAJ&dq=harrypotter&hl=&cd=14&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=kUejzgEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_Encyclopedia_340_Details_Th.html?hl=&id=kUejzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=kUejzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Harry Potter Encyclopedia - 340 Details that&#39;ll Totally Blow Your Mind Hαrry Potter is the best-selling book series in history, with over 500 million copies sold worldwide."
        }
      },
      {
        "kind": "books#volume",
        "id": "8fcQEAAAQBAJ",
        "etag": "Cqc95F3OOPE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/8fcQEAAAQBAJ",
        "volumeInfo": {
          "title": "The Alchemical Harry Potter",
          "subtitle": "Essays on Transfiguration in J.K. Rowling's Novels",
          "authors": [
            "Anne J. Mamary"
          ],
          "publisher": "McFarland",
          "publishedDate": "2020-12-22",
          "description": "When Harry Potter first boards the Hogwarts Express, he journeys to a world which Rowling says has alchemy as its \"internal logic.\" The Philosopher's Stone, known for its power to transform base metals into gold and to give immortality to its maker, is the subject of the conflict between Harry and Voldemort in the first book of the series. But alchemy is not about money or eternal life, it is much more about the transformations of desire, of power and of people--through love. Harry's equally remarkable and ordinary power to love leads to his desire to find but not use the Philosopher's Stone at the start of the series and his wish to end the destructive power of the Elder Wand at the end. This collection of essays on alchemical symbolism and transformations in Rowling's series demonstrates how Harry's work with magical objects, people, and creatures transfigure desire, power, and identity. As Harry's leaden existence on Privet Drive is transformed in the company of his friends and teachers, the Harry Potter novels have transformed millions of readers, inspiring us to find the gold in our ordinary lives.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781476681344"
            },
            {
              "type": "ISBN_10",
              "identifier": "1476681341"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 323,
          "printType": "BOOK",
          "categories": [
            "Literary Criticism"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=8fcQEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=8fcQEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=8fcQEAAAQBAJ&printsec=frontcover&dq=harrypotter&hl=&cd=15&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=8fcQEAAAQBAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_Alchemical_Harry_Potter.html?hl=&id=8fcQEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=8fcQEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This collection of essays on alchemical symbolism and transformations in Rowling&#39;s series demonstrates how Harry&#39;s work with magical objects, people, and creatures transfigure desire, power, and identity."
        }
      },
      {
        "kind": "books#volume",
        "id": "8fcQEAAAQBAJ",
        "etag": "qAFqpjomYrg",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/8fcQEAAAQBAJ",
        "volumeInfo": {
          "title": "The Alchemical Harry Potter",
          "subtitle": "Essays on Transfiguration in J.K. Rowling's Novels",
          "authors": [
            "Anne J. Mamary"
          ],
          "publisher": "McFarland",
          "publishedDate": "2020-12-22",
          "description": "When Harry Potter first boards the Hogwarts Express, he journeys to a world which Rowling says has alchemy as its \"internal logic.\" The Philosopher's Stone, known for its power to transform base metals into gold and to give immortality to its maker, is the subject of the conflict between Harry and Voldemort in the first book of the series. But alchemy is not about money or eternal life, it is much more about the transformations of desire, of power and of people--through love. Harry's equally remarkable and ordinary power to love leads to his desire to find but not use the Philosopher's Stone at the start of the series and his wish to end the destructive power of the Elder Wand at the end. This collection of essays on alchemical symbolism and transformations in Rowling's series demonstrates how Harry's work with magical objects, people, and creatures transfigure desire, power, and identity. As Harry's leaden existence on Privet Drive is transformed in the company of his friends and teachers, the Harry Potter novels have transformed millions of readers, inspiring us to find the gold in our ordinary lives.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781476681344"
            },
            {
              "type": "ISBN_10",
              "identifier": "1476681341"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 323,
          "printType": "BOOK",
          "categories": [
            "Literary Criticism"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=8fcQEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=8fcQEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=8fcQEAAAQBAJ&pg=PA224&dq=harrypotter&hl=&cd=16&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=8fcQEAAAQBAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_Alchemical_Harry_Potter.html?hl=&id=8fcQEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=8fcQEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "In the Pensieve Harry learns the truth about Snape with all his conflicted feelings, and how he, too, was transformed and ultimately did all he could for the side of Good against Evil ... \u003cb\u003eHarry Potter\u003c/b\u003e and the Root of All Evil Charles M."
        }
      },
      {
        "kind": "books#volume",
        "id": "Ivl8zgEACAAJ",
        "etag": "7A//I927yE4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/Ivl8zgEACAAJ",
        "volumeInfo": {
          "title": "Harry Potter Cookbook",
          "subtitle": "Magical Collection of Culinary Wonders Mouthwatering, Flavorful Dishes that Both Muggies and Magical Folk Allke Can Delight Over!",
          "authors": [
            "Rochelle New"
          ],
          "publishedDate": "2021-05-24",
          "description": "This book is filled with a collection of delightful recipes that are constantly enjoyed by the Magical folk attending Hogwarts. Now, instead of just watching your favorite magical folk dining on these mouthwatering dishes, you too can delight on the magical flavors! You can create this collection of Harry Potter's culinary delights right in the comfort of your own home! Harry's recipes are easy and simple to follow and prepare. If you were planning a Harry Potter theme party for example, you could use many of these recipes to serve to your party guests! I can assure you that they will certainly delight your guest's taste-buds to no end, resulting in your theme party being a great success! Or perhaps you want to have a couple of friends over to share your magical treats with-perhaps a couple of friends that are also Harry Potter fans! However, or wherever you decide to serve these dishes will be entirely up to you. The main thing is that you can experience many dishes that your favorite magical folk do, bringing your connection to them and their magical world all the closer and real!",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9798509297311"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 44,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=Ivl8zgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=Ivl8zgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=Ivl8zgEACAAJ&dq=harrypotter&hl=&cd=17&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=Ivl8zgEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_Cookbook.html?hl=&id=Ivl8zgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=Ivl8zgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book is filled with a collection of delightful recipes that are constantly enjoyed by the Magical folk attending Hogwarts."
        }
      },
      {
        "kind": "books#volume",
        "id": "1fcQEAAAQBAJ",
        "etag": "0JEfM7esiKE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/1fcQEAAAQBAJ",
        "volumeInfo": {
          "title": "The Alchemical Harry Potter",
          "subtitle": "Essays on Transfiguration in J.K. Rowling's Novels",
          "authors": [
            "Anne J. Mamary"
          ],
          "publisher": "McFarland",
          "publishedDate": "2020-12-21",
          "description": "When Harry Potter first boards the Hogwarts Express, he journeys to a world which Rowling says has alchemy as its \"internal logic.\" The Philosopher's Stone, known for its power to transform base metals into gold and to give immortality to its maker, is the subject of the conflict between Harry and Voldemort in the first book of the series. But alchemy is not about money or eternal life, it is much more about the transformations of desire, of power and of people--through love. Harry's equally remarkable and ordinary power to love leads to his desire to find but not use the Philosopher's Stone at the start of the series and his wish to end the destructive power of the Elder Wand at the end. This collection of essays on alchemical symbolism and transformations in Rowling's series demonstrates how Harry's work with magical objects, people, and creatures transfigure desire, power, and identity. As Harry's leaden existence on Privet Drive is transformed in the company of his friends and teachers, the Harry Potter novels have transformed millions of readers, inspiring us to find the gold in our ordinary lives.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781476640839"
            },
            {
              "type": "ISBN_10",
              "identifier": "1476640831"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 323,
          "printType": "BOOK",
          "categories": [
            "Literary Criticism"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=1fcQEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=1fcQEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=1fcQEAAAQBAJ&pg=PP1&dq=harrypotter&hl=&cd=18&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=1fcQEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=1fcQEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 2145.58,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 2145.58,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=1fcQEAAAQBAJ&rdid=book-1fcQEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 2145580000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 2145580000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/The_Alchemical_Harry_Potter-sample-epub.acsm?id=1fcQEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/The_Alchemical_Harry_Potter-sample-pdf.acsm?id=1fcQEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=1fcQEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This collection of essays on alchemical symbolism and transformations in Rowling&#39;s series demonstrates how Harry&#39;s work with magical objects, people, and creatures transfigure desire, power, and identity."
        }
      },
      {
        "kind": "books#volume",
        "id": "KCBzzgEACAAJ",
        "etag": "n0qc1H+YnSw",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/KCBzzgEACAAJ",
        "volumeInfo": {
          "title": "Projects Inspired By The World Of Harry Potter",
          "subtitle": "Transfigurate Supplies And Things Around The House: Harry Potter Craft Book",
          "authors": [
            "Noble Schlegel"
          ],
          "publishedDate": "2021-05-07",
          "description": "Harry Potter Crafts & Ideas. Easy Harry Potter Crafts for kids and adults. Learn how to make Harry Potter Bookmarks, Harry Potter Potions and More... Reading this book, you won't need alchemy or a magic wand to make these 30 magical projects inspired by the world of Harry Potter. With a little Hogwarts creativity and the step-by-step guidance of this spellbinding book, you'll be able to transfigurate simple supplies and things around the house into everything from Remembrall Rings to Butterbeer Lip Balm to Nargles for your front lawn. You'll be as busy as Mrs. Weasley knitting her Christmas sweaters as you dive into dozens of Potterific projects. Relive the excitement of Harry's adventures with these genius crafts. Drop some homemade Pgymy Puff Bath Fizzies into the tub and pretend you're Moaning Myrtle. Keep memories of the Quidditch pitch close with your very own Golden Snitch Necklace. Or show off the Sorting Hat's selection with a House Colors Tie-Dye Shirt.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9798500620507"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 180,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=KCBzzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=KCBzzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=KCBzzgEACAAJ&dq=harrypotter&hl=&cd=19&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=KCBzzgEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Projects_Inspired_By_The_World_Of_Harry.html?hl=&id=KCBzzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=KCBzzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Learn how to make Harry Potter Bookmarks, Harry Potter Potions and More... Reading this book, you won&#39;t need alchemy or a magic wand to make these 30 magical projects inspired by the world of Harry Potter."
        }
      },
      {
        "kind": "books#volume",
        "id": "hcgsZSvCGt0C",
        "etag": "FAEFtTlK7nk",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/hcgsZSvCGt0C",
        "volumeInfo": {
          "title": "Secret Existence (A Harry Potter Fanfic)",
          "publisher": "Wattpad",
          "readingModes": {
            "text": true,
            "image": false
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.2.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=hcgsZSvCGt0C&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=hcgsZSvCGt0C&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=hcgsZSvCGt0C&dq=harrypotter&hl=&cd=20&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=hcgsZSvCGt0C&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Secret_Existence_A_Harry_Potter_Fanfic.html?hl=&id=hcgsZSvCGt0C"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true
          },
          "pdf": {
            "isAvailable": true
          },
          "webReaderLink": "http://play.google.com/books/reader?id=hcgsZSvCGt0C&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "He finds the anonymity of his existence difficult to accept and this is the theme that runs through the novel. Hence the title: A Secret Existence."
        }
      },
      {
        "kind": "books#volume",
        "id": "gJrvDwAAQBAJ",
        "etag": "WTy5KCYh2Wk",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/gJrvDwAAQBAJ",
        "volumeInfo": {
          "title": "Harry Potter Film Vault: Horcruxes and the Deathly Hallows",
          "authors": [
            "Insight Editions"
          ],
          "publisher": "Simon and Schuster",
          "publishedDate": "2020-11-24",
          "description": "How artists and craftspeople sought to tell Harry’s story through the design of many important props—from the Sorcerer’s Stone to the Sword of Gryffindor. The Harry Potter film series is filled with incredible artifacts and magical objects, from Harry’s iconic wand and glasses to Marvolo Gaunt’s Ring. Now fans can get an in-depth look at illustrations, sketches, and behind-the-scenes photography that shows the stunning inventiveness of the designers and craftspeople who built the rich and magical Harry Potter film universe. The Film Vault compiles the filmmaking secrets and visionary artistry behind the Harry Potter films into a series of twelve deluxe collectible volumes. Intricately designed and packed with gorgeous concept art and unit photography from the Warner Bros. archive, each volume in the series gives fans striking insights about bringing the Wizarding World to the big screen. Praise for the Harry Potter Film Vault series “A detailed, behind-the-scenes look at creating some aspect of the wizarding world for the films.” —The Leaky Cauldron “They’re gorgeous, and because they break down the different aspects of the films into twelve volumes, they may have more detail than some of the other compendiums out there . . . these might just be my new favorite Potter film books.” —MuggleNet “[A] super cool behind the scenes series of the Harry Potter films . . . Twelve volumes that take the viewer on distinct adventures that unveil various aspects of the beloved movies.” —Apartment Therapy “You’re going to want to collect them all.” —Wizards and Whatnot",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781647223175"
            },
            {
              "type": "ISBN_10",
              "identifier": "1647223172"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 64,
          "printType": "BOOK",
          "categories": [
            "Performing Arts"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "2.2.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=gJrvDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=gJrvDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=gJrvDwAAQBAJ&pg=PT6&dq=harrypotter&hl=&cd=21&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=gJrvDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=gJrvDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 279.66,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 195.76,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=gJrvDwAAQBAJ&rdid=book-gJrvDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 279660000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 195760000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Harry_Potter_Film_Vault_Horcruxes_and_th-sample-epub.acsm?id=gJrvDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Harry_Potter_Film_Vault_Horcruxes_and_th-sample-pdf.acsm?id=gJrvDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=gJrvDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "hen \u003cb\u003eHarry Potter\u003c/b\u003e discovers he&#39;s a wizard, he also learns All of these objects seen on-screen are called “hero props,” that he was attacked when he was an infant by the most powerful Dark wizard of all time. Lord Voldemort killed Harry&#39;s&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "qJvvDwAAQBAJ",
        "etag": "dfxCWPLNsq4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/qJvvDwAAQBAJ",
        "volumeInfo": {
          "title": "Harry Potter Film Vault: Celebrations, Food, and Publications of the Wizarding World",
          "authors": [
            "Insight Editions"
          ],
          "publisher": "Simon and Schuster",
          "publishedDate": "2020-11-24",
          "description": "A behind-the-scenes look into the creation of what contributes to the culture of the Harry Potter community—feasts, music, weddings, magazines, and more. Celebratory gatherings, delicious meals, and books and newspapers are key elements of the Harry Potter films. Packed with concept art and unit photography and featuring striking insights from the filmmakers, this volume gives readers an inside look at many of the props and costumes that help make the Wizarding World feel so richly imagined, from the decor featured at the Yule Ball and Weasley wedding to Hogwarts textbooks. Harry Potter Film Vault compiles the filmmaking secrets and visionary artistry behind the Harry Potter films into a series of twelve deluxe collectible volumes. Intricately designed and packed with concept art and unit photography from the Warner Bros. archive, each volume in the series gives fans striking insights about bringing the Wizarding World to the big screen. Praise for the Harry Potter Film Vault series “A detailed, behind-the-scenes look at creating some aspect of the wizarding world for the films.” —The Leaky Cauldron “These are great! They’re gorgeous, and because they break down the different aspects of the films into twelve volumes, they may have more detail than some of the other compendiums out there . . . these might just be my new favorite Potter film books.” —MuggleNet “[A] super cool behind the scenes series of the Harry Potter films.” —Apartment Therapy “You’re going to want to collect them all.” —Wizards and Whatnot",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781647223267"
            },
            {
              "type": "ISBN_10",
              "identifier": "1647223261"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 64,
          "printType": "BOOK",
          "categories": [
            "Performing Arts"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=qJvvDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=qJvvDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=qJvvDwAAQBAJ&pg=PT56&dq=harrypotter&hl=&cd=22&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=qJvvDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=qJvvDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 279.66,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 195.76,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=qJvvDwAAQBAJ&rdid=book-qJvvDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 279660000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 195760000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Harry_Potter_Film_Vault_Celebrations_Foo-sample-epub.acsm?id=qJvvDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Harry_Potter_Film_Vault_Celebrations_Foo-sample-pdf.acsm?id=qJvvDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=qJvvDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "—Written in \u003cb\u003eHarry Potter&#39;s\u003c/b\u003e textbook by the Half-Blood Prince, \u003cb\u003eHarry Potter\u003c/b\u003e and the Half-Blood Prince I tbringis him Potter&#39;s opportunities to bond in class that with (and interrogate) The ofAdvanced Potion-Making isworn,&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "aDg2zgEACAAJ",
        "etag": "LeikDNg46Ds",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/aDg2zgEACAAJ",
        "volumeInfo": {
          "title": "Harry Joke Book",
          "subtitle": "Funny Harry Potter Jokes That Are Pure Magic",
          "authors": [
            "Magnus Collins"
          ],
          "publishedDate": "2021-01-27",
          "description": "The Unofficial Harry Potter Joke Book: Great hundreds of hilarious jokes from the Harry Potter world. The Pottermore website allows Harry Potter fans everywhere to be sorted into the house that's right for them, and now the Harry's Fans the world over will find their place in The Unofficial Harry Potter Jokes Book. This third book dives deeper into this magical universe, poking fun of every wizard and muggle from Hogsmead to the Ministry of Magic itself. Jokes include clever lines such as: What do you get when you cross a Ravenclaw with the infirmary? Ill-literacy We value wit, humor...and brains! Or maybe we're just \"for the birds.\" Who are we? Ravenclaw Why did everybody want to take Professor Flitwick's class? Because he was so \"charming.\" Why did Gilderoy Lockhart team up with Nearly Headless Nick? He needed a ghost-writer. Featuring hundreds of jokes and fifty fantastic illustrations, this joke book provides endless amounts of fun for readers and fans of the bestselling series.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9798700945615"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 70,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=aDg2zgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=aDg2zgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=aDg2zgEACAAJ&dq=harrypotter&hl=&cd=23&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=aDg2zgEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Joke_Book.html?hl=&id=aDg2zgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=aDg2zgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This third book dives deeper into this magical universe, poking fun of every wizard and muggle from Hogsmead to the Ministry of Magic itself. Jokes include clever lines such as: What do you get when you cross a Ravenclaw with the infirmary?"
        }
      },
      {
        "kind": "books#volume",
        "id": "4KhkzgEACAAJ",
        "etag": "yJ7E6ddtaAU",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/4KhkzgEACAAJ",
        "volumeInfo": {
          "title": "The Magical Harry Potter Quiz Book",
          "authors": [
            "Jacob Logan"
          ],
          "publisher": "Jacob Logan",
          "publishedDate": "2021-01-25",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "139327353X"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781393273530"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 86,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=4KhkzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=4KhkzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=4KhkzgEACAAJ&dq=harrypotter&hl=&cd=24&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=4KhkzgEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_Magical_Harry_Potter_Quiz_Book.html?hl=&id=4KhkzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=4KhkzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Find out if you are a Harry Potter obsessive with this new quiz book."
        }
      },
      {
        "kind": "books#volume",
        "id": "7a2wzQEACAAJ",
        "etag": "Bu1ivjAUsK8",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/7a2wzQEACAAJ",
        "volumeInfo": {
          "title": "Harry Potter and the Half-Blood Prince - Slytherin Edition",
          "authors": [
            "J. K. Rowling"
          ],
          "publisher": "Bloomsbury Children's Books",
          "publishedDate": "2021-01-21",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "152661829X"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781526618290"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 560,
          "printType": "BOOK",
          "categories": [
            "Juvenile Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=7a2wzQEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=7a2wzQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=7a2wzQEACAAJ&dq=harrypotter&hl=&cd=25&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=7a2wzQEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_and_the_Half_Blood_Prince_S.html?hl=&id=7a2wzQEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=7a2wzQEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "P5lEzQEACAAJ",
        "etag": "PTGZiYtfZq4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/P5lEzQEACAAJ",
        "volumeInfo": {
          "title": "Harry Potter: Ravenclaw Wax Seal Set",
          "authors": [
            "Insight Editions"
          ],
          "publisher": "Insights",
          "publishedDate": "2020-09-01",
          "description": "Seal letters, decorate packages, and personalize your stationery with this HARRY POTTERTM: RAVENCLAWTM Wax Seal Set. Inspired by the beloved Harry Potter films, the set comes with a high-quality copper stamp and two wax sticks in the house colors of blue and silver—the perfect gift for Ravenclaws and Harry Potter fans everywhere.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1647220165"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781647220167"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "categories": [
            "Performing Arts"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=P5lEzQEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=P5lEzQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=P5lEzQEACAAJ&dq=harrypotter&hl=&cd=26&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=P5lEzQEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_Ravenclaw_Wax_Seal_Set.html?hl=&id=P5lEzQEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=P5lEzQEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Seal letters, decorate packages, and personalize your stationery with this HARRY POTTERTM: RAVENCLAWTM Wax Seal Set."
        }
      },
      {
        "kind": "books#volume",
        "id": "4-oNzgEACAAJ",
        "etag": "Qrff8i8PwTk",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/4-oNzgEACAAJ",
        "volumeInfo": {
          "title": "Harry Potter: Hogwarts Dress-Up!",
          "authors": [
            "Vanessa Moody"
          ],
          "publisher": "Scholastic Incorporated",
          "publishedDate": "2021-11-02",
          "description": "Have fun dressing up, accessorizing, and learning about the props in the Harry Potter films in this gorgeous book that includes 10 paper characters! Learn all about your favorite Wizarding World characters in this exciting book with amazing paper doll characters! Dolls include Harry Potter, Ron Weasley, Hermione Granger, Draco Malfoy, Luna Lovegood, Cho Chang, Ginny Weasley, and more. You'll be able to dress up and decorate these iconic Harry Potter characters with paper props and accessories as seen in the films.How long is Harry's wand? What about Hermione's? What was the first spell that Ron Weasley successfully cast in the Harry Potter films, and do you know what Luna Lovegood's last word on screen were? All this info - and a whole lot more! - can be found in this awesome activity book.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "133876764X"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781338767643"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 48,
          "printType": "BOOK",
          "categories": [
            "Juvenile Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=4-oNzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=4-oNzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=4-oNzgEACAAJ&dq=harrypotter&hl=&cd=27&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=4-oNzgEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_Hogwarts_Dress_Up.html?hl=&id=4-oNzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=4-oNzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Go on an interactive adventure with your favourite Harry Potter characters in this gorgeous book that includes 10 paper dolls!"
        }
      },
      {
        "kind": "books#volume",
        "id": "qs8cEAAAQBAJ",
        "etag": "KzT3+kqHpKM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/qs8cEAAAQBAJ",
        "volumeInfo": {
          "title": "Harry Potter Paper Models",
          "authors": [
            "Moira Squier"
          ],
          "publisher": "Thunder Bay Press",
          "publishedDate": "2020-11-03",
          "description": "Build your own Wizarding World with these paper models! Also included are a special keepsake book with background information on the story and 22 trading cards packed with fascinating facts. Harry Potter Paper Models contains all the materials and instructions needed to make 22 paper models of landmarks, buildings, and other places that appear in the Harry Potter Wizarding World. Create detailed replicas of Hogwarts castle, Gringotts Wizarding Bank, and Hagrid’s hut, along with other locations from all eight Harry Potter films. Then learn more about the franchise with the included special keepsake book full of background information on the story and the 22 trading cards packed with fascinating facts. Harry Potter fans of all ages will get a kick out of bringing their favorite magical sites to life with paper!",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781684128907"
            },
            {
              "type": "ISBN_10",
              "identifier": "1684128900"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 88,
          "printType": "BOOK",
          "categories": [
            "Games & Activities"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=qs8cEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=qs8cEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=qs8cEAAAQBAJ&printsec=frontcover&dq=harrypotter&hl=&cd=28&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=qs8cEAAAQBAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_Paper_Models.html?hl=&id=qs8cEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED_FOR_ACCESSIBILITY",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=qs8cEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Build your own Wizarding World with these paper models! Also included are a special keepsake book with background information on the story and 22 trading cards packed with fascinating facts."
        }
      },
      {
        "kind": "books#volume",
        "id": "7x2-zQEACAAJ",
        "etag": "xXdOzKLIQyo",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/7x2-zQEACAAJ",
        "volumeInfo": {
          "title": "Harry Potter: Joke Shop: Water-Color!",
          "authors": [
            "Terrance Crawford"
          ],
          "publisher": "Scholastic Incorporated",
          "publishedDate": "2021-07-06",
          "description": "Discover tons of exciting pranks, jokes, and hijinks from the films of the Harry Potter in this hilarious and interactive book with a paintbrush that reveals hidden messages. Ever wanted to tell a joke like Fred or George Weasley? See Wrackspurts like Luna Lovegood? Or leave class early with a Skiving Snackbox? In this fun and interactive Water-Color! book, you'll use a water-activated paintbrush to reveal: - Who used a Love Potion on whom - The Weasley twins' impressive Wildfire Whizbangs fireworks show - Hidden creatures like Thestrals, Pygmy Puffs, and Animagi - And a whole lot more! This amazing book is filled with adorable film-inspired art. The paintbrush is activated with water, so it's completely mess-free!",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1338745174"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781338745177"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 48,
          "printType": "BOOK",
          "categories": [
            "Juvenile Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=7x2-zQEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=7x2-zQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=7x2-zQEACAAJ&dq=harrypotter&hl=&cd=29&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=7x2-zQEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_Joke_Shop_Water_Color.html?hl=&id=7x2-zQEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=7x2-zQEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Or leave class early with a Skiving Snackbox?In this fun and interactive Water-Color! book, you&#39;ll use a water-activated paintbrush to reveal: - Who used a Love Potion on whom- The Weasley twins&#39; impressive Wildfire Whizbangs fireworks show ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "g8OAzQEACAAJ",
        "etag": "RkuRB+RA2p0",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/g8OAzQEACAAJ",
        "volumeInfo": {
          "title": "Harry Potter: Squishy: Bravery and Friendship",
          "authors": [
            "Samantha Swank"
          ],
          "publisher": "Scholastic Incorporated",
          "publishedDate": "2021-02-02",
          "description": "Write in this magical fill-in book about Hogwarts School of Witchcraft and Wizardry, with an amazing squishy Harry on the cover! When Harry is eleven years old, he's sorted into Gryffindor house, where the brave and bold learn and hone their magic. Throughout the films, Harry proves that he's brave-like when he defeats Lord Voldemort in the quest for the Sorcerer's Stone, all the way through the epic cinematic Battle of Hogwarts. And Harry's a good friend, too! Fill in prompts, activities, and more in this fun-filled bravery-themed book. Learn how to draw Godric Gryffindor, the founder of Gryffindor house; write about the bravest thing you've ever done; and discover what you'd pull out of the Sorting Hat if you were in peril. This guided book also includes an adorably squishy Harry on the front cover!",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1338715992"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781338715996"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 128,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=g8OAzQEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=g8OAzQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=g8OAzQEACAAJ&dq=harrypotter&hl=&cd=30&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=g8OAzQEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_Squishy_Bravery_and_Friends.html?hl=&id=g8OAzQEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=g8OAzQEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This guided book also includes an adorably squishy Harry on the front cover!"
        }
      },
      {
        "kind": "books#volume",
        "id": "WA-wzQEACAAJ",
        "etag": "eDXA+/dyceA",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/WA-wzQEACAAJ",
        "volumeInfo": {
          "title": "Harry Potter and the Half-Blood Prince - Ravenclaw Edition",
          "authors": [
            "J. K. Rowling"
          ],
          "publisher": "Bloomsbury Children's Books",
          "publishedDate": "2021",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1526618265"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781526618269"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 560,
          "printType": "BOOK",
          "categories": [
            "Juvenile Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=WA-wzQEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=WA-wzQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=WA-wzQEACAAJ&dq=harrypotter&hl=&cd=31&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=WA-wzQEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_and_the_Half_Blood_Prince_R.html?hl=&id=WA-wzQEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=WA-wzQEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "14mxzQEACAAJ",
        "etag": "62PQmJ9064c",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/14mxzQEACAAJ",
        "volumeInfo": {
          "title": "Harry Potter and the Half-Blood Prince - Slytherin Edition",
          "authors": [
            "J. K. Rowling"
          ],
          "publisher": "Bloomsbury Children's Books",
          "publishedDate": "2021",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1526618281"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781526618283"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 560,
          "printType": "BOOK",
          "categories": [
            "Juvenile Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=14mxzQEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=14mxzQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=14mxzQEACAAJ&dq=harrypotter&hl=&cd=32&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=14mxzQEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_and_the_Half_Blood_Prince_S.html?hl=&id=14mxzQEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=14mxzQEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "GAfuDwAAQBAJ",
        "etag": "cSMB/VnckVY",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/GAfuDwAAQBAJ",
        "volumeInfo": {
          "title": "Teaching K-8 Reading",
          "subtitle": "Disrupting 10 Literacy Myths",
          "authors": [
            "Christine H. Leland",
            "Mitzi Lewison",
            "Jerome C. Harste"
          ],
          "publisher": "Routledge",
          "publishedDate": "2020-07-16",
          "description": "Accessible and engaging, this methods textbook provides a roadmap for improving reading instruction. Leland, Lewison, and Harste explain why certain ineffective or debunked literacy techniques prevail in the classroom, identify the problematic assumptions that underly these popular myths, and offer better alternatives for literacy teaching. Grounded in a mantra that promotes critical thinking and agency—Enjoy! Dig Deeply! Take Action!—this book presents a clear framework, methods, and easy applications for designing and implementing effective literacy instruction. Numerous teaching strategies, classroom examples, teacher vignettes, and recommendations for using children’s and adolescent literature found in this book make it an ideal text for preservice teachers in elementary and middle school reading, and English language arts methods courses as well as a practical resource for professional in-service workshops and teachers. Key features include: Instructional engagements for supporting students as they read picture books, chapter books, and news articles, and interact with social media and participate in the arts and everyday life; Voices from the field that challenge mythical thinking and offer realworld examples of what effective reading and language arts instruction looks like in practice; Owl statements that alert readers to key ideas for use when planning reading and language arts instruction.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781000093766"
            },
            {
              "type": "ISBN_10",
              "identifier": "100009376X"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 198,
          "printType": "BOOK",
          "categories": [
            "Education"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=GAfuDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=GAfuDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=GAfuDwAAQBAJ&pg=PT29&dq=harrypotter&hl=&cd=33&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=GAfuDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=GAfuDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 4146.52,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 4146.52,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=GAfuDwAAQBAJ&rdid=book-GAfuDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 4146520000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 4146520000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Teaching_K_8_Reading-sample-epub.acsm?id=GAfuDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Teaching_K_8_Reading-sample-pdf.acsm?id=GAfuDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=GAfuDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "\u003cb\u003eHarry Potter\u003c/b\u003e (Boxed Set): \u003cb\u003eHarry Potter\u003c/b\u003e and the sorcerer&#39;s stone; \u003cb\u003eHarry Potter\u003c/b\u003e and the chamber of secrets; \u003cb\u003eHarry Potter\u003c/b\u003e and the prisoner of Azkaban; \u003cb\u003eHarry Potter\u003c/b\u003e and the goblet of fire; \u003cb\u003eHarry Potter\u003c/b\u003e and the order of the phoenix;&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "I-YLEAAAQBAJ",
        "etag": "ehXylw91BX0",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/I-YLEAAAQBAJ",
        "volumeInfo": {
          "title": "The Traditions of Freemasonry and Ancient Mystery Cults in \"Harry Potter\"",
          "subtitle": "An Approach Based on Masonic Temple Ideals and Mozart's \"Magic Flute\"",
          "authors": [
            "George Cebadal"
          ],
          "publisher": "BoD – Books on Demand",
          "publishedDate": "2020-11-30",
          "description": "An essay about aspects of Freemasonry and Ancient Mystery Cults in \"Harry Potter\". Table of contents: I. The Great Hall of Hogwarts and its Freemason traditions II. The Triwizard Tournament as the trials of \"The Magic Flute\" III. Freemasonry and its dimensions in \"The Magic Flute\"",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9783752687477"
            },
            {
              "type": "ISBN_10",
              "identifier": "3752687479"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 17,
          "printType": "BOOK",
          "categories": [
            "Literary Criticism"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=I-YLEAAAQBAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=I-YLEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=I-YLEAAAQBAJ&pg=PP1&dq=harrypotter&hl=&cd=34&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=I-YLEAAAQBAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_Traditions_of_Freemasonry_and_Ancien.html?hl=&id=I-YLEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true
          },
          "pdf": {
            "isAvailable": true
          },
          "webReaderLink": "http://play.google.com/books/reader?id=I-YLEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "dEJQEAAAQBAJ",
        "etag": "Pve9Goq8vgY",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/dEJQEAAAQBAJ",
        "volumeInfo": {
          "title": "Harry Potter Film Vault: Hogwarts Professors and Staff",
          "authors": [
            "Insight Editions"
          ],
          "publisher": "Simon and Schuster",
          "publishedDate": "2020-11-24",
          "description": "Discover how cinematic artistry, wardrobe, and the actors themselves brought the school’s instructors, caretakers, and ghosts to life on the big screen. Learn all about the fascinating professors and staff of Hogwarts School of Witchcraft and Wizardry. This volume collects stunning illustrations and behind-the-scenes photography alongside striking insights from the filmmakers to give fans an in-depth look at the many iconic professors seen throughout the Harry Potter films, including Albus Dumbledore, Severus Snape, Minerva McGonagall, and more. Harry Potter Film Vault compiles the filmmaking secrets and visionary artistry behind the Harry Potter films into a series of twelve deluxe collectible volumes. Intricately designed and packed with concept art and unit photography from the Warner Bros. archive, each volume in the series gives fans striking insights about bringing the Wizarding World to the big screen. Praise for the Harry Potter Film Vault series “A detailed, behind-the-scenes look at creating some aspect of the wizarding world for the films.” —The Leaky Cauldron “They’re gorgeous, and because they break down the different aspects of the films into twelve volumes, they may have more detail than some of the other compendiums out there . . . these might just be my new favorite Potter film books.” —MuggleNet “[A] super cool behind the scenes series of the Harry Potter films . . . Twelve volumes that take the viewer on distinct adventures that unveil various aspects of the beloved movies.” —Apartment Therapy “You’re going to want to collect them all.” —Wizards and Whatnot",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781647223250"
            },
            {
              "type": "ISBN_10",
              "identifier": "1647223253"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 64,
          "printType": "BOOK",
          "categories": [
            "Performing Arts"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=dEJQEAAAQBAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=dEJQEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=dEJQEAAAQBAJ&pg=PP1&dq=harrypotter&hl=&cd=35&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=dEJQEAAAQBAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_Film_Vault_Hogwarts_Profess.html?hl=&id=dEJQEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=dEJQEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "Cn_rDwAAQBAJ",
        "etag": "IgMC2KsVOTs",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/Cn_rDwAAQBAJ",
        "volumeInfo": {
          "title": "The Binge Watcher’s Guide to the Harry Potter Films - An Unofficial Companion",
          "authors": [
            "Cecilia Tan"
          ],
          "publisher": "Riverdale Avenue Books LLC",
          "publishedDate": "2020-06-15",
          "description": "A fun, fan-centric guide to re-living the magic of all eight original HP movies, whether you binge watch or just read the book! It's hard to believe, but 20 years have passed since a baby-faced Daniel Radcliffe took the screen test that would lead to him becoming Harry Potter for an entire generation of movie-goers. And now it's time to introduce a new generation to the magic that is the Harry Potter films. Join Cecilia Tan, a writer, editor, and devoted Harry Potter fan, as she takes you back to Hogwarts, through a fan-centric guided tour of all eight movies in THE BINGE WATCHER'S GUIDE TO THE HARRY POTTER FILMS where you can re-live all the excitement and wonder of seeing Harry hop on his broom for the very first time. Tan will guide you through loving, fun--yet occasionally snarky--recaps of each film, as well slather on many behind-the-scenes facts and stories about how the films were made. Casting decisions, near misses, movie artistry: she’ll cover it all, and more, as well as critical analysis of the films' significance in pop culture, filmmaking, and history. Not only that, since this is a Binge Watcher's Guide, Tan shares actual tips for binge watching, including recipes and suggestions for hosting your own Harry Potter themed binge-watching party.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781626015555"
            },
            {
              "type": "ISBN_10",
              "identifier": "1626015554"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "printType": "BOOK",
          "categories": [
            "Performing Arts"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.2.3.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=Cn_rDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=Cn_rDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=Cn_rDwAAQBAJ&pg=PP1&dq=harrypotter&hl=&cd=36&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=Cn_rDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=Cn_rDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 893.55,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 446.78,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=Cn_rDwAAQBAJ&rdid=book-Cn_rDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 893550000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 446780000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true
          },
          "pdf": {
            "isAvailable": true
          },
          "webReaderLink": "http://play.google.com/books/reader?id=Cn_rDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Not only that, since this is a Binge Watcher&#39;s Guide, Tan shares actual tips for binge watching, including recipes and suggestions for hosting your own Harry Potter themed binge-watching party."
        }
      },
      {
        "kind": "books#volume",
        "id": "gC-BzgEACAAJ",
        "etag": "2ksOrTufSvg",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/gC-BzgEACAAJ",
        "volumeInfo": {
          "title": "LEGO (R) Harry Potter (TM): Wizard Vs Wizard (Includes Harry Potter (TM) and Draco Malfoy (TM) LEGO (R) Minifigures, Pop-up Play Scenes and 2 Books)",
          "authors": [
            "Buster Books"
          ],
          "publisher": "Buster Books",
          "publishedDate": "2021-10-14",
          "description": "Discover one of HogwartsT' biggest rivalries with this awesome LEGO® Harry PotterT set. Included inside are a double-sided pop-up play scene, two activity books and two super-cool LEGO minifigures. Read the books to find out all about the most famous clashes between Harry PotterT and his rival, Draco MalfoyT. Both books are packed with puzzles and facts based on memorable moments from the Harry PotterT movies. Then, build your Harry PotterT and Draco MalfoyT LEGO minifigures to create stories of your own against the backdrop of the two pop-up scenes. Harry PotterT fans will love this opportunity to bring the Wizarding WorldT to life through imaginative play and fun activities. LEGO, the LEGO logo, the Brick and Knob configurations and the Minifigure are trademarks of the LEGO Group. ©2021 The LEGO Group. WIZARDING WORLD characters, names, and related indicia are © & T Warner Bros. Entertainment Inc. Publishing Rights © JKR. (s21)",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1780558139"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781780558134"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 40,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=gC-BzgEACAAJ&dq=harrypotter&hl=&cd=37&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=gC-BzgEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/LEGO_R_Harry_Potter_TM_Wizard_Vs_Wizard.html?hl=&id=gC-BzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=gC-BzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Included inside are a double-sided pop-up play scene, two activity books and two super-cool LEGO minifigures. Read the books to find out all about the most famous clashes between Harry PotterT and his rival, Draco MalfoyT."
        }
      },
      {
        "kind": "books#volume",
        "id": "NRFbEAAAQBAJ",
        "etag": "wPVo4sLdUBo",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/NRFbEAAAQBAJ",
        "volumeInfo": {
          "title": "Harry Potter and the Prisoner of Azkaban",
          "authors": [
            "J. K. Rowling"
          ],
          "publisher": "Bloomsbury Publishing",
          "publishedDate": "2020-11-12",
          "description": "For twelve long years, the dread fortress of Azkaban held an infamous prisoner named Sirius Black. Convicted of killing thirteen people with a single curse, he was said to be the heir apparent to the Dark Lord, Voldemort. Now he has escaped, leaving only two clues as to where he might be headed: Harry Potter's defeat of You-Know-Who was Black's downfall as well. And the Azkaban guards heard Black muttering in his sleep, \"He's at Hogwarts... he's at Hogwarts.\" Harry Potter isn't safe, not even within the walls of his magical school, surrounded by his friends. Because on top of it all, there may be a traitor in their midst. This edition has been beautifully designed with illustrations by Jim Kay and is packed with breathtaking scenes and unforgettable characters.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781526622808"
            },
            {
              "type": "ISBN_10",
              "identifier": "1526622807"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 342,
          "printType": "BOOK",
          "categories": [
            "Juvenile Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=NRFbEAAAQBAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=NRFbEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=NRFbEAAAQBAJ&dq=harrypotter&hl=&cd=38&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=NRFbEAAAQBAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_and_the_Prisoner_of_Azkaban.html?hl=&id=NRFbEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=NRFbEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Because on top of it all, there may be a traitor in their midst. This edition has been beautifully designed with illustrations by Jim Kay and is packed with breathtaking scenes and unforgettable characters."
        }
      },
      {
        "kind": "books#volume",
        "id": "jXoxywEACAAJ",
        "etag": "r0AczBpK9Ls",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/jXoxywEACAAJ",
        "volumeInfo": {
          "title": "Harry Potter and the Order of the Phoenix - Gryffindor Edition",
          "authors": [
            "J. K. Rowling"
          ],
          "publisher": "Bloomsbury Children's Books",
          "publishedDate": "2020-06",
          "description": "The noble values of Gryffindor house shine through the gathering darkness in Harry's fifth year at Hogwarts. The Weasley family remains steadfast in friendship as Harry awaits trial and Dumbledore revives the Order of the Phoenix, a secret society devoted to thwarting the Dark Lord. Gryffindor house provides its staunch heart, none more so than Sirius Black... This Gryffindor edition of Harry Potter and the Order of the Phoenix celebrates the house famed for its courage, bravery and determination.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "152661815X"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781526618153"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 816,
          "printType": "BOOK",
          "categories": [
            "Juvenile Fiction"
          ],
          "averageRating": 5,
          "ratingsCount": 1,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=jXoxywEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=jXoxywEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=jXoxywEACAAJ&dq=harrypotter&hl=&cd=39&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=jXoxywEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Harry_Potter_and_the_Order_of_the_Phoeni.html?hl=&id=jXoxywEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=jXoxywEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Gryffindor house provides its staunch heart, none more so than Sirius Black... This Gryffindor edition of Harry Potter and the Order of the Phoenix celebrates the house famed for its courage, bravery and determination."
        }
      },
      {
        "kind": "books#volume",
        "id": "CWUKzgEACAAJ",
        "etag": "tem2N7IWI4A",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/CWUKzgEACAAJ",
        "volumeInfo": {
          "title": "The Unofficial Harry Potter Cookbook",
          "subtitle": "Learn How to Prepare Cauldron Cakes, Butterbeer and 50+ Other Potterhead Recipes for Wizards and Non-Wizards Alike",
          "authors": [
            "Marie Whipkey"
          ],
          "publishedDate": "2020-11-05",
          "description": "Are you a Harry Potter Fan and want's to try some Magical Cooking Recipes Hitch a ride on the Hogwarts Express and eat just like Harry, Ron, Hermione, Hagrid, and all your favorite characters from the Wizarding World! A love of food has always been part of the Harry Potter universe, from the fabulous feasts served in the Great Hall to the sweets exchanged in the common room. Every one of these recipes has been concocted with love for occasions large and small, to be enjoyed alone or with friends, at home or on the go. This amazing cookbook contains: ●50+ recipes to choose from, based on every taste and personal cooking preference ●Step-by-step directions to cook the best Harry Potter desserts even if you have never baked before ●A rich collection of tasty and nice-looking dishes, all of them having a Hogwarts inspired design ●Guaranteed fun by making the best Harry Potter recipes and get everyone asking for more of your delicacies ●And much more! With a dash of magic and a drop of creativity, you'll conjure up the entrees, desserts, snacks, and drinks you need to transform ordinary Muggle meals into magical culinary masterpieces, sure to make even Mrs. Weasley proud! Here is the most remarkable thing you definitely cannot resist about this book; it does not care if you are good at wizardry or not, it only wants you to enjoy one of the best things that came off the Harry Potter world. Nothing more to wait for, is there? Jump on the download train and get started on this cookbook!",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1801210098"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781801210096"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 74,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=CWUKzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=CWUKzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=CWUKzgEACAAJ&dq=harrypotter&hl=&cd=40&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=CWUKzgEACAAJ&dq=harrypotter&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/The_Unofficial_Harry_Potter_Cookbook.html?hl=&id=CWUKzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=CWUKzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },{
        "kind": "books#volume",
        "id": "jVdEzgEACAAJ",
        "etag": "FEyAAWM3f7E",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/jVdEzgEACAAJ",
        "volumeInfo": {
          "title": "Superman '78",
          "authors": [
            "Robert Venditti"
          ],
          "publishedDate": "2021-11-09",
          "description": "DC follows the very successful Batman '66 with the new Superman '78, inspired by the Man of Steel's movie adventures starring Christopher Reeve. In the late 1970s moviegoers were thrilled by the words \"You'll believe a man can fly!,\" which introduced actor Christopher Reeve as the silver screen's charming new Man of Steel. These adventures are set in a world where superheroes are strange, thrilling, and romantic. These stories, written by comics veteran Robert Venditti (Hawkman, Green Lantern, Justice League) with crisply drawn art by Wilfredo Torres, feature colorful villains like Brainiac and Lex Luthor, as well as the heroism of Superman and the determined grit of reporter Lois Lane. Collects the first 12 chapters of the Superman '78 digital comics series.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1779512651"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781779512659"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 152,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=jVdEzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=jVdEzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=jVdEzgEACAAJ&dq=superman&hl=&cd=1&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=jVdEzgEACAAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Superman_78.html?hl=&id=jVdEzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=jVdEzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "These stories, written by comics veteran Robert Venditti (Hawkman, Green Lantern, Justice League) with crisply drawn art by Wilfredo Torres, feature colorful villains like Brainiac and Lex Luthor, as well as the heroism of Superman and the ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "w_9NEAAAQBAJ",
        "etag": "KF/PAbuPQTY",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/w_9NEAAAQBAJ",
        "volumeInfo": {
          "title": "Beppo!",
          "subtitle": "The Origin of Superman's Monkey",
          "authors": [
            "Steve Korté"
          ],
          "publisher": "Capstone",
          "publishedDate": "2022",
          "description": "Even Batman needs a crime-fighting canine by his side. But how did Ace become the Dark Knight's loyal Bat-Hound?",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781666328530"
            },
            {
              "type": "ISBN_10",
              "identifier": "1666328537"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 48,
          "printType": "BOOK",
          "categories": [
            "Juvenile Fiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=w_9NEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=w_9NEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=w_9NEAAAQBAJ&pg=PP1&dq=superman&hl=&cd=2&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=w_9NEAAAQBAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Beppo.html?hl=&id=w_9NEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=w_9NEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Even Batman needs a crime-fighting canine by his side. But how did Ace become the Dark Knight&#39;s loyal Bat-Hound?"
        }
      },
      {
        "kind": "books#volume",
        "id": "LEJUEAAAQBAJ",
        "etag": "zydME+cj7rU",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/LEJUEAAAQBAJ",
        "volumeInfo": {
          "title": "Why We Need Superheroes",
          "authors": [
            "Jeffrey Kahan"
          ],
          "publisher": "McFarland",
          "publishedDate": "2021-12-09",
          "description": "Comic books and superhero stories mirror essential societal values and beliefs. We can be Superman, Batman, Wonder Woman, Spider-Ham, Black Panther or Rocket Raccoon through our everyday choices. We can't fly, fix hyper drives or hear human heartbeats a mile away, but we can think about what Matt Murdock would do in a conflict, how Superman would respond to natural disasters and how Captain America would handle humanitarian crises. This book analyzes the impact of dozens of comics by examining the noble personalities, traits and actions of the main characters. Chapters detail how superheroes, comic books and other pop culture phenomena offer more than pure entertainment, and how we can better model ourselves after our favorite heroes. Through our good deeds, quick thinking and positive choices, we can become more like superheroes than we ever imagined.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781476644974"
            },
            {
              "type": "ISBN_10",
              "identifier": "1476644977"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 273,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=LEJUEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=LEJUEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=LEJUEAAAQBAJ&pg=PP1&dq=superman&hl=&cd=3&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=LEJUEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=LEJUEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 1608.99,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 1608.99,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=LEJUEAAAQBAJ&rdid=book-LEJUEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 1608990000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 1608990000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Why_We_Need_Superheroes-sample-epub.acsm?id=LEJUEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Why_We_Need_Superheroes-sample-pdf.acsm?id=LEJUEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=LEJUEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book analyzes the impact of dozens of comics by examining the noble personalities, traits and actions of the main characters."
        }
      },
      {
        "kind": "books#volume",
        "id": "gl5KEAAAQBAJ",
        "etag": "zFmfIfYLnfQ",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/gl5KEAAAQBAJ",
        "volumeInfo": {
          "title": "Justice League Incarnate (2021-) #1",
          "authors": [
            "Joshua Williamson",
            "Dennis Culver"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-11-30",
          "description": "After the shocking ending of Infinite Frontier, Justice League Incarnate defends the Multiverse from Darkseid across infinite Earths! Following a devastating defeat at the hands of the one true Darkseid, the Superman of Earth-23 leads a team of superheroes from myriad worlds that includes Flashpoint Batman, China’s Flash from Earth-0, Captain Carrot from Earth-26, and the brand new superhero DR. MULTIVERSE from Earth-8 in a last ditch effort to stop the end of every possible universe as we know it! Written by Joshua Williamson and Dennis Culver with first-issue art by Brandon Peterson and Andrei Berssan and a rotating cast of artists exploring the many different worlds of the DC Multiverse, this can’t-miss series is the next thrilling chapter in the Infinite Frontier saga!",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "PKEY:T2180300015001"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 30,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.2.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "03040cbb94864af4_A",
            "imageBubbleVersion": "03040cbb94864af4_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=gl5KEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=gl5KEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=gl5KEAAAQBAJ&printsec=frontcover&dq=superman&hl=&cd=4&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=gl5KEAAAQBAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Justice_League_Incarnate_2021_1.html?hl=&id=gl5KEAAAQBAJ",
          "seriesInfo": {
            "kind": "books#volume_series_info",
            "bookDisplayNumber": "1",
            "volumeSeries": [
              {
                "seriesId": "doItGwAAABBamM",
                "seriesBookType": "ISSUE",
                "orderNumber": 1
              }
            ]
          }
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Justice_League_Incarnate_2021_1-sample-epub.acsm?id=gl5KEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Justice_League_Incarnate_2021_1-sample-pdf.acsm?id=gl5KEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=gl5KEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Written by Joshua Williamson and Dennis Culver with first-issue art by Brandon Peterson and Andrei Berssan and a rotating cast of artists exploring the many different worlds of the DC Multiverse, this can’t-miss series is the next ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "IaJyzgEACAAJ",
        "etag": "v+nlWsP5n6A",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/IaJyzgEACAAJ",
        "volumeInfo": {
          "title": "Superman: Action Comics Vol. 1: Warworld Rising",
          "authors": [
            "Phillip Kennedy Johnson"
          ],
          "publishedDate": "2022",
          "description": "A new chapter in Superman's life begins as the challenges of Dark Nights: Death Metal are causing Clark Kent to feel...a change in his powers. Is it possible the Metropolis Marvel could be losing a step? The Man of Steel's struggles in taking down the creatures from the Breach would suggest as much! If he's going to continue to protect the people of Earth, he'll have to adapt--especially with threats like Mongul out there waiting to launch their biggest attacks on the Earth yet. After a war-torn battleship escapes Warworld and makes the perilous journey to Earth, Superman searches for answers about the identities of its mysterious refugees and their apparent link to the planet Krypton. Could there be other Kryptonians in the universe? Meanwhile, Atlantean scientists study the wreckage of the Warworld vessel...and make a shocking discovery that could change the balance of power on Earth. Phillip Kennedy Johnson and Mikel Janín begin an exciting new era for the Last Son of Krypton! Includes Action Comics #1030-1035!",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1779514271"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781779514271"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 160,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "comicsContent": true,
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=IaJyzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=IaJyzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=IaJyzgEACAAJ&dq=superman&hl=&cd=5&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=IaJyzgEACAAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Superman_Action_Comics_Vol_1_Warworld_Ri.html?hl=&id=IaJyzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=IaJyzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Phillip Kennedy Johnson and Mikel Janín begin an exciting new era for the Last Son of Krypton! Includes Action Comics #1030-1035!"
        }
      },
      {
        "kind": "books#volume",
        "id": "zkdKEAAAQBAJ",
        "etag": "8Zzt99Ghe68",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/zkdKEAAAQBAJ",
        "volumeInfo": {
          "title": "Batman/Superman: Authority Special (2021) #1",
          "authors": [
            "Phillip Kennedy Johnson"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-11-02",
          "description": "Following Mongul’s brazen attack on Earth, Superman’s world has been turned upside down: conflict between Atlantis and the surface world, the discovery of an immensely powerful new element, dead refugees with mysterious ties to Krypton, and expulsion from the Justice League! When Superman re-forms the experimental, antiestablishment Authority to join him in liberating Warworld, Batman comes to them with a request: join him for one unorthodox, off-the-books mission first, one he could never ask the Justice League to be a part of…and one he doesn’t expect everyone to come back from.",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "PKEY:T2175300015001"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 40,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "5bcd5db08bee8d52_A",
            "imageBubbleVersion": "5bcd5db08bee8d52_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=zkdKEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=zkdKEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=zkdKEAAAQBAJ&printsec=frontcover&dq=superman&hl=&cd=6&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=zkdKEAAAQBAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Batman_Superman_Authority_Special_2021_1.html?hl=&id=zkdKEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Batman_Superman_Authority_Special_2021_1-sample-epub.acsm?id=zkdKEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Batman_Superman_Authority_Special_2021_1-sample-pdf.acsm?id=zkdKEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=zkdKEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "When Superman re-forms the experimental, antiestablishment Authority to join him in liberating Warworld, Batman comes to them with a request: join him for one unorthodox, off-the-books mission first, one he could never ask the Justice ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "F51BEAAAQBAJ",
        "etag": "ydjCn1kY7aM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/F51BEAAAQBAJ",
        "volumeInfo": {
          "title": "DC Sticker Art Puzzles",
          "authors": [
            "Steve Behling"
          ],
          "publisher": "Simon and Schuster",
          "publishedDate": "2021-10-05",
          "description": "These fifteen sticker puzzles featuring classic DC Comics covers will elevate you to Super Hero status Fifteen classic DC Comics covers are transformed into sticker puzzle challenges in this book that will appeal to comic book fans everywhere. As you fit more than 100 sticker shapes into each tessellated grid, a glossy art poster of the comic book cover will emerge. When you're done, you'll have a nifty piece of art to frame and hang on your wall. Comic book fans and puzzle enthusiasts will enjoy hours of puzzling fun with this collection of iconic DC Comics covers and characters like Batman, Superman, Wonder Woman, and more",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781684128938"
            },
            {
              "type": "ISBN_10",
              "identifier": "1684128935"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 80,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "comicsContent": true,
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=F51BEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=F51BEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=F51BEAAAQBAJ&pg=PA1&dq=superman&hl=&cd=7&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=F51BEAAAQBAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/DC_Sticker_Art_Puzzles.html?hl=&id=F51BEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED_FOR_ACCESSIBILITY",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=F51BEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "These fifteen sticker puzzles featuring classic DC Comics covers will elevate you to Super Hero status Fifteen classic DC Comics covers are transformed into sticker puzzle challenges in this book that will appeal to comic book fans ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "_bs8EAAAQBAJ",
        "etag": "y+pruLYVA2k",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/_bs8EAAAQBAJ",
        "volumeInfo": {
          "title": "Superman '78 (2021-) #1",
          "authors": [
            "Robert Venditti"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-08-24",
          "description": "Fly into director Richard Donner’s Superman once more in Superman ’78! Written by Robert Venditti (Superman: Man of Tomorrow) and drawn by Wilfredo Torres (Batman ’66), Superman ’78 tells a brand-new adventure in the world of the beloved film. A bright, shining day in Metropolis is interrupted by a mysterious drone that crash-lands in the city and starts wreaking havoc. This looks like a job for Superman! But where did the metallic menace come from, what is its purpose, and who is Brainiac?",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "PKEY:T2131900015001"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 20,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "45e97cb678fc14c8_A",
            "imageBubbleVersion": "45e97cb678fc14c8_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=_bs8EAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=_bs8EAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=_bs8EAAAQBAJ&printsec=frontcover&dq=superman&hl=&cd=8&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=_bs8EAAAQBAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Superman_78_2021_1.html?hl=&id=_bs8EAAAQBAJ",
          "seriesInfo": {
            "kind": "books#volume_series_info",
            "bookDisplayNumber": "1",
            "volumeSeries": [
              {
                "seriesId": "WVgtGwAAABB1QM",
                "seriesBookType": "ISSUE",
                "orderNumber": 1
              }
            ]
          }
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_78_2021_1-sample-epub.acsm?id=_bs8EAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_78_2021_1-sample-pdf.acsm?id=_bs8EAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=_bs8EAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Written by Robert Venditti (Superman: Man of Tomorrow) and drawn by Wilfredo Torres (Batman ’66), Superman ’78 tells a brand-new adventure in the world of the beloved film."
        }
      },
      {
        "kind": "books#volume",
        "id": "6JY5EAAAQBAJ",
        "etag": "P4bBqfEt9X8",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/6JY5EAAAQBAJ",
        "volumeInfo": {
          "title": "Superman and the Authority (2021-) #2",
          "authors": [
            "Grant Morrison"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-08-17",
          "description": "Clark Kent and Manchester Black continue to put Superman’s new team together, even though keeping Black in check seems like just as difficult a job as convincing the new recruits to come along. The pair hits different parts of the world looking for different types of heroes. While Midnighter, Apollo, and Natasha Irons only need to tie up some loose ends before getting on board, the Enchantress is going to be a little harder. Superman is going to have to set her free from a deadly illusion hell-bent on destroying her before she can help him save the universe.",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "PKEY:T2153900025001"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 30,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.2.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "1b699697be602c5f_A",
            "imageBubbleVersion": "1b699697be602c5f_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=6JY5EAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=6JY5EAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=6JY5EAAAQBAJ&printsec=frontcover&dq=superman&hl=&cd=9&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=6JY5EAAAQBAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Superman_and_the_Authority_2021_2.html?hl=&id=6JY5EAAAQBAJ",
          "seriesInfo": {
            "kind": "books#volume_series_info",
            "bookDisplayNumber": "2",
            "volumeSeries": [
              {
                "seriesId": "9igtGwAAABDaMM",
                "seriesBookType": "ISSUE",
                "orderNumber": 2
              }
            ]
          }
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_and_the_Authority_2021_2-sample-epub.acsm?id=6JY5EAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_and_the_Authority_2021_2-sample-pdf.acsm?id=6JY5EAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=6JY5EAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Clark Kent and Manchester Black continue to put Superman’s new team together, even though keeping Black in check seems like just as difficult a job as convincing the new recruits to come along."
        }
      },
      {
        "kind": "books#volume",
        "id": "snc5EAAAQBAJ",
        "etag": "uWUo59vdCj8",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/snc5EAAAQBAJ",
        "volumeInfo": {
          "title": "Justice League Infinity (2021-) #2",
          "authors": [
            "J.M. DeMatteis"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-08-03",
          "description": "Across the globe people begin disappearing, replaced with different but similar individuals. So where is Superman and who is this new monstrous Overman?! In order to get to the bottom of what’s happening, the Justice League will need to first take down the new villain! And what horrors are revealed in the twisted mirror room?!",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "PKEY:T2131700025001"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 20,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "618a3016b73137d4_A",
            "imageBubbleVersion": "618a3016b73137d4_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=snc5EAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=snc5EAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=snc5EAAAQBAJ&printsec=frontcover&dq=superman&hl=&cd=10&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=snc5EAAAQBAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Justice_League_Infinity_2021_2.html?hl=&id=snc5EAAAQBAJ",
          "seriesInfo": {
            "kind": "books#volume_series_info",
            "bookDisplayNumber": "2",
            "volumeSeries": [
              {
                "seriesId": "NBAtGwAAABAYCM",
                "seriesBookType": "ISSUE",
                "orderNumber": 2
              }
            ]
          }
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Justice_League_Infinity_2021_2-sample-epub.acsm?id=snc5EAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Justice_League_Infinity_2021_2-sample-pdf.acsm?id=snc5EAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=snc5EAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Across the globe people begin disappearing, replaced with different but similar individuals."
        }
      },
      {
        "kind": "books#volume",
        "id": "L3o5EAAAQBAJ",
        "etag": "2IePg62qYeU",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/L3o5EAAAQBAJ",
        "volumeInfo": {
          "title": "Bizarro Comics The Deluxe Edition",
          "authors": [
            "Various"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-07-27",
          "description": "Where else could the world’s greatest alternative cartoonists run rampant through the DC Universe in utterly unhinged stories? Bizarro, an imperfect duplicate of Superman who does everything backward, tries drawing comics, concocting stories in which Wonder Woman participates in a poetry slam, baby Superman torments his baby-sitter...and that’s just the start! This deluxe edition collects the two anthology titles Bizarro Comics and Bizarro World, with a cover by the legendary creator of The Simpsons, Matt Groening! Includes stories and art by acclaimed creators including Kyle Baker, Jeff Smith, Ivan Brunetti, Paul Pope, Hunt Emerson, Carol Lay, Roger Langridge, Mark Crilley, Dave Cooper, Eddie Campbell, Tony Millionaire, James Kochalka, Harvey Pekar, Peter Bagge, and many more!",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781779513861"
            },
            {
              "type": "ISBN_10",
              "identifier": "1779513860"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 426,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "73a8b812b3b9335a_A",
            "imageBubbleVersion": "73a8b812b3b9335a_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=L3o5EAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=L3o5EAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=L3o5EAAAQBAJ&pg=PP1&dq=superman&hl=&cd=11&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=L3o5EAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=L3o5EAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 4470.78,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 4470.78,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=L3o5EAAAQBAJ&rdid=book-L3o5EAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 4470780000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 4470780000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Bizarro_Comics_The_Deluxe_Edition-sample-epub.acsm?id=L3o5EAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Bizarro_Comics_The_Deluxe_Edition-sample-pdf.acsm?id=L3o5EAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=L3o5EAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This deluxe edition collects the two anthology titles Bizarro Comics and Bizarro World, with a cover by the legendary creator of The Simpsons, Matt Groening!"
        }
      },
      {
        "kind": "books#volume",
        "id": "rx6ZzgEACAAJ",
        "etag": "XdrKjPI0uTQ",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/rx6ZzgEACAAJ",
        "volumeInfo": {
          "title": "Justice League Vol. 1: Prisms",
          "authors": [
            "Brian Michael Bendis"
          ],
          "publishedDate": "2022-05-10",
          "description": "Meet the New Justice League: Batman, Superman, the Flash, Hawkgirl, Aquaman, Hippolyta, Naomi, and Black Adam! Writer Brian Michael Bendis reunites with artist David Marquez (Miles Morales: The Ultimate Spider-Man, Iron Man, Batman/Superman) for a new, star-studded Justice League featuring Batman, Superman, the Flash, Hawkgirl, Aquaman, Hippolyta, new DC powerhouse Naomi, and...is that Black Adam? Superman is leading the charge to reinvent the Justice League--and at the same time, a new, cosmic-powered threat arrives from Naomi's homeworld to rule the Earth! And as a backup story, dark days ahead for the new Justice League Dark. Zatanna and John Constantine take a road trip, only to discover horror around the bend as a friend--and sometimes foe--is reborn in fire! A legend is destroyed and another takes a terrible turn, as Merlin reveals the beginning of a new, blood-drenched plot for all humankind. So begins writer Ram V's new journey into the abyss with the Justice League Dark! Collects Justice League #59-63.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1779514379"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781779514370"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 128,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=rx6ZzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=rx6ZzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=rx6ZzgEACAAJ&dq=superman&hl=&cd=12&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=rx6ZzgEACAAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Justice_League_Vol_1_Prisms.html?hl=&id=rx6ZzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=rx6ZzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "&quot;Writer Brian Michael Bendis reunites with artist David Marquez for a new, star-studded Justice League featuring Batman, Superman, the Flash, Hawkgirl, Aquaman, Hippolyta, new DC powerhouse Naomi, and...is that Black Adam?"
        }
      },
      {
        "kind": "books#volume",
        "id": "Jx85EAAAQBAJ",
        "etag": "8w9CeukjPkY",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/Jx85EAAAQBAJ",
        "volumeInfo": {
          "title": "Superman: Man of Tomorrow Vol. 1: Hero of Metropolis",
          "authors": [
            "Robert Venditti"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-07-20",
          "description": "No matter how many times Superman saves Metropolis, there’s always some devious plot in the works! Robert Venditti brings a new take on some of Superman’s most famous villains. From Toyman to Metallo, the Man of Steel faces them all-but with a familiar foe watching his every move, will he be able to save the city he loves? Collected for the first time ever in print Superman: Man of Tomorrow #1-6 and #11-15!",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781779514653"
            },
            {
              "type": "ISBN_10",
              "identifier": "1779514654"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 211,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "73f3f7cf68708dc9_A",
            "imageBubbleVersion": "73f3f7cf68708dc9_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=Jx85EAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=Jx85EAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=Jx85EAAAQBAJ&pg=PP1&dq=superman&hl=&cd=13&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=Jx85EAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=Jx85EAAAQBAJ",
          "seriesInfo": {
            "kind": "books#volume_series_info",
            "bookDisplayNumber": "1",
            "volumeSeries": [
              {
                "seriesId": "qhkrGwAAABCAAM",
                "seriesBookType": "COLLECTED_EDITION",
                "orderNumber": 1,
                "issue": [
                  {
                    "issueOrderNumber": 1,
                    "issueDisplayNumber": "1"
                  },
                  {
                    "issueOrderNumber": 2,
                    "issueDisplayNumber": "2"
                  },
                  {
                    "issueDisplayNumber": "3"
                  },
                  {
                    "issueDisplayNumber": "4"
                  },
                  {
                    "issueDisplayNumber": "5"
                  },
                  {
                    "issueDisplayNumber": "6"
                  },
                  {
                    "issueDisplayNumber": "11"
                  },
                  {
                    "issueDisplayNumber": "12"
                  },
                  {
                    "issueDisplayNumber": "13"
                  },
                  {
                    "issueDisplayNumber": "14"
                  },
                  {
                    "issueDisplayNumber": "15"
                  }
                ]
              }
            ]
          }
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 535.68,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 535.68,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=Jx85EAAAQBAJ&rdid=book-Jx85EAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 535680000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 535680000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_Man_of_Tomorrow_Vol_1_Hero_of_M-sample-epub.acsm?id=Jx85EAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_Man_of_Tomorrow_Vol_1_Hero_of_M-sample-pdf.acsm?id=Jx85EAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=Jx85EAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "No matter how many times Superman saves Metropolis, there’s always some devious plot in the works! Robert Venditti brings a new take on some of Superman’s most famous villains."
        }
      },
      {
        "kind": "books#volume",
        "id": "9eUzEAAAQBAJ",
        "etag": "1VU3Knh30yE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/9eUzEAAAQBAJ",
        "volumeInfo": {
          "title": "Action Comics 2021 Annual (2021) #1",
          "authors": [
            "Phillip Kennedy Johnson"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-07-13",
          "description": "The return of Future State’s House of El! It’s time to head back to tomorrow, as Superman’s descendants face a threat from today. This special tale connects to “Warworld Rising” as the actions of Clark Kent in the present reverberate, leaving long-lasting changes...and a deadly threat for the House of El to reckon with. Can Brandon Kent, the Superman of his era, stop the danger from hurting the next generation? Also, for those wanting to know more about Brandon’s relationshop with Theand’r, the Tamaranean queen, prepare yourself for a little romance as well.",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "PKEY:T2155000015001"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 40,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.3.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "c8b61110908fc2b9_A",
            "imageBubbleVersion": "c8b61110908fc2b9_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=9eUzEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=9eUzEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=9eUzEAAAQBAJ&printsec=frontcover&dq=superman&hl=&cd=14&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=9eUzEAAAQBAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Action_Comics_2021_Annual_2021_1.html?hl=&id=9eUzEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Action_Comics_2021_Annual_2021_1-sample-epub.acsm?id=9eUzEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Action_Comics_2021_Annual_2021_1-sample-pdf.acsm?id=9eUzEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=9eUzEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This special tale connects to “Warworld Rising” as the actions of Clark Kent in the present reverberate, leaving long-lasting changes...and a deadly threat for the House of El to reckon with."
        }
      },
      {
        "kind": "books#volume",
        "id": "WoMwEAAAQBAJ",
        "etag": "rzeFaQ/vtgE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/WoMwEAAAQBAJ",
        "volumeInfo": {
          "title": "Adapting Superman",
          "subtitle": "Essays on the Transmedia Man of Steel",
          "authors": [
            "John Darowski"
          ],
          "publisher": "McFarland",
          "publishedDate": "2021-05-29",
          "description": "Almost immediately after his first appearance in comic books in June 1938, Superman began to be adapted to other media. The subsequent decades have brought even more adaptations of the Man of Steel, his friends, family, and enemies in film, television, comic strip, radio, novels, video games, and even a musical. The rapid adaptation of the Man of Steel occurred before the character and storyworld were fully developed on the comic book page, allowing the adaptations an unprecedented level of freedom and adaptability. The essays in this collection provide specific insight into the practice of adapting Superman from comic books to other media and cultural contexts through a variety of methods, including social, economic, and political contexts. Authors touch on subjects such as the different international receptions to the characters, the evolution of both Clark Kent's character and Superman's powers, the importance of the radio, how the adaptations interact with issues such as racism and Cold War paranoia, and the role of fan fiction in the franchise. By applying a wide range of critical approaches to adaption and Superman, this collection offers new insights into our popular entertainment and our cultural history.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781476642390"
            },
            {
              "type": "ISBN_10",
              "identifier": "1476642397"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 287,
          "printType": "BOOK",
          "categories": [
            "Literary Criticism"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "2.2.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=WoMwEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=WoMwEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=WoMwEAAAQBAJ&printsec=frontcover&dq=superman&hl=&cd=15&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=WoMwEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=WoMwEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 2145.58,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 2145.58,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=WoMwEAAAQBAJ&rdid=book-WoMwEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 2145580000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 2145580000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Adapting_Superman-sample-epub.acsm?id=WoMwEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Adapting_Superman-sample-pdf.acsm?id=WoMwEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=WoMwEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The essays in this collection provide specific insight into the practice of adapting Superman from comic books to other media and cultural contexts through a variety of methods, including social, economic, and political contexts."
        }
      },
      {
        "kind": "books#volume",
        "id": "WoMwEAAAQBAJ",
        "etag": "NW/BI1ZCMAI",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/WoMwEAAAQBAJ",
        "volumeInfo": {
          "title": "Adapting Superman",
          "subtitle": "Essays on the Transmedia Man of Steel",
          "authors": [
            "John Darowski"
          ],
          "publisher": "McFarland",
          "publishedDate": "2021-05-29",
          "description": "Almost immediately after his first appearance in comic books in June 1938, Superman began to be adapted to other media. The subsequent decades have brought even more adaptations of the Man of Steel, his friends, family, and enemies in film, television, comic strip, radio, novels, video games, and even a musical. The rapid adaptation of the Man of Steel occurred before the character and storyworld were fully developed on the comic book page, allowing the adaptations an unprecedented level of freedom and adaptability. The essays in this collection provide specific insight into the practice of adapting Superman from comic books to other media and cultural contexts through a variety of methods, including social, economic, and political contexts. Authors touch on subjects such as the different international receptions to the characters, the evolution of both Clark Kent's character and Superman's powers, the importance of the radio, how the adaptations interact with issues such as racism and Cold War paranoia, and the role of fan fiction in the franchise. By applying a wide range of critical approaches to adaption and Superman, this collection offers new insights into our popular entertainment and our cultural history.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781476642390"
            },
            {
              "type": "ISBN_10",
              "identifier": "1476642397"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 287,
          "printType": "BOOK",
          "categories": [
            "Literary Criticism"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "2.2.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=WoMwEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=WoMwEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=WoMwEAAAQBAJ&pg=PA72&dq=superman&hl=&cd=16&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=WoMwEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=WoMwEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 2145.58,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 2145.58,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=WoMwEAAAQBAJ&rdid=book-WoMwEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 2145580000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 2145580000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Adapting_Superman-sample-epub.acsm?id=WoMwEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Adapting_Superman-sample-pdf.acsm?id=WoMwEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=WoMwEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The dangling plot thread concerning the last piece of kryptonite is picked up a year-and-a-half later in “\u003cb\u003eSuperman\u003c/b\u003e vs. Kryptonite” (33 episodes, 14 May–27 June 1947). 24. Much has been documented about Stetson Kennedy&#39;s infiltration of&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "Ts8vEAAAQBAJ",
        "etag": "QpsfJeNse/k",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/Ts8vEAAAQBAJ",
        "volumeInfo": {
          "title": "Is Superman Circumcised?",
          "subtitle": "The Complete Jewish History of the World's Greatest Hero",
          "authors": [
            "Roy Schwartz"
          ],
          "publisher": "McFarland",
          "publishedDate": "2021-05-19",
          "description": "Superman is the original superhero, an American icon, and arguably the most famous character in the world--and he's Jewish! Introduced in June 1938, the Man of Steel was created by two Jewish teens, Jerry Siegel, the son of immigrants from Eastern Europe, and Joe Shuster, an immigrant. They based their hero's origin story on Moses, his strength on Samson, his mission on the golem, and his nebbish secret identity on themselves. They made him a refugee fleeing catastrophe on the eve of World War II and sent him to tear Nazi tanks apart nearly two years before the US joined the war. In the following decades, Superman's mostly Jewish writers, artists, and editors continued to borrow Jewish motifs for their stories, basing Krypton's past on Genesis and Exodus, its society on Jewish culture, the trial of Lex Luthor on Adolf Eichmann's, and a future holiday celebrating Superman on Passover. A fascinating journey through comic book lore, American history, and Jewish tradition, this book examines the entirety of Superman's career from 1938 to date, and is sure to give readers a newfound appreciation for the Mensch of Steel!",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781476644417"
            },
            {
              "type": "ISBN_10",
              "identifier": "1476644411"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 374,
          "printType": "BOOK",
          "categories": [
            "Literary Criticism"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "2.2.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=Ts8vEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=Ts8vEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=Ts8vEAAAQBAJ&pg=PP1&dq=superman&hl=&cd=17&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=Ts8vEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=Ts8vEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 2503.3,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 2503.3,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=Ts8vEAAAQBAJ&rdid=book-Ts8vEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 2503300000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 2503300000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Is_Superman_Circumcised-sample-epub.acsm?id=Ts8vEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Is_Superman_Circumcised-sample-pdf.acsm?id=Ts8vEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=Ts8vEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "A fascinating journey through comic book lore, American history, and Jewish tradition, this book examines the entirety of Superman&#39;s career from 1938 to date, and is sure to give readers a newfound appreciation for the Mensch of Steel!"
        }
      },
      {
        "kind": "books#volume",
        "id": "f3UrEAAAQBAJ",
        "etag": "TW9yCuCpXXw",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/f3UrEAAAQBAJ",
        "volumeInfo": {
          "title": "Superman (2018-) #31",
          "authors": [
            "Phillip Kennedy Johnson",
            "Sean Lewis"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-05-11",
          "description": "“The One Who Fell” part two! Thought to have been defeated long ago by Superman and his allies, the ancient Shadowbreed have returned in a horrifying new form, and Superman’s oldest ally has been assimilated into their ranks. As Jon and the besieged new Thakkramite leader search for the key that will help them defeat the creatures, Superman returns to the site of his first historic victory over the Shadowbreed in an attempt to warn the Thakkramites of the incoming threat. But Superman’s old allies kept terrible secrets from him, and both he and Jon are more vulnerable against the Shadowbreed than they know. And in the backup story, Jimmy Olsen’s plan to build a backup squad to help out his pal Superman looks like it’s already falling apart when two of its members, Loose Cannon and Gangbuster, would rather fight than be friends.“The One Who Fell” part two! Thought to have been defeated long ago by Superman and his allies, the ancient Shadowbreed have returned in a horrifying new form, and Superman’s oldest ally has been assimilated into their ranks. As Jon and the besieged new Thakkramite leader search for the key that will help them defeat the creatures, Superman returns to the site of his first historic victory over the Shadowbreed in an attempt to warn the Thakkramites of the incoming threat. But Superman’s old allies kept terrible secrets from him, and both he and Jon are more vulnerable against the Shadowbreed than they know. And in the backup story, Jimmy Olsen’s plan to build a backup squad to help out his pal Superman looks like it’s already falling apart when two of its members, Loose Cannon and Gangbuster, would rather fight than be friends.",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "PKEY:T1881000315001"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 30,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.3.3.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "437cf23f8e1f20be_A",
            "imageBubbleVersion": "437cf23f8e1f20be_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=f3UrEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=f3UrEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=f3UrEAAAQBAJ&printsec=frontcover&dq=superman&hl=&cd=18&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=f3UrEAAAQBAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Superman_2018_31.html?hl=&id=f3UrEAAAQBAJ",
          "seriesInfo": {
            "kind": "books#volume_series_info",
            "bookDisplayNumber": "31",
            "volumeSeries": [
              {
                "seriesId": "aygbGwAAABBxMM",
                "seriesBookType": "ISSUE",
                "orderNumber": 31
              }
            ]
          }
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_2018_31-sample-epub.acsm?id=f3UrEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_2018_31-sample-pdf.acsm?id=f3UrEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=f3UrEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "And in the backup story, Jimmy Olsen’s plan to build a backup squad to help out his pal Superman looks like it’s already falling apart when two of its members, Loose Cannon and Gangbuster, would rather fight than be friends."
        }
      },
      {
        "kind": "books#volume",
        "id": "XIMwEAAAQBAJ",
        "etag": "/9PE0ioCnqo",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/XIMwEAAAQBAJ",
        "volumeInfo": {
          "title": "Is Superman Circumcised?",
          "subtitle": "The Complete Jewish History of the World's Greatest Hero",
          "authors": [
            "Roy Schwartz"
          ],
          "publisher": "McFarland",
          "publishedDate": "2021-05-05",
          "description": "Superman is the original superhero, an American icon, and arguably the most famous character in the world--and he's Jewish! Introduced in June 1938, the Man of Steel was created by two Jewish teens, Jerry Siegel, the son of immigrants from Eastern Europe, and Joe Shuster, an immigrant. They based their hero's origin story on Moses, his strength on Samson, his mission on the golem, and his nebbish secret identity on themselves. They made him a refugee fleeing catastrophe on the eve of World War II and sent him to tear Nazi tanks apart nearly two years before the US joined the war. In the following decades, Superman's mostly Jewish writers, artists, and editors continued to borrow Jewish motifs for their stories, basing Krypton's past on Genesis and Exodus, its society on Jewish culture, the trial of Lex Luthor on Adolf Eichmann's, and a future holiday celebrating Superman on Passover. A fascinating journey through comic book lore, American history, and Jewish tradition, this book examines the entirety of Superman's career from 1938 to date, and is sure to give readers a newfound appreciation for the Mensch of Steel!",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781476662909"
            },
            {
              "type": "ISBN_10",
              "identifier": "1476662908"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 374,
          "printType": "BOOK",
          "categories": [
            "Literary Criticism"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=XIMwEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=XIMwEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=XIMwEAAAQBAJ&printsec=frontcover&dq=superman&hl=&cd=19&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=XIMwEAAAQBAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Is_Superman_Circumcised.html?hl=&id=XIMwEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=XIMwEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "A fascinating journey through comic book lore, American history, and Jewish tradition, this book examines the entirety of Superman&#39;s career from 1938 to date, and is sure to give readers a newfound appreciation for the Mensch of Steel!"
        }
      },
      {
        "kind": "books#volume",
        "id": "Bh0oEAAAQBAJ",
        "etag": "Lz3YyrgotlQ",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/Bh0oEAAAQBAJ",
        "volumeInfo": {
          "title": "Batman/Superman (2019-) #17",
          "authors": [
            "Gene Luen Yang"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-04-27",
          "description": "In a world where Superman’s rocket never reached Earth, the Dark Knight and his sidekick discover a startling rift between dimensions. On the other side? A world where Martha Wayne survived, and Bruce never grew up to be Batman! Not only that, but a strange alien has emerged from the rift who’s faster than a locomotive and can leap tall buildings in a single bound...the Superman of Metropolis! When these worlds collide, the architects of this alternate history are revealed, and the only ones who can thwart their deadly experiments are the Batman and Superman of Earth-0! It’s a dynamic dual-world adventure!",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "PKEY:T1975000175001"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 22,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.2.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "2c258183e19a72e5_A",
            "imageBubbleVersion": "2c258183e19a72e5_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=Bh0oEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=Bh0oEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=Bh0oEAAAQBAJ&printsec=frontcover&dq=superman&hl=&cd=20&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=Bh0oEAAAQBAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Batman_Superman_2019_17.html?hl=&id=Bh0oEAAAQBAJ",
          "seriesInfo": {
            "kind": "books#volume_series_info",
            "bookDisplayNumber": "17",
            "volumeSeries": [
              {
                "seriesId": "w8opGwAAABDr0M",
                "seriesBookType": "ISSUE",
                "orderNumber": 17
              }
            ]
          }
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Batman_Superman_2019_17-sample-epub.acsm?id=Bh0oEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Batman_Superman_2019_17-sample-pdf.acsm?id=Bh0oEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=Bh0oEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "In a world where Superman’s rocket never reached Earth, the Dark Knight and his sidekick discover a startling rift between dimensions."
        }
      },
      {
        "kind": "books#volume",
        "id": "tD0nEAAAQBAJ",
        "etag": "JP4ZZMzx2zA",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/tD0nEAAAQBAJ",
        "volumeInfo": {
          "title": "Superman Red & Blue (2021-) #2",
          "authors": [
            "Jason Howard",
            "Steven T. Seagle",
            "Robert Venditti"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-04-20",
          "description": "Explore the world of Superman in a way you’ve never seen before. Five brand-new stories, a visual tour de force, with only the Man of Steel’s signature colors. There are tales starring Clark Kent, the original Superman, including a showdown with his most tenacious foe, Lex Luthor-but there is also a great space adventure with Val-Zod, the Superman of Earth-2, going up against an amped-up version of Prometheus. And then there is Cyborg Superman, a warped reflection of the real deal, with a mission as opposite to Superman’s as any could be. But no matter how out there the situation gets, it always comes back to the one man and the planet he loves and has sworn to protect-and the people he inspires, young and old.",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "PKEY:T2118200025001"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 40,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "5dc40868819eb772_A",
            "imageBubbleVersion": "5dc40868819eb772_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=tD0nEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=tD0nEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=tD0nEAAAQBAJ&printsec=frontcover&dq=superman&hl=&cd=21&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=tD0nEAAAQBAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Superman_Red_Blue_2021_2.html?hl=&id=tD0nEAAAQBAJ",
          "seriesInfo": {
            "kind": "books#volume_series_info",
            "bookDisplayNumber": "2",
            "volumeSeries": [
              {
                "seriesId": "V9EsGwAAABB6yM",
                "seriesBookType": "ISSUE",
                "orderNumber": 2
              }
            ]
          }
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_Red_Blue_2021_2-sample-epub.acsm?id=tD0nEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_Red_Blue_2021_2-sample-pdf.acsm?id=tD0nEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=tD0nEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Explore the world of Superman in a way you’ve never seen before."
        }
      },
      {
        "kind": "books#volume",
        "id": "zc6VzgEACAAJ",
        "etag": "x3L8dFZfYHs",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/zc6VzgEACAAJ",
        "volumeInfo": {
          "title": "DC One Million Omnibus (2022 Edition)",
          "authors": [
            "Grant Morrison"
          ],
          "publishedDate": "2022-05-03",
          "description": "Get ready to go to the 853rd Century! In the 853rd century, Earth remains safe, thanks to the heroics of the JLA of the future. The ancestors of Batman, Superman, Wonder Woman, The Flash and others remain united in combating forces of evil, but perhaps have never met anything as deadly as the sentient super-computer Solaris, the Tyrant Sun. As this villainous threat becomes too much to handle, these heroes of the future turn to the only group they know can help: the original JLA. The entire DC ONE MILLION series is reprinted here, along with every crossover issue and tie-in. This massive Omnibus edition is a must-have for any collector. Includes the following issues: DC ONE MILLION #1-4, and tales from the following: ACTION COMICS 1,000,000, ADVENTURES OF SUPERMAN 1,000,000, AQUAMAN 1,000,000, AZRAEL 1,000,000, BATMAN 1,000,000, BATMAN: SHADOW OF THE BAT 1,000,000, CATWOMAN 1,000,000, CHASE 1,000,000, CHRONOS 1,000,000, CREEPER 1,000,000, DETECTIVE COMICS 1,000,000, FLASH 1,000,000, GREEN ARROW 1,000,000, GREEN LANTERN 1,000,000, HITMAN 1,000,000, IMPULSE 1,000,000, JLA 1,000,000, LEGION OF SUPER-HEROES 1,000,000, LEGIONNAIRES 1,000,000, LOBO 1,000,000, MARTIAN MANHUNTER 1,000,000, NIGHTWING 1,000,000, POWER OF SHAZAM 1,000,000, RESURRECTION MAN 1,000,000, ROBIN 1,000,000, STARMAN 1,000,000, SUPERBOY 1,000,000, SUPERGIRL 1,000,000, SUPERMAN 1,000,000, SUPERMAN: THE MAN OF STEEL 1,000,000, SUPERMAN: THE MAN OF TOMORROW 1,000,000, WONDER WOMAN 1,000,000, YOUNG JUSTICE 1,000,000, JLA IN CRISIS SECRET FILES, DC ONE MILLION 80-PAGE GIANT #1, BOOSTER GOLD 1,000,000, and SUPERMAN/BATMAN #79-80!",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1779515448"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781779515445"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 42,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=zc6VzgEACAAJ&dq=superman&hl=&cd=22&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=zc6VzgEACAAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/DC_One_Million_Omnibus_2022_Edition.html?hl=&id=zc6VzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=zc6VzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The entire DC ONE MILLION series is reprinted here, along with every crossover issue and tie-in. This massive Omnibus edition is a must-have for any collector."
        }
      },
      {
        "kind": "books#volume",
        "id": "5V8lEAAAQBAJ",
        "etag": "HmVW4iLkvdU",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/5V8lEAAAQBAJ",
        "volumeInfo": {
          "title": "Superman's Greatest Team-Ups",
          "authors": [
            "Mike W. Barr",
            "Cary Bates",
            "E. Nelson Bridwell",
            "Gary Cohn"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-04-06",
          "description": "The greatest Superman team-up tales from the pre-Crisis on Infinite Earths era of the late 1970s and 1980s are collected in hardcover for the first time! In these stories from the pages of DC Comics Presents, the Man of Tomorrow faces evil with the help of heroes including Wonder Woman, Aquaman, Mister Miracle, Batgirl, Black Canary, the Flash, and even Santa Claus and…Clark Kent? Collects DC Comics Presents #5, #9-10, #12, #14, #19, #28, #30, #35, #38-39, #45, #50, #58, #63, #67, #71, and #97.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781779504876"
            },
            {
              "type": "ISBN_10",
              "identifier": "177950487X"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 400,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.0.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "573ef5e408f71891_A",
            "imageBubbleVersion": "573ef5e408f71891_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=5V8lEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=5V8lEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=5V8lEAAAQBAJ&pg=PP1&dq=superman&hl=&cd=23&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=5V8lEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=5V8lEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 1251.13,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 1251.13,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=5V8lEAAAQBAJ&rdid=book-5V8lEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 1251130000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 1251130000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_s_Greatest_Team_Ups-sample-epub.acsm?id=5V8lEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_s_Greatest_Team_Ups-sample-pdf.acsm?id=5V8lEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=5V8lEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "In these stories from the pages of DC Comics Presents, the Man of Tomorrow faces evil with the help of heroes including Wonder Woman, Aquaman, Mister Miracle, Batgirl, Black Canary, the Flash, and even Santa Claus and…Clark Kent?"
        }
      },
      {
        "kind": "books#volume",
        "id": "d3yyzgEACAAJ",
        "etag": "fUSkUzW2SWY",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/d3yyzgEACAAJ",
        "volumeInfo": {
          "title": "Jesus And Superman's Journeys",
          "subtitle": "Discover The Savior For All Mankind: The Four Gospels",
          "authors": [
            "Livia Manago"
          ],
          "publisher": "Independently Published",
          "publishedDate": "2021-07-14",
          "description": "This book is a good read that raises several thought-provoking points, with a few points of humor and several of nostalgia thrown in. Superman and Jesus have many similarities: They both come from other worlds, raised by humans, sent out to discover themselves, and provide hope to the world. Is this because of who they are....or how their stories are told? Similar to Joseph (Hero of a Thousand Faces/Power of Myth) Campbell's work in Mythology, this book looks into Jesus and Superman's journeys being linked by a thread of storytelling that spans time and many other hero characters; including Batman, Spider-Man, and Luke Skywalker. If you've wondered why Jesus' story is told the way it is in the four gospels, perhaps looking at the story of Superman can shed some light.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9798537133056"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 58,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=d3yyzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=d3yyzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=d3yyzgEACAAJ&dq=superman&hl=&cd=24&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=d3yyzgEACAAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Jesus_And_Superman_s_Journeys.html?hl=&id=d3yyzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=d3yyzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book is a good read that raises several thought-provoking points, with a few points of humor and several of nostalgia thrown in."
        }
      },
      {
        "kind": "books#volume",
        "id": "vtciEAAAQBAJ",
        "etag": "7xDS7Q8WFpU",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/vtciEAAAQBAJ",
        "volumeInfo": {
          "title": "Action Comics (2016-) #1029",
          "authors": [
            "Phillip Kennedy Johnson",
            "Becky Cloonan",
            "Michael Conrad"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-03-23",
          "description": "“The Golden Age” reaches its conclusion in this issue that continues directly from Superman #29! Following an almost-deadly attack by an alien foe, the new Superman realizes that any threat could be the one! Neither Superboy nor Superman know what’s behind this latest attack. Two words: the Wall. Plus, in an all-new backup “Tale of Metropolis,” writers Becky Cloonan and Michael W. Conrad continue the Midnighter story they started in DC Future State. But is the DC Universe ready for Trojan Solutions?“The Golden Age” reaches its conclusion in this issue that continues directly from Superman #29! Following an almost-deadly attack by an alien foe, the new Superman realizes that any threat could be the one! Neither Superboy nor Superman know what’s behind this latest attack. Two words: the Wall. Plus, in an all-new backup “Tale of Metropolis,” writers Becky Cloonan and Michael W. Conrad continue the Midnighter story they started in DC Future State. But is the DC Universe ready for Trojan Solutions?",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "PKEY:T1655610295001"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 30,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.2.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "e67f98319c9a6799_A",
            "imageBubbleVersion": "e67f98319c9a6799_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=vtciEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=vtciEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=vtciEAAAQBAJ&printsec=frontcover&dq=superman&hl=&cd=25&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=vtciEAAAQBAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Action_Comics_2016_1029.html?hl=&id=vtciEAAAQBAJ",
          "seriesInfo": {
            "kind": "books#volume_series_info",
            "bookDisplayNumber": "1029",
            "volumeSeries": [
              {
                "seriesId": "dFXpFwAAABCcQM",
                "seriesBookType": "ISSUE",
                "orderNumber": 73
              }
            ]
          }
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Action_Comics_2016_1029-sample-epub.acsm?id=vtciEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Action_Comics_2016_1029-sample-pdf.acsm?id=vtciEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=vtciEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Two words: the Wall. Plus, in an all-new backup “Tale of Metropolis,” writers Becky Cloonan and Michael W. Conrad continue the Midnighter story they started in DC Future State."
        }
      },
      {
        "kind": "books#volume",
        "id": "Gv8gEAAAQBAJ",
        "etag": "ipTXhnoBhJE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/Gv8gEAAAQBAJ",
        "volumeInfo": {
          "title": "Superman Red & Blue (2021-) #1",
          "authors": [
            "John Ridley",
            "Brandon Easton",
            "Wes Craig"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-03-16",
          "description": "This new series presents fresh new visions of the Man of Steel in his two signature colors of red and blue! Around the world, everyone knows that when they see a red and blue streak in the sky, it’s not a bird...it’s not a plane...it’s Superman. To start things off, Academy Award-winning writer of DC Future State: The Next Batman John Ridley joins artist Clayton Henry (Batman/Superman) to tell a story of Clark Kent as he confronts a villain who still haunts him, in a story that shows what Superman can mean to a whole country. Then, Brandon Easton (DC Future State’s “Mister Miracle”) and Steve Lieber (Superman’s Pal Jimmy Olsen) take readers to the streets of Metropolis to show how one hero can mean so much to an individual in pain. Plus, writer/artist Wes Craig (Deadly Class) tells a tale of Superman’s early days and the man who inspired him to become the hero he is today! And Marguerite Bennett (DC Future State: Kara Zor-El, Superwoman) and artist Jill Thompson give us a tale of teenage Clark Kent, while Dan Watters and Dani, the team behind Coffin Bound, bring us an outlandish fable about what happens when all colors are stolen!",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "PKEY:T2118200015001"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 40,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "98b6a4cb71e7fccc_A",
            "imageBubbleVersion": "98b6a4cb71e7fccc_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=Gv8gEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=Gv8gEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=Gv8gEAAAQBAJ&pg=PP1&dq=superman&hl=&cd=26&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=Gv8gEAAAQBAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Superman_Red_Blue_2021_1.html?hl=&id=Gv8gEAAAQBAJ",
          "seriesInfo": {
            "kind": "books#volume_series_info",
            "bookDisplayNumber": "1",
            "volumeSeries": [
              {
                "seriesId": "V9EsGwAAABB6yM",
                "seriesBookType": "ISSUE",
                "orderNumber": 1
              }
            ]
          }
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_Red_Blue_2021_1-sample-epub.acsm?id=Gv8gEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_Red_Blue_2021_1-sample-pdf.acsm?id=Gv8gEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=Gv8gEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This new series presents fresh new visions of the Man of Steel in his two signature colors of red and blue!"
        }
      },
      {
        "kind": "books#volume",
        "id": "Jv8gEAAAQBAJ",
        "etag": "ulWHux5iatw",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/Jv8gEAAAQBAJ",
        "volumeInfo": {
          "title": "Justice League (2018-) #59",
          "authors": [
            "Brian Michael Bendis",
            "Ram V."
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-03-16",
          "description": "Writer Brian Michael Bendis reunites with artist David Marquez (Miles Morales, Iron Man, Batman/Superman) for a new, star-studded Justice League featuring Superman, Batman, the Flash, Hawkgirl, Aquaman, Hippolyta, new DC powerhouse Naomi, and...is that Black Adam?! Superman is leading the charge to reinvent the Justice League-and at the same time, a new, cosmic-powered threat arrives from Naomi’s homeworld to rule the Earth! And in the backup story, dark days lie ahead for the new Justice League Dark. Zatanna and John Constantine take a road trip, only to discover horror around the bend as a friend-and sometime foe-is reborn in fire! A legend is destroyed, and another takes a terrible turn, as Merlin reveals the beginning of a new, blood-drenched plot for all humankind. So begins writer Ram V’s new journey into the abyss with the Justice League Dark and artist Xermanico!",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "PKEY:T1878400595001"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 30,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "85ee7c1d1030ebbc_A",
            "imageBubbleVersion": "85ee7c1d1030ebbc_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=Jv8gEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=Jv8gEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=Jv8gEAAAQBAJ&printsec=frontcover&dq=superman&hl=&cd=27&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=Jv8gEAAAQBAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Justice_League_2018_59.html?hl=&id=Jv8gEAAAQBAJ",
          "seriesInfo": {
            "kind": "books#volume_series_info",
            "bookDisplayNumber": "59",
            "volumeSeries": [
              {
                "seriesId": "pmEXGwAAABCweM",
                "seriesBookType": "ISSUE",
                "orderNumber": 59
              }
            ]
          }
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Justice_League_2018_59-sample-epub.acsm?id=Jv8gEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Justice_League_2018_59-sample-pdf.acsm?id=Jv8gEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=Jv8gEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "And in the backup story, dark days lie ahead for the new Justice League Dark. Zatanna and John Constantine take a road trip, only to discover horror around the bend as a friend-and sometime foe-is reborn in fire!"
        }
      },
      {
        "kind": "books#volume",
        "id": "JdAfEAAAQBAJ",
        "etag": "LKwbA/0CK9Y",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/JdAfEAAAQBAJ",
        "volumeInfo": {
          "title": "Superman: The Last Son The Deluxe Edition",
          "authors": [
            "Geoff Johns",
            "Richard Donner"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-03-09",
          "description": "Geoff Johns’s two most acclaimed stories of his now-classic Action Comics run, previously collected separately as Superman: Lost Son and Superman: Brainiac, are now in a brand-new hardcover! In a story co-written by Superman film director Richard Donner, a rocket lands in Metropolis containing a boy Superman thinks is from Krypton. Will Superman be able to protect him against Lex Luthor and his new Superman Revenge Squad, as well as the Phantom Zone criminals General Zod, Ursa, and Non? This all sets the stage for Superman’s showdown with one of his greatest foes: Brainiac! Collects Action Comics #844-846, #851, #866-870, and Action Comics Annual #11.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781779512864"
            },
            {
              "type": "ISBN_10",
              "identifier": "1779512864"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 285,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.2.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "a695b82ac01546dc",
            "imageBubbleVersion": "a695b82ac01546dc"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=JdAfEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=JdAfEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=JdAfEAAAQBAJ&pg=PA1&dq=superman&hl=&cd=28&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=JdAfEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=JdAfEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 1251.13,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 1251.13,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=JdAfEAAAQBAJ&rdid=book-JdAfEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 1251130000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 1251130000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_The_Last_Son_The_Deluxe_Edition-sample-epub.acsm?id=JdAfEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_The_Last_Son_The_Deluxe_Edition-sample-pdf.acsm?id=JdAfEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=JdAfEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Geoff Johns’s two most acclaimed stories of his now-classic Action Comics run, previously collected separately as Superman: Lost Son and Superman: Brainiac, are now in a brand-new hardcover!"
        }
      },
      {
        "kind": "books#volume",
        "id": "yoAUEAAAQBAJ",
        "etag": "QpR8jLH1G0Q",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/yoAUEAAAQBAJ",
        "volumeInfo": {
          "title": "Superman: Kryptonite Nevermore",
          "authors": [
            "Dennis O'Neil"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-01-26",
          "description": "Everyone knows Superman’s major weakness: Kryptonite. But what happens when that’s taken off the board, as a scientific experiment turns all the kryptonite on Earth to iron? Originally published in 1971, this story turned the Man of Steel’s status quo on its head. When all Kryptonite has been destroyed, the Man of Steel is anything but invulnerable as his powers slowly begin to fade and a doppelgänger Superman arrives on the scene with strange powers of its own-and any contact between the two might result in the destruction of the planet! Collects Superman #233-238 and #240-242, all newly restored and recolored for this special edition.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781779512147"
            },
            {
              "type": "ISBN_10",
              "identifier": "1779512147"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 172,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "abc244f424c71a29_A",
            "imageBubbleVersion": "abc244f424c71a29_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=yoAUEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=yoAUEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=yoAUEAAAQBAJ&pg=PP1&dq=superman&hl=&cd=29&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=yoAUEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=yoAUEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 803.98,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 803.98,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=yoAUEAAAQBAJ&rdid=book-yoAUEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 803980000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 803980000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_Kryptonite_Nevermore-sample-epub.acsm?id=yoAUEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_Kryptonite_Nevermore-sample-pdf.acsm?id=yoAUEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=yoAUEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "But what happens when that’s taken off the board, as a scientific experiment turns all the kryptonite on Earth to iron? Originally published in 1971, this story turned the Man of Steel’s status quo on its head."
        }
      },
      {
        "kind": "books#volume",
        "id": "0IAUEAAAQBAJ",
        "etag": "ba5LhH5hdM4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/0IAUEAAAQBAJ",
        "volumeInfo": {
          "title": "Legends of the DC Universe: Doug Mahnke",
          "authors": [
            "Grant Morrison",
            "Garth Ennis"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-01-26",
          "description": "These tales spotlight Doug Mahnke, one of DC’s most dynamic artists, including stories starring Batman, Superman, Green Lantern, and more. Collects stories and art from Action Comics #775 and #1000; Batman #645; Batman: The Man Who Laughs #1; Batman and Robin Annual #2; Black Adam: The Dark Age #1; Detective Comics #1000; Final Crisis: Requiem #1; Green Lantern (2011) #0 and #50; Green Lantern (2016) #50; Hitman/Lobo: That Stupid Bastich #1; JLA #61 and #65; Justice League #25; Justice League of America #25; Justice League: Elite #1; The Multiversity: Ultra Comics #1; Seven Soldiers: Frankenstein #1; Superman #8-9; and Superman: The Man of Steel #87.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781779512130"
            },
            {
              "type": "ISBN_10",
              "identifier": "1779512139"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 408,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "5478dec7c488d8fd_A",
            "imageBubbleVersion": "5478dec7c488d8fd_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=0IAUEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=0IAUEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=0IAUEAAAQBAJ&printsec=frontcover&dq=superman&hl=&cd=30&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=0IAUEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=0IAUEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 1251.13,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 1251.13,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=0IAUEAAAQBAJ&rdid=book-0IAUEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 1251130000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 1251130000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Legends_of_the_DC_Universe_Doug_Mahnke-sample-epub.acsm?id=0IAUEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Legends_of_the_DC_Universe_Doug_Mahnke-sample-pdf.acsm?id=0IAUEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=0IAUEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "These tales spotlight Doug Mahnke, one of DC’s most dynamic artists, including stories starring Batman, Superman, Green Lantern, and more."
        }
      },
      {
        "kind": "books#volume",
        "id": "u0UQEAAAQBAJ",
        "etag": "UHfVVP3+l/I",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/u0UQEAAAQBAJ",
        "volumeInfo": {
          "title": "Future State: Superman of Metropolis (2021-2021) #1",
          "authors": [
            "Sean Lewis",
            "Brandon Easton"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2021-01-05",
          "description": "Before leaving for parts unknown, Clark Kent entrusted Earth’s safety to his son. Now, Jonathan Kent is Superman! Top priority for this new Superman: to protect Metropolis. When a new version of Brainiac attacks, Jon takes drastic measures-which result in the Bottle City of Metropolis! But watch out, Jon, because Supergirl is on her way, and she is not happy with your decision. Meanwhile, in the new bottle city, a new hero has risen. Jake Jordan, the former Manhattan Guardian, came to the City of Tomorrow to start over. But he’s not the only one who wants a new beginning. An anarchist calling herself Honest Mary sees this time of trouble as an opportunity for rebirth-and she’ll tear down the entire city to prove her point. Does Jake have what it takes to save his new home from disasters both inside and out of the bottle? Superman’s former pal Jimmy Olsen is going to make sure he does! Finally, the current Mister Miracle, Shilo Norman, is also in the bottle, and he’s looking for a way out! He’d better be careful, though, or he may end up someplace unexpected. It’s a story that continues in Superman: Worlds of War #1!",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "PKEY:T2116400015001"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 44,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.2.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "75c6e5c69086c9bf_A",
            "imageBubbleVersion": "75c6e5c69086c9bf_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=u0UQEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=u0UQEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=u0UQEAAAQBAJ&pg=PP1&dq=superman&hl=&cd=31&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=u0UQEAAAQBAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Future_State_Superman_of_Metropolis_2021.html?hl=&id=u0UQEAAAQBAJ",
          "seriesInfo": {
            "kind": "books#volume_series_info",
            "bookDisplayNumber": "1",
            "volumeSeries": [
              {
                "seriesId": "lmQsGwAAABC7fM",
                "seriesBookType": "ISSUE",
                "orderNumber": 1
              }
            ]
          }
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Future_State_Superman_of_Metropolis_2021-sample-epub.acsm?id=u0UQEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Future_State_Superman_of_Metropolis_2021-sample-pdf.acsm?id=u0UQEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=u0UQEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Before leaving for parts unknown, Clark Kent entrusted Earth’s safety to his son."
        }
      },
      {
        "kind": "books#volume",
        "id": "5XoEEAAAQBAJ",
        "etag": "3xgG8zT7yqI",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/5XoEEAAAQBAJ",
        "volumeInfo": {
          "title": "Empire of the Superheroes",
          "subtitle": "America’s Comic Book Creators and the Making of a Billion-Dollar Industry",
          "authors": [
            "Mark Cotta Vaz"
          ],
          "publisher": "University of Texas Press",
          "publishedDate": "2021-01-05",
          "description": "Superman may be faster than a speeding bullet, but even he can't outrun copyright law. Since the dawn of the pulp hero in the 1930s, publishers and authors have fought over the privilege of making money off of comics, and the authors and artists usually have lost. Jerry Siegel and Joe Shuster, the creators of Superman, got all of $130 for the rights to the hero. In Empire of the Superheroes, Mark Cotta Vaz argues that licensing and litigation do as much as any ink-stained creator to shape the mythology of comic characters. Vaz reveals just how precarious life was for the legends of the industry. Siegel and Shuster—and their heirs—spent seventy years battling lawyers to regain rights to Superman. Jack Kirby and Joe Simon were cheated out of their interest in Captain America, and Kirby's children brought a case against Marvel to the doorstep of the Supreme Court. To make matters worse, the infant comics medium was nearly strangled in its crib by censorship and moral condemnation. For the writers and illustrators now celebrated as visionaries, the \"golden age\" of comics felt more like hard times. The fantastical characters that now earn Hollywood billions have all-too-human roots. Empire of the Superheroes digs them up, detailing the creative martyrdom at the heart of a pop-culture powerhouse.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781477321829"
            },
            {
              "type": "ISBN_10",
              "identifier": "1477321829"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 488,
          "printType": "BOOK",
          "categories": [
            "Social Science"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=5XoEEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=5XoEEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=5XoEEAAAQBAJ&pg=PT528&dq=superman&hl=&cd=32&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=5XoEEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=5XoEEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 3125.53,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 3125.53,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=5XoEEAAAQBAJ&rdid=book-5XoEEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 3125530000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 3125530000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true
          },
          "pdf": {
            "isAvailable": true
          },
          "webReaderLink": "http://play.google.com/books/reader?id=5XoEEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "“\u003cb\u003eSuperman\u003c/b\u003e as Cyberman,” New York Times, Tuesday, January 14, 1997. 3. “\u003cb\u003eSuperman\u003c/b\u003e #75 ... The Death of a Hero,” DC: Direct Currents #58 (January 1993). 4. Daniels, DC Comics, 228; “\u003cb\u003eSuperman&#39;s\u003c/b\u003e Death Is a Sign of the Times: Gallup Poll&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "JtpCzgEACAAJ",
        "etag": "0CViA5RfNnY",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/JtpCzgEACAAJ",
        "volumeInfo": {
          "title": "Superman: the One Who Fell",
          "authors": [
            "Phillip Kennedy Johnson"
          ],
          "publishedDate": "2021",
          "description": "\"In 'The Golden Age, ' Jonathan Kent is back from the 31st century and fighting cosmic threats alongside his legendary father, Clark Kent. But when an interdimensional breach opens near Earth, Jon recognizes the creatures that emerge: the cosmic leviathans that the Legion of Super-Heroes credits with the death of Superman. As Superboy desperately tries to save Superman's life from the leviathans of the breach, Superman discovers the breach's shocking origins\"--",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1779512643"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781779512642"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 136,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "comicsContent": true,
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=JtpCzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=JtpCzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=JtpCzgEACAAJ&dq=superman&hl=&cd=33&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=JtpCzgEACAAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Superman_the_One_Who_Fell.html?hl=&id=JtpCzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=JtpCzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "&quot;In &#39;The Golden Age, &#39; Jonathan Kent is back from the 31st century and fighting cosmic threats alongside his legendary father, Clark Kent."
        }
      },
      {
        "kind": "books#volume",
        "id": "F94EEAAAQBAJ",
        "etag": "mVoEOELYozc",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/F94EEAAAQBAJ",
        "volumeInfo": {
          "title": "Supersex",
          "subtitle": "Sexuality, Fantasy, and the Superhero",
          "authors": [
            "Anna Peppard"
          ],
          "publisher": "University of Texas Press",
          "publishedDate": "2020-12-08",
          "description": "From Superman, created in 1938, to the transmedia DC and Marvel universes of today, superheroes have always been sexy. And their sexiness has always been controversial, inspiring censorship and moral panic. Yet aside from jokes and innuendo, accusations of moral depravity, and sporadic academic discourse, the topic of superhero sexuality is like superhero sexuality itself—seemingly obvious yet conspicuously absent. Supersex: Sexuality, Fantasy, and the Superhero is the first scholarly book specifically devoted to unpacking the superhero genre’s complicated relationship with sexuality. Exploring sexual themes and imagery within mainstream comic books, television shows, and films as well as independent and explicitly pornographic productions catering to various orientations and kinks, Supersex offers a fresh—and lascivious—perspective on the superhero genre’s historical and contemporary popularity. Across fourteen essays touching on Superman, Batman, the X-Men, and many others, Anna F. Peppard and her contributors present superhero sexuality as both dangerously exciting and excitingly dangerous, encapsulating the superhero genre’s worst impulses and its most productively rebellious ones. Supersex argues that sex is at the heart of our fascination with superheroes, even—and sometimes especially—when the capes and tights stay on.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781477321607"
            },
            {
              "type": "ISBN_10",
              "identifier": "1477321608"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 400,
          "printType": "BOOK",
          "categories": [
            "Social Science"
          ],
          "maturityRating": "MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=F94EEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=F94EEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=F94EEAAAQBAJ&pg=PP1&dq=superman&hl=&cd=34&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=F94EEAAAQBAJ&dq=superman&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Supersex.html?hl=&id=F94EEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=F94EEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Supersex: Sexuality, Fantasy, and the Superhero is the first scholarly book specifically devoted to unpacking the superhero genre’s complicated relationship with sexuality."
        }
      },
      {
        "kind": "books#volume",
        "id": "TK4CEAAAQBAJ",
        "etag": "hBIlN4KAtuM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/TK4CEAAAQBAJ",
        "volumeInfo": {
          "title": "Superman's Pal Jimmy Olsen: Who Killed Jimmy Olsen?",
          "authors": [
            "Matt Fraction"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2020-10-27",
          "description": "Jimmy Olsen must die! Wait, we’re getting ahead of ourselves. Jimmy Olsen lives! Superman’s best friend and Daily Planet photographer Jimmy Olsen tours the bizarre underbelly of the DC Universe in this new series featuring death, destruction, giant turtles, and more, combining Silver Age energy with a distinctly modern sensibility! It’s a centuries-spanning whirlwind of weird that starts in Metropolis and ends in Gotham City. Award-winning writer Matt Fraction (Sex Criminals, Hawkeye) makes his DC debut with Superman’s Pal Jimmy Olsen, an irreverent, hijinks-filled journey across the weirdest and wildest corners of the DCU, illustrated by Eisner Award-winning artist Steve Lieber. Collects Superman’s Pal Jimmy Olsen #1-12.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781779511027"
            },
            {
              "type": "ISBN_10",
              "identifier": "1779511027"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 292,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "averageRating": 3,
          "ratingsCount": 2,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.2.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "dfb275759aad9ade_A",
            "imageBubbleVersion": "dfb275759aad9ade_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=TK4CEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=TK4CEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=TK4CEAAAQBAJ&pg=PA1&dq=superman&hl=&cd=35&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=TK4CEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=TK4CEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 803.98,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 803.98,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=TK4CEAAAQBAJ&rdid=book-TK4CEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 803980000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 803980000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_s_Pal_Jimmy_Olsen_Who_Killed_Ji-sample-epub.acsm?id=TK4CEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_s_Pal_Jimmy_Olsen_Who_Killed_Ji-sample-pdf.acsm?id=TK4CEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=TK4CEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Superman’s best friend and Daily Planet photographer Jimmy Olsen tours the bizarre underbelly of the DC Universe in this new series featuring death, destruction, giant turtles, and more, combining Silver Age energy with a distinctly ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "gRnBDwAAQBAJ",
        "etag": "Dww0RvYEVOw",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/gRnBDwAAQBAJ",
        "volumeInfo": {
          "title": "Superman's Not Coming",
          "subtitle": "Our National Water Crisis and What We the People Can Do About It",
          "authors": [
            "Erin Brockovich"
          ],
          "publisher": "Vintage",
          "publishedDate": "2020-08-25",
          "description": "From the environmental activist, consumer advocate, and renowned crusader—a stirring call to action that gives us the tools we need to take action ourselves, to make our voices heard, to ensure our water is safe, and to finally bring about change. Clean water is as basic to life on planet Earth as hydrogen or oxygen. In her long-awaited book—her first to reckon with the condition of water on our planet—Erin Brockovich shows us what’s at stake. She writes powerfully of the fraudulent science disguising our national water crisis: Cancer clusters are not being reported. People in Detroit and the state of New Jersey don’t have clean water. The drinking water for more than six million Americans contains unsafe levels of industrial chemicals linked to cancer and other health issues. The saga of PG&E continues to this day. Yet communities and people around the country are fighting to make an impact, and Brockovich tells us their stories. In Poughkeepsie, New York, a water operator responded to his customers’ concerns and changed his system to create some of the safest water in the country. Local moms in Hannibal, Missouri, became the first citizens in the nation to file an ordinance prohibiting the use of ammonia in their public drinking water. Like them, we can each protect our right to clean water by fighting for better enforcement of laws, new legislation, and stronger regulations.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781524746971"
            },
            {
              "type": "ISBN_10",
              "identifier": "1524746975"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 384,
          "printType": "BOOK",
          "categories": [
            "Political Science"
          ],
          "averageRating": 5,
          "ratingsCount": 1,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.5.3.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=gRnBDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=gRnBDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=gRnBDwAAQBAJ&pg=PP1&dq=superman&hl=&cd=36&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=gRnBDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=gRnBDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 632.04,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 316.02,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=gRnBDwAAQBAJ&rdid=book-gRnBDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 632040000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 316020000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_s_Not_Coming-sample-epub.acsm?id=gRnBDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=gRnBDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Clean water is as basic to life on planet Earth as hydrogen or oxygen. In her long-awaited book—her first to reckon with the condition of water on our planet—Erin Brockovich shows us what’s at stake."
        }
      },
      {
        "kind": "books#volume",
        "id": "3VH4DwAAQBAJ",
        "etag": "7/Cm0Rv4SZ4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/3VH4DwAAQBAJ",
        "volumeInfo": {
          "title": "Superman: The Man of Steel Vol. 1",
          "authors": [
            "John Byrne",
            "Marv Wolfman"
          ],
          "publisher": "DC Comics",
          "publishedDate": "2020-08-25",
          "description": "Following Crisis on Infinite Earths, comic book superstar John Byrne reimagined Superman for a new era in bold tales presented in this new collection! Starting with the six-issue Man of Steel miniseries, Byrne fundamentally changed Superman’s origins and propelled him into the present, including iconic encounters with Lex Luthor, Metallo, and Darkseid! This title collects The Man of Steel #1-6, Superman #1-4, Adventures of Superman #424-428, and Action Comics #584-587.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781779504920"
            },
            {
              "type": "ISBN_10",
              "identifier": "1779504926"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 480,
          "printType": "BOOK",
          "categories": [
            "Comics & Graphic Novels"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": true,
            "containsImageBubbles": true,
            "epubBubbleVersion": "b124da55d38b1b38_A",
            "imageBubbleVersion": "b124da55d38b1b38_A"
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=3VH4DwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=3VH4DwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=3VH4DwAAQBAJ&pg=PP1&dq=superman&hl=&cd=37&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=3VH4DwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=3VH4DwAAQBAJ",
          "seriesInfo": {
            "kind": "books#volume_series_info",
            "bookDisplayNumber": "1",
            "volumeSeries": [
              {
                "seriesId": "P4jXFwAAABDpnM",
                "seriesBookType": "COLLECTED_EDITION",
                "orderNumber": 2,
                "issue": [
                  {
                    "issueDisplayNumber": "1"
                  },
                  {
                    "issueDisplayNumber": "2"
                  },
                  {
                    "issueDisplayNumber": "3"
                  },
                  {
                    "issueDisplayNumber": "4"
                  },
                  {
                    "issueDisplayNumber": "5"
                  },
                  {
                    "issueDisplayNumber": "6"
                  },
                  {
                    "issueDisplayNumber": "424"
                  },
                  {
                    "issueDisplayNumber": "425"
                  },
                  {
                    "issueDisplayNumber": "426"
                  },
                  {
                    "issueDisplayNumber": "427"
                  },
                  {
                    "issueDisplayNumber": "428"
                  },
                  {
                    "issueDisplayNumber": "584"
                  },
                  {
                    "issueDisplayNumber": "585"
                  },
                  {
                    "issueDisplayNumber": "586"
                  },
                  {
                    "issueDisplayNumber": "587"
                  }
                ]
              }
            ]
          }
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 1251.13,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 1251.13,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=3VH4DwAAQBAJ&rdid=book-3VH4DwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 1251130000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 1251130000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_The_Man_of_Steel_Vol_1-sample-epub.acsm?id=3VH4DwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_The_Man_of_Steel_Vol_1-sample-pdf.acsm?id=3VH4DwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=3VH4DwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Following Crisis on Infinite Earths, comic book superstar John Byrne reimagined Superman for a new era in bold tales presented in this new collection!"
        }
      },
      {
        "kind": "books#volume",
        "id": "gRnBDwAAQBAJ",
        "etag": "EgicOE0d+6o",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/gRnBDwAAQBAJ",
        "volumeInfo": {
          "title": "Superman's Not Coming",
          "subtitle": "Our National Water Crisis and What We the People Can Do About It",
          "authors": [
            "Erin Brockovich"
          ],
          "publisher": "Vintage",
          "publishedDate": "2020-08-25",
          "description": "From the environmental activist, consumer advocate, and renowned crusader—a stirring call to action that gives us the tools we need to take action ourselves, to make our voices heard, to ensure our water is safe, and to finally bring about change. Clean water is as basic to life on planet Earth as hydrogen or oxygen. In her long-awaited book—her first to reckon with the condition of water on our planet—Erin Brockovich shows us what’s at stake. She writes powerfully of the fraudulent science disguising our national water crisis: Cancer clusters are not being reported. People in Detroit and the state of New Jersey don’t have clean water. The drinking water for more than six million Americans contains unsafe levels of industrial chemicals linked to cancer and other health issues. The saga of PG&E continues to this day. Yet communities and people around the country are fighting to make an impact, and Brockovich tells us their stories. In Poughkeepsie, New York, a water operator responded to his customers’ concerns and changed his system to create some of the safest water in the country. Local moms in Hannibal, Missouri, became the first citizens in the nation to file an ordinance prohibiting the use of ammonia in their public drinking water. Like them, we can each protect our right to clean water by fighting for better enforcement of laws, new legislation, and stronger regulations.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781524746971"
            },
            {
              "type": "ISBN_10",
              "identifier": "1524746975"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 384,
          "printType": "BOOK",
          "categories": [
            "Political Science"
          ],
          "averageRating": 5,
          "ratingsCount": 1,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.5.3.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=gRnBDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=gRnBDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=gRnBDwAAQBAJ&pg=PA138&dq=superman&hl=&cd=38&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=gRnBDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=gRnBDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 632.04,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 316.02,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=gRnBDwAAQBAJ&rdid=book-gRnBDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 632040000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 316020000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_s_Not_Coming-sample-epub.acsm?id=gRnBDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=gRnBDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "... with an increase in children&#39;s blood lead levels , suggesting that the switch could have created an increase in lead exposure . Even the U.S. EPA considered changing regulations related to chloramines 138 \u003cb\u003eSUPERMAN&#39;S\u003c/b\u003e NOT COMING."
        }
      },
      {
        "kind": "books#volume",
        "id": "gRnBDwAAQBAJ",
        "etag": "l8w7l0Ta3sA",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/gRnBDwAAQBAJ",
        "volumeInfo": {
          "title": "Superman's Not Coming",
          "subtitle": "Our National Water Crisis and What We the People Can Do About It",
          "authors": [
            "Erin Brockovich"
          ],
          "publisher": "Vintage",
          "publishedDate": "2020-08-25",
          "description": "From the environmental activist, consumer advocate, and renowned crusader—a stirring call to action that gives us the tools we need to take action ourselves, to make our voices heard, to ensure our water is safe, and to finally bring about change. Clean water is as basic to life on planet Earth as hydrogen or oxygen. In her long-awaited book—her first to reckon with the condition of water on our planet—Erin Brockovich shows us what’s at stake. She writes powerfully of the fraudulent science disguising our national water crisis: Cancer clusters are not being reported. People in Detroit and the state of New Jersey don’t have clean water. The drinking water for more than six million Americans contains unsafe levels of industrial chemicals linked to cancer and other health issues. The saga of PG&E continues to this day. Yet communities and people around the country are fighting to make an impact, and Brockovich tells us their stories. In Poughkeepsie, New York, a water operator responded to his customers’ concerns and changed his system to create some of the safest water in the country. Local moms in Hannibal, Missouri, became the first citizens in the nation to file an ordinance prohibiting the use of ammonia in their public drinking water. Like them, we can each protect our right to clean water by fighting for better enforcement of laws, new legislation, and stronger regulations.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781524746971"
            },
            {
              "type": "ISBN_10",
              "identifier": "1524746975"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 384,
          "printType": "BOOK",
          "categories": [
            "Political Science"
          ],
          "averageRating": 5,
          "ratingsCount": 1,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.5.3.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=gRnBDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=gRnBDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=gRnBDwAAQBAJ&pg=PA158&dq=superman&hl=&cd=39&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=gRnBDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=gRnBDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 632.04,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 316.02,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=gRnBDwAAQBAJ&rdid=book-gRnBDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 632040000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 316020000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_s_Not_Coming-sample-epub.acsm?id=gRnBDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=gRnBDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "... them see another point of view instead of just the one from the utility company . “ Listen , the ammonia is going to be removed , ” Melissa told me . Bob Bowcock meeting the moms who became water warriors in 158 \u003cb\u003eSUPERMAN&#39;S\u003c/b\u003e NOT COMING."
        }
      },
      {
        "kind": "books#volume",
        "id": "gRnBDwAAQBAJ",
        "etag": "G2NVbXSVRHw",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/gRnBDwAAQBAJ",
        "volumeInfo": {
          "title": "Superman's Not Coming",
          "subtitle": "Our National Water Crisis and What We the People Can Do About It",
          "authors": [
            "Erin Brockovich"
          ],
          "publisher": "Vintage",
          "publishedDate": "2020-08-25",
          "description": "From the environmental activist, consumer advocate, and renowned crusader—a stirring call to action that gives us the tools we need to take action ourselves, to make our voices heard, to ensure our water is safe, and to finally bring about change. Clean water is as basic to life on planet Earth as hydrogen or oxygen. In her long-awaited book—her first to reckon with the condition of water on our planet—Erin Brockovich shows us what’s at stake. She writes powerfully of the fraudulent science disguising our national water crisis: Cancer clusters are not being reported. People in Detroit and the state of New Jersey don’t have clean water. The drinking water for more than six million Americans contains unsafe levels of industrial chemicals linked to cancer and other health issues. The saga of PG&E continues to this day. Yet communities and people around the country are fighting to make an impact, and Brockovich tells us their stories. In Poughkeepsie, New York, a water operator responded to his customers’ concerns and changed his system to create some of the safest water in the country. Local moms in Hannibal, Missouri, became the first citizens in the nation to file an ordinance prohibiting the use of ammonia in their public drinking water. Like them, we can each protect our right to clean water by fighting for better enforcement of laws, new legislation, and stronger regulations.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781524746971"
            },
            {
              "type": "ISBN_10",
              "identifier": "1524746975"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 384,
          "printType": "BOOK",
          "categories": [
            "Political Science"
          ],
          "averageRating": 5,
          "ratingsCount": 1,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.5.3.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=gRnBDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=gRnBDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=gRnBDwAAQBAJ&pg=PA54&dq=superman&hl=&cd=40&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=gRnBDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=gRnBDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 632.04,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 316.02,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=gRnBDwAAQBAJ&rdid=book-gRnBDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 632040000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 316020000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Superman_s_Not_Coming-sample-epub.acsm?id=gRnBDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=gRnBDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "“ If they don&#39;t act on a bill for the betterment of this country and our children , nothing happens . I think it comes. 54 \u003cb\u003eSUPERMAN&#39;S\u003c/b\u003e NOT COMING."
        }
      },{
        "kind": "books#volume",
        "id": "NbJYEAAAQBAJ",
        "etag": "pRRsO8ahkLY",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/NbJYEAAAQBAJ",
        "volumeInfo": {
          "title": "Discrete Contact Mechanics with Applications in Tribology",
          "authors": [
            "Irina Goryacheva",
            "Yulia Makhovskaya"
          ],
          "publisher": "Elsevier",
          "publishedDate": "2022-05-03",
          "description": "Discrete Contact Mechanics with Applications in Tribology presents new solutions to contact problems for elastic and viscoelastic bodies in normal, sliding, and rolling contact, taking into account effects such as surface microgeometry, adhesion, fluid films, and viscous hysteresis in bulk material or surface layers. These solutions are applied to problems in tribology for modeling contact and friction of bodies with surface microgeometry (rough or textured). The book provides exact mathematical formulations for cases of discrete contact based on classical approaches of contact mechanics, allowing readers to study the influence of different parameters of surface microgeometry on contact characteristics and friction force. The book will help solve problems in modeling contact and friction interaction in cases of discrete character of contact interaction, mutual influence of individual contact spots in contact interaction of elastic and viscoelastic solids, calculating sliding and rolling friction forces as a result of adhesive and viscoelastic mechanisms of dissipation, and more. Provides a raft of solutions to contact problems for elastic and viscoelastic materials in normal, sliding, and rolling contact Provides solutions and formulations that consider surface microgeometry, adhesion, fluid films, viscous hysteresis in bulk material or surface layers, and other common material effects Features applied methods based on classical contact mechanics approaches, allowing for analytic and half-analytic treatment of problems",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780128218051"
            },
            {
              "type": "ISBN_10",
              "identifier": "0128218053"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 220,
          "printType": "BOOK",
          "categories": [
            "Technology & Engineering"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.3.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=NbJYEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=NbJYEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=NbJYEAAAQBAJ&printsec=frontcover&dq=friction&hl=&cd=1&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=NbJYEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=NbJYEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 14380.66,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 14380.66,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=NbJYEAAAQBAJ&rdid=book-NbJYEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 14380660000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 14380660000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Discrete_Contact_Mechanics_with_Applicat-sample-epub.acsm?id=NbJYEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Discrete_Contact_Mechanics_with_Applicat-sample-pdf.acsm?id=NbJYEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=NbJYEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The book provides exact mathematical formulations for cases of discrete contact based on classical approaches of contact mechanics, allowing readers to study the influence of different parameters of surface microgeometry on contact ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "DVUwEAAAQBAJ",
        "etag": "FS+EGQmRXIk",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/DVUwEAAAQBAJ",
        "volumeInfo": {
          "title": "The Economics of Sovereign Debt and Default",
          "authors": [
            "Mark Aguiar",
            "Manuel Amador"
          ],
          "publisher": "Princeton University Press",
          "publishedDate": "2021-12-21",
          "description": "An integrated approach to the economics of sovereign default Fiscal crises and sovereign default repeatedly threaten the stability and growth of economies around the world. Mark Aguiar and Manuel Amador provide a unified and tractable theoretical framework that elucidates the key economics behind sovereign debt markets, shedding light on the frictions and inefficiencies that prevent the smooth functioning of these markets, and proposing sensible approaches to sovereign debt management. The Economics of Sovereign Debt and Default looks at the core friction unique to sovereign debt—the lack of strong legal enforcement—and goes on to examine additional frictions such as deadweight costs of default, vulnerability to runs, the incentive to “dilute” existing creditors, and sovereign debt’s distortion of investment and growth. The book uses the tractable framework to isolate how each additional friction affects the equilibrium outcome, and illustrates its counterpart using state-of-the-art computational modeling. The novel approach presented here contrasts the outcome of a constrained efficient allocation—one chosen to maximize the joint surplus of creditors and government—with the competitive equilibrium outcome. This allows for a clear analysis of the extent to which equilibrium prices efficiently guide the government’s debt and default decisions, and of what drives divergences with the efficient outcome. Providing an integrated approach to sovereign debt and default, this incisive and authoritative book is an ideal resource for researchers and graduate students interested in this important topic.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780691189246"
            },
            {
              "type": "ISBN_10",
              "identifier": "0691189242"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 200,
          "printType": "BOOK",
          "categories": [
            "Business & Economics"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=DVUwEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=DVUwEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=DVUwEAAAQBAJ&pg=PP1&dq=friction&hl=&cd=2&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=DVUwEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=DVUwEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 3451.5,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 3451.5,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=DVUwEAAAQBAJ&rdid=book-DVUwEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 3451500000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 3451500000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/The_Economics_of_Sovereign_Debt_and_Defa-sample-pdf.acsm?id=DVUwEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=DVUwEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The book uses the tractable framework to isolate how each additional friction affects the equilibrium outcome, and illustrates its counterpart using state-of-the-art computational modeling."
        }
      },
      {
        "kind": "books#volume",
        "id": "rHC1zgEACAAJ",
        "etag": "M3QribkEaXE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/rHC1zgEACAAJ",
        "volumeInfo": {
          "title": "Advances in Engine Tribology",
          "authors": [
            "Vikram Kumar",
            "Avinash Kumar Agarwal",
            "Ashutosh Jena",
            "Ram Krishna Upadhyay"
          ],
          "publisher": "Springer",
          "publishedDate": "2021-12-10",
          "description": "This book is focuses on novel materials for advanced engine design. It includes the study of friction, wear, lubrication, suitable lubricant additives, and durability of different engine components of alcohol/biodiesel fueled engines. The contents highlight different lubrication systems to overcome friction and wear problems of automotive transportation systems. It also discusses different materials for future applications, wear of wheels and axels of locomotives, friction-induced noise and vibration and tribological behavior of texture surfaces in the automotive transport sector. This book will be of interest to those in academia and industry involved in alternative fuels application in IC engines, friction and wear study of various engine components, lubrication approaches and different additives of lubricants, and novel materials for advanced engine design.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "9811683360"
            },
            {
              "type": "ISBN_13",
              "identifier": "9789811683367"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 256,
          "printType": "BOOK",
          "categories": [
            "Technology & Engineering"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=rHC1zgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=rHC1zgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=rHC1zgEACAAJ&dq=friction&hl=&cd=3&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=rHC1zgEACAAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Advances_in_Engine_Tribology.html?hl=&id=rHC1zgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=rHC1zgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book is focuses on novel materials for advanced engine design. It includes the study of friction, wear, lubrication, suitable lubricant additives, and durability of different engine components of alcohol/biodiesel fueled engines."
        }
      },
      {
        "kind": "books#volume",
        "id": "G4tGEAAAQBAJ",
        "etag": "Nhsjz3pNADQ",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/G4tGEAAAQBAJ",
        "volumeInfo": {
          "title": "Discourses on Livy",
          "authors": [
            "Niccolò Machiavelli"
          ],
          "publisher": "Phoemixx Classics Ebooks",
          "publishedDate": "2021-10-14",
          "description": "Discourses on Livy Niccolo Machiavelli - Discourses on Livy (1531) is as essential to an understanding of Machiavelli as his famous treatise, The Prince. Equally controversial, it reveals his fundamental preference for a republican state.Comparing the practice of the ancient Romans with that of his contemporaries provided Machiavelli with a consistent point of view in all his works. Machiavelli's close analysis of Livy's history of Rome led him to advance his most original and outspoken view of politics - the belief that a healthy body politic was characterized by social friction and conflict rather than by rigid stability. His discussion of conspiracies in Discourses on Livy is one of the most sophisticatedtreatments of archetypal political upheaval every written. In an age of increasing political absolutism, Machiavelli's theories became a dangerous ideology.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9783986475338"
            },
            {
              "type": "ISBN_10",
              "identifier": "3986475338"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 555,
          "printType": "BOOK",
          "categories": [
            "History"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=G4tGEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=G4tGEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=G4tGEAAAQBAJ&pg=PP1&dq=friction&hl=&cd=4&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=G4tGEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=G4tGEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 583,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 291.5,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=G4tGEAAAQBAJ&rdid=book-G4tGEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 583000000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 291500000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Discourses_on_Livy-sample-epub.acsm?id=G4tGEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Discourses_on_Livy-sample-pdf.acsm?id=G4tGEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=G4tGEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Discourses on Livy Niccolo Machiavelli - Discourses on Livy (1531) is as essential to an understanding of Machiavelli as his famous treatise, The Prince."
        }
      },
      {
        "kind": "books#volume",
        "id": "yx5AEAAAQBAJ",
        "etag": "yheo4EZr5+8",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/yx5AEAAAQBAJ",
        "volumeInfo": {
          "title": "Tribological Behavior of Functional Surface",
          "subtitle": "Models and Methods",
          "authors": [
            "Pawel Pawlus",
            "Andrzej Dzierwa"
          ],
          "publisher": "MDPI",
          "publishedDate": "2021-08-31",
          "description": "Material loss due to wear and corrosion and high resistance to motion generate high costs. Therefore, minimizing friction and wear is a problem of great importance. This book is focused on the tribological behavior of functional surfaces. It contains information regarding the improvement of tribological properties of sliding elements via changes in surface topography. Tribological impacts of surface texturing depending on the creation of dimples on co-acting surfaces are also discussed. The effects of various coatings on the minimization of friction and wear and corrosion resistance are also studied. Friction can be also reduced by introducing a new oil.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9783036510361"
            },
            {
              "type": "ISBN_10",
              "identifier": "3036510362"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 208,
          "printType": "BOOK",
          "categories": [
            "Technology & Engineering"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.0.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=yx5AEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=yx5AEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=yx5AEAAAQBAJ&pg=PP1&dq=friction&hl=&cd=5&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=yx5AEAAAQBAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Tribological_Behavior_of_Functional_Surf.html?hl=&id=yx5AEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "ALL_PAGES",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=yx5AEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Material loss due to wear and corrosion and high resistance to motion generate high costs. Therefore, minimizing friction and wear is a problem of great importance. This book is focused on the tribological behavior of functional surfaces."
        }
      },
      {
        "kind": "books#volume",
        "id": "BVhFEAAAQBAJ",
        "etag": "mNYQ3+UyfAg",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/BVhFEAAAQBAJ",
        "volumeInfo": {
          "title": "Designs and Anthropologies",
          "subtitle": "Frictions and Affinities",
          "authors": [
            "Keith M. Murphy",
            "Eitan Y. Wilf"
          ],
          "publisher": "University of New Mexico Press",
          "publishedDate": "2021-11-01",
          "description": "The chapters in this captivating volume demonstrate the importance and power of design and the ubiquitous and forceful effects it has on human life within the study of anthropology. The scholars explore the interactions between anthropology and design through a cross-disciplinary approach, and while their approaches vary in how they specifically consider design, they are all centered around the design-and-anthropology relationship. The chapters look at anthropology for design, in which anthropological methods and concepts are mobilized in the design process; anthropology of design, in which design is positioned as an object of ethnographic inquiry and critique; and design for anthropology, in which anthropologists borrow concepts and practices from design to enhance traditional ethnographic forms. Collectively, the chapters argue that bringing design and anthropology together can transform both fields in more than one way and that to tease out the implications of using design to reimagine ethnography—and of using ethnography to reimagine design—we need to consider the historical specificity of their entanglements.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780826362797"
            },
            {
              "type": "ISBN_10",
              "identifier": "0826362796"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "pageCount": 224,
          "printType": "BOOK",
          "categories": [
            "Social Science"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "2.2.2.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=BVhFEAAAQBAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=BVhFEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=BVhFEAAAQBAJ&pg=PP1&dq=friction&hl=&cd=6&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=BVhFEAAAQBAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Designs_and_Anthropologies.html?hl=&id=BVhFEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true
          },
          "pdf": {
            "isAvailable": true
          },
          "webReaderLink": "http://play.google.com/books/reader?id=BVhFEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "dB8_EAAAQBAJ",
        "etag": "O6gAuyxelTs",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/dB8_EAAAQBAJ",
        "volumeInfo": {
          "title": "Tribology of Polymer and Polymer Composites for Industry 4.0",
          "authors": [
            "Hemalata Jena",
            "Jitendra Kumar Katiyar",
            "Amar Patnaik"
          ],
          "publisher": "Springer Nature",
          "publishedDate": "2021-08-23",
          "description": "This book first introduces polymers and polymer composites which are widely used in different industrial and engineering applications where the proper selection of fiber, filler, and polymer can be tailored for particular application. The primary objective of this book is to broaden the knowledge of tribology of polymer composites in a new dimension for Industry 4.0. For instance, the book covers polymer composites used as self-lubricating material used in the automotive industry and other manufacturing equipment to reduce the effect of energy loss due to friction and wear. This book is of interest to researchers and industrial practitioners who work in the field of tribology of polymer composites, manufacturing equipment and production engineering.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789811639036"
            },
            {
              "type": "ISBN_10",
              "identifier": "9811639035"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 210,
          "printType": "BOOK",
          "categories": [
            "Technology & Engineering"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=dB8_EAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=dB8_EAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=dB8_EAAAQBAJ&pg=PP1&dq=friction&hl=&cd=7&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=dB8_EAAAQBAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Tribology_of_Polymer_and_Polymer_Composi.html?hl=&id=dB8_EAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Tribology_of_Polymer_and_Polymer_Composi-sample-epub.acsm?id=dB8_EAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Tribology_of_Polymer_and_Polymer_Composi-sample-pdf.acsm?id=dB8_EAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=dB8_EAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book first introduces polymers and polymer composites which are widely used in different industrial and engineering applications where the proper selection of fiber, filler, and polymer can be tailored for particular application."
        }
      },
      {
        "kind": "books#volume",
        "id": "WGsvEAAAQBAJ",
        "etag": "0IIxPxXMz50",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/WGsvEAAAQBAJ",
        "volumeInfo": {
          "title": "Applied Mechanics for Engineering and Technical Courses",
          "authors": [
            "Harbhajan Singh"
          ],
          "publisher": "Abhishek Publications",
          "publishedDate": "2021-05-20",
          "description": "the book includes all the topics as made mandatory by AICTE for all engineering and diploma level courses: the contents of the book are : Introduction to mechanics, Laws of Forces, Movements, Friction, Centre of Gravity, Simple Lifting machines and Moment of Inertia",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9788182472464"
            },
            {
              "type": "ISBN_10",
              "identifier": "8182472466"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 326,
          "printType": "BOOK",
          "categories": [
            "Science"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=WGsvEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=WGsvEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=WGsvEAAAQBAJ&pg=PA1&dq=friction&hl=&cd=8&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=WGsvEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=WGsvEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 116.82,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 116.82,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=WGsvEAAAQBAJ&rdid=book-WGsvEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 116820000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 116820000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Applied_Mechanics_for_Engineering_and_Te-sample-pdf.acsm?id=WGsvEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=WGsvEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "the book includes all the topics as made mandatory by AICTE for all engineering and diploma level courses: the contents of the book are : Introduction to mechanics, Laws of Forces, Movements, Friction, Centre of Gravity, Simple Lifting ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "JsMpEAAAQBAJ",
        "etag": "TgaJqOA8yl0",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/JsMpEAAAQBAJ",
        "volumeInfo": {
          "title": "Frictions in Cosmopolitan Mobilities",
          "subtitle": "The Ethics and Social Practices of Movement across Cultures",
          "authors": [
            "Rodanthi Tzanelli"
          ],
          "publisher": "Edward Elgar Publishing",
          "publishedDate": "2021-04-30",
          "description": "This groundbreaking book investigates the clash between a desire for unfettered mobility and the prevalence of inequality, exploring how this generates frictions in everyday life and how it challenges the ideal of just cosmopolitanism. Reading fictional and popular cultural texts against real global contexts, it develops an ‘aesthetics of justice’ that does not advocate cosmopolitan mobility at the expense of care and hospitality but rather interrogates their divorce in neoliberal contexts.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781800881426"
            },
            {
              "type": "ISBN_10",
              "identifier": "1800881428"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 208,
          "printType": "BOOK",
          "categories": [
            "Social Science"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=JsMpEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=JsMpEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=JsMpEAAAQBAJ&pg=PA5&dq=friction&hl=&cd=9&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=JsMpEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=JsMpEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 2931.96,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 2931.96,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=JsMpEAAAQBAJ&rdid=book-JsMpEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 2931960000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 2931960000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Frictions_in_Cosmopolitan_Mobilities-sample-pdf.acsm?id=JsMpEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=JsMpEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "My own starting point is that world travels of the cosmopolitan type, which can be enacted in the mind, on foot or in endless combinations of these modes of mobility, always generate \u003cb\u003efriction\u003c/b\u003e. The concept&#39;s twin emergence in philosophy&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "v6oeEAAAQBAJ",
        "etag": "nOiscrocafQ",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/v6oeEAAAQBAJ",
        "volumeInfo": {
          "title": "Tariff Structure, Intermediate Goods, and China–U.S. Trade Friction",
          "authors": [
            "Haichao Fan"
          ],
          "publisher": "Routledge",
          "publishedDate": "2021-03-29",
          "description": "Focusing on the interconnection of tariff structure, international trade and welfare evaluation, the book investigates the characteristics of tariff structures of China and the U.S. in recent years and measures the impact of the Sino–U.S. trade friction that started in 2018. The first part of the book discusses levels and evolution trends of tariff systems of China and the U.S. from 2000 to 2014 and makes a comparison between the two countries' tariff structures. The second part centers on the Sino–U.S. trade friction in 2018, analyzing its development, overall impact on welfare, and relevant impact mechanisms. The author draws on the quantitative analysis method currently prevailing in the field of international trade, taking global value chains, intermediate goods, and variable markup into consideration. In contrast to the research conclusion applying standard trade theory, the result indicates that either unilateral imposition of additional tariffs or bilateral tariff friction will give rise to the deteriorated welfare level of both countries. The book will appeal to academics and policy makers interested in international trade, China–U.S. relation and the trade friction.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781000359138"
            },
            {
              "type": "ISBN_10",
              "identifier": "1000359131"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 187,
          "printType": "BOOK",
          "categories": [
            "Business & Economics"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=v6oeEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=v6oeEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=v6oeEAAAQBAJ&pg=PA2024&dq=friction&hl=&cd=10&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=v6oeEAAAQBAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Tariff_Structure_Intermediate_Goods_and.html?hl=&id=v6oeEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Tariff_Structure_Intermediate_Goods_and-sample-epub.acsm?id=v6oeEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Tariff_Structure_Intermediate_Goods_and-sample-pdf.acsm?id=v6oeEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=v6oeEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "3.2.2.1 Industry transfer Disputes of the Sino–U.S. trade \u003cb\u003efrictions\u003c/b\u003e within industries such as the high and new technology ... The outbreak of the Sino–U.S. trade \u003cb\u003efriction\u003c/b\u003e also further pushes relevant domestic manufacturing companies&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "5fggEAAAQBAJ",
        "etag": "CsC1bvYIrVk",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/5fggEAAAQBAJ",
        "volumeInfo": {
          "title": "Recent Advances in Mechanical Infrastructure",
          "subtitle": "Proceedings of ICRAM 2020",
          "authors": [
            "Ajit Kumar Parwani",
            "PL. Ramkumar",
            "Kumar Abhishek",
            "Saurabh Kumar Yadav"
          ],
          "publisher": "Springer Nature",
          "publishedDate": "2021-03-01",
          "description": "This book contains high-quality papers presented in the conference Recent Advances in Mechanical Infrastructure (ICRAM 2020) held at IITRAM, Ahmedabad, India, from 21-23 August 2020. The topics covered in this book are recent advances in thermal infrastructure, manufacturing infrastructure and infrastructure planning and design.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789813341760"
            },
            {
              "type": "ISBN_10",
              "identifier": "9813341769"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 512,
          "printType": "BOOK",
          "categories": [
            "Technology & Engineering"
          ],
          "averageRating": 5,
          "ratingsCount": 1,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.2.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=5fggEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=5fggEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=5fggEAAAQBAJ&printsec=frontcover&dq=friction&hl=&cd=11&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=5fggEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=5fggEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 16874,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 16874,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=5fggEAAAQBAJ&rdid=book-5fggEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 16874000000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 16874000000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Recent_Advances_in_Mechanical_Infrastruc-sample-epub.acsm?id=5fggEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Recent_Advances_in_Mechanical_Infrastruc-sample-pdf.acsm?id=5fggEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=5fggEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book contains high-quality papers presented in the conference Recent Advances in Mechanical Infrastructure (ICRAM 2020) held at IITRAM, Ahmedabad, India, from 21-23 August 2020."
        }
      },
      {
        "kind": "books#volume",
        "id": "kQt0zgEACAAJ",
        "etag": "3cpRurxrSA8",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/kQt0zgEACAAJ",
        "volumeInfo": {
          "title": "Friction Fatigue",
          "subtitle": "What the Failure of Advertising Means for Future-Focused Brands",
          "authors": [
            "Paul Dyer"
          ],
          "publisher": "Lioncrest Publishing",
          "publishedDate": "2021-06",
          "description": "Google and Facebook changed our way of life. With this transformation, they unleashed a wave of disruption that handed unprecedented power to Big Advertising. Consumers paid the price as their lives were interrupted and intruded upon in ever-more invasive attempts to sway opinion and drive sales. Now, this friction has reached a boiling point. Consumers are fighting back with ad blockers, ad-free subscriptions, and calls to regulate Big Advertising's overreach. Marketing today-and tomorrow-will be on their terms. As a brand marketer, are you ready to deliver? Marketing expert Paul Dyer has helped dozens of leading brands stay ahead of the curve and navigate the rocky media landscape of the last two decades. In Friction Fatigue, Paul shows you why advertising is broken and provides a frictionless marketing framework to help build your brand in an era in which advertising is no longer the answer. With a new wave of pandemic-accelerated disruption, you'll learn how to gird your business against competitors and lead the pack with fresh marketing strategies. Featuring behind-the-scenes stories and expert insights, this book is your chance to prepare for a future in which the consumer rules.",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "1544520778"
            },
            {
              "type": "ISBN_13",
              "identifier": "9781544520773"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 252,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=kQt0zgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=kQt0zgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=kQt0zgEACAAJ&dq=friction&hl=&cd=12&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=kQt0zgEACAAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Friction_Fatigue.html?hl=&id=kQt0zgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=kQt0zgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Featuring behind-the-scenes stories and expert insights, this book is your chance to prepare for a future in which the consumer rules."
        }
      },
      {
        "kind": "books#volume",
        "id": "G74fEAAAQBAJ",
        "etag": "BzNiIJYhLs8",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/G74fEAAAQBAJ",
        "volumeInfo": {
          "title": "Advanced Engineering for Processes and Technologies II",
          "authors": [
            "Azman Ismail",
            "Wardiah Mohd Dahalan",
            "Andreas Öchsner"
          ],
          "publisher": "Springer Nature",
          "publishedDate": "2021-02-22",
          "description": "This book “Advanced Engineering for Processes and Technologies II” provides a good platform for participating researchers and academicians to share their latest innovation, technology and research findings in the areas of marine engineering technology and applications, sea management as well as engineering education. It offers an opportunity for academicians of the Universiti Kuala Lumpur, Malaysian Institute of Marine Engineering Technology (UniKL MIMET) to exchange ideas and establish a professional network. There are more than 30 papers covering a wide range of topics related to technologies and education including simulation, intellectual discussion, environmental awareness, enhancement of knowledge and skills. The aim of this book focuses more on the numerous technological methods used for the establishment of engineering innovation and productivity through their competitive research findings and the exposure of their relative merits and limitations. The papers shared in this issue will enable other researchers to generate interest and novel ideas that can lead to the discovery of new engineering knowledge.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9783030673079"
            },
            {
              "type": "ISBN_10",
              "identifier": "3030673073"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 334,
          "printType": "BOOK",
          "categories": [
            "Technology & Engineering"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=G74fEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=G74fEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=G74fEAAAQBAJ&printsec=frontcover&dq=friction&hl=&cd=13&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=G74fEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=G74fEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 14278,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 14278,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=G74fEAAAQBAJ&rdid=book-G74fEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 14278000000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 14278000000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Advanced_Engineering_for_Processes_and_T-sample-epub.acsm?id=G74fEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Advanced_Engineering_for_Processes_and_T-sample-pdf.acsm?id=G74fEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=G74fEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book “Advanced Engineering for Processes and Technologies II” provides a good platform for participating researchers and academicians to share their latest innovation, technology and research findings in the areas of marine ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "0-gdEAAAQBAJ",
        "etag": "ejCAxb+HVxo",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/0-gdEAAAQBAJ",
        "volumeInfo": {
          "title": "Welding Technology",
          "authors": [
            "J. Paulo Davim"
          ],
          "publisher": "Springer Nature",
          "publishedDate": "2021-02-12",
          "description": "This book presents some developments in the field of welding technology. It starts with classical welding concepts, covering then new approaches. Topics such as ultrasonic welding, robots welding, welding defects and welding quality control are presented in a clear, didactic way. Lower temperature metal-joining techniques such as brazing and soldering are highlighted as well.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9783030639860"
            },
            {
              "type": "ISBN_10",
              "identifier": "303063986X"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 422,
          "printType": "BOOK",
          "categories": [
            "Technology & Engineering"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=0-gdEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=0-gdEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=0-gdEAAAQBAJ&pg=PP1&dq=friction&hl=&cd=14&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=0-gdEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=0-gdEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 12626,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 12626,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=0-gdEAAAQBAJ&rdid=book-0-gdEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 12626000000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 12626000000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Welding_Technology-sample-epub.acsm?id=0-gdEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Welding_Technology-sample-pdf.acsm?id=0-gdEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=0-gdEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book presents some developments in the field of welding technology. It starts with classical welding concepts, covering then new approaches."
        }
      },
      {
        "kind": "books#volume",
        "id": "9DlUEAAAQBAJ",
        "etag": "1uCf/xLSjns",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/9DlUEAAAQBAJ",
        "volumeInfo": {
          "title": "Advances in Engine Tribology",
          "authors": [
            "Vikram Kumar"
          ],
          "publisher": "Springer Nature",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789811683374"
            },
            {
              "type": "ISBN_10",
              "identifier": "9811683379"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=9DlUEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=9DlUEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=9DlUEAAAQBAJ&printsec=frontcover&dq=friction&hl=&cd=15&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=9DlUEAAAQBAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Advances_in_Engine_Tribology.html?hl=&id=9DlUEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Advances_in_Engine_Tribology-sample-epub.acsm?id=9DlUEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=9DlUEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book focuses on novel materials for advanced engine design including the study of friction, wear, lubrication, suitable lubricant additives, and durability of different engine components of alcohol/biodiesel fueled engines."
        }
      },
      {
        "kind": "books#volume",
        "id": "LFIMEAAAQBAJ",
        "etag": "ZyVZbMQOqkM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/LFIMEAAAQBAJ",
        "volumeInfo": {
          "title": "Managing Large Teams",
          "subtitle": "Overcoming Skip- Level Frictions & Executive Isolation",
          "authors": [
            "Rishi Kapal"
          ],
          "publisher": "SAGE Publishing India",
          "publishedDate": "2020-12-01",
          "description": "Managing and leading large teams is an acquired skill and doesn’t come naturally to people. As the team grows horizontally in number and vertically in levels, team management gets complicated. Managing Large Teams is borne out of the author’s twenty-five plus years of experience of navigating multiple scenarios, transitioning from an individual contributor to becoming a first-time manager to later helming teams as a CXO that expanded across North America, Europe, Japan and Southeast Asia. Brimming with the wisdom and experiences of Indian and global CXOs, and Stanford LEAD alumni, the book tackles subjects such as handling multicultural and multi-locational teams, building a strong trustworthy culture of skip-level engagements and the oft-discussed phenomenon of executive isolation at work. Get your hands on this reservoir of knowledge on leadership, organization development and management practices for the present and future generations of performers.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789353886738"
            },
            {
              "type": "ISBN_10",
              "identifier": "9353886732"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 236,
          "printType": "BOOK",
          "categories": [
            "Business & Economics"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.2.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=LFIMEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=LFIMEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=LFIMEAAAQBAJ&pg=PP1&dq=friction&hl=&cd=16&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=LFIMEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=LFIMEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 371.7,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 260.19,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=LFIMEAAAQBAJ&rdid=book-LFIMEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 371700000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 260190000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Managing_Large_Teams-sample-epub.acsm?id=LFIMEAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Managing_Large_Teams-sample-pdf.acsm?id=LFIMEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=LFIMEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Brimming with the wisdom and experiences of Indian and global CXOs, and Stanford LEAD alumni, the book tackles subjects such as handling multicultural and multi-locational teams, building a strong trustworthy culture of skip-level ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "zioMEAAAQBAJ",
        "etag": "boDI6h3HgpU",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/zioMEAAAQBAJ",
        "volumeInfo": {
          "title": "Adaptive Vehicle Estimation and Control for Dynamic Road Conditions",
          "subtitle": "Vehicle Control and Estimation",
          "authors": [
            "Kalyana Veluvolu",
            "Jagat Jyoti Rath"
          ],
          "publisher": "GRIN Verlag",
          "publishedDate": "2020-12-01",
          "description": "Document from the year 2020 in the subject Engineering - Automotive Engineering, grade: 2, , language: English, abstract: Global chassis controller (GCC) design for autonomous vehicles relies on the information of the environmental factors, weather conditions, vehicle dynamics, actuation bandwidth, among others. Typically, various sensors and actuators are employed to provide such information. Challenges such as cost of sensors, actuator complexity and constraints, fail-safe operations, control authority allocation, and adaptability to a wide range of driving scenarios such as acceleration/ deceleration at set speed, double lane change, and driving on a circular path among others persist for design of such GCC architectures. Specifically for longitudinal-vertical vehicle controllers tuned to achieve safety and comfort objectives, the performance is significantly affected by the precise knowledge of road conditions i.e., tire friction and road elevation in the presence of nonlinearities such as aerodynamic drag, rolling resistance, spring and damper nonlinearities. For the longitudinal vehicle motion, tire-road friction conditions, aerodynamic forces, engine friction, and rolling nonlinearities critically affect the design of safety controllers such as traction control or active cruise control. Similarly, for vertical vehicle motion control using active suspension, the random road roughness and road defects, spring and damper nonlinearities, hydraulic actuator nonlinearities, and multi-objective design criteria, make design of controller a challenging task. With that motivation, the use cost effective virtual sensors to detect such external inputs and subsequent output feedback control solutions for the longitudinal-vertical autonomous vehicle motion is proposed in this book. The focus lies on adaptability of designed controllers and estimators to road friction conditions such as road conditions such as asphalt, snow, ice and the road elevation based on various rough roads and road defects.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9783346307170"
            },
            {
              "type": "ISBN_10",
              "identifier": "3346307174"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 177,
          "printType": "BOOK",
          "categories": [
            "Technology & Engineering"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.1.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=zioMEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=zioMEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=zioMEAAAQBAJ&printsec=frontcover&dq=friction&hl=&cd=17&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=zioMEAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=zioMEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 4157.51,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 4157.51,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=zioMEAAAQBAJ&rdid=book-zioMEAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 4157510000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 4157510000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Adaptive_Vehicle_Estimation_and_Control-sample-pdf.acsm?id=zioMEAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=zioMEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "With that motivation, the use cost effective virtual sensors to detect such external inputs and subsequent output feedback control solutions for the longitudinal-vertical autonomous vehicle motion is proposed in this book."
        }
      },
      {
        "kind": "books#volume",
        "id": "4OsCEAAAQBAJ",
        "etag": "1o1sxMSPonY",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/4OsCEAAAQBAJ",
        "volumeInfo": {
          "title": "Monetary Policy and Macroprudential Regulation with Financial Frictions",
          "authors": [
            "Pierre-Richard Agenor"
          ],
          "publisher": "MIT Press",
          "publishedDate": "2020-11-10",
          "description": "An integrated analysis of how financial frictions can be accounted for in macroeconomic models built to study monetary policy and macroprudential regulation. Since the global financial crisis, there has been a renewed effort to emphasize financial frictions in designing closed- and open-economy macroeconomic models for monetary and macroprudential policy analysis. Drawing on the extensive literature of the past decade as well as his own contributions, in this book Pierre-Richard Agénor provides a unified set of theoretical and quantitative macroeconomic models with financial frictions to explore issues that have emerged in the wake of the crisis. These include the need to understand better how the financial system amplifies and propagates shocks originating elsewhere in the economy; how it can itself be a source of aggregate fluctuations; the extent to which central banks should account for financial stability considerations in the conduct of monetary policy; whether national central banks and regulators should coordinate their policies to promote macroeconomic and financial stability; and how much countercyclical macroprudential policies should be coordinated at the international level to mitigate financial spillovers across countries. Agénor focuses on upper middle-income countries, which differ from advanced economies in terms of both their structural features (which include a financial sector dominated by banks, weak supervisory capacity, and a high degree of vulnerability to external shocks) and their long-standing policy challenges (such as managing volatile capital flows). Some of the analytical insights and broad policy lessons that can be drawn from the book will be of relevance to advanced economies as well.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780262044226"
            },
            {
              "type": "ISBN_10",
              "identifier": "0262044226"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 600,
          "printType": "BOOK",
          "categories": [
            "Business & Economics"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=4OsCEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=4OsCEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=4OsCEAAAQBAJ&printsec=frontcover&dq=friction&hl=&cd=18&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=4OsCEAAAQBAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Monetary_Policy_and_Macroprudential_Regu.html?hl=&id=4OsCEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=4OsCEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Drawing on the extensive literature of the past decade as well as his own contributions, in this book Pierre-Richard Agénor provides a unified set of theoretical and quantitative macroeconomic models with financial frictions to explore ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "fZFgzgEACAAJ",
        "etag": "kyoXVLpj2IY",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/fZFgzgEACAAJ",
        "volumeInfo": {
          "title": "Designs and Anthropologies",
          "subtitle": "Frictions and Affinities",
          "authors": [
            "Keith M. Murphy",
            "Eitan Y. Wilf"
          ],
          "publishedDate": "2021",
          "description": "\"The chapters in this captivating volume demonstrate the importance and power of design and the ubiquitous and forceful effects it has on human life within the study of anthropology. The scholars explore the interactions between anthropology and design through a cross-disciplinary approach, and while their approaches vary in how they specifically consider design, they are all centered around the design-and-anthropology relationship. The chapters look at anthropology for design, in which anthropological methods and concepts are mobilized in the design process; anthropology of design, in which design is positioned as an object of ethnographic inquiry and critique; and design for anthropology, in which anthropologists borrow concepts and practices from design to enhance traditional ethnographic forms. Collectively, the chapters argue that bringing design and anthropology together can transform both fields in more than one way and that to tease out the implications of using design to reimagine ethnography-and of using ethnography to reimagine design-we need to consider the historical specificity of their entanglements. Published in Association with School for Advanced Research Press\"--",
          "industryIdentifiers": [
            {
              "type": "ISBN_10",
              "identifier": "0826362788"
            },
            {
              "type": "ISBN_13",
              "identifier": "9780826362780"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 224,
          "printType": "BOOK",
          "categories": [
            "Anthropology"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=fZFgzgEACAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=fZFgzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=fZFgzgEACAAJ&dq=friction&hl=&cd=19&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=fZFgzgEACAAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Designs_and_Anthropologies.html?hl=&id=fZFgzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=fZFgzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Examines the importance and power of design and the ubiquitous and forceful effects it has on human life within the study of anthropology."
        }
      },
      {
        "kind": "books#volume",
        "id": "tovgDwAAQBAJ",
        "etag": "OIQnxzw5Qrw",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/tovgDwAAQBAJ",
        "volumeInfo": {
          "title": "Friction and Wear of Ceramics",
          "subtitle": "Principles and Case Studies",
          "authors": [
            "Bikramjit Basu",
            "Mitjan Kalin",
            "B. V. Manoj Kumar"
          ],
          "publisher": "John Wiley & Sons",
          "publishedDate": "2020-06-23",
          "description": "This book covers the area of tribology broadly, providing important introductory chapters to fundamentals, processing, and applications of tribology. The book is designed primarily for easy and cohesive understanding for students and practicing scientists pursuing the area of tribology with focus on materials. This book helps students and practicing scientists alike understand that a comprehensive knowledge about the friction and wear properties of advanced materials is essential to further design and development of new materials. The description of the wear micromechanisms of various materials will provide a strong background to the readers as how to design and develop new tribological materials. This book also places importance on the development of new ceramic composites in the context of tribological applications. Some of the key features of the book include: Fundamentals section highlights the salient issues of ceramic processing and mechanical properties of important oxide and non-oxide ceramic systems; State of the art research findings on important ceramic composites are included and an understanding on the behavior of silicon carbide (SiC) based ceramic composites in dry sliding wear conditions is presented as a case study; Erosion wear behavior of ceramics, in which case studies on high temperature erosion behavior of SiC based composites and zirconium diboride (ZrB2) based composites is also covered; Wear behavior of ceramic coatings is rarely discussed in any tribology related books therefore a case study explaining the abrasion wear behavior of WC-Co coating is provided. Finally an appendix chapter is included in which a collection of several types of questions including multiple choice, short answer and long answer are provided.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781119538387"
            },
            {
              "type": "ISBN_10",
              "identifier": "1119538386"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 400,
          "printType": "BOOK",
          "categories": [
            "Technology & Engineering"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.2.1.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=tovgDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=tovgDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=tovgDwAAQBAJ&pg=PA119&dq=friction&hl=&cd=20&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=tovgDwAAQBAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Friction_and_Wear_of_Ceramics.html?hl=&id=tovgDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=tovgDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "\u003cb\u003eFriction\u003c/b\u003e mechanisms, \u003cb\u003efriction\u003c/b\u003e laws, and key factors affecting \u003cb\u003efriction\u003c/b\u003e in tribological contacts are discussed in this chapter. Moreover, the contact temperature of the engineering surfaces at the multiple-asperity level is discussed."
        }
      },
      {
        "kind": "books#volume",
        "id": "tovgDwAAQBAJ",
        "etag": "NPdy2GoUkb4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/tovgDwAAQBAJ",
        "volumeInfo": {
          "title": "Friction and Wear of Ceramics",
          "subtitle": "Principles and Case Studies",
          "authors": [
            "Bikramjit Basu",
            "Mitjan Kalin",
            "B. V. Manoj Kumar"
          ],
          "publisher": "John Wiley & Sons",
          "publishedDate": "2020-06-23",
          "description": "This book covers the area of tribology broadly, providing important introductory chapters to fundamentals, processing, and applications of tribology. The book is designed primarily for easy and cohesive understanding for students and practicing scientists pursuing the area of tribology with focus on materials. This book helps students and practicing scientists alike understand that a comprehensive knowledge about the friction and wear properties of advanced materials is essential to further design and development of new materials. The description of the wear micromechanisms of various materials will provide a strong background to the readers as how to design and develop new tribological materials. This book also places importance on the development of new ceramic composites in the context of tribological applications. Some of the key features of the book include: Fundamentals section highlights the salient issues of ceramic processing and mechanical properties of important oxide and non-oxide ceramic systems; State of the art research findings on important ceramic composites are included and an understanding on the behavior of silicon carbide (SiC) based ceramic composites in dry sliding wear conditions is presented as a case study; Erosion wear behavior of ceramics, in which case studies on high temperature erosion behavior of SiC based composites and zirconium diboride (ZrB2) based composites is also covered; Wear behavior of ceramic coatings is rarely discussed in any tribology related books therefore a case study explaining the abrasion wear behavior of WC-Co coating is provided. Finally an appendix chapter is included in which a collection of several types of questions including multiple choice, short answer and long answer are provided.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781119538387"
            },
            {
              "type": "ISBN_10",
              "identifier": "1119538386"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 400,
          "printType": "BOOK",
          "categories": [
            "Technology & Engineering"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.2.1.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=tovgDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=tovgDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=tovgDwAAQBAJ&pg=PA120&dq=friction&hl=&cd=21&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=tovgDwAAQBAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Friction_and_Wear_of_Ceramics.html?hl=&id=tovgDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=tovgDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "W is the normal load and F is the \u003cb\u003efriction\u003c/b\u003e. required, such as vehicle brakes, the \u003cb\u003efrictional\u003c/b\u003e transmission of power (such as belt drives), and clutches. Nevertheless, most applications indeed tend to reduce \u003cb\u003efriction\u003c/b\u003e, such as seals,&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "lEjmDwAAQBAJ",
        "etag": "d/ojDLRxEPw",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/lEjmDwAAQBAJ",
        "volumeInfo": {
          "title": "Science, Characterization and Technology of Joining and Welding",
          "authors": [
            "Meysam Haghshenas"
          ],
          "publisher": "MDPI",
          "publishedDate": "2020-05-22",
          "description": "As the Guest Editor of this Special Issue entitled \"Science, Characterization, and Technology of Joining and Welding\" of Metals, I am pleased to have this book published by MDPI. Joining, including welding, soldering, brazing, and assembly, is an essential requirement in manufacturing processes and is classified as a secondary manufacturing process. This Special Issue of Metals includes technical and review papers on, but not limited to, different aspects of joining and welding, including welding technologies (i.e., fusion-based welding and solid-state welding), characterization, metallurgy and materials science, quality control, and design and numerical simulation. This Special Issue also includes the joining of different materials, including metal and non-metals (polymers and composites), including 17 peer-reviewed papers from several researchers all around the globe (China, Germany, Brazil, South Koria, Slovakia, USA, Taiwan, Canada, and India). As of this date (April 2020), the papers in this Special Issue have been cited 47 times by other researchers, which I think is an eminent number and shows the high quality of the published papers in this Issue. This Special Issue includes a large diversity of various subjects in the field of joining: laser welding, friction stir welding, diffusion bonding, multipass welding, rotary friction-welding, friction bit joining, adhesive bonding, weldbonding, simulation and experimentation, metal/FRP joints, welding simulation, plasma–TIG coupled arc welding, liquation cracking, soldering, resin bonding, microstructural characteristics, brazing, and friction stir butt and scarf welding. I would like to sincerely thank all the researchers who contributed to this Special Issue for their high-quality research. I also would like to acknowledge Mr. Toliver Guo, Senior Assistant Editor at MDPI, who continuously and tirelessly contributed toward this Special Issue by assisting me with inviting the authors and the follow ups. I think this Special Issue will enhance our knowledge and understanding in the field of joining and assembly. I would like to dedicate this book to my wife, Mehrnoosh, for her continued support and encouragement.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9783039289974"
            },
            {
              "type": "ISBN_10",
              "identifier": "3039289977"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 252,
          "printType": "BOOK",
          "categories": [
            "Technology & Engineering"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=lEjmDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=lEjmDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=lEjmDwAAQBAJ&printsec=frontcover&dq=friction&hl=&cd=22&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=lEjmDwAAQBAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Science_Characterization_and_Technology.html?hl=&id=lEjmDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "ALL_PAGES",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=lEjmDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "As the Guest Editor of this Special Issue entitled &quot;Science, Characterization, and Technology of Joining and Welding&quot; of Metals, I am pleased to have this book published by MDPI."
        }
      },
      {
        "kind": "books#volume",
        "id": "vNk7EAAAQBAJ",
        "etag": "ZP69xrsm6vM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/vNk7EAAAQBAJ",
        "volumeInfo": {
          "title": "Exploring Science Book for Class 8",
          "authors": [
            "V.K. Sally ",
            "S.K. Aggarwal",
            "Goyal Brothers Prakashan"
          ],
          "publisher": "Goyal Brothers Prakashan",
          "publishedDate": "2020-04-16",
          "description": "Goyal Brothers Prakashan",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789389693775"
            },
            {
              "type": "ISBN_10",
              "identifier": "9389693772"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "printType": "BOOK",
          "categories": [
            "Juvenile Nonfiction"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.1.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=vNk7EAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=vNk7EAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=vNk7EAAAQBAJ&pg=PP1&dq=friction&hl=&cd=23&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=vNk7EAAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=vNk7EAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 234,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 163.8,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=vNk7EAAAQBAJ&rdid=book-vNk7EAAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 234000000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 163800000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Exploring_Science_Book_for_Class_8-sample-pdf.acsm?id=vNk7EAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=vNk7EAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Goyal Brothers Prakashan"
        }
      },
      {
        "kind": "books#volume",
        "id": "DOXbDwAAQBAJ",
        "etag": "u0cJU06YPLY",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/DOXbDwAAQBAJ",
        "volumeInfo": {
          "title": "Border Frictions",
          "subtitle": "Gender, Generation and Technology on the Frontline",
          "authors": [
            "Karine Côté-Boucher"
          ],
          "publisher": "Routledge",
          "publishedDate": "2020-04-27",
          "description": "How did Canadian border officers come to think of themselves as a \"police of the border\"? This book tells the story of the shift to law enforcement in Canadian border control. From the 1990s onward, it traces the transformation of a customs organization into a border-policing agency. Border Frictions investigates how considerable political efforts and state resources have made bordering a matter of security and trade facilitation best managed with surveillance technologies. Based on interviews with border officers, ethnographic work carried out in the vicinity of land border ports of entry and policy analysis, this book illuminates features seldom reviewed by critical border scholars. These include the fraught circulation of data, the role of unions in shaping the border policy agenda, the significance of professional socialization in the making of distinct generations of security workers and evidence of the masculinization of bordering. In a time when surveillance technologies track the mobilities of goods and people and push their control beyond and inside geopolitical borderlines, Côté-Boucher unpacks how we came to accept the idea that it is vital to deploy coercive bordering tactics at the land border. Written in a clear and engaging style, this book will appeal to students and scholars in criminology, sociology, social theory, politics, and geography and appeal to those interested in learning about the everyday reality of policing the border.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780429648366"
            },
            {
              "type": "ISBN_10",
              "identifier": "0429648367"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 206,
          "printType": "BOOK",
          "categories": [
            "Law"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.1.1.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=DOXbDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=DOXbDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=DOXbDwAAQBAJ&pg=PP1&dq=friction&hl=&cd=24&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=DOXbDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=DOXbDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 3138.8,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 3138.8,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=DOXbDwAAQBAJ&rdid=book-DOXbDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 3138800000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 3138800000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Border_Frictions-sample-epub.acsm?id=DOXbDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Border_Frictions-sample-pdf.acsm?id=DOXbDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=DOXbDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "How did Canadian border officers come to think of themselves as a &quot;police of the border&quot;? This book tells the story of the shift to law enforcement in Canadian border control."
        }
      },
      {
        "kind": "books#volume",
        "id": "CZ7SDwAAQBAJ",
        "etag": "SqRfuSAa9vI",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/CZ7SDwAAQBAJ",
        "volumeInfo": {
          "title": "Newton's Laws of Motion and Friction",
          "subtitle": "Mechanics",
          "authors": [
            "SANJAY KUMAR"
          ],
          "publisher": "SANJAY KUMAR",
          "publishedDate": "2020-02-26",
          "description": "This physics book is the product of more than fifteen years of teaching and innovation experience in physics for JEE main and Advanced aspirants. Our main goals in writing this book are · to present the basic concepts and principles of physics that students need to know for JEE-advanced and other related competitive exams. · to provide a balance of quantitative reasoning and conceptual understanding, with special attention to concepts that have been causing difficulties to student in understanding the concepts. · to develop students' problem-solving skills and confidence in a systematic manner. · to motivate students by integrating real-world examples that build upon their everyday experiences. What’s New? Lots! Much is new and unseen before. Here are the big four: 1. Every concept is given in student friendly language with various solved problems. The solution is provided with problem solving approach and discussion. 2. Checkpoint questions have been added to applicable sections of the text to allow students to pause and test their understanding of the concept explored within the current section. The answers to the Checkpoints are given in answer keys, at the end of the chapter, so that students can confirm their knowledge without jumping too quickly to the provided answer. 3. Special attention is given to constrained relations and block over block friction problems, so that student can easily solve them with fun. 4. To test the understanding level of students, multiple choice questions, conceptual questions, practice problems with previous years JEE Main and Advanced problems are provided at the end of the whole discussion. Number of dots indicates level of problem difficulty. Straightforward problems (basic level) are indicated by single dot (●), intermediate problems (JEE mains level) are indicated by double dots (●●), whereas challenging problems (advanced level) are indicated by thee dots (●●●). Answer keys with hints and solutions are provided at the end of the chapter.",
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 193,
          "printType": "BOOK",
          "categories": [
            "Science"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "0.1.0.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=CZ7SDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=CZ7SDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=CZ7SDwAAQBAJ&pg=PR1&dq=friction&hl=&cd=25&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=CZ7SDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=CZ7SDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 171.1,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 119.77,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=CZ7SDwAAQBAJ&rdid=book-CZ7SDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 171100000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 119770000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Newton_s_Laws_of_Motion_and_Friction-sample-pdf.acsm?id=CZ7SDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=CZ7SDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This physics book is the product of more than fifteen years of teaching and innovation experience in physics for JEE main and Advanced aspirants."
        }
      },
      {
        "kind": "books#volume",
        "id": "rqkZEAAAQBAJ",
        "etag": "NpcFkyqQo64",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/rqkZEAAAQBAJ",
        "volumeInfo": {
          "title": "Informality, Frictions, and Macroprudential Policy",
          "authors": [
            "Moez Ben Hassine",
            "Mr.Nooman Rebei"
          ],
          "publisher": "International Monetary Fund",
          "publishedDate": "2019-11-27",
          "description": "We analyze the effects of macroprudential policies through the lens of an estimated dynamic stochastic general equilibrium (DSGE) model tailored to developing markets. In particular, we explicitly introduce informality in the labor and goods markets within a small open economy embedding financial frictions, nominal and real rigidities, labor search and matching, and an explicit banking sector. We use the estimated version of the model to run welfare analysis under optimized monetary and macroprudential rules. Results show that although informality reduces the efficiency of macroprudential policies following a convex fashion, combining the latter with an inflation targeting objective could be beneficial.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781498320856"
            },
            {
              "type": "ISBN_10",
              "identifier": "1498320856"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 37,
          "printType": "BOOK",
          "categories": [
            "Business & Economics"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=rqkZEAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=rqkZEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=rqkZEAAAQBAJ&printsec=frontcover&dq=friction&hl=&cd=26&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=rqkZEAAAQBAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Informality_Frictions_and_Macroprudentia.html?hl=&id=rqkZEAAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=rqkZEAAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "We analyze the effects of macroprudential policies through the lens of an estimated dynamic stochastic general equilibrium (DSGE) model tailored to developing markets."
        }
      },
      {
        "kind": "books#volume",
        "id": "eUeODwAAQBAJ",
        "etag": "Ky2DaKXjIQE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/eUeODwAAQBAJ",
        "volumeInfo": {
          "title": "Frottage",
          "subtitle": "Frictions of Intimacy across the Black Diaspora",
          "authors": [
            "Keguro Macharia"
          ],
          "publisher": "NYU Press",
          "publishedDate": "2019-11-19",
          "description": "A new understanding of freedom in the black diaspora grounded in the erotic In Frottage, Keguro Macharia weaves together histories and theories of blackness and sexuality to generate a fundamentally new understanding of both the black diaspora and queer studies. Macharia maintains that to reach this understanding, we must start from the black diaspora, which requires re-thinking not only the historical and theoretical utility of identity categories such as gay, lesbian, and bisexual, but also more foundational categories such as normative and non-normative, human and non-human. Simultaneously, Frottage questions the heteronormative tropes through which the black diaspora has been imagined. Between Frantz Fanon, René Maran, Jomo Kenyatta, and Claude McKay, Macharia moves through genres—psychoanalysis, fiction, anthropology, poetry—as well as regional geohistories across Africa and Afro-diaspora to map the centrality of sex, gender, desire, and eroticism to black freedom struggles. In lyrical, meditative prose, Macharia invigorates frottage as both metaphor and method with which to rethink diaspora by reading, and reading against, discomfort, vulnerability, and pleasure.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781479861675"
            },
            {
              "type": "ISBN_10",
              "identifier": "1479861677"
            }
          ],
          "readingModes": {
            "text": true,
            "image": false
          },
          "printType": "BOOK",
          "categories": [
            "Social Science"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "1.5.3.0.preview.2",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=eUeODwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=eUeODwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=eUeODwAAQBAJ&pg=PP1&dq=friction&hl=&cd=27&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=eUeODwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=eUeODwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 2414.63,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 2414.63,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=eUeODwAAQBAJ&rdid=book-eUeODwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 2414630000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 2414630000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Frottage-sample-epub.acsm?id=eUeODwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=eUeODwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Winner, 2020 Alan Bray Memorial Prize, given by the GL/Q Caucus of the Modern Language Association A new understanding of freedom in the black diaspora grounded in the erotic In Frottage, Keguro Macharia weaves together histories and ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "tGX8DwAAQBAJ",
        "etag": "LHitkDFdaTE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/tGX8DwAAQBAJ",
        "volumeInfo": {
          "title": "Friction, Lubrication and Wear",
          "authors": [
            "Mohammad Asaduzzaman Chowdhury"
          ],
          "publisher": "BoD – Books on Demand",
          "publishedDate": "2019-10-30",
          "description": "Tribology has rapidly expanded in recent years as the demand for improved materials has increased. The good function of numerous electrical, electrochemical, mechanical, and biological systems or components depends on suitable friction, lubrication, and wear as well as tribological values. In this context, the study of friction, wear, and lubrication is of tremendous pragmatic importance. The reduction of friction and loss of materials in relative motion are important challenges to improveing energy efficiency. This book guides the rational design of material for technological application. Chapters cover topics such as the resistance of dry abrasive wear, the role of a brand-new additive in the minimization of friction and wear, the structural-energy model of elastic-plastic deformation, the influence of micro-abrasive wear modes, tribological characteristics of magneto-rheological fluids (MRFs) and magneto-rheological elastomers (MREs), and different treatment technologies to improve tribological properties, among others.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781789842876"
            },
            {
              "type": "ISBN_10",
              "identifier": "1789842875"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 224,
          "printType": "BOOK",
          "categories": [
            "Science"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=tGX8DwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=tGX8DwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=tGX8DwAAQBAJ&pg=PA132&dq=friction&hl=&cd=28&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=tGX8DwAAQBAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Friction_Lubrication_and_Wear.html?hl=&id=tGX8DwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=tGX8DwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The \u003cb\u003efrictional\u003c/b\u003e coefficient of MoS2 is generally lower than 0.1 under room temperature. The oxidations of Mo element will be generated if MoS2 working temperature exceeds 200°C, that the self-lubricity of MoS2 is reduced."
        }
      },
      {
        "kind": "books#volume",
        "id": "xiK3DwAAQBAJ",
        "etag": "+FIdlRFvxYM",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/xiK3DwAAQBAJ",
        "volumeInfo": {
          "title": "Advances in Additive Manufacturing and Joining",
          "subtitle": "Proceedings of AIMTDR 2018",
          "authors": [
            "M. S. Shunmugam",
            "M. Kanthababu"
          ],
          "publisher": "Springer Nature",
          "publishedDate": "2019-10-16",
          "description": "This volume presents research papers on additive manufacturing (popularly known as 3D printing) and joining which were presented during the 7th International and 28th All India Manufacturing Technology, Design and Research conference 2018 (AIMTDR 2018). The contents of this volume present the latest technological advancements for improving the efficiency, accuracy and speed of the additive manufacturing process and in fusion and solid-state welding technologies, with a variety of technologies, including fused deposition modelling, poly jet 3D printing, weld deposition based technology, selective laser melting and important welding technologies being covered. This volume will be of interest to academicians, researchers, and practicing engineers alike.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789813294332"
            },
            {
              "type": "ISBN_10",
              "identifier": "9813294337"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 749,
          "printType": "BOOK",
          "categories": [
            "Technology & Engineering"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=xiK3DwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=xiK3DwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=xiK3DwAAQBAJ&printsec=frontcover&dq=friction&hl=&cd=29&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=xiK3DwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=xiK3DwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 15222,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 15222,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=xiK3DwAAQBAJ&rdid=book-xiK3DwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 15222000000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 15222000000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Advances_in_Additive_Manufacturing_and_J-sample-epub.acsm?id=xiK3DwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Advances_in_Additive_Manufacturing_and_J-sample-pdf.acsm?id=xiK3DwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=xiK3DwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This volume presents research papers on additive manufacturing (popularly known as 3D printing) and joining which were presented during the 7th International and 28th All India Manufacturing Technology, Design and Research conference 2018 ..."
        }
      },
      {
        "kind": "books#volume",
        "id": "9YavDwAAQBAJ",
        "etag": "nut22TgRSVY",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/9YavDwAAQBAJ",
        "volumeInfo": {
          "title": "Additive Manufacturing",
          "subtitle": "Fundamentals and Advancements",
          "authors": [
            "Manu Srivastava",
            "Sandeep Rathee",
            "Sachin Maheshwari",
            "TK Kundra"
          ],
          "publisher": "CRC Press",
          "publishedDate": "2019-09-16",
          "description": "There is a growing need for manufacturing optimization all over the world. The immense market of Additive Manufacturing (AM) technologies dictates a need for a book that will provide knowledge of the various aspects of AM for anyone interested in learning about this fast-growing topic. This book disseminates knowledge of AM amongst scholars at graduate level, post graduate level, doctoral level, as well as industry personnel. The objective is to offer a state-of-the-art book which covers all aspects of AM and incorporates all information regarding trends, historical developments, classifications, materials, tooling, software issues, dynamic design, principles, limitations, and communication interfaces in a one-stop resource. Features: Breaks down systematic coverage of various aspects of AM within four distinct sections Contains details of various AM techniques based on ASTM guidelines Discusses many AM applications with suitable illustrations Includes recent trends in the field of AM Covers engineering materials utilized as raw materials in AM Compares AM techniques with different traditional manufacturing methods",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9781351049368"
            },
            {
              "type": "ISBN_10",
              "identifier": "1351049364"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 286,
          "printType": "BOOK",
          "categories": [
            "Technology & Engineering"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.3.2.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=9YavDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=9YavDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=9YavDwAAQBAJ&pg=PP1&dq=friction&hl=&cd=30&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=9YavDwAAQBAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Additive_Manufacturing.html?hl=&id=9YavDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Additive_Manufacturing-sample-epub.acsm?id=9YavDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Additive_Manufacturing-sample-pdf.acsm?id=9YavDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=9YavDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This book disseminates knowledge of AM amongst scholars at graduate level, post graduate level, doctoral level, as well as industry personnel."
        }
      },
      {
        "kind": "books#volume",
        "id": "I1CqDwAAQBAJ",
        "etag": "aWs3SZ02/Ss",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/I1CqDwAAQBAJ",
        "volumeInfo": {
          "title": "Friction and Wear: From Elementary Mechanisms to Macroscopic Behavior",
          "authors": [
            "Valentin L. Popov",
            "Roman Pohrt"
          ],
          "publisher": "Frontiers Media SA",
          "publishedDate": "2019-08-21",
          "description": "Friction and the interaction of surfaces can usually be felt at the scale of the contacting bodies. Indeed, phenomena such as the frictional resistance or the occurrence of wear can be observable with plain eye, but to characterize them and in order to make a prediction, a more detailed understanding at smaller scales is often required. These can include individual roughness peaks or single molecule interactions. In this Research Topic, we have gathered a collection of articles representing the state of the art in tribology’s endeavor to bridge the gap between nano scale elementary research and the macroscopic behavior of contacting bodies. These articles showcase the breadth of questions related to the interaction of micro and macro scale and give examples of successful transfer of insights from one to the other. We are delighted to present this Research Topic to the reader with the hope that it will further inspire and stimulate research in the field.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9782889630745"
            },
            {
              "type": "ISBN_10",
              "identifier": "2889630749"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 104,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=I1CqDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=I1CqDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=I1CqDwAAQBAJ&pg=PP1&dq=friction&hl=&cd=31&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=I1CqDwAAQBAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Friction_and_Wear_From_Elementary_Mechan.html?hl=&id=I1CqDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=I1CqDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Friction and the interaction of surfaces can usually be felt at the scale of the contacting bodies."
        }
      },
      {
        "kind": "books#volume",
        "id": "wKOfDwAAQBAJ",
        "etag": "1qAqsNnBf2U",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/wKOfDwAAQBAJ",
        "volumeInfo": {
          "title": "(Free Sample) Concepts of Mechanics Vol.1 for JEE Advanced & Main 7th Edition_interior",
          "authors": [
            "Disha Experts"
          ],
          "publisher": "Disha Publications",
          "publishedDate": "2019-07-02",
          "readingModes": {
            "text": false,
            "image": true
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": true,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=wKOfDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=wKOfDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=wKOfDwAAQBAJ&pg=PP1&dq=friction&hl=&cd=32&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=wKOfDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=wKOfDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 0,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 0,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=wKOfDwAAQBAJ&rdid=book-wKOfDwAAQBAJ&rdot=1&source=gbs_api"
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "ALL_PAGES",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Free_Sample_Concepts_of_Mechanics_Vol_1-sample-pdf.acsm?id=wKOfDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=wKOfDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        }
      },
      {
        "kind": "books#volume",
        "id": "nAGfDwAAQBAJ",
        "etag": "ltjlDq0v+kc",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/nAGfDwAAQBAJ",
        "volumeInfo": {
          "title": "Heat Transfer Enhancement in Plate and Fin Extended Surfaces",
          "authors": [
            "Sujoy Kumar Saha",
            "Hrishiraj Ranjan",
            "Madhu Sruthi Emani",
            "Anand Kumar Bharti"
          ],
          "publisher": "Springer",
          "publishedDate": "2019-06-24",
          "description": "This Brief deals with heat transfer and friction in plate and fin extended heat transfer enhancement surfaces. It examines Offset-Strip Fin (OSF), Enhancement Principle, Analytically Based Models for j and f vs. Re, Transition from Laminar to Turbulent Region, Correlations for j and f vs. Re, Use of OSF with Liquids, Effect of Percent Fin Offset, Effect of Burred Edges, Louver fin, heat transfer and friction correlations, flow structure in the louver fin array, analytical model for heat transfer and friction, convex louver fin, wavy fin, 3D corrugated fin, perforated fin, pin fins and wire mesh, types of vortex generators, metal foam fin, plain fin, packings, numerical simulation of various types of fins.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9783030207366"
            },
            {
              "type": "ISBN_10",
              "identifier": "3030207366"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 145,
          "printType": "BOOK",
          "categories": [
            "Science"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=nAGfDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=nAGfDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=nAGfDwAAQBAJ&printsec=frontcover&dq=friction&hl=&cd=33&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=nAGfDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=nAGfDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 4200.8,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 4200.8,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=nAGfDwAAQBAJ&rdid=book-nAGfDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 4200800000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 4200800000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Heat_Transfer_Enhancement_in_Plate_and_F-sample-epub.acsm?id=nAGfDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Heat_Transfer_Enhancement_in_Plate_and_F-sample-pdf.acsm?id=nAGfDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=nAGfDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This Brief deals with heat transfer and friction in plate and fin extended heat transfer enhancement surfaces."
        }
      },
      {
        "kind": "books#volume",
        "id": "jiZtzgEACAAJ",
        "etag": "+59r9pPAupQ",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/jiZtzgEACAAJ",
        "volumeInfo": {
          "title": "Productive and Unproductive Friction in Game Design",
          "authors": [
            "Changsok Isaac Sung"
          ],
          "publishedDate": "2021",
          "description": "Video game design is an important aspect of how games can impact players in terms of behavior, player experience, and learning. How a game is designed and not just what is in a game affects how users are influenced. This dissertation introduces productive frictional designs as a new category of designs that may be useful for researchers and designers searching for creative and empirically studied methods to affect players in their games. Productive friction is hypothesized to create points of friction in the gameplay but result in positive outcomes for the player (e.g. learning, increased game performance, improved player experience). The framework for productive friction draws on theories from various fields such as the learning sciences, human-computer interaction, and player-computer interaction. For example, research on productive failure and microboundaries provide a theoretical basis for expecting positive outcomes from introducing friction into a game. Two types of productive frictional designs are proposed and examined: obstructions on game actions and juicy design. This study aimed to evaluate the effectiveness of productive friction in the form of obstructions and juice empirically. In order to do so, two primary research questions were pursued: 1. How do productive and unproductive design frictions in a casual word game influence players' behaviors and experiences? 2. What effects might productive and unproductive design frictions in a casual word game have on game outcomes? A mixed-methods approach was conducted to investigate the effects and mechanisms of obstructive and juicy designs in a custom designed word game called Brave New Word. One study gathered anonymous game log data from 200+ participants who downloaded and played the game. Another study consisted of one-on-one video conferencing sessions with 7 participants that included think-alouds and interviews. The studies found that productive frictions in the form of obstructions have the potential to change player behavior by introducing microboundaries that encourage mindful interactions. Another general finding was that productive frictions in the form of juicy design have the potential to improve player experiences by creating engaging feedback but do not seem to impact player performances in games. These findings indicated that certain design frictions can be included in games to benefit players. Current user experience and player experience literature mostly align with these findings and support the conclusions made in this document.",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OCLC:1245963497"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "pageCount": 158,
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=jiZtzgEACAAJ&dq=friction&hl=&cd=34&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=jiZtzgEACAAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Productive_and_Unproductive_Friction_in.html?hl=&id=jiZtzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=jiZtzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Video game design is an important aspect of how games can impact players in terms of behavior, player experience, and learning."
        }
      },
      {
        "kind": "books#volume",
        "id": "P5HUDQAAQBAJ",
        "etag": "CmG8vo+1Vp4",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/P5HUDQAAQBAJ",
        "volumeInfo": {
          "title": "Coulson and Richardson’s Chemical Engineering",
          "subtitle": "Volume 2A: Particulate Systems and Particle Technology",
          "authors": [
            "R. P. Chhabra",
            "Basavaraj Gurappa"
          ],
          "publisher": "Butterworth-Heinemann",
          "publishedDate": "2019-04-15",
          "description": "Coulson and Richardson's Chemical Engineering: Volume 2A: Particulate Systems and Particle Technology, Sixth Edition, has been fully revised and updated to provide practitioners with an overview of chemical engineering, including clear explanations of theory and thorough coverage of practical applications, all supported by case studies. A worldwide team of contributors has pooled their experience to revise old content and add new content. The content has been updated to be more useful to practicing engineers. This complete reference to chemical engineering will support you throughout your career, as it covers every key chemical engineering topic. Fluid Flow, Heat Transfer and Mass Transfer has been developed from the series’ volume 1, 6th edition. This volume covers the three main transport process of interest to chemical engineers: momentum transfer (fluid flow), heat transfer and mass transfer and the relationships between them. Particulate Systems and Particle Technology has been developed from the series’ volume 2, 5th edition. This volume covers the properties of particulate systems, including the character of individual particles and their behavior in fluids. Sedimentation of particles, both singly and at high concentrations, flow in packed and fluidized beads and filtration are then examined. Separation Processes has been developed from the series’ volume 2, 5th edition. This volume covers distillation and gas absorption, which illustrate applications of the fundamental principles of mass transfer. Several techniques—adsorption, ion exchange, chromatographic and membrane separations, and process intensification—are described. Chemical and Biochemical Reactors and Reaction Engineering has been developed from the series’ volume 3, 3rd edition. Features fully revised reference material converted from textbooks Covers foundational to technical topics Features emerging applications, numerical methods and computational tools",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9780081012208"
            },
            {
              "type": "ISBN_10",
              "identifier": "0081012209"
            }
          ],
          "readingModes": {
            "text": true,
            "image": true
          },
          "pageCount": 871,
          "printType": "BOOK",
          "categories": [
            "Technology & Engineering"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "1.3.4.0.preview.3",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=P5HUDQAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=P5HUDQAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=P5HUDQAAQBAJ&pg=PA68&dq=friction&hl=&cd=35&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=P5HUDQAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=P5HUDQAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 9060.04,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 9060.04,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=P5HUDQAAQBAJ&rdid=book-P5HUDQAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 9060040000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 9060040000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Coulson_and_Richardson_s_Chemical_Engine-sample-epub.acsm?id=P5HUDQAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Coulson_and_Richardson_s_Chemical_Engine-sample-pdf.acsm?id=P5HUDQAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=P5HUDQAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "3.1.1 \u003cb\u003eFrictional\u003c/b\u003e Nature of Bulk Materials Interparticle forces in the bulk material are \u003cb\u003efrictional\u003c/b\u003e in nature, ... Two examples illustrating the effect of the limiting value of the \u003cb\u003efriction\u003c/b\u003e force are explained below to emphasise the&nbsp;..."
        }
      },
      {
        "kind": "books#volume",
        "id": "UlzwDwAAQBAJ",
        "etag": "EvYpPN7FIDQ",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/UlzwDwAAQBAJ",
        "volumeInfo": {
          "title": "Olympiad Books Practice Sets - science Class 8th",
          "authors": [
            "Arihant Experts"
          ],
          "publisher": "Arihant Publications India limited",
          "publishedDate": "2019-04-15",
          "description": "Various institutes and associations across the country conduct Science Olympiads & Competitions for Class 8 students. This specialized book has been designed to provide relevant and the best study material for the preparation for Class 8 students preparing for Science Olympiads and competitions. This book has been designed to give the students an insight and proficiency into almost all the areas of Science asked in various Science Olympiads. The present book has been divided into 16 chapters namely Microorganisms: Friends & Foe, Synthetic Fibres & Plastics, Materials: Metals & Non-Metals, Coal & Petroleum, Combustion & Flame, Conservation of Plants & Animals, Cell-Structure & Functions, Reproduction in Animals, Force & Pressure, Friction, Sound, Chemical Effects of Electric Current, Some Natural Phenomena, Light, Stars & the Solar System and Pollution of Air & Water. The book contains complete theoretical content exactly on the pattern of various Science Olympiads with sufficient number of solved examples set according to the pattern and level of Indian National Science Olympiads. Exercises have also been given in the book. Problems from recently held Olympiads have also been given in the book. The book also contains five practice sets designed on the lines of the questions asked in the precious years’ Science Olympiads questions. Also answers & explanations for the practice sets have been provided at the end. As the book contains ample study as well as practice material, it for sure will help aspirants score high in the upcoming Science Olympiads and competitions for Class 8 students.",
          "industryIdentifiers": [
            {
              "type": "ISBN_13",
              "identifier": "9789352034000"
            },
            {
              "type": "ISBN_10",
              "identifier": "9352034007"
            }
          ],
          "readingModes": {
            "text": false,
            "image": true
          },
          "printType": "BOOK",
          "averageRating": 4,
          "ratingsCount": 1,
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "0.1.1.0.preview.1",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=UlzwDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=UlzwDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=UlzwDwAAQBAJ&printsec=frontcover&dq=friction&hl=&cd=36&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=UlzwDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=UlzwDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 130.5,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 130.5,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=UlzwDwAAQBAJ&rdid=book-UlzwDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 130500000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 130500000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true,
            "acsTokenLink": "http://books.google.co.in/books/download/Olympiad_Books_Practice_Sets_science_Cla-sample-pdf.acsm?id=UlzwDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api"
          },
          "webReaderLink": "http://play.google.com/books/reader?id=UlzwDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Problems from recently held Olympiads have also been given in the book. The book also contains five practice sets designed on the lines of the questions asked in the precious years’ Science Olympiads questions."
        }
      },
      {
        "kind": "books#volume",
        "id": "o6emzgEACAAJ",
        "etag": "hHES1xj8oG8",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/o6emzgEACAAJ",
        "volumeInfo": {
          "title": "THERMOMECHANICAL MECHANISMS THAT CAUSE ADHESION OF ALUMINUM HIGH PRESSURE DIE CASTINGS TO THE DIE",
          "publishedDate": "2021",
          "description": "Abstract : In high pressure die casting (HPDC) of aluminum, cast material adhering to die is a significant defect. Adhesion occurs in two primary ways. The casting may stick preventing its removal from the die. Aluminum can also adhere to the die and buildup in local areas on the die surface with additional casting cycles. This second form of adhesion is called soldering. Lubricant is the best technology to control all forms of adhesion, but it comes at the cost of casting porosity, blisters, reduced die life, and increased die casting machine wear. New strategies to prevent adhesion are desired to eliminate the downsides of spray lubricants. Thermodynamically, there is a drive to form intermetallic phases between the aluminum casting and steel die. The kinetically controlled formation of these phases has been understood as the primary mechanism which causes sticking and soldering. Assuming this mechanism, adhesion should be eliminated by coating the die surface with a non-reactive material, but laboratory and industrial experiments show that this approach is partially effective. Also, kinetics based predictions cannot identify the areas where adhesion is most severe. Additional mechanisms are needed to further predict and reduce these defects. Friction is such a mechanism, and it has been overlooked as a significant cause of sticking and soldering in HPDC. Sticking results from the thermal contraction of the casting onto the die. This creates a friction force that resists ejection and may be larger than the ejection force capability of the die casting machine. Soldering is a special case where the local shear stress due to friction exceeds the local shear strength of the casting. This typically happens at high temperatures and can be predicted by the ratio of the local ejection shear stress and temperature dependent shear strength. Four aspects of HPDC adhesion were investigated to support this friction mechanism. First, the accepted theory of a kinetically controlled approach to the thermodynamic equilibrium does not adequately predict sticking and soldering. Next, the decrease in sticking force with increasing draft angle is predicted by a friction model. Third, soldering is shown to occur when the shear stress at ejection exceeds the strength of the casting via hot ejection test and computer models of industrial castings. Finally, the friction approach is applied to a range of casting conditions and alloys with discussion of optimization opportunities.",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OCLC:1269217188"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=o6emzgEACAAJ&dq=friction&hl=&cd=37&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=o6emzgEACAAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/THERMOMECHANICAL_MECHANISMS_THAT_CAUSE_A.html?hl=&id=o6emzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=o6emzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "Abstract : In high pressure die casting (HPDC) of aluminum, cast material adhering to die is a significant defect. Adhesion occurs in two primary ways. The casting may stick preventing its removal from the die."
        }
      },
      {
        "kind": "books#volume",
        "id": "-3WQDwAAQBAJ",
        "etag": "wql4+q48mSk",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/-3WQDwAAQBAJ",
        "volumeInfo": {
          "title": "GB/T 17469-2012: Translated English of Chinese Standard. (GBT 17469-2012, GB/T17469-2012, GBT17469-2012)",
          "subtitle": "Characteristics evaluation of brake linings for automobile - Small sample bench test method [After payment, write to & get a FREE-of-charge, unprotected true-PDF from: Sales@ChineseStandard.net]",
          "authors": [
            "https://www.chinesestandard.net"
          ],
          "publisher": "https://www.chinesestandard.net",
          "publishedDate": "2019-04-07",
          "description": "[After payment, write to & get a FREE-of-charge, unprotected true-PDF from: Sales@ChineseStandard.net] This Standard specifies the small sample bench test procedure and the grades and marks of friction coefficients for the friction wear of brake linings for automobile. This Standard applies to automobile disc brake linings and automobile drum brake linings. This Standard does not apply to parking brake linings.",
          "readingModes": {
            "text": false,
            "image": true
          },
          "pageCount": 16,
          "printType": "BOOK",
          "categories": [
            "Technology & Engineering"
          ],
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "imageLinks": {
            "smallThumbnail": "http://books.google.com/books/content?id=-3WQDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
            "thumbnail": "http://books.google.com/books/content?id=-3WQDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=-3WQDwAAQBAJ&pg=PA1&dq=friction&hl=&cd=38&source=gbs_api",
          "infoLink": "https://play.google.com/store/books/details?id=-3WQDwAAQBAJ&source=gbs_api",
          "canonicalVolumeLink": "https://play.google.com/store/books/details?id=-3WQDwAAQBAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "FOR_SALE",
          "isEbook": true,
          "listPrice": {
            "amount": 18601.58,
            "currencyCode": "INR"
          },
          "retailPrice": {
            "amount": 18601.58,
            "currencyCode": "INR"
          },
          "buyLink": "https://play.google.com/store/books/details?id=-3WQDwAAQBAJ&rdid=book--3WQDwAAQBAJ&rdot=1&source=gbs_api",
          "offers": [
            {
              "finskyOfferType": 1,
              "listPrice": {
                "amountInMicros": 18601580000,
                "currencyCode": "INR"
              },
              "retailPrice": {
                "amountInMicros": 18601580000,
                "currencyCode": "INR"
              }
            }
          ]
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "PARTIAL",
          "embeddable": true,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": true
          },
          "webReaderLink": "http://play.google.com/books/reader?id=-3WQDwAAQBAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "SAMPLE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "This Standard specifies the small sample bench test procedure and the grades and marks of friction coefficients for the friction wear of brake linings for automobile."
        }
      },
      {
        "kind": "books#volume",
        "id": "KzKgzgEACAAJ",
        "etag": "khHWh/RKIyw",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/KzKgzgEACAAJ",
        "volumeInfo": {
          "title": "Leveraging Learning for Vehicle Control at the Limits of Handling",
          "authors": [
            "Nathan Spielberg"
          ],
          "publishedDate": "2021",
          "description": "Autonomous vehicles have the capability to revolutionize human mobility and vehicle safety. To prove safe, they must be capable of navigating their environment as well as or better than the best human drivers. The best human drivers can leverage the limits of a vehicle's capabilities to avoid collisions and stabilize the vehicle while sliding on pavement, ice, and snow. Automated vehicles should similarly be capable of navigating safety-critical scenarios when friction is limited, and one large advantage they hold over human drivers is the amount of data they can generate. With self-driving vehicles in the San Francisco Bay Area collecting almost two human lifetimes worth of data just during 2020, this abundance of data holds the key to improving vehicle safety. This dissertation examines how data generated by self-driving vehicles can be used to learn control policies and models to improve vehicle control near the limits of handling. As data collection and vehicle operation near the limits can be expensive, this work uses skilled humans as an inspiration for learning policies because of their incredible data efficiency. This ability is clearly demonstrated in racing where skilled human drivers act to improve their performance after each lap by shifting their braking point to maximize corner entry speed and minimize lap time. Starting from a benchmark feedforward and feedback control architecture already comparable to skilled human drivers, this work directly learns feedforward policies to improve vehicle performance over time. By using an approximate physics-based model of the vehicle, recorded lap data, and the gradient of lap time, this approach improves lap time by almost seven tenths of a second on a nineteen second lap over an initial optimization-based approach for racing. Additionally, this approach generalizes to low-friction driving. While model-based policy search shows improvement over a solely optimization-based approach, model-based policy search is ultimately limited by the vehicle model used. Physics-based models are useful for interpretability and understanding, but fail to make use of the abundance of data self-driving vehicles generate and often do not capture high-order or complex-to-model effects. Additionally, to operate at a vehicle's true limits, precise identification of the vehicle's road-tire friction coefficient is required which is a very difficult task. To overcome the drawbacks of physics-based models, this thesis next examines the ability of neural networks to use vehicle data to learn vehicle dynamics models. These models are capable of not only modeling higher-order and complex effects, but also vehicle motion on high- and low-friction surfaces. Furthermore, these models do so while retaining comparable control performance near the limits to a benchmark physics-based feedforward and feedback control architecture. Though this control approach shows promise in operating near the limits, feedforward and feedback control is ultimately limited in its ability to trade of small errors in the short term to prevent larger errors in the future. Additionally, actuator and road boundary constraints play an increasingly important role in safety as the vehicle nears the limits. To deal with these limitations, this work presents neural network model predictive control for automated driving near the limits of friction. Neural network model predictive control not only leverages the neural network model's ability to predict dynamics on high- and low-friction test tracks, but also retains comparable or better performance to MPC using a well-tuned physics model optimized to the corresponding high- or low-friction test track. While neural network MPC shows improved performance over physics-based MPC when operating near the limits, MPC leverages its dynamics model with complete certainty. These effects can lead to MPC overleveraging its dynamics model, which in the presence of model mismatch can lead to poor controller performance. Additionally, when using neural network models in MPC, the network predicts vehicle motion with complete certainty regardless of the presence or absence of training data in the corresponding modeled region. To mitigate this issue, this work presents an approach which leverages a neural network model to learn the uncertainty in the underlying dynamics model used in MPC. By learning the uncertainty in MPC's dynamics model, the vehicle can take actions to avoid highly uncertain regions of operation while still attempting to optimize the original MPC cost function. The insights from this work can be used to design automated vehicles capable of leveraging vehicle data to more effectively operate near the limits of handling.",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OCLC:1265044931"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=KzKgzgEACAAJ&dq=friction&hl=&cd=39&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=KzKgzgEACAAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/Leveraging_Learning_for_Vehicle_Control.html?hl=&id=KzKgzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=KzKgzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The insights from this work can be used to design automated vehicles capable of leveraging vehicle data to more effectively operate near the limits of handling."
        }
      },
      {
        "kind": "books#volume",
        "id": "zTSFzgEACAAJ",
        "etag": "HoKddNGaIzE",
        "selfLink": "https://www.googleapis.com/books/v1/volumes/zTSFzgEACAAJ",
        "volumeInfo": {
          "title": "An Investigation on the Daily Activity Forces and Frictional Moments and Their Contribution to the Fretting Corrosion Failure of Modular Hip Joint Implants",
          "authors": [
            "Hamidreza Farhoudi"
          ],
          "publishedDate": "2021",
          "description": "The contemporary design of hip implants for Total Hip Arthroplasty (THA) comes with modular components to provide flexibility for the surgeons during the operation. This modularity increases the number of material interfaces, each of can become a source of failure. Fretting-corrosion at the metallic components of the femoral head- stem neck (head-neck) interface can lead to THA failure due to adverse local tissue reaction to the emitted ions and debris from the interface. Literature review suggests loads on the interface, the geometry of the interface, and corrosivity of the ambient as the main effective parameters on fretting-corrosion of an interface. Loads acting on the head-neck interface of THA comprise body forces and frictional moments caused by sliding of the femoral head inside the pelvic cup. Body forces of daily activities have been well studied and are available in the literature. However, frictional moments of these activities, especially for metal on metal head-cup bearing, is poorly studied and is currently not available. Given the importance of load components on fretting-corrosion, the frictional moment of daily activities needs to be provided as an effective parameter of the study on fretting-corrosion. -- An analytical method is developed to provide the currently not available frictional moments for metal-on-metal bearing couples for different patient weights and wide range daily activities. For the nine investigated activities, the maximum magnitude of the frictional moment ranged from 2.6 to 7.1 Nm. The maximum magnitude of the torque acting on the head-neck interface ranged from 2.3 to 5.7 Nm. These induced torques on the head-neck interface were close or even higher than the pure torques previously reported for depassivation of the head-neck interface. Interruption of this oxide layer by fretting initiates corrosion of active metal underneath. Forces and frictional moments of level gait walking found to be in a range inclusive of most of the other daily activity and considering its high daily frequency, it was selected as the loading scenario of this study. -- A Finite Element Analysis, which was developed by another PhD student in the research group, was implemented to investigate mechanical responses of the head-neck interface to the frictional moments and forces of walking activity. Loading scenarios were frictional moment only, forces only and simultaneous frictional moments and forces. In the walking forces only loading scenario mechanical response of the head-neck interface had a considerable change as 8.43% initially separated surface nodes came into contact. The stress-field of the press-fitted area also changed temporarily. The frictional moments only did not cause considerable changes in the mechanical response of the interface (only 0.27% of the non-contacting surface nodes temporarily came into contact). The effect of frictional moments was considerable in superposition on forces in simultaneous frictional moments and forces case where the micro-motions and contact stresses changed compared to forces only case. The normal contact stresses and micro-motions obtained from this realistic load-controlled study were typically in the range of 0-275 MPa and 0-38 μm, respectively. -- In vitro investigation on fretting-corrosion of the head-neck interface was conducted on two different head-neck material combinations of Ti6Al4V-CoCr and CoCr-CoCr. To keep the stress field, induced micromotion and crevice geometry of the head-neck interface as of its service condition, a full-scale implant was studied under frictional moments and forces profile of walking activity. A range of frictional moment varying from 0Nm to 7.5Nm was combined by a range of forces from 900N to 1800N. It observed that Ti6Al4V-CoCr head-neck combination was more susceptible than CoCr-CoCr material combination. The non-loaded control value of Open Circuit Potential (OCP) of Ti6Al4V-CoCr was -0.311V against -0.116V of CoCr-CoCr material combination, and at the highest drop of OCP, their OCP reached to -0.615V and -0.506V, respectively. Frictional moments effects on fretting-corrosion damage were more considerable in the lower vertical forces (for example, walking force with a maximum magnitude of 900N). In the presence of higher vertical forces equal to 1800N, the variation of moments from zero to 7.5Nm had a smaller effect on the OCP and the fretting-corrosion response of the interface. The general outcome suggests that increase of the forces had a more intensifying effect on fretting-corrosion while frictional moments, is more effective on fretting-corrosion damage when is combined with lower contact forces. -- The outcome of this research suggests that frictional moments play a considerable role in both mechanical responses of the head-neck interface and fretting-corrosion of the head-neck interface. Considering the accumulative nature of fretting-corrosion damage in the interface, simplification of loading to forces only scenarios in FEA studies and in vitro studies need to at least come with a justified increase in the force magnitude.",
          "industryIdentifiers": [
            {
              "type": "OTHER",
              "identifier": "OCLC:1256712839"
            }
          ],
          "readingModes": {
            "text": false,
            "image": false
          },
          "printType": "BOOK",
          "maturityRating": "NOT_MATURE",
          "allowAnonLogging": false,
          "contentVersion": "preview-1.0.0",
          "panelizationSummary": {
            "containsEpubBubbles": false,
            "containsImageBubbles": false
          },
          "language": "en",
          "previewLink": "http://books.google.co.in/books?id=zTSFzgEACAAJ&dq=friction&hl=&cd=40&source=gbs_api",
          "infoLink": "http://books.google.co.in/books?id=zTSFzgEACAAJ&dq=friction&hl=&source=gbs_api",
          "canonicalVolumeLink": "https://books.google.com/books/about/An_Investigation_on_the_Daily_Activity_F.html?hl=&id=zTSFzgEACAAJ"
        },
        "saleInfo": {
          "country": "IN",
          "saleability": "NOT_FOR_SALE",
          "isEbook": false
        },
        "accessInfo": {
          "country": "IN",
          "viewability": "NO_PAGES",
          "embeddable": false,
          "publicDomain": false,
          "textToSpeechPermission": "ALLOWED",
          "epub": {
            "isAvailable": false
          },
          "pdf": {
            "isAvailable": false
          },
          "webReaderLink": "http://play.google.com/books/reader?id=zTSFzgEACAAJ&hl=&printsec=frontcover&source=gbs_api",
          "accessViewStatus": "NONE",
          "quoteSharingAllowed": false
        },
        "searchInfo": {
          "textSnippet": "The contemporary design of hip implants for Total Hip Arthroplasty (THA) comes with modular components to provide flexibility for the surgeons during the operation."
        }
      }
    ]


  export default bookies

  